import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
  XMLHttpRequestHandler,
  XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { articlesEdit_template_new } from "../components/templates/articlesEdit_template_new";
import { UploadStatusHandler } from "../utils/UploadStatusHandler";
//import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
// @ts-ignore
import * as diff from "diff";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import EmbedHelper from "../utils/EmbedHelper";
import { is } from "@amcharts/amcharts4/core";
import Title from "amcharts/Title";
import {PollPickerInsertData} from "../components/templates/pollPickerView_template";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';
declare var Diff2Html: any;

let contentEditor;
let currentArticleModule: articles_edit_new;
let articleDirectoryItemDescriptionEditor;
let sandboxDirectoryItemDescriptionEditor;
let republishDirectoryItemDescriptionEditor;
let introTextEditor;
let sandboxEditor;
let republishEditor;
let sandboxIntroTextEditor;
let republishIntroTextEditor;
let faqEditor;
let prodRevReviewText;
let imageDescriptionEditor;
let imageCaptionEditor;
let galleryDescriptionEditor;
let additionalCreditEditor;
let bulkImageDescriptionEditor;
let bulkImageCaptionEditor;
let chartDiv;
let tagPickerSpecAreaEditor;
let promptResponseEditor;
let factualSummaryEditor;
let simpleSummaryEditor;
let satiricalCommentaryEditor;
let quizQuestionEditors = [];
let galleryCreditTextEditor;
let threadSummaryEditor;
let aiEventArray = [];
let allEditors = [];
let quizUniqueIdCounter = 0;

const ID_TEMPLATE_VIDEO = 15;
const ID_TEMPLATE_THREAD = 16;
const AUDIO_READER_BACKGROUND_NOTICE = "This article is taking longer than usual to turn into audio. We will finish it in the background, so you can keep working and check back later.";
const AUDIO_READER_MANUAL_TIMEOUT_FALLBACK_MS = 245000;

export class articles_edit_new extends vnModule_knockoutJS {
  public articlesEdit: articlesEdit_template_new;
  public XHRHdl: XMLHttpRequestHandler;
  protected XHRHdlCaller: string;
  protected XHRHdls: XMLHttpRequestHandler[] = [];
  protected recoveryXHRHdl: XMLHttpRequestHandler | null = null;
  protected imageXHRHdl: XMLHttpRequestHandler;
  protected galleryXHRHdl: XMLHttpRequestHandler;
  protected tagXHRHdl: XMLHttpRequestHandler;
  protected tagSearchXHRHdl: XMLHttpRequestHandler;
  protected contentImageXHRHdl: XMLHttpRequestHandler;
  protected keyPointsXHRHdl: XMLHttpRequestHandler;
  protected sensaiVaultXHRHdl: XMLHttpRequestHandler;
  protected autoCategorizeXHRHdl: XMLHttpRequestHandler;
  protected paymentCategoryXHR: XMLHttpRequestHandler;
  protected ImagePickerXHRHdl: XMLHttpRequestHandler;
  protected SensaiXHRHdl: XMLHttpRequestHandler;
  protected widgetXHRHdl: XMLHttpRequestHandler;
  protected quizPickerXHRHdl: XMLHttpRequestHandler;
  protected quizPickerOpenEditOnLoad: boolean = false;
  protected pollPickerXHRHdl: XMLHttpRequestHandler;
  protected pollPickerOpenEditOnLoad: boolean = false;
  protected threadSuggestionXHRHdl: XMLHttpRequestHandler;
  protected tocXHRHdl: XMLHttpRequestHandler;
  protected threadSummary: XMLHttpRequestHandler;
  protected articleFAQS: XMLHttpRequestHandler;
  protected progressBar: HTMLProgressElement;
  protected uploadProgress: any;
  protected recoveryTimeout: any;
  protected recoveryWarning: any;
  protected recoveryWarningShown = false;
  protected isSaveImage: any;
  protected isSaveGallery: any;
  protected recoveryDelay = 120; // set to 2 minutes
  protected recoveryWarningTimeout = 360; // set to 6 minutes
  protected lastSaved = new Date(Date.now()); // sets to current time, when page is loaded, this is considered saved from server
  protected lastUpdatedTimer: any;
  protected hasLastSuccessfulAutosave = false;
  protected isSaveAndStay = false;
  protected isSaveInProgress = false;
  protected isArticleDataLoading = false;
  protected loadedArticleId: number | null = null;
  protected loadedArticleStatus: number | null = null;
  protected loadedArticlePublishStatus: number | null = null;
  protected publishStatuses: any;
  private recoverySaveMode: string;
  public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
  protected _isLeavePageWarningNeeded: boolean = true;
  protected isSaveStuck = false;

  protected isSensaiProgressBarStuck = false;
  protected isCompensationTrackerStuck = false;
  //protected imagePickerHelper: imagePickerHelper;

  protected keyPointsAttempts = 0;
  protected imageMode: string;
  protected previewMode: string;
  protected embedHelper: EmbedHelper;

  protected videoXHRHdl: XMLHttpRequestHandler;
  protected contentVideoXHRHdl: XMLHttpRequestHandler;
  private deleteVideoXHRHdl: XMLHttpRequestHandler;
  protected eventSource: EventSource;

  protected isSensaiChat = false;

  protected requestStatus = [];
  protected firstRevealComplete = false;
  protected audioReaderFallbackTimeout: any;
  protected isAudioReaderResolvingCurrentInput = false;

  protected CKE4Finder: any;
  protected lastValidSelection: any = null;

  constructor(vnAppZone) {
    super(vnAppZone);
    this.embedHelper = new EmbedHelper(this);
  }

  private getImageMode(): string {
    return this.imageMode;
  }

  private setImageMode(mode: string): void {
    this.imageMode = mode;
  }

  private getPreviewMode(): string {
    return this.previewMode;
  }

  private setPreviewMode(mode: string): void {
    this.previewMode = mode;
  }

  private logArticleContext(prefix: string): void {
    const vm = this.articlesEdit.getTemplateViewModel();
    console.log(prefix, {
      routeId: this.getArticleIdFromUrl(),
      vmId: Number(vm.id()) || null,
      vmStatus: vm.idStatus(),
      vmPublishStatus: vm.idPublishStatus(),
      loadedArticleId: this.loadedArticleId,
      loadedArticleStatus: this.loadedArticleStatus,
      loadedArticlePublishStatus: this.loadedArticlePublishStatus,
      isArticleDataLoading: this.isArticleDataLoading,
    });
  }

  private startArticleDataLoading(): void {
    this.stopQuizGenerationPolling();
    this.isArticleDataLoading = true;
    this.loadedArticleId = null;
    this.loadedArticleStatus = null;
    this.loadedArticlePublishStatus = null;
    this.articlesEdit.disableSaveButtons();
    this.logArticleContext("[LOAD] Start article hydration");
  }

  private finishArticleDataLoading(article: any = null): void {
    if (article) {
      this.loadedArticleId = Number(article["id"]) || null;
      this.loadedArticleStatus =
        article["status"] && article["status"]["id"] !== undefined
          ? Number(article["status"]["id"])
          : null;
      this.loadedArticlePublishStatus =
        article["publishStatus"] && article["publishStatus"]["id"] !== undefined
          ? Number(article["publishStatus"]["id"])
          : null;
    }

    this.isArticleDataLoading = false;
    this.articlesEdit.enableSaveButtons();
    this.logArticleContext("[LOAD] Finish article hydration");
  }

  private finishSaveRequest(): void {
    this.isSaveInProgress = false;
    if (!this.isArticleDataLoading) {
      this.articlesEdit.enableSaveButtons();
    }
  }

  protected getModuleName(): string {
    return "articles_edit_new";
  }

  protected getImagePickerHelper() {
    return this.articlesEdit.imagePickerHelper;
  }

  public viewImage(target) {
    this.articlesEdit.viewImage(target);
  }

  public closeImage(target) {
    this.articlesEdit.closeImage(target);
  }

  public removeImage(target) {
    this.articlesEdit.removeImage(target);
  }

  buildContent(): Array<Element> {
    this.articlesEdit = new articlesEdit_template_new(
      "edit_template_new",
      this.viewModel,
      this as articles_edit_new
    );
    this.articlesEdit.setCanSearchUsers(true);
    this.template = this.articlesEdit;

    return [this.articlesEdit.build()];
  }

  public fillPage(): void {
    // Set article ID immediately from URL params before any async operations
    // Read article ID from the actual URL (not cached app.params) to avoid race conditions
    let id: number;
    if ((id = this.getArticleIdFromUrl()) && !isNaN(id)) {
      this.articlesEdit.getTemplateViewModel().id(id);
      console.log('[fillPage] Article ID set from URL:', id);
    }

    this.setUpCkEditorTagsPickerEditTextArea();
    this.minimizeSideNav();
    this.getArticleReferences();
    this.getQuizPickerReferences();
    this.getPollPickerReferences();
    this.getPaymentCategories();
    this.articlesEdit.buildDatePickerCalendar();
    this.watchScroll();
    this.recoveryWarningShown = false;
    this.articlesEdit.attachClickHandler();
    this.articlesEdit.attachWindowResizeHandler();
    this.articlesEdit.attachSaveShortcut();
  }

  public watchScroll() {
    let _this = this;
    _this.isSaveStuck = false;
    _this.isSensaiProgressBarStuck = false;
    _this.isCompensationTrackerStuck = false;
    window.addEventListener('scroll', this.updateTitleAnalysisWindowPosition.bind(this));
    window.addEventListener('resize', this.updateTitleAnalysisWindowPosition.bind(this));
    window.addEventListener('pagehide', () => this.stopQuizGenerationPolling());
    window.addEventListener('popstate', () => this.stopQuizGenerationPolling());

    // Immediately position it on load
    this.updateTitleAnalysisWindowPosition();

  }
  private updateTitleAnalysisWindowPosition(): void {
    const buttons = document.querySelectorAll('.copyAiButtonResponse') as NodeListOf<HTMLButtonElement>;
    buttons.forEach(button => {

      const templateViewModel = this.articlesEdit.getTemplateViewModel();
      if (templateViewModel.isPublishingControl() || templateViewModel.isGlobalLockEnabled()) {
        button.disabled = true;
      }
      //@ts-ignore
      if (button.isAttached) return;
      button.addEventListener('click', function (event) {
        const value = button.getAttribute('data-value');
        const fieldName = button.getAttribute('data-field');
        const tabName = button.getAttribute('data-tab');
        this.updateField.call(this, value, fieldName, tabName);
      }.bind(this));
      //@ts-ignore
      button.isAttached = true;

    });
  }

  private escapeRegex(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  private updateField(this, value, fieldName,tabName) {

    const fieldToSectionMap = {
        title: 'articleHeader',
        excerpt: 'articleHeader',
        article_tagFilter: 'articleTagSection',
        article_categoryFilter: 'articleCategorySection'
    };

    const templateViewModel = this.articlesEdit.getTemplateViewModel();
    if (templateViewModel) {

      const section = fieldToSectionMap[fieldName];
      if (section) {
        this.articlesEdit.onClickOpenArticleDetailsModal(section);
      }

      if (fieldName === 'articleContent') {
        const ckEditor = contentEditor;
        if (ckEditor) {
          const selection = ckEditor.getSelection();
          const ranges = selection.getRanges();

          // If there is a selection
          if (ranges.length > 0) {
            const range = ranges[0];
            range.collapse(false); // Collapse to the end of selection
            const fragment = ckEditor.document.createText(value);
            range.insertNode(fragment);
          } else {
            // Insert at the end if no selection
            const existingData = ckEditor.getData();
            ckEditor.setData(existingData + value);
          }
        }

        const fieldElement = document.getElementById(`cke_article_content`);
        if (fieldElement) {
          fieldElement.classList.remove('is-inserting');
          void fieldElement.offsetWidth; // trigger reflow
          fieldElement.classList.add('is-inserting');
        }
        return;
      }

      if(fieldName == 'promptResponse'){
          const ckEditor = CKEDITOR.instances['prompt_response'];
          if (ckEditor) {
            ckEditor.setData(value);
          }
          const fieldElement = document.getElementById(`cke_prompt_response`);
          if (fieldElement) {
            fieldElement.classList.remove('is-inserting');
            void fieldElement.offsetWidth; // trigger reflow
            fieldElement.classList.add('is-inserting');
          }
          return;
      }

      if(fieldName == 'article_categoryFilter'){

        const fieldElement = document.getElementById('multipleSelector_article_categoryFilter');
         templateViewModel.onClickTab(tabName);
       if (fieldElement) {
          if (fieldElement) {
            const y = fieldElement.getBoundingClientRect().top + window.pageYOffset - 150;
            window.scrollTo({top: y, behavior: 'smooth'});
            // fieldElement.classList.remove('is-inserting');
            // void fieldElement.offsetWidth; // trigger reflow
            //fieldElement.classList.add('is-inserting');
          }
        }
        this.articlesEdit.setAICategories([JSON.parse(value)]);
        return;
      }

      if(fieldName == 'article_tagFilter'){

        const fieldElement = document.getElementById('filterTag');
         templateViewModel.onClickTab(tabName);
       if (fieldElement) {
          if (fieldElement) {
            const y = fieldElement.getBoundingClientRect().top + window.pageYOffset - 150;
            window.scrollTo({top: y, behavior: 'smooth'});
          }
        }

        this.articlesEdit.setAITags([JSON.parse(value)]);
        return;
      }
      templateViewModel[fieldName](value);
      const fieldElement = document.getElementById(`article-${fieldName}`);
      if (fieldElement) {
        fieldElement.classList.remove('is-inserting');
        void fieldElement.offsetWidth; // trigger reflow
        fieldElement.classList.add('is-inserting');

        // Resize textarea if fieldName is title or excerpt
        if ((fieldName === 'title' || fieldName === 'excerpt') && fieldElement instanceof HTMLTextAreaElement) {
          // Use setTimeout to ensure the value is updated in the DOM
          setTimeout(() => {
            fieldElement.style.height = '';
            const neededHeight = fieldElement.scrollHeight;
            fieldElement.style.height = neededHeight + 'px';
          }, 0);
        }
      }

      templateViewModel.onClickTab(tabName);
      if (fieldElement) {
        if (fieldElement) {
          const y = fieldElement.getBoundingClientRect().top + window.pageYOffset - 150;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      }
    }
  }


  private stopWatchScroll() {
    window.onscroll = null;
  }

  private static getDistance(h: any): any {
    return h.offsetTop;
  }

  public cancelForm() {
    this.cancelEditArticle();
  }

  protected minimizeAllEditors() {
    for (let name in CKEDITOR.instances) {
      if (
        CKEDITOR.instances[name].getCommand("maximize") != null &&
        CKEDITOR.instances[name].getCommand("maximize").state ===
        CKEDITOR.TRISTATE_ON
      ) {
        CKEDITOR.instances[name].execCommand("maximize");
      }
    }
  }

  protected initializeCkEditors() {
    currentArticleModule = this;
    allEditors = [];
    for (let name in CKEDITOR.instances) {
      CKEDITOR.instances[name].destroy(true);
    }

    if (!CKEDITOR.stylesSet.registered.my_styles) {
      CKEDITOR.stylesSet.add("my_styles", [
        // Block-level styles.
        // { name: "Heading 1", element: "h1" },
        { name: "Heading 2", element: "h2" },
        { name: "Heading 3", element: "h3" },
        { name: "Preformatted", element: "pre" },
        { name: "Quote", element: "blockquote" },
        { name: "Code", element: "code" },
        // Inline styles.
        {
          name: "Related: One link",
          element: "span",
          attributes: { class: "related-single" },
        },
        {
          name: "Next - One link",
          element: "span",
          attributes: { class: "next-single" },
        },
        {
          name: "Affiliate - One link",
          element: "span",
          attributes: { class: "affiliate-single" },
        },
        {
          name: "Spoiler Alert",
          element: "span",
          attributes: { class: "article-alert" },
        },
        {
          name: "Tip",
          element: "div",
          attributes: { class: "emaki-custom tip" },
        },
        {
          name: "Warning",
          element: "div",
          attributes: { class: "emaki-custom warning" },
        },
        {
          name: "Note",
          element: "div",
          attributes: { class: "emaki-custom note" },
        },
        {
          name: "Expandable",
          element: "div",
          attributes: { class: "emaki-custom expandable" },
        },
        {
          name: "Pullquote",
          element: "div",
          attributes: { class: "emaki-custom pullquote" },
        },
        {
          name: "Promoted",
          element: "div",
          attributes: { class: "emaki-custom promoted" },
        },
        {
          name: "Drop Cap",
          element: "div",
          attributes: { class: "emaki-custom paragraph-dropcap" },
        },
        {
          name: "Float Image Left",
          element: "div",
          attributes: { class: "emaki-custom wrap-image" },
        },
        {
          name: "Float Image Right",
          element: "div",
          attributes: { class: "emaki-custom wrap-image-right" },
        },
        {
          name: "Float Badge Left",
          element: "div",
          attributes: { class: "emaki-custom wrap-badge-left" },
        }
      ]);
    }
    //
    if (!CKEDITOR.plugins.registered.FormatBtn) {
		CKEDITOR.plugins.add("FormatBtn", {
			init: function (editor) {
				editor.ui.addRichCombo("FormatBtn", {
					label: "Format",
					title: "Format",
					toolbar: "clipboard,0",
					panel: {
						css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
						multiSelect: false,
					},

					init: function () {
                        var isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) || /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
                        this.add("Superscript", "<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/superscript-icon.svg');\"></span>Superscript", isMac ? "Superscript (⌘ + Shift + .)" : "Superscript (Ctrl+Shift+.)");
                        this.add("Subscript", "<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/subscript-icon.svg');\"></span>Subscript", isMac ? "Subscript (⌘ + Shift + ,)" : "Subscript (Ctrl+Shift+,)");
                        this.add("TextHex", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/format-color.svg');vertical-align:middle;margin-right:8px;\"></span>Text Color", "Text Color");
                        this.add("BgHex", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/format-bg.svg');vertical-align:middle;margin-right:8px;\"></span>Background Color", "Background Color");
                        this.add("RemoveLink", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/format-link-remove.svg');vertical-align:middle;margin-right:8px;\"></span>Remove Link", "Remove Link");
                        this.add("RemoveFormatting", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/format-style-remove.svg');vertical-align:middle;margin-right:8px;\"></span>Remove Formatting", isMac ? "Remove Formatting (⌘ + \\)" : "Remove Formatting (Ctrl+\\)");
					},

					onClick: function (value) {
						try {
							editor.focus();
						} catch (_) {}

						switch (value) {
							case "RemoveLink":
								try {
									const unlinkCommand = editor.getCommand("unlink");
									if (unlinkCommand && unlinkCommand.state !== CKEDITOR.TRISTATE_DISABLED) {
										const result = editor.execCommand("unlink");
										if (!result) {
											// If execCommand returns false, try executing again
											editor.execCommand("unlink");
										}
									} else {
										// Command not available or disabled, try executing anyway
										editor.execCommand("unlink");
									}
								} catch (error) {
									console.error("Error executing Unlink command:", error);
									// Fallback: try executing without command check
									try {
										editor.execCommand("unlink");
									} catch (fallbackError) {
										console.error("Fallback Unlink command also failed:", fallbackError);
									}
								}
								break;
							case "RemoveFormatting":
								try {
									const removeFormatCommand = editor.getCommand("removeFormat");
									if (removeFormatCommand && removeFormatCommand.state !== CKEDITOR.TRISTATE_DISABLED) {
										const result = editor.execCommand("removeFormat");
										if (!result) {
											// If execCommand returns false, try executing again
											editor.execCommand("removeFormat");
										}
									} else {
										// Command not available or disabled, try executing anyway
										editor.execCommand("removeFormat");
									}
								} catch (error) {
									console.error("Error executing RemoveFormat command:", error);
									// Fallback: try executing without command check
									try {
										editor.execCommand("removeFormat");
									} catch (fallbackError) {
										console.error("Fallback RemoveFormat command also failed:", fallbackError);
									}
								}
								break;
							case "TextHex":
								editor.execCommand("maTextHex");
								break;
							case "BgHex":
								editor.execCommand("maBgHex");
								break;
							case "Superscript":
                                editor.execCommand("superscript");
                                break;
							case "Subscript":
                                editor.execCommand("subscript");
                                break;
						}
					},
				});
			},
		});
	}
    if (!CKEDITOR.plugins.registered.InsertDropdown) {
		CKEDITOR.plugins.add("InsertDropdown", {
			init: function (editor) {
				editor.ui.addRichCombo("InsertDropdown", {
					label: "Insert",
					title: "Insert",
					toolbar: "clipboard,0",
					panel: {
						css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
						multiSelect: false,
					},

					init: function () {
						this.add("CodeSnippet",
                            "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -384px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span></span>Code Snippet",
                            "Code Snippet"
                        );

                        this.add("HorizontalRule",
                            "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -1176px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Horizontal Line",
                            "Horizontal Line"
                        );

                        this.add("SpecialChar",
                            "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -2256px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Special Character",
                            "Special Character"
                        );
                        this.add("PollBtn",
                          "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1469 1024\" fill=\"currentColor\" style=\"width:16px;height:16px;vertical-align:middle;margin-right:8px;\"><g transform=\"scale(1,-1) translate(0,-960)\"><path fill-rule=\"evenodd\" d=\"M367.288 721.997c-163.076 0-293.831-132.224-293.831-293.831s130.755-293.831 293.831-293.831c163.076 0 293.831 132.224 293.831 293.831s-130.755 293.831-293.831 293.831zM367.288 648.539c121.94 0 220.373-98.433 220.373-220.373s-98.433-220.373-220.373-220.373-220.373 98.433-220.373 220.373 98.433 220.373 220.373 220.373zM238.003 506.032l77.865-77.865-77.865-77.865 51.42-51.42 77.865 77.865 77.865-77.865 51.42 51.42-77.865 77.865 77.865 77.865-51.42 51.42-77.865-77.865-77.865 77.865-51.42-51.42zM1101.865 721.997c-163.076 0-293.831-132.224-293.831-293.831s130.755-293.831 293.831-293.831c163.076 0 293.831 132.224 293.831 293.831s-130.755 293.831-293.831 293.831zM1101.865 648.539c121.94 0 220.373-98.433 220.373-220.373s-98.433-220.373-220.373-220.373-220.373 98.433-220.373 220.373 98.433 220.373 220.373 220.373z\"/></g></svg>Poll",
                          "Poll"
                        );
                        this.add("QuizBtn",
                            "<svg style=\"width:16px;height:16px;vertical-align:middle;margin-right:8px;\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z\"/></svg>Quiz",
                            "Quiz"
                        );
					},
                    onClick: function (value) {
						try {
							editor.focus();
						} catch (_) {}

						switch (value) {
							case "CodeSnippet":
								// CodeSnippet opens a dialog
								try {
									// First try to get and click the button (most reliable)
									var codeSnippetButton = editor.ui.get("CodeSnippet");
									if (codeSnippetButton) {
										codeSnippetButton.click();
									} else {
										// Button not found, use execCommand directly
										var cmd = editor.getCommand("codeSnippet");
										if (cmd) {
											editor.execCommand("codeSnippet");
										} else {
											// Command not found, try anyway
											editor.execCommand("codeSnippet");
										}
									}
								} catch (error) {
									console.error("Error executing CodeSnippet command:", error);
									// Final fallback - just try execCommand
									try {
										editor.execCommand("codeSnippet");
									} catch (fallbackError) {
										console.error("Fallback CodeSnippet command also failed:", fallbackError);
									}
								}
								break;
							case "HorizontalRule":
								// HorizontalRule inserts an <hr> element
								case "HorizontalRule":
                                try {
                                    editor.execCommand("horizontalrule");
                                } catch (error) {
                                    console.error("HorizontalRule command failed:", error);
                                }
                                break;

							case "SpecialChar":
								try {
									const specialCharCommand = editor.getCommand("specialchar");
									if (specialCharCommand && specialCharCommand.state !== CKEDITOR.TRISTATE_DISABLED) {
										const result = editor.execCommand("specialchar");
										if (!result) {
											// If execCommand returns false, try executing again
											editor.execCommand("specialchar");
										}
									} else {
										// Command not available or disabled, try executing anyway
										editor.execCommand("specialchar");
									}
								} catch (error) {
									console.error("Error executing SpecialChar command:", error);
									// Fallback: try executing without command check
									try {
										editor.execCommand("specialchar");
									} catch (fallbackError) {
										console.error("Fallback SpecialChar command also failed:", fallbackError);
									}
								}
								break;
							case "PollBtn":
								try {
                                    editor.execCommand("pollPickerCommand");
								} catch (error) {
									console.error("Error executing PollBtn command:", error);
								}
								break;
                            case "QuizBtn":
                                try {
                                    editor.execCommand("quizPickerCommand");
                                } catch (error) {
                                    console.error("Error executing QuizBtn command:", error);
                                }
                                break;
						}
					},
				});
			},
		});
	}
    if (!CKEDITOR.plugins.registered.editMenu) {
		CKEDITOR.plugins.add("editMenu", {
			init: function (editor) {
				editor.ui.addRichCombo("EditMenu", {
					label: "Edit",
					title: "Edit",
					toolbar: "clipboard,0",
					panel: {
						css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
						multiSelect: false,
					},

					init: function () {
                        let isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) || /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
						this.add("Cut", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -312px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Cut", isMac ? "Cut (⌘ + X)" : "Cut (Ctrl+Shift+X)");
						this.add("Copy", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -264px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Copy",  isMac ? "Copy (⌘ + C)" : "Copy (Ctrl+Shift+C)");
						this.add("Paste", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -360px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Paste",  isMac ? "Paste (⌘ + V)" : "Paste (Ctrl+Shift+V)");
						this.add("PasteWithoutFormatting", "<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/past-without-formatting.svg');\"></span>Paste Without Style", isMac ? "Paste Without Style (⌘ + Shift + V)" : "Paste Without Style (Ctrl+Shift+V)");
						this.add("SelectAll", "<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;background-image:url('/node_modules/ckeditor4/skins/emakiCustomComprehensive/icon-menu/select-all.svg');\"></span>Select All", isMac ? "Select All (⌘ + A)" : "Select All (Ctrl+A)");
					},

					onClick: function (value) {
						try {
							editor.focus();
						} catch (_) {}

						switch (value) {
							case "Cut":
								editor.execCommand("cut");
								break;
							case "Copy":
								editor.execCommand("copy");
								break;
							case "Paste":
								editor.execCommand("paste");
								break;
							case "PasteWithoutFormatting":
								editor.execCommand("maPasteWithoutStyle");
								break;
							case "SelectAll":
								setTimeout(function () {
									editor.focus();
									editor.execCommand("selectAll");
								}, 50);
								break;
						}
					},
				});
			},
		});
	}

    if (!CKEDITOR.plugins.registered.AlignDropdown) {
		CKEDITOR.plugins.add("AlignDropdown", {
			init: function (editor) {
				editor.ui.addRichCombo("AlignDropdown", {
					label: "Align",
					title: "Align",
					toolbar: "clipboard,0",
					panel: {
						css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
						multiSelect: false,
					},

					init: function () {
						var isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) || /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
						this.add("JustifyLeft",
							"<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;\"><svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><rect x='1' y='2' width='14' height='2'/><rect x='1' y='7' width='10' height='2'/><rect x='1' y='12' width='14' height='2'/></svg></span>Left Align",
							isMac ? "Left Align (⌘ + Shift + L)" : "Left Align (Ctrl+Shift+L)"
						);
						this.add("JustifyCenter",
							"<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;\"><svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><rect x='1' y='2' width='14' height='2'/><rect x='3' y='7' width='10' height='2'/><rect x='1' y='12' width='14' height='2'/></svg></span>Center Align",
							isMac ? "Center Align (⌘ + Shift + E)" : "Center Align (Ctrl+Shift+E)"
						);
						this.add("JustifyRight",
							"<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;\"><svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><rect x='1' y='2' width='14' height='2'/><rect x='5' y='7' width='10' height='2'/><rect x='1' y='12' width='14' height='2'/></svg></span>Right Align",
							isMac ? "Right Align (⌘ + Shift + R)" : "Right Align (Ctrl+Shift+R)"
						);
						this.add("JustifyBlock",
							"<span style=\"display:inline-block;width:16px;height:16px;vertical-align:middle;margin-right:8px;\"><svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><rect x='1' y='2' width='14' height='2'/><rect x='1' y='7' width='14' height='2'/><rect x='1' y='12' width='14' height='2'/></svg></span>Justify",
							isMac ? "Justify (⌘ + Shift + J)" : "Justify (Ctrl+Shift+J)"
						);
					},

					onClick: function (value) {
						try {
							editor.focus();
						} catch (_) {}

						switch (value) {
							case "JustifyLeft":
								editor.execCommand("justifyleftHeadingOnly");
								break;
							case "JustifyCenter":
								editor.execCommand("justifycenterHeadingOnly");
								break;
							case "JustifyRight":
								editor.execCommand("justifyrightHeadingOnly");
								break;
							case "JustifyBlock":
								editor.execCommand("justifyblockHeadingOnly");
								break;
						}
					},
				});
			},
		});
	}

    if (!CKEDITOR.plugins.registered.blocksCombo) {
      (function () {

        function blockStyles(editor) {
          return {
            'Heading 2': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'h2' }),
            'Heading 3': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'h3' }),
            'Drop Cap': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom paragraph-dropcap' } }),
            'Blockquote': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'blockquote' }),
            'Pullquote': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom pullquote' } }),
            'Tip - Box': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom tip' } }),
            'Warning - Box': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom warning' } }),
            'Note - Box': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom note' } }),
            'Promoted - Box': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom promoted' } }),
            'Expandable - See More': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom expandable' } }),
            'Float Image Left': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom wrap-image' } }),
            'Float Image Right': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom wrap-image-right' } }),
            'Float Badge Left': new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: 'div', attributes: { 'class': 'emaki-custom wrap-badge-left' } })
          };
        }

        // Helper to add custom plugin
        function addStyleCombo(pluginName, uiName, label, getStylesMap) {
          CKEDITOR.plugins.add(pluginName, {
            init: function (editor) {
              editor.ui.addRichCombo(uiName, {
                label: label,
                title: label,
                toolbar: 'styles,10',
                panel: {
                  css: [CKEDITOR.skin.getPath('editor')].concat(editor.config.contentsCss),
                  multiSelect: false
                },
                init: function () {
                  var isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.platform) ||
                             /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
                  this.add('Plain', 'Plain', isMac ? 'Plain (⌘ + ⌥ + 0)' : 'Plain (Ctrl+Alt+0)');
                  var map = getStylesMap(editor);

                  // Detect platform for shortcuts

                  for (var name in map) {
                    var displayName = name;
                    var title = name;

                    // Add shortcuts to Heading 2 and Heading 3 titles
                    if (name === 'Heading 2') {
                      var shortcut = isMac ? '⌘ + ⌥ + 2' : 'Ctrl+Alt+2';
                      title = name + ' (' + shortcut + ')';
                    } else if (name === 'Heading 3') {
                      var shortcut = isMac ? '⌘ + ⌥ + 3' : 'Ctrl+Alt+3';
                      title = name + ' (' + shortcut + ')';
                    }

                    this.add(name, displayName, title);
                  }
                },
                onClick: function (value) {
                  try { editor.focus(); } catch (_) { }

                  if (value === 'Plain') {
                    var mark = getTarget && getTarget();

                    // fallback: current block if it's one of recognized types
                    if (!mark) {
                      var path = editor.elementPath && editor.elementPath();
                      var b = path && path.block;
                      if (b) {
                        var n = b.getName();
                        if (n === 'h2' || n === 'h3' || n === 'blockquote' ||
                            (n === 'div' && b.hasClass && b.hasClass('emaki-custom'))) {
                          mark = b;
                        }
                      }
                    }

                    if (!mark || (mark.equals && mark.equals(editor.editable()))) return;

                    editor.fire('saveSnapshot'); // begin single undo step

                    // unwrap in one call
                    try {
                      mark.remove(true);
                    } catch (_) {
                      editor.fire('saveSnapshot');
                      return;
                    }

                    editor.fire('saveSnapshot'); // end single undo step
                    return;
                  }

                  var map = getStylesMap(editor);
                  var style = map[value];
                  if (!style) return;

                  // helpers
                  function getTarget() {
                    try {
                      var mark = editor.editable().findOne('[data-cke-ma-indicator]');
                      if (mark) return mark;
                    } catch (_) { }
                    // fallback: walk up from current selection
                    var sel = editor.getSelection && editor.getSelection();
                    var ranges = sel ? sel.getRanges() : [];
                    if (!ranges || !ranges.length) return null;

                    var el = ranges[0].getCommonAncestor();
                    while (el) {
                      if (el.hasAttribute && el.hasAttribute('data-cke-ma-indicator')) return el;
                      if (el.equals && el.equals(editor.editable())) break;
                      el = el.getParent && el.getParent();
                    }
                    return null;
                  }

                  function getStyleDef(s) {
                    return s && (s.getDefinition ? s.getDefinition() : s._ && s._.definition) || {};
                  }

                  function uiSync(blockName) {
                    CKEDITOR.tools.setTimeout(function () {
                      if (blockName !== undefined) _myThis.updateDropdownSelection(editor, 'Blocks', blockName || '');
                      _myThis.updateVisualIndicator(editor);
                    }, 0);
                  }

                  function applyBlockStyles(mark, s, displayName) {
                    // one undo step
                    editor.fire('saveSnapshot');

                    // 1) capture selection as bookmarks
                    var sel = editor.getSelection();
                    var ranges = sel ? sel.getRanges() : null;
                    var bookmarks = [];
                    if (ranges && ranges.length) {
                      for (var i = 0; i < ranges.length; i++) {
                        // createBookmark2 survives DOM moves better
                        bookmarks.push(ranges[i].createBookmark2());
                      }
                    }

                    // 2) build the target element
                    var def = getStyleDef(s);
                    var attrs = (def && def.attributes) || null;
                    var tag = String(s.element || '').toLowerCase();
                    var newEl = new CKEDITOR.dom.element(tag, editor.document);
                    if (attrs) for (var k in attrs) if (attrs.hasOwnProperty(k)) newEl.setAttribute(k, attrs[k]);

                    // 3) move children over (preserves bookmark nodes)
                    while (mark.getFirst()) {
                      newEl.append(mark.getFirst().remove());
                    }

                    // 4) insert in place robustly (avoid replace() on detached nodes)
                    var parent = mark.getParent();
                    if (parent) {
                      newEl.insertBefore(mark); // <parent>[newEl, mark,...]
                      mark.remove();
                    } else {
                      // extremely rare: sentinel got detached; fall back to insert at caret
                      editor.insertElement(newEl);
                    }

                    // keep indicator on the new block
                    try { newEl.setAttribute('data-cke-ma-indicator', '1'); } catch (_) { }

                    // 5) restore selection from bookmarks (back to exact caret/selection)
                    if (bookmarks.length) {
                      var restored = [];
                      for (var j = 0; j < bookmarks.length; j++) {
                        var r = editor.createRange();
                        r.moveToBookmark(bookmarks[j]);
                        restored.push(r);
                      }
                      sel.selectRanges(restored);
                      try { editor.focus(); } catch (_) { }
                    } else {
                      // fallback: place caret at start of the new block
                      var r2 = editor.createRange();
                      r2.moveToPosition(newEl, CKEDITOR.POSITION_AFTER_START);
                      sel.selectRanges([r2]);
                    }

                    // 6) UI sync & end undo step
                    uiSync(displayName);
                    editor.fire('saveSnapshot');
                  }

                  var isActive = false;
                  try { isActive = !!style.checkActive(editor); } catch (_) { isActive = false; }

                  try {
                    if (isActive) {
                      editor.removeStyle(style);
                    } else {
                      var mark = getTarget();

                      // BLOCK STYLES (swap container in place)
                      if (mark && style.element && CKEDITOR.dtd.$block[style.element]) {
                        applyBlockStyles(mark, style, value);
                        return;
                      }

                      // Fallback: default CKEditor behavior
                      editor.applyStyle(style);
                    }

                    // Final UI sync for fallback path
                    setTimeout(function () {
                      _myThis.updateVisualIndicator(editor);
                      if (value === 'Heading 2' || value === 'Heading 3') _myThis.scrubIfHeadingOrBQ(editor);
                    }, 50);

                  } catch (e) {
                    console.error('Error in style application:', e);
                    try {
                      // Fallback: default CKEditor behavior
                      editor.applyStyle(style);
                      setTimeout(function () { _myThis.updateVisualIndicator(editor); }, 50);
                    } catch (fallbackError) {
                      console.error('Fallback also failed:', fallbackError);
                    }
                  }
                }
              });
            }
          });
        }

        // Register the style comboboxes
        addStyleCombo('blocksCombo', 'Blocks', 'Block Style', blockStyles);
      })();
    }

    if (!CKEDITOR.plugins.registered.selectionWrapCombo) {
      CKEDITOR.plugins.add('selectionWrapCombo', {
        init: function (editor) {
          var WRAP_DEFS = [
            { name: "Heading 2", element: "h2" },
            { name: "Heading 3", element: "h3" },
            { name: "Code", element: "code" },
            { name: "Drop Cap", element: "div", attributes: { "class": "emaki-custom paragraph-dropcap" } },
            { name: "Block Quote", element: "blockquote" },
            { name: "Pullquote", element: "div", attributes: { "class": "emaki-custom pullquote" } },
            { name: "Tip - Box", element: "div", attributes: { "class": "emaki-custom tip" } },
            { name: "Warning - Box", element: "div", attributes: { "class": "emaki-custom warning" } },
            { name: "Note - Box", element: "div", attributes: { "class": "emaki-custom note" } },
            { name: "Promoted - Box", element: "div", attributes: { "class": "emaki-custom promoted" } },
            { name: "Expandable - See More", element: "div", attributes: { "class": "emaki-custom expandable" } },
            { name: "Float Image Left", element: "div", attributes: { "class": "emaki-custom wrap-image" } },
            { name: "Float Image Right", element: "div", attributes: { "class": "emaki-custom wrap-image-right" } },
            { name: "Float Badge Left", element: "div", attributes: { "class": "emaki-custom wrap-badge-left" } },
            { name: "Float Widget Right", element: "div", attributes: { "class": "emaki-custom wrap-widget-right" } },
            { name: "Preformatted", element: "pre" },
            { name: "Spoiler Alert", element: "span", attributes: { "class": "article-alert" } },
            { name: "Affiliate - Button", element: "span", attributes: { "class": "affiliate-single" } }
          ];

          // pre-allow inline span classes for this editor so insertHtml won't be stripped by ACF
          for (var i = 0; i < WRAP_DEFS.length; i++) {
            var d = WRAP_DEFS[i];
            if (d.element === 'span' && d.attributes && d.attributes['class']) {
              var cls = d.attributes['class'];
              if (editor.filter && editor.filter.allow) {
                editor.filter.allow('span(' + cls + ')[*]{*}');
              } else if (editor.addFeature) {
                editor.addFeature({ allowedContent: 'span(' + cls + ')[*]{*}' });
              }
            }
          }
          var DEF_MAP = {}; for (var i = 0; i < WRAP_DEFS.length; i++) DEF_MAP[WRAP_DEFS[i].name] = WRAP_DEFS[i];

          editor.addCommand('maWrapSelection', {
            exec: function (ed) {
              var def = ed._maWrapDef; if (!def) return;

              var sel = ed.getSelection(); if (!sel) return;
              var ranges = sel.getRanges(); if (!ranges || !ranges.length) return;
              var range = ranges[0]; if (range.collapsed) return;   // only when text is selected

              // 1) Get the selected HTML (no DOM mutation)
              var selectedHtml = ed.getSelectedHtml && ed.getSelectedHtml(true);
              if (!selectedHtml) return;

              // 2) Build wrapper html
              var tag = String(def.element || 'span').toLowerCase();
              var attrs = def.attributes || {};
              var attrStr = '';
              for (var k in attrs) if (attrs.hasOwnProperty(k)) {
                // basic escaping
                attrStr += ' ' + k + '="' + CKEDITOR.tools.htmlEncode(String(attrs[k])) + '"';
              }
              var wrapperHtml = '<' + tag + attrStr + '>' + selectedHtml + '</' + tag + '>';

              // 3) Single editor operation that REPLACES the selection -> single undo step
              ed.insertHtml(wrapperHtml);
            }
          });

          editor.ui.addRichCombo('SelectionWrap', {
            label: 'Apply Style',
            title: 'Apply Style',
            toolbar: 'styles,20',
            panel: {
              css: [CKEDITOR.skin.getPath('editor')].concat(editor.config.contentsCss),
              multiSelect: false
            },
            init: function () {
              for (var name in DEF_MAP) if (DEF_MAP.hasOwnProperty(name)) this.add(name, name, name);
            },
            onClick: function (value) {
              try { editor.focus(); } catch (_) { }
              var def = DEF_MAP[value]; if (!def) return;

              var sel = editor.getSelection();
              var ranges = sel ? sel.getRanges() : [];
              if (!ranges || !ranges.length || ranges[0].collapsed) return;

              var range = ranges[0];
              var tag = String(def.element || 'span').toLowerCase();
              var isBlock = !!CKEDITOR.dtd.$block[tag];

              if (isBlock) {

                var styleAttrs = def.attributes || {};
                editor.fire('saveSnapshot'); // begin single undo step

                // Extract just the selected DOM into a fragment
                var frag = range.extractContents();

                // Build the new block and put the fragment inside
                var newBlock = new CKEDITOR.dom.element(tag, editor.document);
                for (var k in styleAttrs) if (styleAttrs.hasOwnProperty(k)) newBlock.setAttribute(k, styleAttrs[k]);
                newBlock.append(frag);

                // Insert the block back at the caret (now a collapsed range at original position)
                range.insertNode(newBlock);

                // Normalize and select the new block
                var newSelRange = editor.createRange();
                newSelRange.selectNodeContents(newBlock);
                sel.selectRanges([newSelRange]);

                editor.fire('saveSnapshot');
                return;
              }

              // Inline via a command
              editor._maWrapDef = def;
              editor.execCommand('maWrapSelection');
              editor._maWrapDef = null;
            }
          });
        }
      });
    }

    if (!CKEDITOR.plugins.registered.maTextHex) {
      CKEDITOR.plugins.add('maTextHex', {
        requires: 'colordialog,colorbutton',
        init: function (editor) {
          editor.addCommand('maTextHex', {
            canUndo: true,
            exec: function (ed) {
              ed.getColorFromDialog(function (color) {
                if (color === null || color === false || typeof color === 'undefined') return;
                ed.fire('saveSnapshot');
                ed.applyStyle(new CKEDITOR.style({
                  element: 'span',
                  styles: { color: color }
                }));
                ed.fire('saveSnapshot');
              }, 'fore');
            }
          });

          editor.ui.addButton('TextHex', {
            label: 'HEX Color',
            command: 'maTextHex',
            toolbar: 'styles,21',
            icon: 'textcolor'
          });
        }
      });
    }

    if (!CKEDITOR.plugins.registered.maBgHex) {
      CKEDITOR.plugins.add('maBgHex', {
        requires: 'colordialog,colorbutton',
        init: function (editor) {
          editor.addCommand('maBgHex', {
            canUndo: true,
            exec: function (ed) {
              ed.getColorFromDialog(function (color) {
                if (color === null || color === false || typeof color === 'undefined') return;
                ed.fire('saveSnapshot');
                ed.applyStyle(new CKEDITOR.style({
                  element: 'span',
                  styles: { 'background-color': color }
                }));
                ed.fire('saveSnapshot');
              }, 'fore');
            }
          });

          editor.ui.addButton('BgHex', {
            label: 'HEX Background',
            command: 'maBgHex',
            toolbar: 'styles,22',
            icon: 'bgcolor'
          });
        }
      });
    }

    if (!CKEDITOR.plugins.registered.maPasteWithoutStyle) {
      CKEDITOR.plugins.add('maPasteWithoutStyle', {
        init: function(editor) {
          // Add context menu option
          editor.addMenuItem('maPasteWithoutStyle', {
            label: 'Paste Without Style',
            command: 'maPasteWithoutStyle',
            group: 'clipboard',
            order: 20
          });

          // Register the command
          editor.addCommand('maPasteWithoutStyle', {
            exec: function () {
              editor.showNotification(
                'Press ' + (CKEDITOR.env.mac ? '⌘' : 'Ctrl') + '+V to paste (style will be removed).',
                'info',
                1800
              );
              editor.focus();

              var startId = 'pwos-start-' + CKEDITOR.tools.getNextNumber();
              var endId   = 'pwos-end-'   + CKEDITOR.tools.getNextNumber();
              var ZWSP    = '&#8203;'; // zero-width space

              // 1) Wrap incoming fragment with <a> anchors that will survive ACF
              editor.once('paste', function (evt) {
                var raw = (evt.data && typeof evt.data.dataValue === 'string') ? evt.data.dataValue : '';
                // console.log('[PWOS] raw BEFORE filters >>>\n' + raw + '\n<<<');
                evt.data.dataValue =
                  '<a id="' + startId + '" data-pwos="1">' + ZWSP + '</a>' +
                  raw +
                  '<a id="' + endId   + '" data-pwos="1">' + ZWSP + '</a>';
              });

              // 2) After paste, grab exactly what's between anchors and clean it
              editor.once('afterPaste', function () {
                var doc   = editor.document;
                var start = doc.getById(startId);
                var end   = doc.getById(endId);

                if (!start || !end) {
                  console.warn('[PWOS] Anchors not found — ACF stripped or pipeline skipped. Check allowedContent.');
                  return;
                }

                // Read HTML between anchors
                var r = doc.$.createRange();
                r.setStartAfter(start.$);
                r.setEndBefore(end.$);
                var frag = r.cloneContents();
                var tmp  = document.createElement('div');
                tmp.appendChild(frag);
                var between = tmp.innerHTML;

                // Clean (2 steps only) and replace
                var cleaned = cleanHtml(between);
                // console.log('[PWOS] cleaned >>>\n' + cleaned + '\n<<<');

                var rng = new CKEDITOR.dom.range(doc);
                rng.setStartAfter(start);
                rng.setEndBefore(end);
                rng.deleteContents();
                rng.collapse(true);
                editor.getSelection().selectRanges([rng]);
                editor.insertHtml(cleaned);

                // 3) Cleanup markers
                start.remove();
                end.remove();
              });
            }
          });

          // Hook into context menu
          if (editor.contextMenu) {
            editor.addMenuGroup('clipboard', 10);

            editor.contextMenu.addListener(function(element, selection) {
              // Show "Paste Without Style" always
              return { maPasteWithoutStyle: CKEDITOR.TRISTATE_OFF };
            });
          }

          function cleanHtml(html) {
            var container = document.createElement('div');
            container.innerHTML = html;

            var ATTR_WHITELIST = {
              a:    ['href', 'target', 'name', 'id', 'title'],
              img:  ['src', 'alt', 'width', 'height', 'title', 'data-image-id', 'data-mobile-optimized'],
              ol:   ['start', 'type'],
              li:   ['value'],
              table:['border', 'cellpadding', 'cellspacing'],
              td:   ['colspan', 'rowspan', 'headers', 'abbr'],
              th:   ['colspan', 'rowspan', 'headers', 'abbr']
            };

            // Step 1: remove all attributes from all elements
            var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, null, false);
            var nodes = [];
            while (walker.nextNode()) nodes.push(walker.currentNode);
            nodes.forEach(function (el) {
              var tag = el.tagName ? el.tagName.toLowerCase() : '';
              var allowed = ATTR_WHITELIST[tag] || [];
              Array.prototype.slice.call(el.attributes || []).forEach(function (attr) {
                if (allowed.indexOf(attr.name.toLowerCase()) === -1) {
                  el.removeAttribute(attr.name);
                }
              });
            });

            // Step 2: remove all <span> tags (unwrap, keep children)
            Array.prototype.slice.call(container.querySelectorAll('span')).forEach(function (sp) {
              var parent = sp.parentNode;
              while (sp.firstChild) parent.insertBefore(sp.firstChild, sp);
              parent.removeChild(sp);
            });

            return container.innerHTML;
          }
        }
      });
    }

    CKEDITOR.on("dialogDefinition", function (ev) {

      var dialogName = ev.data.name;
      var dialogDefinition = ev.data.definition;

      //Remove background color and border color in dialog cells properties
      if (dialogName == "cellProperties") {
        // "bgColor"
        // "borderColor"
        const cellProps = dialogDefinition.getContents("info");
        cellProps.remove("borderColor");
        cellProps.remove("bgColor");
      }

      //remove features from tableProperties dialog
      if (dialogName == "tableProperties") {
        var infoTab = dialogDefinition.getContents("info");
        infoTab.remove("txtCaption");
        infoTab.remove("txtSummary");
      }

      //remove features from table dialog
      if (dialogName == "table") {
        // Get the advanced tab reference
        var infoTab2 = dialogDefinition.getContents("advanced");

        //Set the default
        // Remove the 'Advanced' tab completely
        dialogDefinition.removeContents("advanced");

        // Get the properties tab reference
        var infoTab = dialogDefinition.getContents("info");

        // Remove unnecessary bits from this tab
        /// infoTab.remove('txtBorder');
        infoTab.remove("cmbAlign");
        infoTab.remove("txtWidth");
        infoTab.remove("txtHeight");
        // infoTab.remove('txtCellSpace');
        //infoTab.remove('txtCellPad');
        infoTab.remove("txtCaption");
        infoTab.remove("txtSummary");
      }

      if (dialogName == "link") {
        /* Getting the contents of the Target tab */

        var targetTab = dialogDefinition.getContents("target");
        var informationTab = dialogDefinition.getContents("info");
        var advancedTab = dialogDefinition.getContents("advanced");

        //remove the browse server button
        informationTab.remove("browse");

        //moving the target dropdown to the main tab
        var targetField = targetTab.get("linkTargetType");

        targetTab.remove("linkTargetType");
        informationTab.add(targetField);
      }

    });

    //Directory item CK editor
    this.initCkEditor("article_directory_item_description");
    articleDirectoryItemDescriptionEditor =
      CKEDITOR.instances.article_directory_item_description;
    allEditors.push(articleDirectoryItemDescriptionEditor);

    //Directory item CK editor
    this.initCkEditor("sandbox_directory_item_description");
    sandboxDirectoryItemDescriptionEditor =
      CKEDITOR.instances.sandbox_directory_item_description;
    allEditors.push(sandboxDirectoryItemDescriptionEditor);

    //Directory item CK editor
    this.initCkEditor("republish_directory_item_description");
    republishDirectoryItemDescriptionEditor =
      CKEDITOR.instances.republish_directory_item_description;
    allEditors.push(republishDirectoryItemDescriptionEditor);

    // Main article content
    this.initCkEditor("article_content");
    let _myThis = this;
    contentEditor = CKEDITOR.instances.article_content;

      contentEditor.on('instanceReady', function () {

        contentEditor.on('selectionChange', function (evt) {
          _myThis.handleSelectionChange(evt);
        });

        contentEditor.document.on('mouseup', function () {
          setTimeout(() => {
            _myThis.handleSelectionChange({ editor: contentEditor }); // simulate event
          }, 50);
        });

        contentEditor.document.on('keyup', function () {
          setTimeout(() => {
            _myThis.handleSelectionChange({ editor: contentEditor }); // simulate event
          }, 50);
        });

      // Initial state
      //this.updateInsertButtonState(contentEditor);

    });


    allEditors.push(contentEditor);

    // Article Intro
    //if (!CKEDITOR.instances.article_intro) {
    this.initCkEditor("productReview_intro_text");
    //}
    introTextEditor = CKEDITOR.instances.productReview_intro_text;
    allEditors.push(introTextEditor);

    // Article Sandbox
    //if (!CKEDITOR.instances.article_sandbox) {
    this.initCkEditor("article_sandbox");
    //}
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    allEditors.push(sandboxEditor);

    // republish Sandbox
    this.initCkEditor("article_republish");
    republishEditor = CKEDITOR.instances.article_republish;
    allEditors.push(republishEditor);

    // Product Review Sandbox
    this.initCkEditor("productReviewSandbox_intro_text");
    sandboxIntroTextEditor = CKEDITOR.instances.productReviewSandbox_intro_text;
    allEditors.push(sandboxIntroTextEditor);

    // Product Review Republish
    this.initCkEditor("productReviewRepublish_intro_text");
    republishIntroTextEditor =
      CKEDITOR.instances.productReviewRepublish_intro_text;
    allEditors.push(republishIntroTextEditor);

    // Article FAQ
    //if (!CKEDITOR.instances.article_faq) {
    this.initCkEditor("article_faq");
    //}
    faqEditor = CKEDITOR.instances.article_faq;
    allEditors.push(faqEditor);

    // Product Review Text
    //if(!CKEDITOR.instances.product_review_text) {
    this.initCkEditor("product_review_text");
    prodRevReviewText = CKEDITOR.instances.product_review_text;
    //}
    allEditors.push(prodRevReviewText);

    // Image Description Editor
    this.initCkEditor("image_description");
    imageDescriptionEditor = CKEDITOR.instances.image_description;
    allEditors.push(imageDescriptionEditor);

    // Image Caption Editor
    this.initCkEditor("image_caption");
    imageCaptionEditor = CKEDITOR.instances.image_caption;
    allEditors.push(imageCaptionEditor);

    // Gallery Description
    this.initCkEditor("gallery_description");
    galleryDescriptionEditor = CKEDITOR.instances.gallery_description;
    allEditors.push(galleryDescriptionEditor);


    //Gallery credit text
    this.initCkEditor("gallery_credit_text");
    galleryCreditTextEditor = CKEDITOR.instances.gallery_credit_text;
    allEditors.push(galleryCreditTextEditor);

    let that = this;

    this.initCkEditor("bulk_image_description");
    bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;
    bulkImageDescriptionEditor.on("change", function () {
      that.articlesEdit.imagePicker.imagesBulkEdit
        .getTemplateViewModel()
        .description(this.getData());
    });
    allEditors.push(bulkImageDescriptionEditor);

    this.initCkEditor("bulk_image_caption");

    bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;
    bulkImageCaptionEditor.on("change", function () {
      that.articlesEdit.imagePicker.imagesBulkEdit
        .getTemplateViewModel()
        .caption(this.getData());
    });
    allEditors.push(bulkImageCaptionEditor);

    this.initCkEditorDisabled("aiThreadSummary", true);
    threadSummaryEditor = CKEDITOR.instances.aiThreadSummary;
    threadSummaryEditor.on("change", function () {
      that.articlesEdit.getTemplateViewModel().parsedAiThreadSummary(this.getData());
    });
    allEditors.push(threadSummaryEditor);

    this.initCkEditorDisabled("factualSummary", false);
    factualSummaryEditor = CKEDITOR.instances.factualSummary;
    factualSummaryEditor.on("change", function () {
      that.articlesEdit.getTemplateViewModel().factualSummary(this.getData());
    });

    allEditors.push(factualSummaryEditor);
    this.initCkEditorDisabled("simpleSummary", false);
    simpleSummaryEditor = CKEDITOR.instances.simpleSummary;
    simpleSummaryEditor.on("change", function () {
      that.articlesEdit.getTemplateViewModel().simpleSummary(this.getData());
    });
    allEditors.push(simpleSummaryEditor);

    this.initCkEditorDisabled("satiricalCommentary", false);
    satiricalCommentaryEditor = CKEDITOR.instances.satiricalCommentary;
    satiricalCommentaryEditor.on("change", function () {
      that.articlesEdit.getTemplateViewModel().satiricalCommentary(this.getData());
    });
    allEditors.push(satiricalCommentaryEditor);

    // this.initializeSummariesCKEditor("factualSummary");
    // Adds comments to specified editors
    //this.addLinkToolCommand(allEditors);
    this.addImagePickerCommand(allEditors);
    this.addEmbedBlockCommand(allEditors);
    this.addClassMaximize([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
    ]);
    this.addFocusHandler([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
    ]);
    this.addUpdateBlockCommand([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
      faqEditor,
      prodRevReviewText,
      imageDescriptionEditor,
      imageCaptionEditor,
      galleryDescriptionEditor,
      bulkImageDescriptionEditor,
      bulkImageCaptionEditor,
      galleryCreditTextEditor,
    ]);
    this.addTwoColumnCommand([
      contentEditor,
      introTextEditor,
      sandboxEditor,
      sandboxIntroTextEditor,
      republishEditor,
      republishIntroTextEditor,
      faqEditor,
      prodRevReviewText,
      imageDescriptionEditor,
      imageCaptionEditor,
      galleryDescriptionEditor,
      bulkImageDescriptionEditor,
      bulkImageCaptionEditor,
      galleryCreditTextEditor,
    ]);
    this.addOnClickContentHandler([
      contentEditor,
      sandboxEditor,
      republishEditor,
      faqEditor,
    ]);
    this.addArticlePickerCommand([
      contentEditor,
      sandboxEditor,
      republishEditor,
    ]);
    this.addTagPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addQuizPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addPollPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addVignettePickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addSensaiVaultCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addVideoPickerCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addAIKeyPointsCommand([contentEditor, sandboxEditor, republishEditor]);
    this.addDeleteElementCommand([
      contentEditor,
      sandboxEditor,
      republishEditor,
    ]);
    this.addQuicklinksCommandCKEditor([contentEditor, sandboxEditor, republishEditor]);
    //this.addAIContentCommand([ contentEditor ]);

    this.articlesEdit.initTagPickerCkEditors();

    /**
     * Enhanced find utility for CKEditor 4 that finds and selects text without popup
     */
    this.CKE4Finder = {
      lastMatchRange: null,
      allMatches: [],
      currentMatchIndex: -1,
      searchText: '',

      find: function(editor, searchText, direction = 'next') {
        console.log('=== CKE4Finder.find() called ===');
        console.log('Search text:', searchText);
        console.log('Direction:', direction);
        console.log('Current searchText:', this.searchText);
        console.log('Current allMatches.length:', this.allMatches.length);
        console.log('Current currentMatchIndex:', this.currentMatchIndex);

        // Reset if this is a new search
        if (this.searchText !== searchText) {
            console.log('New search detected - resetting state');
            this.searchText = searchText;
            this.lastMatchRange = null;
            this.allMatches = [];
            this.currentMatchIndex = -1;
        }

        if (!searchText || !editor) {
            console.log('Early return: missing searchText or editor');
            if(editor.getSelection()) {
              editor.getSelection().removeAllRanges();
            }
            return false;
        }

        // If we haven't found all matches yet, find them all
        if (this.allMatches.length === 0) {
            console.log('Finding all matches...');
            this.findAllMatches(editor, searchText);
            console.log('Found', this.allMatches.length, 'matches');
            // Set the starting position based on direction
            if (direction === 'previous') {
                console.log('Setting position for previous direction');
                this.setCurrentMatchFromPositionForPrevious(editor);
            } else {
                console.log('Setting position for next direction');
                this.setCurrentMatchFromPosition(editor);
            }
            console.log('Initial currentMatchIndex set to:', this.currentMatchIndex);
        }

        if (this.allMatches.length === 0) {
            console.log('No matches found');
            return false;
        }

        // Handle wraparound - only increment/decrement if we're continuing from a previous search
        // For the first search, we want to use the index set by setCurrentMatchFromPosition
        const isFirstSearch = this.lastMatchRange === null;

        if (!isFirstSearch) {
            if (direction === 'next') {
                console.log('Direction: next - incrementing currentMatchIndex from', this.currentMatchIndex);
                this.currentMatchIndex++;
                console.log('After increment, currentMatchIndex is:', this.currentMatchIndex);
                if (this.currentMatchIndex >= this.allMatches.length) {
                    console.log('Wrapping to beginning');
                    // Refresh matches when wrapping to handle dynamic content changes
                    this.findAllMatches(editor, searchText);
                    // When wrapping from end to beginning, start from index 0
                    this.currentMatchIndex = 0;
                }
            } else if (direction === 'previous') {
                console.log('Direction: previous - decrementing currentMatchIndex from', this.currentMatchIndex);
                this.currentMatchIndex--;
                console.log('After decrement, currentMatchIndex is:', this.currentMatchIndex);
                if (this.currentMatchIndex < 0) {
                    console.log('Wrapping to end');
                    // Refresh matches when wrapping to handle dynamic content changes
                    this.findAllMatches(editor, searchText);
                    // When wrapping from beginning to end, start from last index
                    this.currentMatchIndex = this.allMatches.length - 1;
                }
            }
        } else {
            console.log('First search - using index from setCurrentMatchFromPosition:', this.currentMatchIndex);
        }

        console.log('Final currentMatchIndex:', this.currentMatchIndex);
        // Select the current match
        const match = this.allMatches[this.currentMatchIndex];
        if (!match) {
          console.error('No match found at index', this.currentMatchIndex, 'out of', this.allMatches.length, 'matches');
          return false;
        }
        //console.log('Selecting match:', match);
        this.selectMatch(editor, match);

        return true;
      },

      findAllMatches: function(editor, searchText) {
        this.allMatches = [];
        const lowerCaseSearchText = searchText.toLowerCase();
        if (!lowerCaseSearchText) return;

        // --- Step 1: Build a plain text version of the content and a character map ---
        let plainText = '';
        const charMap = []; // This map links each char in plainText to its DOM node and offset

        const body = editor.editable();
        const searchScopeRange = editor.createRange();
        searchScopeRange.selectNodeContents(body);
        const walker = new CKEDITOR.dom.walker(searchScopeRange);
        let textNode;

        while ((textNode = walker.next())) {
            if (textNode.type === CKEDITOR.NODE_TEXT) {
                if (this.isInsideContentEditableFalse(textNode)) {
                    continue;
                }
                const nodeText = textNode.getText();
                for (let i = 0; i < nodeText.length; i++) {
                    // For each character, store its source node and its offset within that node
                    charMap.push({ node: textNode, offset: i });
                    plainText += nodeText[i];
                }
            }
        }

        const lowerCasePlainText = plainText.toLowerCase();

        // --- Step 2: Search the plain text and use the map to create match ranges ---
        let startIndex = 0;
        let matchIndex;

        while ((matchIndex = lowerCasePlainText.indexOf(lowerCaseSearchText, startIndex)) !== -1) {
            const endIndex = matchIndex + lowerCaseSearchText.length - 1;

            // Ensure the match is valid and within the bounds of our map
            if (charMap[matchIndex] && charMap[endIndex]) {
                const startMarker = charMap[matchIndex];
                const endMarker = charMap[endIndex];

                // Create a match object with the precise start and end points in the DOM
                this.allMatches.push({
                    startNode: startMarker.node,
                    startOffset: startMarker.offset,
                    endNode: endMarker.node,
                    // The end offset for a range is *after* the last character
                    endOffset: endMarker.offset + 1,
                });
            }

            startIndex = matchIndex + 1;
        }
      },

      setCurrentMatchFromPosition: function(editor) {
        const currentSelection = editor.getSelection();
        const currentRanges = currentSelection ? currentSelection.getRanges() : [];

        console.log('=== setCurrentMatchFromPosition DEBUG ===');
        console.log('Total matches found:', this.allMatches.length);
        console.log('Current ranges length:', currentRanges.length);

        if (this.allMatches.length === 0) {
            this.currentMatchIndex = -1;
            return;
        }

        // If no selection, start from the first match
        if (currentRanges.length === 0) {
            console.log('No selection - starting from first match (index 0)');
            this.currentMatchIndex = 0;
            return;
        }

        const currentRange = currentRanges[0];
        const currentPosition = this.getPositionFromRange(currentRange);

        // Find the first match that comes after the current position
        let bestMatchIndex = -1;
        for (let i = 0; i < this.allMatches.length; i++) {
            const match = this.allMatches[i];
            const matchPosition = this.getPositionFromMatch(match);

            const isAfter = this.isPositionAfter(matchPosition, currentPosition);

            if (isAfter) {
                bestMatchIndex = i;
                console.log(`  -> Found first match after current position at index ${i}`);
                break;
            }
        }

        // Set the index to the match we want to select next
        // If we found a match after current position, use it
        // If no match found after current position, start from beginning (index 0)
        this.currentMatchIndex = bestMatchIndex >= 0 ? bestMatchIndex : 0;
      },

      setCurrentMatchFromPositionForPrevious: function(editor) {
        const currentSelection = editor.getSelection();
        const currentRanges = currentSelection ? currentSelection.getRanges() : [];

        if (currentRanges.length === 0 || this.allMatches.length === 0) {
            this.currentMatchIndex = -1;
            return;
        }

        const currentRange = currentRanges[0];
        const currentPosition = this.getPositionFromRange(currentRange);

        // Find the last match that comes before the current position
        let bestMatchIndex = -1;
        for (let i = this.allMatches.length - 1; i >= 0; i--) {
            const match = this.allMatches[i];
            const matchPosition = this.getPositionFromMatch(match);

            if (this.isPositionAfter(currentPosition, matchPosition)) {
                bestMatchIndex = i;
                break;
            }
        }

        // Set the index to the match we want to select next
        // If we found a match before current position, use it
        // If no match found before current position, start from end (last index)
        this.currentMatchIndex = bestMatchIndex >= 0 ? bestMatchIndex : this.allMatches.length - 1;
      },

      getPositionFromRange: function(range) {
        // Return the range itself for proper comparison
        return range;
      },

      getPositionFromMatch: function(match) {
        const editor = CKEDITOR.instances[Object.keys(CKEDITOR.instances)[0]];
        const matchRange = editor.createRange();
        // Use the new properties here as well
        matchRange.setStart(match.startNode, match.startOffset);
        matchRange.setEnd(match.endNode, match.endOffset);
        return matchRange;
      },

      isPositionAfter: function(range1, range2) {
        // Use CKEditor's built-in range comparison
        try {
          const result = range1.compareBoundaryPoints(CKEDITOR.POSITION_FOLLOWING, range2);
          return result;
        } catch (e) {
      // Fallback to simple comparison if CKEditor method fails
          return false;
        }
      },

      isInsideContentEditableFalse: function(textNode) {
        // Walk up the DOM tree to check if any parent has contenteditable="false"
        let element = textNode.getParent();
        while (element) {
            if (element.getAttribute && element.getAttribute('contenteditable') === 'false') {
                return true;
            }
            element = element.getParent();
        }
        return false;
      },

      selectMatch: function(editor, match) {
        if (!match || !match.startNode) {
          console.error('Invalid match object passed to selectMatch:', match);
          return;
        }

        const matchRange = editor.createRange();
        matchRange.setStart(match.startNode, match.startOffset);
        matchRange.setEnd(match.endNode, match.endOffset);

        const selection = editor.getSelection();
        if (selection) {
          // This sets the correct selection.
          selection.selectRanges([matchRange]);
        }

        editor.focus();

        setTimeout(() => {
            try {
                // Get the editor's main scrollable container
                const containerElement = editor.container.$;
                const rangeRects = matchRange.getClientRects();

                if (!rangeRects || rangeRects.length === 0) {
                    return; // Can't scroll to something that doesn't exist
                }

                const selectionRect = rangeRects[0]; // Position of the highlighted text
                const containerRect = containerElement.getBoundingClientRect(); // Position of the editor itself

                // 1. Check if the selection is already visible
                if (selectionRect.top >= containerRect.top && selectionRect.bottom <= containerRect.bottom) {
                    return; // No need to scroll
                }

                // 2. Calculate where to scroll to center the selection in the editor
                const selectionCenter = selectionRect.top + (selectionRect.height / 2);
                const containerCenter = containerRect.top + (containerRect.height / 2);
                const scrollBy = selectionCenter - containerCenter;

                // 3. Perform the scroll
                containerElement.scrollTop += scrollBy;

            } catch (e) {
                console.error("Error during manual scroll:", e);
            }
        }, 50); // A small delay allows the editor to render the selection first

        this.lastMatchRange = matchRange;
      },

      selectMatchOld: function(editor, match) {
        // Safety check for match parameter
        if (!match || !match.textNode) {
          console.error('Invalid match object passed to selectMatch:', match);
          return;
        }


        // Create a precise range for just the text we want
        const matchRange = editor.createRange();
        matchRange.setStart(match.textNode, match.startIndex);
        matchRange.setEnd(match.textNode, match.endIndex);

        // Clear any existing selections
        if(editor.getSelection()) {
          editor.getSelection().removeAllRanges();
        }

        // Use CKEditor's native selection method to avoid auto-expansion
        const selection = editor.getSelection();
        if(selection) {
          selection.selectRanges([matchRange]);
        }
        // Force the selection to be exactly what we want
        const selectedRanges = selection ? selection.getRanges() : [];
        if (selectedRanges.length > 0) {
            const actualRange = selectedRanges[0];
            // Check if the actual selection matches what we wanted
            try {
                const actualText = actualRange.getText();
                if (actualText !== match.matchedText) {
                    // If CKEditor expanded the selection, try to shrink it back
                    try {
                        actualRange.shrink(CKEDITOR.SHRINK_TEXT, false);
                        selection.selectRanges([actualRange]);
                    } catch (e) {
                        // If that fails, try a different approach
                        const newRange = editor.createRange();
                        newRange.setStart(match.textNode, match.startIndex);
                        newRange.setEnd(match.textNode, match.endIndex);
                        selection.selectRanges([newRange]);
                    }
                }
            } catch (e) {
                // Do nothing - the selection is already correct
            }
        }

        editor.focus();

        // Manual scroll method for CKEditor (avoiding scrollIntoView which can expand selection)
        setTimeout(() => {
            try {
                const editorElement = editor.container;
                const editorRect = editorElement.getBoundingClientRect();
                const selectionRect = matchRange.getClientRects()[0];

                if (selectionRect) {
                    const editorScrollTop = editorElement.scrollTop;
                    const selectionTop = selectionRect.top - editorRect.top + editorScrollTop;
                    const editorHeight = editorRect.height;

                    // Center the selection in the viewport
                    const targetScrollTop = selectionTop - (editorHeight / 2);
                    editorElement.scrollTop = Math.max(0, targetScrollTop);
                }
            } catch (e) {
                // Ignore scroll errors
            }
        }, 50);

        this.lastMatchRange = matchRange;
      },

      // Convenience methods for external use
      findNext: function(editor, searchText) {
        return this.find(editor, searchText, 'next');
      },

      findPrevious: function(editor, searchText) {
        return this.find(editor, searchText, 'previous');
      },

      getCount: function(editor, searchText) {
        if (!searchText || !editor) {
            return 0;
        }

        // 1. Get the raw HTML content from the editor.
        const editorHtml = editor.getData();

        // 2. Convert the HTML to a plain text string.
        // This is the most reliable way to strip all tags and get text content
        // that accurately reflects what the user sees, including spacing for block elements.
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = editorHtml;
        const editorText = tempDiv.innerText || tempDiv.textContent || '';

        // 3. Normalize both strings to lower case for a case-insensitive search.
        const lowerCaseEditorText = editorText.toLowerCase();
        const lowerCaseSearchText = searchText.toLowerCase();

        if (lowerCaseSearchText.length === 0) {
            return 0;
        }

        // 4. Count all non-overlapping occurrences of the search text.
        let matchCount = 0;
        let startIndex = 0;
        let matchIndex;

        while ((matchIndex = lowerCaseEditorText.indexOf(lowerCaseSearchText, startIndex)) !== -1) {
            matchCount++;
            // Move the starting point to after the found match to find the next one.
            startIndex = matchIndex + lowerCaseSearchText.length;
        }

        return matchCount;
    },

    decodeHtmlEntities: function(text) {
      // Create a temporary div element to decode HTML entities
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      return tempDiv.textContent || tempDiv.innerText || '';
    },

    stripHtmlTags: function(text) {
      // Create a temporary div element to strip HTML tags
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      return tempDiv.textContent || tempDiv.innerText || '';
    }
  };

  }


  protected handleSelectionChange(evt) {
    if (!evt || !evt.editor) {
      this.articlesEdit.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled(false);
      return;
    }

    this.updateChatButtons(evt.editor);

    const selection = evt.editor.getSelection();

    if (!selection) {
      this.articlesEdit.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled(false);
      return;
    }

    const selectedText = selection.getSelectedText();
    const trimmedText = selectedText ? selectedText.trim() : '';

    this.articlesEdit.getTemplateViewModel().aiPromptSelectedTextIncludedEnabled(trimmedText.length > 0);

  }

  protected updateChatButtons(editor) {

    // Add safety check
    let chatHistoryEl = document.getElementById("title-analysis-content");
    if (!chatHistoryEl) {
      //console.log("title-analysis-content element not found");
      return;
    }

    let autoLinkingButtons = this.getAllAutoLinkingButtons(chatHistoryEl);
    //console.log("Found auto-linking buttons:", autoLinkingButtons.length);

    const selection = editor.getSelection();
    const selectedText = selection ? selection.getSelectedText() : '';
    const ranges = selection ? selection.getRanges() : [];

    //console.log("Selected text:", selectedText);
    //console.log("Ranges length:", ranges.length);

    let shouldEnable = false;

    if (selectedText && selectedText.trim() !== '' && ranges.length > 0) {
      const range = ranges[0];
      const isInsideLink = this.isInsideHyperlink(range);
      //console.log("Is inside hyperlink:", isInsideLink);
      shouldEnable = !isInsideLink;
    }

    //console.log("Should enable buttons:", shouldEnable);

    autoLinkingButtons.forEach((btn: HTMLButtonElement) => {
      btn.disabled = !shouldEnable;
    });

    const listItemsWithHasInsert = chatHistoryEl.querySelectorAll('li.has-insert');

    let _myThis = this;

    listItemsWithHasInsert.forEach((li: HTMLElement) => {
      const titleSpan = li.querySelector('.title');
      const textToFind = li.getAttribute('data-text');
      const searchButtonContainer = li.querySelector('.insert-search-btn');

      if(titleSpan && textToFind && searchButtonContainer){
        // Use the CKE4Finder's getCount to count matches without affecting find behavior
        if (typeof _myThis.CKE4Finder.getCount === 'function') {
          const matchCount = _myThis.CKE4Finder.getCount(editor, textToFind);

          const countSpan = li.querySelector('.count');

          if(matchCount > 1){
            if(!countSpan){
              const countSpan = document.createElement('span');
              countSpan.classList.add('count');
              countSpan.textContent = ' (' + matchCount.toString() + ')';
              titleSpan.insertBefore(countSpan, titleSpan.firstChild);
            }else{
              countSpan.textContent = ' (' + matchCount.toString() + ')';
            }
            searchButtonContainer.classList.add('search-function');
            searchButtonContainer.innerHTML = '<button class="btn-assistant icon i-dropdown-simple btn-prev" type="button" data-text="' + textToFind + '"></button><button class="btn-assistant icon i-dropdown-simple btn-next" type="button" data-text="' + textToFind + '"></button>';
          }else if(matchCount == 1){
            if(countSpan){
              //remove the count span
              countSpan.remove();
            }
            searchButtonContainer.classList.remove('search-function');
            searchButtonContainer.innerHTML = '<button class="btn-assistant icon i-target btn-find" type="button" data-text="' + textToFind + '"></button>';
          }else{
            if(!countSpan){
              const countSpan = document.createElement('span');
              countSpan.classList.add('count');
              countSpan.textContent = ' (' + matchCount.toString() + ')';
              titleSpan.insertBefore(countSpan, titleSpan.firstChild);
            }else{
              countSpan.textContent = ' (' + matchCount.toString() + ')';
            }
            searchButtonContainer.classList.remove('search-function');
            searchButtonContainer.innerHTML = "";
          }
        }
      }

    });

    this.attachChatEventListeners(chatHistoryEl);

  }

  protected minimizeSideNav() {

    document
      .getElementsByClassName("btn-sidebar")[0]
      .classList.add("is-closed");
    document.getElementsByClassName("sidenav")[0].classList.add("is-closed");
    document.getElementsByClassName("sidenav")[0].classList.add("is-desable");
    document
      .getElementsByClassName("main-header")[0]
      .classList.add("is-desable");
    document.getElementById("closedHeader").classList.add("is-closed");
    document.getElementById("header").classList.add("is-closed");
    document.getElementById("closedContent").classList.add("is-closed");

    document
      .getElementsByClassName("btn-sidebar")[0]
      .classList.add("is-disabled");
  }

  protected maximizeSideNav() {
    document
      .getElementsByClassName("btn-sidebar")[0]
      .classList.remove("is-closed");
    document.getElementsByClassName("sidenav")[0].classList.remove("is-closed");
    document
      .getElementsByClassName("sidenav")[0]
      .classList.remove("is-desable");
    document
      .getElementsByClassName("main-header")[0]
      .classList.remove("is-desable");
    document.getElementById("closedHeader").classList.remove("is-closed");
    document.getElementById("header").classList.remove("is-closed");
    document.getElementById("closedContent").classList.remove("is-closed");
    document
      .getElementsByClassName("btn-sidebar")[0]
      .classList.remove("is-disabled");
  }

  protected addClassMaximize(editors) {
    editors.forEach(function (editor) {
      editor.on("maximize", function (evt) {
        if (evt.data === CKEDITOR.TRISTATE_ON) {
          document
            .getElementsByClassName("form-side-header")[0]
            .classList.add("editor-maximized");
        } else if (evt.data === CKEDITOR.TRISTATE_OFF) {
          document
            .getElementsByClassName("form-side-header")[0]
            .classList.remove("editor-maximized");
        }
      });
    });
  }


  protected addFocusHandler(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      editor.on("focus", function (e) {
        if (e.editor.name == "article_sandbox") {
          _myThis.setIsSandboxContentAvailable(true);
        }

        if (_myThis.isSaveAndStay) {
          _myThis.isSaveAndStay = false;
        }

        _myThis.startAutosave(e.editor.name);

        e.removeListener();
      });
    });
  }

  protected startAutosave(callerName) {
    if (callerName != null) {
      let _myThis = this;
      _myThis.articlesEdit.showAutoSaveMessage(
        "Autosave timer initiated by " + callerName + "."
      );
      console.log(
        "startAutosave timer called. Last saved: " +
        Math.round(
          (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
        )
      );

      console.log("lastUpdateTimer: ", _myThis.lastUpdatedTimer);
      console.log("recoveryTimeout: ", _myThis.recoveryTimeout);

      // initialize lastsaved time
      if (
        typeof _myThis.lastUpdatedTimer === "undefined" ||
        _myThis.lastUpdatedTimer === null
      ) {
        console.log("Initializing lastsaved timer display");
        _myThis.lastUpdatedTimer = setInterval(function () {
          _myThis.displayLastSavedTime();
        }, 5050);
      }

      // set the lastSaved time (even though it wasn't actually saved yet, this is the first time content changed).
      // _myThis.lastSaved = new Date((Date.now()));

      if (
        typeof _myThis.recoveryTimeout === "undefined" ||
        _myThis.recoveryTimeout === null
      ) {
        console.log(
          "Initializing Saving recovery in " +
          _myThis.recoveryDelay +
          " seconds"
        );
        // Capture the current article ID to verify it hasn't changed when timer fires
        const currentArticleId = _myThis.articlesEdit.getId();
        _myThis.recoveryTimeout = setTimeout(function () {
          // Verify we're still on the same article before autosaving
          if (_myThis.articlesEdit.getId() !== currentArticleId) {
            console.log(
              "Article ID changed from " + currentArticleId + " to " +
              _myThis.articlesEdit.getId() + ", aborting autosave"
            );
            return;
          }
          console.log(
            "Autosaving (automatic timer - originally called by " +
            callerName +
            ")"
          );
          _myThis.save_recovery("automatic");
        }, _myThis.recoveryDelay * 1000);
      }

      // initialize autosave warning if not saved within a specific time period.
      //set timer to save the recovery of content

      console.log("Checking recoveryWarning: ", _myThis.recoveryWarning);
      if (
        typeof _myThis.recoveryWarning === "undefined" ||
        _myThis.recoveryWarning === null
      ) {
        console.log("Initialing recovery warning timer.");
        let timeLastSaved = Math.round(
          (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
        );

        let recoveryWarningTimeout = _myThis.recoveryWarningTimeout;
        // augment recovery warning time by amount since last saved. This extends the warning on the first save request
        recoveryWarningTimeout = recoveryWarningTimeout + timeLastSaved;

        _myThis.recoveryWarning = setInterval(function () {
          // todo: check to see if we are still on edit route?
          let timeSinceRecovery = Math.round(
            (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
          );
          console.log(
            "Last saved time: " +
            Math.round(
              (new Date().getTime() - _myThis.lastSaved.getTime()) / 1000
            )
          );
          console.log(
            "Time since last save: " +
            timeSinceRecovery +
            " Warning at: " +
            recoveryWarningTimeout
          );

          if (
            _myThis.hasLastSuccessfulAutosave &&
            recoveryWarningTimeout > _myThis.recoveryWarningTimeout
          ) {
            // reset to regular warning timeout after first/any save
            recoveryWarningTimeout = _myThis.recoveryWarningTimeout;
          }

          _myThis.displayLastSavedTime();

          if (
            timeSinceRecovery > recoveryWarningTimeout &&
            _myThis.recoveryWarningShown === false
          ) {
            console.log("Time since auto save is too long");

            _myThis.articlesEdit.setNoticeMessage(
              "\nYour work hasn't been autosaved in " +
              Math.floor(timeSinceRecovery / 60) +
              " minutes. In order to prevent content loss we recommend that you backup your article content and attempt to save your work manually. \n"
            );
            _myThis.articlesEdit.setIsNoticeVisible(true);
            _myThis.articlesEdit.showAutoSaveMessage(
              "Too long since auto save. Save post manually."
            );
            _myThis.articlesEdit.enableAutosaveBox();
            _myThis.recoveryWarningShown = true;
          }
        }, 55000); // checks every 60-ish seconds
      }
    }
  }

  protected getEditor(target) {
    let editor = null;
    switch (target) {
      case "article_content":
        editor = contentEditor;
        break;
      case "article_intro":
        editor = introTextEditor;
        break;
      case "article_sandbox":
        editor = sandboxEditor;
        break;
      case "article_faq":
        editor = faqEditor;
        break;
      case "article_directory_item_description":
        editor = articleDirectoryItemDescriptionEditor;
        break;
      case "sandbox_directory_item_description":
        editor = sandboxDirectoryItemDescriptionEditor;
        break;
      case "article_republish":
        editor = republishEditor;
        break;
      case "republish_directory_item_description":
        editor = republishDirectoryItemDescriptionEditor;
        break;
      case "featuredTag":
        editor = target;
    }

    return editor;
  }

  protected insertTagElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    let editor = this.getEditor(target);

    //set cursor position to end of current selection - to insert tag after elements
    if (editor != null) {
      if (editor == "featuredTag") {
        //set the featured tag
        //et newData = {"name": element.name, "image":}
        element.isVersusStyle = this.articlesEdit.getIsVersusStyle();
        this.articlesEdit.setFeaturedTags(element);
      } else {
        let range = null;
        let selectionElement = editor.getSelection().getStartElement();

        if (
          selectionElement != null &&
          selectionElement.$ &&
          selectionElement.$.nodeName != "BODY" &&
          selectionElement.$.nodeName != "TD" &&
          selectionElement.getParent() != null
        ) {
          range = editor.createRange();
          range.setStartAt(selectionElement, CKEDITOR.POSITION_AFTER_END);
          range.collapse(true);
        } else if (selectionElement == null) {
          range = editor.createRange();
          range.moveToElementEditEnd(range.root);
        }
        editor.insertHtml(element, "html", range);
      }
    }
  }

  protected insertTagHyperlinkElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    let editor = this.getEditor(target);
    if (editor != null) {
      this.insertTag(element, editor);
    }
  }

    protected insertQuizElement(elementToReplace, element, target) {
        const insertToken = this.getQuizInsertToken(element);

        if (elementToReplace != null && elementToReplace.parentElement != null) {
            elementToReplace.parentElement.removeChild(elementToReplace);
        }

        let editor = this.getEditor(target);
        if (editor != null) {
            this.insertTag(element, editor);
            this.removeDuplicateInsertedQuizElements(editor, insertToken);
        }
    }

    private getQuizInsertToken(element: string): string | null {
      const template = document.createElement("template");
      template.innerHTML = element.trim();
      const quizElement = template.content.firstElementChild as HTMLElement | null;
      return quizElement ? quizElement.getAttribute("data-quiz-insert-token") : null;
    }

    private removeDuplicateInsertedQuizElements(editor, insertToken: string | null): void {
      if (!insertToken || !editor || !editor.document) {
        return;
      }

      const editorBody: HTMLElement = editor.document.getBody().$;
      const insertedQuiz = editorBody.querySelector(`[data-quiz-insert-token="${insertToken}"]`) as HTMLElement | null;
      if (!insertedQuiz) {
        return;
      }

      const quizId = insertedQuiz.getAttribute("data-id");
      if (quizId) {
        const quizElements = editorBody.querySelectorAll(`[data-widget-injection="quiz"][data-id="${quizId}"]`);
        quizElements.forEach((quizElement: HTMLElement) => {
          if (quizElement !== insertedQuiz) {
            quizElement.remove();
          }
        });
      }

      insertedQuiz.removeAttribute("data-quiz-insert-token");
    }

  protected editTagElement(element, editor) {
    let tagInsertedFields =
      this.articlesEdit.getTagElementInsertedFieldsInOrder(element);
    this.articlesEdit.setTagGroupTagElements([tagInsertedFields]);
    this.getTag(tagInsertedFields.id);

    this.articlesEdit.editTagElement(element, editor);
  }

  protected editTagGroupElement(element, editor) {
    let tagIds = [];
    let tagGroupFieldsInserted = [];
    for (let child of element.childNodes) {
      if (
        child.nodeName == "DIV" &&
        child.className &&
        child.className.includes("emaki-displayCard") &&
        child.className.includes("tag")
      ) {
        let tagInsertedFields =
          this.articlesEdit.getTagElementInsertedFieldsInOrder(child);
        if (tagInsertedFields.id != null) {
          tagIds.push(tagInsertedFields.id);
          tagGroupFieldsInserted.push(tagInsertedFields);
        }
      }
    }

    this.articlesEdit.setTagGroupTagElements(tagGroupFieldsInserted);

    if (tagIds.length == 1) {
      this.getTags(tagIds);
      this.articlesEdit.editTagElement(element, editor);
    } else if (tagIds.length > 1) {
      this.getTags(tagIds);
      this.articlesEdit.editTagGroup(element, editor);
    }
  }

  protected editVideoCardElement(element, editorName) {
    let videoId = element.dataset.id;
    this.articlesEdit.showVideoPicker(editorName, "in-content");
    this.getVideo(videoId);
    this.articlesEdit.videoPickerHelper.setVideoCardElement(element);
  }

  protected editArticleElement(element, target) {
    this.articlesEdit.editArticleElement(element, target);
  }

  protected editArticleGroupElement(element, target) {
    let articleIds = [];
    let articleGroupFieldsInserted = [];
    for (let child of element.childNodes) {
      if (
        child.nodeName == "DIV" &&
        child.classList.contains("emaki-displayCard") &&
        child.classList.contains("article")
      ) {
        let idArticle = child.getAttribute("data-id");
        if (idArticle != null) {
          articleIds.push(idArticle);
          articleGroupFieldsInserted.push({ id: idArticle });
        }
      }
    }
    this.articlesEdit.setArticleGroupArticleElements(articleGroupFieldsInserted);
    if (articleIds.length >= 1) {
      this.articlesEdit.editArticleGroup(element, target);
      this.articlesEdit.articlePickerHelper.getArticlesByIds(articleIds);
    }
  }

  protected editVignetteElement(element, target) {
    this.articlesEdit.editVignetteElement(element, target);
  }

  protected addOnClickContentHandler(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      editor.on("pluginsLoaded", function (event) {
        editor.on("contentDom", function () {
          var editable = editor.editable();
          editable.attachListener(
            editable,
            "click",
            function (evt) {
              let target = evt.data.getTarget();
              let el = target.$;
              _myThis.onClickCkEditorElement(el, editor);
            },
            null,
            null,
            10
          );
          /*if(editor.name == "article_content"){
                        _myThis.updateKeyPointsButton(_myThis.keyPointsAttempts);
                    }*/
        });
      });
    });
  }

  public onClickCkEditorElement(element, editor, isSensaiChat = false) {

    let editorName = editor.name;
    // Ignore clicks on CKEditor widget mask overlays (non-editable), e.g., images with classes "cke_reset cke_widget_mask"
    try {
      const el = element as HTMLElement;
      const isMaskSelf = el && el.classList && el.classList.contains('cke_widget_mask') && el.classList.contains('cke_reset');
      const maskAncestor = el && el.closest ? el.closest('.cke_widget_mask') as HTMLElement | null : null;
      const isMasked = isMaskSelf || (maskAncestor && maskAncestor.classList.contains('cke_reset'));
      if (isMasked) {
        return;
      }
        // tslint:disable-next-line:no-empty
    } catch (_) {}

    // Ignore clicks on CKEditor drag handler overlays (non-editable), e.g., images with classes "cke_reset cke_widget_drag_handler"
    try {
      const el = element as HTMLElement;
      const isDragSelf = el && el.classList && el.classList.contains('cke_widget_drag_handler') && el.classList.contains('cke_reset');
      const dragAncestor = el && el.closest ? el.closest('.cke_widget_drag_handler') as HTMLElement | null : null;
      const isDragHandled = isDragSelf || (dragAncestor && dragAncestor.classList.contains('cke_reset'));
      if (isDragHandled) {
        return;
      }
        // tslint:disable-next-line:no-empty
    } catch (_) {}

    if (editorName === 'article_content' || editorName === 'article_sandbox' || editorName === 'article_republish') {
      this.clearIndicatorMarkers(editor);
    }

    if (isSensaiChat) {
      this.isSensaiChat = true;
    }
    //handle tag
    let foundTag = false;
    let foundGroup = false;
    let foundVideo = false;
    let foundValnetMapPreviewImage = false;

    let tagDisplayCard = this.isTagDisplayCard(element);
    let articleDisplayCard = this.isArticleDisplayCard(element);
    let vignetteDisplayCard = this.isVignetteDisplayCard(element);
    let pollDisplayCard = this.isPollDisplayCard(element);
    let quizDisplayCard = this.isQuizDisplayCard(element);
    foundValnetMapPreviewImage = this.isValnetMapPreviewImage(element);

    if (articleDisplayCard != null && articleDisplayCard.isGroupArticle) {
      element = articleDisplayCard.element;
      this.editArticleGroupElement(element, editorName);
      return;
    }

    if (articleDisplayCard != null && articleDisplayCard.isSingleArticle) {
      if (articleDisplayCard.isHyperlink) {
        element = articleDisplayCard.element;
        this.editArticleElement(element, editorName);
        return;
      }
      element = articleDisplayCard.element;
      this.editArticleElement(element, editorName);
      return;
    }

    if (vignetteDisplayCard != null && vignetteDisplayCard.isVignetteDisplayCard) {
      element = vignetteDisplayCard.element;
      this.editVignetteElement(element, editorName);
      return;
    }

    if (pollDisplayCard != null && pollDisplayCard.isPollDisplayCard) {
      element = pollDisplayCard.element;
      this.editPollElement(element, editorName);
      return;
    }

    if (quizDisplayCard != null && quizDisplayCard.isQuizDisplayCard) {
      element = quizDisplayCard.element;
      const quizId = element.getAttribute("data-id");
      if (quizId) {
        this.articlesEdit.showQuizPicker("in-content", editorName, null, element);
        this.getQuizForPicker(quizId);
        return;
      }

      this.articlesEdit.getTemplateViewModel().onClickTab("widgets");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (tagDisplayCard.isSingleTag) {
      foundTag = true;
      element = tagDisplayCard.element;
    }

    if (tagDisplayCard.isGroupTag) {
      element = tagDisplayCard.element;
      foundGroup = true;
      foundTag = false;
    }

    if (tagDisplayCard.isVideoCard) {
      foundVideo = true;
      element = tagDisplayCard.element;
    }

    if (this.articlesEdit.isSectionForTagPicker(editorName)) {
      if (!foundGroup && !foundTag) {
        foundGroup = true;
      }
    }

    if (foundGroup) {
      this.editTagGroupElement(element, editorName);
      return;
    }

    if (foundTag) {
      this.editTagElement(element, editorName);
      return;
    }

    if (foundVideo) {
      this.editVideoCardElement(element, editorName);
    }

    if (foundValnetMapPreviewImage) {
      return;
    }

    //handle image
    if (element.nodeName == "IMG") {
      let imgSrc = element.getAttribute("src");
      if (imgSrc.includes('?')) {
        imgSrc = imgSrc.split('?')[0];
      }
      let isMobileOptimized =
        element.getAttribute("data-mobile-optimized") || "false";
      this.articlesEdit.setImagePickerTarget(imgSrc);

      let target = { element: element, editor: editorName };

      this.articlesEdit.showImagePicker("content-select", target.editor);
      this.setImageMode("content-select");

      this.getImage(imgSrc, isMobileOptimized);
    }

    // After all cases, handle indicator toolbar logic
    if (editor.name === 'article_content' || editor.name === 'article_sandbox' || editor.name === 'article_republish') {
      if (this.isExcludedForIndicator(editor, element)) return;

      const topmost = this.getHighestEligibleAncestor(editor, element);
      if (!topmost) return;

      const styleInfo = this.resolveStyleName(topmost);
      if (!styleInfo || !styleInfo.name || styleInfo.name == '') return;
      topmost.setAttribute('data-cke-ma-indicator', '1');
      topmost.setAttribute('data-tag', styleInfo.name || topmost.tagName.toLowerCase());

      // Update dropdowns
      const block = styleInfo.type === 'block' ? (styleInfo.name || '') : '';
      this.updateDropdownSelection(editor, 'Blocks', block);

      // Focus
      try { editor.focus(); } catch { }
    }
  }

  public isTagDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isVideoCard: false,
      isSingleTag: false,
      isHyperlink: false,
      isGroupTag: false,
      element: originalElement,
    };

    while (element) {
      if (
        (element.nodeName == "DIV" &&
          element.classList.contains("emaki-displayCard") &&
          element.classList.contains("tag")) || (element.classList && element.classList.contains("emaki-displayCard") && element.classList.contains("tag"))
      ) {
        elementInfo.isSingleTag = true;
        elementInfo.element = element;
        if (
          element.parentNode.nodeName == "DIV" &&
          element.parentNode.classList.contains("emaki-displayCard-group")
        ) {
          elementInfo.isSingleTag = false;
          elementInfo.isGroupTag = true;
          elementInfo.element = element.parentNode;
          break;
        }
      }

      if (
        element.nodeName === "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("video")
      ) {
        elementInfo.isVideoCard = true;
        elementInfo.element = element;
      }

      if (
        element.nodeName === "SPAN" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("hyperlink")
      ) {
        elementInfo.isSingleTag = true;
        elementInfo.isHyperlink = true;
        elementInfo.element = element;
      }

      element = element.parentNode;
    }

    return elementInfo;
  }

  public isArticleDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isSingleArticle: false,
      isGroupArticle: false,
      isHyperlink: false,
      element: originalElement,
    };

    while (element) {
      if (
        element.nodeName == "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("article")
      ) {
        elementInfo.isSingleArticle = true;
        elementInfo.element = element;
        if (
          element.parentNode &&
          element.parentNode.nodeName == "DIV" &&
          element.parentNode.classList.contains("emaki-displayCard-group") &&
          element.parentNode.classList.contains("article")
        ) {
          elementInfo.isSingleArticle = false;
          elementInfo.isGroupArticle = true;
          elementInfo.element = element.parentNode;
          break;
        }
        break;
      }

      if (
        (element.nodeName == "SPAN" &&
          element.classList.contains("emaki-displayCard") &&
          element.classList.contains("hyperlink-article") &&
          element.classList.contains("hyperlink")) || (element.classList && element.classList.contains("emaki-article-card"))
      ) {
        elementInfo.isSingleArticle = true;
        elementInfo.isHyperlink = true;
        elementInfo.element = element;
        break;
      }

      element = element.parentNode;
    }

    return elementInfo;
  }

  public isVignetteDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isVignetteDisplayCard: false,
      element: originalElement,
    };

    while (element) {
      if (
        element.nodeName == "DIV" &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("vignette")
      ) {
        elementInfo.isVignetteDisplayCard = true;
        elementInfo.element = element;
        break;
      }

      element = element.parentNode;
    }

    return elementInfo;
  }

  public isPollDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isPollDisplayCard: false,
      element: originalElement,
    };

    while (element) {
      if (
        element.nodeName === "DIV" &&
        element.classList &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("poll")
      ) {
        elementInfo.isPollDisplayCard = true;
        elementInfo.element = element;
        break;
      }
      element = element.parentNode;
    }

    return elementInfo;
  }

  public isQuizDisplayCard(element) {
    let originalElement = element;
    let elementInfo = {
      isQuizDisplayCard: false,
      element: originalElement,
    };

    while (element) {
      if (
        element.nodeName === "DIV" &&
        element.classList &&
        element.classList.contains("emaki-displayCard") &&
        element.classList.contains("quiz")
      ) {
        elementInfo.isQuizDisplayCard = true;
        elementInfo.element = element;
        break;
      }
      element = element.parentNode;
    }

    return elementInfo;
  }

  protected async editPollElement(element: HTMLElement, editorName: string) {
    const pollId = element.getAttribute("data-poll-id");
    if (!pollId) {
      return;
    }

    this.articlesEdit.showPollPicker("in-content", editorName, null, element);
    this.getPollForPicker(pollId);
  }

  private isValnetMapPreviewImage(element) {

    if (element.nodeName == "IMG" && element.alt == 'Preview Image') {
      let parentElement = element.parentElement;
      if (parentElement.nodeName == "DIV" && parentElement.classList.contains("emaki-embed") && parentElement.classList.contains("valnet_map")) {
        return true;
      }
    }
  }

  protected getImage(imgSrc, isMobileOptimized = "false") {
    if (this.contentImageXHRHdl) {
      this.contentImageXHRHdl.cancelAndReset();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;

    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/get-content-image/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["imgSrc", imgSrc]);

    formReq_params.push(["isMobileOptimized", isMobileOptimized]);

    this.contentImageXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
    this.contentImageXHRHdl.execute();
  }

  protected getImagePicker() {
    return this.articlesEdit.getImagePicker();
  }

  protected onImageRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let image = responseParsed.image.data[0];
        if (responseParsed.isMobileOptimized) {
          image.isMobileOptimized =
            String(responseParsed.isMobileOptimized).toLowerCase() === "true";
        } else {
          image.isMobileOptimized = false;
        }
        obj.editImage(image, obj.getImageMode());

        obj.articlesEdit.imagePicker.hideLoading();
      });
    };
  }

  protected editImage(image, mode = "") {
    this.articlesEdit.imagePicker.editImage(image, mode);
  }

  protected showImagePicker(image, mode = "", selectedImages) {
    this.articlesEdit.showImagePicker(image, mode, selectedImages);
  }

  protected addImagePickerCommand(editors) {
    let _myThis = this;
    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showEditorImagePicker(editor);
          },
        };
      }

      if (editor && editor.name !== "additional_credit") {

        editor.addCommand("imagePickerCommand", showMyDialog(this));
        editor.ui.addButton("ImgBtn", {
          // add new button and bind our command
          label: "Insert Images",
          command: "imagePickerCommand",
          toolbar: "insert",
          icon: "/node_modules/ckeditor4/plugins/image2/icons/image.png",
        });
      }

    });
  }

  protected addVideoPickerCommand(editors) {
    let that = this;
    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            that.showVideoPicker(editor);
          },
        };
      }

      editor.addCommand("videoPickerCommand", showMyDialog(this));
      editor.ui.addButton("VideoBtn", {
        // add new button and bind our command
        label: "Insert Videos",
        command: "videoPickerCommand",
        toolbar: "insert",
        icon: "/assets/images/video.png",
      });
    });
  }

  protected addTagPickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showTagPicker(editor);
          },
        };
      }

      editor.addCommand("tagPickerCommand", showMyDialog(this));

      editor.ui.addButton("TagBtn", {
        // add new button and bind our command
        label: "Insert Tags",
        command: "tagPickerCommand",
        toolbar: "insert",
        icon: "/assets/images/tag.png",
      });
    });
  }

  protected addQuizPickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showQuizPicker(editor);
          },
        };
      }

      editor.addCommand("quizPickerCommand", showMyDialog(this));
    });
  }

  protected addPollPickerCommand(editors) {
    const _self = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _self.showPollPicker(editor);
          },
        };
      }

      editor.addCommand("pollPickerCommand", showMyDialog(this));

    });
  }

  /**
   * Save/Restore selection for inserting widgets
   */
  protected savedBookmark: any = null;
  protected saveSelection(editor: typeof CKEDITOR.editor) {
    const sel = editor.getSelection();
    if (!sel) return;

    const ranges = sel.getRanges();
    if (!ranges.length) return;

    this.savedBookmark = ranges[0].createBookmark2();
  }
  protected restoreSelection(editor: typeof CKEDITOR.editor) {
    if (!this.savedBookmark) return;

    try {
      editor.focus();
      const range = new CKEDITOR.dom.range(editor.document);
      range.moveToBookmark(this.savedBookmark);

      const sel = editor.getSelection();
      sel.selectRanges([range]);
    } catch (e) {
      // Bookmark is stale, ignore
    } finally {
      this.savedBookmark = null;
    }
  }

  protected getDynamicPlacementDefault(kind: 'poll' | 'quiz'): boolean {
    try {
      const settings = this.articlesEdit.getTemplateViewModel().articlePageSettings();
      if (!settings) return false;
      const key = kind === 'poll' ? 'isPollDynamicPlacementOnByDefault' : 'isQuizDynamicPlacementOnByDefault';
      return !!settings[key];
    } catch (e) {
      return false;
    }
  }

  public insertPollPlaceholder(editorOrName: typeof CKEDITOR.editor | string, data?: PollPickerInsertData, editingElement?: HTMLElement) {
    let editor = typeof editorOrName === "string" ? this.getEditor(editorOrName) : editorOrName;
    if (!editor || !data) return;

    const pollName = String(data.pollName);
    const escapedName = pollName
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

    if (editingElement) {
      // The DOM escapes on serialization, so the raw name belongs here and the escaped one only in
      // the HTML string built below.
      editingElement.textContent = pollName;
      editingElement.setAttribute('data-poll-id', String(data.idPoll));
      editingElement.setAttribute('data-poll-name', pollName);
      editingElement.setAttribute('data-poll-is-with-title', data.isWithTitle ? '1' : '0');
      editingElement.setAttribute('data-dynamic-placement', data.isDynamicPlacement ? '1' : '0');
      // Re-pointing a card at a poll embedded elsewhere keeps this one and drops the other.
      this.removeWidgets(editor, this.getWidgetsById(editor, 'poll', String(data.idPoll)), editingElement);
      return;
    }

    this.insertWidgetPlaceholder(editor, 'poll', this.createWidgetPlaceholder(editor, 'poll', escapedName, {
      'data-poll-id': String(data.idPoll),
      'data-poll-name': escapedName,
      'data-poll-is-with-title': data.isWithTitle ? '1' : '0',
      'data-dynamic-placement': data.isDynamicPlacement ? '1' : '0',
    }));
  }
  public insertQuizPlaceholder(editorOrName: string | typeof CKEDITOR.editor, quiz: any = null): void {
    let editor = typeof editorOrName === "string" ? this.getEditor(editorOrName) : editorOrName;
    if (!editor) {
        return;
    }

    const quizTitle = quiz && quiz.title
      ? quiz.title
      : this.articlesEdit.getTemplateViewModel().quizTitle();

    const displayText = this.escapeWidgetText(quizTitle ? `${quizTitle}` : "Quiz Generation...");

    // Dynamic placement is a per-instance content attribute (same model as polls).
    // Seed it from the current checkbox value, falling back to the brand default.
    const vm = this.articlesEdit.getTemplateViewModel();
    const isDynamic = vm.quizIsDynamicPlacement && vm.quizIsDynamicPlacement() !== undefined
      ? !!vm.quizIsDynamicPlacement()
      : this.getDynamicPlacementDefault('quiz');
    vm.quizIsDynamicPlacement(isDynamic);

    const attrs: Record<string, string> = {
      'data-dynamic-placement': isDynamic ? '1' : '0',
    };
    if (quiz && quiz.id) {
      attrs['data-id'] = String(quiz.id);
    }

    this.insertWidgetPlaceholder(editor, 'quiz', this.createWidgetPlaceholder(editor, 'quiz', displayText, attrs));
  }

  /**
   * Writes the dynamic-placement flag onto the in-content quiz placeholder in
   * every editor instance. The placeholder attribute is the source of truth
   * (parsed by the content splitter), so the Widgets-tab checkbox mirrors here.
   */
  public setQuizDynamicPlacementAttr(isDynamic: boolean): void {
    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    editorNames.forEach(name => {
      const ed = this.getEditor(name);
      if (!ed || !ed.document) return;
      const el = ed.document.$.querySelector('[data-widget-injection="quiz"]') as HTMLElement | null;
      if (el) {
        el.setAttribute('data-dynamic-placement', isDynamic ? '1' : '0');
        ed.fire('saveSnapshot');
      }
    });
  }

  /**
   * Reads the dynamic-placement flag from the in-content quiz placeholder.
   * Returns null when no quiz placeholder exists yet (caller falls back to the
   * brand default).
   */
  public getQuizDynamicPlacementFromContent(): boolean | null {
    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    for (const name of editorNames) {
      const ed = this.getEditor(name);
      if (!ed || !ed.document) continue;
      const el = ed.document.$.querySelector('[data-widget-injection="quiz"]') as HTMLElement | null;
      if (el) {
        return el.getAttribute('data-dynamic-placement') === '1';
      }
    }
    return null;
  }
  protected insertAtCursorHtml(editor: typeof CKEDITOR.editor, html: string): boolean {
    if (!editor.focusManager.hasFocus) return false;

    const sel = editor.getSelection();
    if (!sel) return false;

    const ranges = sel.getRanges();
    if (!ranges.length) return false;

    const range = ranges[0];
    if (!range.collapsed) {
      range.collapse(true); // collapse to start so insertHtml doesn't delete selected content
      sel.selectRanges([range]);
    }

    editor.insertHtml(html);
    return true;
  }
  protected isDoubleBreak(nodes: Node[], i: number): boolean {
    const node = nodes[i];
    const nextNode = nodes[i + 1];

    if(!node || !nextNode) return false;

    return node.nodeName === 'BR' && nextNode.nodeName === 'BR';
  }
  protected isTextContent(node: Node): boolean {
    if(!node) return false;
    if(node.nodeType === Node.TEXT_NODE) {
      console.log(node, node.textContent)
      return node.textContent.trim() !== '';
    }
    if(node.nodeType === Node.ELEMENT_NODE) {
      return ['A', 'SPAN', 'STRONG', 'B', 'I', 'EM'].indexOf(node.nodeName) !== -1;
    }
    return false;
  }
  protected getNonEmptyTextNode(nodes: Node[], index: number, direction: 'previous' | 'next' = 'next') {
    const node = nodes[index];
    if(!node || ([Node.ELEMENT_NODE, Node.TEXT_NODE] as number[]).indexOf(node.nodeType) === -1) return null;

    if (node.nodeType === Node.ELEMENT_NODE && ['A', 'SPAN', 'STRONG', 'B', 'I', 'EM'].indexOf(node.nodeName) === -1) {
      return null;
    }

    if(node.textContent.trim() === '') {
      return this.getNonEmptyTextNode(nodes, index + (direction === 'next' ? 1 : -1), direction);
    }
    return node;
  }
  protected insertAtPercentEditorHeight(editor: typeof CKEDITOR.editor, el: typeof CKEDITOR.dom.element | string, percent: number = 0.66): boolean {
    const editable = editor.editable().$;

    const children = Array.from<Node>(editable.childNodes);

    if (!children.length) return false;

    const targetY = editable.scrollHeight * percent;

    let candidateIndex = -1;

    // Step 1: find first node past 66% height
    for (let i = 0; i < children.length; i++) {
      const node = children[i];

      if (!this.isDoubleBreak(children, i)) continue;

      const element = node as HTMLElement;

      let top;
      if( node.nodeType === Node.ELEMENT_NODE) {
        top = element.getBoundingClientRect().top;
      }

      if(node.nodeType === Node.TEXT_NODE) {
        const range = editor.createRange();
        range.selectNodeContents(node);
        top = range.getBoundingClientRect().top;
      }

      if (top >= targetY) {
        candidateIndex = i;
        break;
      }
    }

    if (candidateIndex === -1) {
      return false;
    }

    // Step 2: Insert between 2 paragraphs
    // scan downward for 2x <br>
    // check previous element and next element for textContent
    // replace 2x <br><br> that is between 2 textContent blocks with the placeholder
    // ignore span, a because they count as textContent

    for (let i = candidateIndex; i < children.length - 1; i++) {
      if (this.isDoubleBreak(children, i)) {
        const previousNode = this.getNonEmptyTextNode(children, i - 1, 'previous');
        const nextNode = this.getNonEmptyTextNode(children, i + 2, 'next'); // next node is the node after the 2x <br>
        if (this.isTextContent(previousNode) && this.isTextContent(nextNode)) {
          // insert placeholder between the 2x <br><br> so if it is removed it will be a double break again
          const paragraphBreak2 = children[i + 1] as Element;
          if (typeof el === 'string') {
            paragraphBreak2.insertAdjacentHTML('beforebegin', el);
            editor.fire('saveSnapshot');
            const inserted = paragraphBreak2.previousElementSibling;
            if (inserted) inserted.scrollIntoView({ block: 'center' });
          } else {
            editable.insertBefore(el.$, paragraphBreak2);
            editor.fire('saveSnapshot');
            el.$.scrollIntoView({ block: 'center' });
          }
          return true;
        }
      }
    }

    return false;
  }
  private escapeWidgetText(value: string): string {
    const div = document.createElement("div");
    div.textContent = value;
    return div.innerHTML;
  }

  protected createWidgetPlaceholder(_editor: typeof CKEDITOR.editor, type: string, textContent: string, attrs?: Record<string, string>): string {
    let extraAttrs = '';
    if (attrs) {
      for (const k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k)) {
          extraAttrs += ` ${k}="${attrs[k].replace(/"/g, '&quot;')}"`;
        }
      }
    }
    // Return an HTML string with class first so CKEditor's insertHtml preserves
    // attribute order (matching how article/vignette/tag display cards are inserted).
    return `<div class="emaki-displayCard ${type}" data-widget-injection="${type}" contenteditable="false"${extraAttrs}>${textContent}</div>`;
  }
  private insertWidgetPlaceholder(editor: typeof CKEDITOR.editor, type: 'quiz' | 'poll', html: string): void {
    const id = this.getWidgetIdFromHtml(type, html);

    // An article can embed several polls/quizzes, so re-inserting one only moves the
    // cards pointing at the same entity: they are collected here and dropped once the
    // new card is placed, which keeps it at the spot the user picked. A placeholder
    // carrying no id (the quiz generation card) still has to stay unique.
    const sameWidgets = id ? this.getWidgetsById(editor, type, id) : [];
    if (!id) {
      this.removeExistingWidget(editor, type);
    }

    // Restore the saved cursor position, which also recovers from the removal above,
    // so the card lands where the user was.
    this.restoreSelection(editor);

    this.insertWidgetHtml(editor, html);
    this.removeWidgets(editor, sameWidgets);
  }

  private insertWidgetHtml(editor: typeof CKEDITOR.editor, html: string): void {
    // 1. Try cursor — editor.insertHtml preserves attribute order via CKEditor's
    //    own HTML parser, matching how article/vignette/tag display cards are inserted.
    if (this.insertAtCursorHtml(editor, html)) return;

    // 2. Try 66% placement
    if (this.insertAtPercentEditorHeight(editor, html)) return;

    // 3. Fallback: append via insertAdjacentHTML to preserve attribute order
    const editable = editor.editable().$;
    editable.insertAdjacentHTML('beforeend', html);
    editor.fire('saveSnapshot');
    const inserted = editable.lastElementChild;
    if (inserted) inserted.scrollIntoView({ block: 'center' });
  }

  private removeExistingWidget(editor: typeof CKEDITOR.editor, type: 'poll' | 'quiz'): void {
    try {
      const editorBody: HTMLElement = editor.document.getBody().$;
      const existing = editorBody.querySelector(`[data-widget-injection="${type}"]`);
      if (existing) {
        existing.remove();
      }
    } catch (e) {}
  }

  private getWidgetsById(editor: typeof CKEDITOR.editor, type: 'poll' | 'quiz', id: string): Array<HTMLElement> {
    try {
      const editorBody: HTMLElement = editor.document.getBody().$;
      const widgets = editorBody.querySelectorAll(`[data-widget-injection="${type}"][${this.getWidgetIdAttribute(type)}="${id}"]`);

      return Array.prototype.slice.call(widgets);
    } catch (e) {
      return [];
    }
  }

  private removeWidgets(editor: typeof CKEDITOR.editor, widgets: Array<HTMLElement>, keep: HTMLElement | null = null): void {
    let removed = false;
    widgets.forEach((widget) => {
      if (widget !== keep && widget.parentNode) {
        widget.remove();
        removed = true;
      }
    });

    if (removed) {
      editor.fire('saveSnapshot');
    }
  }

  private getWidgetIdAttribute(type: 'poll' | 'quiz'): string {
    return type === 'poll' ? 'data-poll-id' : 'data-id';
  }

  private getWidgetIdFromHtml(type: 'poll' | 'quiz', html: string): string | null {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const widget = template.content.firstElementChild as HTMLElement | null;
    const id = widget ? widget.getAttribute(this.getWidgetIdAttribute(type)) : null;

    return id && /^\d+$/.test(id) ? id : null;
  }

  private isQuizInEditor(): boolean {
    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    return editorNames.some(name => {
      const ed = this.getEditor(name);
      if (!ed || !ed.document) return false;
      return !!ed.document.$.querySelector("[data-widget-injection=\"quiz\"]");
    });
  }

  public hasWidgetPlaceholderInContent(): boolean {
    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    return editorNames.some(name => {
      const ed = this.getEditor(name);
      if (!ed || !ed.document) return false;
      return !!ed.document.$.querySelector("[data-widget-injection=\"poll\"], [data-widget-injection=\"quiz\"]");
    });
  }

  public validateEditorHasWidget(): boolean {
    return this.hasWidgetPlaceholderInContent();
  }

  /**
   * The quiz "Generate & Insert" picker button. Mirrors the poll flow and returns whether something
   * was inserted so the picker knows whether to close (success) or stay open with the error popup.
   */
  public async insertGeneratedQuizFromPicker(editorName: string | typeof CKEDITOR.editor, isQuizDynamicPlacement: boolean): Promise<boolean> {
    const vm = this.articlesEdit.getTemplateViewModel();
    if (vm.quizIsDynamicPlacement) {
      vm.quizIsDynamicPlacement(!!isQuizDynamicPlacement);
    }

    return this.showQuizInsertFlow(editorName || "article_content");
  }

  /**
   * Mirrors the poll "Generate & Insert" flow. The picker's loading animation spans the initial
   * round trip to QuizController::getOrCreateForArticle, which rejects a source article under its
   * minimum content length before any placeholder quiz is created or inserted. When a matching quiz
   * exists it is carded straight away; otherwise a "Quiz Generating..." placeholder is inserted and
   * the generation runs in the background, refreshing the card once the questions come back.
   *
   * @returns Whether something was inserted, so the picker's "Generate & Insert" button knows whether
   * to close (success) or stay open with the error popup already shown.
   */
  protected async showQuizInsertFlow(editorName: string | typeof CKEDITOR.editor): Promise<boolean> {
    const idBrand = Number(this.getVnAppZone().app.params.idBrand);
    const idArticle = Number(this.articlesEdit.getTemplateViewModel().id());
    if (!idBrand || !idArticle) {
        return false;
    }

    const editor = typeof editorName === "string" ? this.getEditor(editorName) : editorName;
    if (!editor) {
        return false;
    }

    const quizPicker = this.articlesEdit.quizPicker;
    this.saveSelection(editor);

    // Switch to the article tab and yield one tick for Knockout + layout.
    this.articlesEdit.getTemplateViewModel().onClickTab("article");
    await new Promise(resolve => setTimeout(resolve, 0));

    quizPicker.showLoading();
    try {
      const response = await this.getQuizForInsertFlow(idBrand, idArticle);
      const quiz = response && response.data ? response.data : null;
      if (!quiz || !quiz.id) {
        return false;
      }

      const vm = this.articlesEdit.getTemplateViewModel();
      vm.quizTitle(quiz.title || "");
      vm.quizIsGenerating(!!response.isPlaceholderCreated);
      this.insertQuizPlaceholder(editor, quiz);

      if (response.isPlaceholderCreated) {
        // Not awaited: the placeholder card is already in the content, and the picker should close
        // on this success rather than wait for the AI response.
        this.generateInsertedQuizInBackground(quiz, editor);
      }

      return true;
    } catch (error) {
      console.error("Failed to insert quiz:", error);
      this.articlesEdit.getTemplateViewModel().quizIsGenerating(false);
      this.notifyQuizGenerationFailed(error && error.message);
      return false;
    } finally {
      quizPicker.hideLoading();
    }
  }

  private async getQuizForInsertFlow(idBrand: number, idArticle: number): Promise<any> {
    const response = await fetch(`/api/brand/${idBrand}/article/${idArticle}/quizzes/insert/`);
    const responseParsed = await response.json().catch(() => null);
    if (!response.ok) {
      const message = responseParsed && (responseParsed.message || responseParsed.error);
      throw new Error(message || `Quiz insert request failed: HTTP ${response.status}`);
    }

    return responseParsed;
  }

  private async generateInsertedQuizInBackground(quiz: any, editor: typeof CKEDITOR.editor): Promise<void> {
    const idBrand = this.getVnAppZone().app.params.idBrand;
    const idArticle = this.articlesEdit.getTemplateViewModel().id();
    if (!idBrand || !idArticle || !quiz || !quiz.id) return;

    try {
      const response = await fetch(`/api/brand/${idBrand}/quizzes/save/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: quiz.id,
          title: quiz.title || "Quiz Generating...",
          brands: [Number(idBrand)],
          idSourceArticle: Number(idArticle),
          quiz: quiz.quiz || [],
          regenerate: true,
        }),
      });

      if (!response.ok) {
        throw new Error(`Quiz generation request failed: HTTP ${response.status}`);
      }

      const responseParsed = await response.json();
      const generatedQuiz = responseParsed && responseParsed.data ? responseParsed.data : null;

      const vm = this.articlesEdit.getTemplateViewModel();
      vm.quizIsGenerating(false);
      if (!generatedQuiz) {
        this.notifyQuizGenerationFailed();
        return;
      }

      vm.quizTitle(generatedQuiz.title || "");
      this.replaceQuizPlaceholder(editor, generatedQuiz);
    } catch (error) {
      console.error("Failed to generate inserted quiz:", error);
      this.articlesEdit.getTemplateViewModel().quizIsGenerating(false);
      this.notifyQuizGenerationFailed();
    }
  }

  private notifyQuizGenerationFailed(message?: string): void {
    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_ERROR,
      message || "Quiz generation failed. Please try again."
    );
    this.getVnAppZone().showNotificationToModule();
  }

  private replaceQuizPlaceholder(editor: typeof CKEDITOR.editor, quiz: any): void {
    if (!editor || !editor.editable || !quiz || !quiz.id) return;

    const editable = editor.editable().$;
    const existing = editable.querySelector(`[data-widget-injection="quiz"][data-id="${quiz.id}"]`) as HTMLElement | null;
    if (!existing) {
      this.insertQuizPlaceholder(editor, quiz);
      return;
    }

    const isDynamic = existing.getAttribute('data-dynamic-placement') === '1';
    const html = this.createWidgetPlaceholder(editor, 'quiz', this.escapeWidgetText(quiz.title || "Quiz"), {
      'data-dynamic-placement': isDynamic ? '1' : '0',
      'data-id': String(quiz.id),
    });
    existing.outerHTML = html;
    editor.fire('saveSnapshot');
  }

  protected addSensaiVaultCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showSensaiVault(editor);
          },
        };
      }
      editor.addCommand("sensaiCommand", showMyDialog(this));

      editor.ui.addButton("sensaiBtn", {
        // add new button and bind our command
        label: "Sensai Vault",
        command: "sensaiCommand",
        toolbar: "insert",
        icon: "/assets/images/tag.png",
      });
    });
  }

  protected showSensaiVault(editor) {

    this.articlesEdit.getTemplateViewModel().isSensaiVaultVisible(true);
    this.getSensaiVaultData();

  }

  protected addDeleteElementCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      // Ensure the contextMenu plugin is ready and the custom setup hasn't been added yet
      if (!editor.contextMenu) {
        editor.on("pluginsLoaded", function () {
          _myThis.setupContextMenu(editor);
        });
      } else {
        _myThis.setupContextMenu(editor);
      }
    });
  }

  setupContextMenu(editor) {
    // Define the command if it does not exist
    if (!editor.getCommand("deleteElement")) {
      editor.addCommand("deleteElement", {
        exec: function (edt) {
          var selection = edt.getSelection();
          var element = selection.getStartElement();
          if (element && element.is("span") && element.hasClass("hyperlink")) {
            var range = new CKEDITOR.dom.range(edt.document);
            range.setStartBefore(element);
            range.setEndAfter(element);

            range.deleteContents();
            var textNode = new CKEDITOR.dom.text(
              element.getText(),
              edt.document
            );
            range.insertNode(textNode);

            selection.selectRanges([range]);
          }
        },
      });
    }

    // Add the custom context menu item
    if (editor.contextMenu && !editor._deleteElementMenuAdded) {
      editor.addMenuGroup("deleteGroup");
      editor.addMenuItem("customUnlinkItem", {
        label: "Delete Element",
        command: "deleteElement",
        group: "deleteGroup",
        icon: editor.skinPath + "icons/unlink.png",
      });

      editor.contextMenu.addListener(function (element) {
        if (element && element.is("span") && element.hasClass("hyperlink")) {
          return { customUnlinkItem: CKEDITOR.TRISTATE_OFF };
        }
      });

      editor._deleteElementMenuAdded = true; // Flag to prevent re-adding
    }
  }

  /**
   * @deprecated Link tool is not used anymore on emaki
   */
  protected addLinkToolCommand(editors) {
    editors.forEach((editor) => {
      function showLinkTool(obj) {
        return {
          exec: function (editor) {
            obj.showLinkTool();
          },
        };
      }

      editor.addCommand("linkToolCommand", showLinkTool(this));

      editor.ui.addButton("LinkBtn", {
        // add new button and bind our command
        label: "Link Tool",
        command: "linkToolCommand",
        toolbar: "insert",
      });
    });
  }

  protected addUpdateBlockCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addUpdateBlock(obj) {
        return {
          exec: function (editor) {
            _myThis.addUpdateBlock(editor);
          },
        };
      }

      editor.addCommand("updateBlockCommand", addUpdateBlock(this));

      editor.ui.addButton("UpdateBtn", {
        // add new button and bind our command
        label: "Update",
        command: "updateBlockCommand",
        toolbar: "insert",
      });
    });
  }

  protected addTwoColumnCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addTwoColumns(obj) {
        return {
          exec: function (editor) {
            _myThis.addTwoColumns(editor);
          },
        };
      }

      editor.addCommand("twoColumnCommand", addTwoColumns(this));

      editor.ui.addButton("TwoColumnsBtn", {
        // add new button and bind our command
        label: "Two Columns",
        command: "twoColumnCommand",
        toolbar: "insert",
        icon: "/assets/images/2cols-icon.png",
      });
    });
  }

  protected addAIKeyPointsCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addAIKeyPoints(obj) {
        return {
          exec: function (editor) {
            _myThis.getAIKeyPoints(editor);
          },
        };
      }

      editor.addCommand("keyPointsCommand", addAIKeyPoints(this));

      editor.ui.addButton('KeyPointsBtn', { // add new button and bind our command
        label: "",
        title: "Key Takeaways",
        command: 'keyPointsCommand',
        toolbar: 'insert',
      });
    });
  }

  /*
  PME-8871 - Custom Quick Links/Table of Contents Article in CKEditor
  Make BE call to content splitter & return content blocks in format
  Add Table of Contents button to CKEditor that injects formatted toc blocks
  */
  protected getQuicklinkBlocks(editor) {

    if (this.tocXHRHdl) {
      this.tocXHRHdl.cancelAndReset();
    }

    const editorNames = ["article_content", "article_sandbox", "article_republish"];
    if (editorNames.indexOf(editor.name) !== -1) {
      const editorElement = document.getElementById('cke_' + editor.name);
      editorElement.children[1].classList.add('loading');
    } else {
      console.error(`Unknown editor name: ${editor.name}`);
      return;
    }

    editor.setReadOnly(true);

    const idBrand = this.getVnAppZone().app.params.idBrand;
    const idArticle = this.articlesEdit.getId();

    const data = {
      "idArticle": idArticle,
      "content": editor.getData(),
      "editor": editor.name
    };

    let formReq_url: string = `/api/brand/${idBrand}/articles/tableOfContents/get/`;
    let formReq_params: Array<[string, string]> = [["data", JSON.stringify(data)]];

    this.tocXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
    this.tocXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.tocXHRHdl.onReadyStateFunction = this.onGetQuicklinkBlocksReturn;
    this.tocXHRHdl.execute();
  }


  protected onGetQuicklinkBlocksReturn(req, obj) {
    //set editor to be editable otherwise nothing from BE will inject
    contentEditor.setReadOnly(false);
    sandboxEditor.setReadOnly(false);
    republishEditor.setReadOnly(false);
    return () => {

      obj.manageResponse(req, obj, () => {
        const responseParsed = JSON.parse(req.request.response);

        if (!responseParsed || !responseParsed.quickLinks || !responseParsed.headings || !responseParsed.editor) return;

        const headings = responseParsed.headings;
        const quickLinksBlock = responseParsed.quickLinks;
        const editorInstance = CKEDITOR.instances[responseParsed.editor];

        //1. Quicklinks Insertion logic in CKEditor - active cursor position, non-selected cursor position, or first non-empty div, or beginning of article
        editorInstance.focus();

        const selection = editorInstance.getSelection();
        let range = selection ? selection.getRanges()[0] : null;

        const editorContent = editorInstance.document.$;
        const firstDiv = editorContent.querySelector('body > div:not(:empty)') || editorContent.querySelector('body > div'); // Select first non-empty div

        if (range) {
          // Get the start container of the current range
          const rangeStartElement = range.startContainer;
          // Check if the cursor is within or before the first div
          const isCursorAtStart = firstDiv && (firstDiv.contains(rangeStartElement.$) || rangeStartElement.$ === firstDiv);

          if (isCursorAtStart) {
            // Cursor is at or before the first div, so insert after the first div
            range = editorInstance.createRange();
            range.moveToPosition(new CKEDITOR.dom.element(firstDiv), CKEDITOR.POSITION_AFTER_END);
            range.collapse(true);
            editorInstance.insertHtml(quickLinksBlock, 'html', range);
          } else {
            // Insert at the current cursor position if it's not at the start
            editorInstance.insertHtml(quickLinksBlock, 'html', range);
          }
        } else {
          // If no range or selection, insert at the beginning of the editor content
          const newRange = editorInstance.createRange();
          newRange.moveToElementEditablePosition(editorInstance.editable(), true); // Move to the start of the editor
          editorInstance.insertHtml(quickLinksBlock, 'html', newRange);
        }

        // 2.search+replace: find matching h2+h3s in content & replace with headings+id
        let content = editorInstance.getData();
        let editor;
        headings.forEach(heading => {
          content = content.replace(heading.searchTerm, heading.replaceTerm);
        });

        editorInstance.setData(content);

        switch (responseParsed.editor) {
          case "article_content":
            editor = contentEditor;
            break;
          case "article_sandbox":
            editor = sandboxEditor;
            break;
          case "article_republish":
            editor = republishEditor;
            break;
          default:
            return;
        }

      });

      //remove the 'generating' modal after content injection
      ["article_content", "article_sandbox", "article_republish"].forEach(id => {
        document.getElementById(`cke_${id}`).children[1].classList.remove('loading');
      });

    };

  }

  protected addQuicklinksCommandCKEditor(editors) {
    let _myThis = this;

    editors.forEach((editor) => {
      function addTableOfContents(obj) {
        return {
          exec: function (editor) {
            _myThis.getQuicklinkBlocks(editor);
          }
        };
      }
      editor.addCommand("quicklinksCommand", addTableOfContents(this));
      editor.ui.addButton('TableOfContentsBtn', {
        label: "Jump Links",
        title: 'Insert Jump Links',
        command: 'quicklinksCommand',
        toolbar: 'insert',
        icon: '/assets/images/lightning-bolt.png'
      });
    });
  }



  protected addAIContentCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function addAIContent(obj) {
        return {
          exec: function (editor) {
            _myThis.getAIContent();
          },
        };
      }

      editor.addCommand("contentCommand", addAIContent(this));

      editor.ui.addButton("ContentBtn", {
        // add new button and bind our command
        label: "",
        command: "contentCommand",
        toolbar: "insert",
      });
    });
  }

  protected addEmbedBlockCommand(editors) {
    let _myThis = this;

    editors.forEach((editor) => {
      function showEmbedDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showEmbedPopUp(editor);
          },
        };
      }
      if (editor && editor.name !== "additional_credit") {

        editor.addCommand("embedBlockCommand", showEmbedDialog(this));

        editor.ui.addButton("EmbedBtn", {
          // add new button and bind our command
          label: "Insert Embeds",
          command: "embedBlockCommand",
          toolbar: "insert",
        });
      }
    });
  }

  protected getSensaiVaultData() {

    if (this.sensaiVaultXHRHdl) {
      this.sensaiVaultXHRHdl.cancelAndReset();
    }

    let formReq_url: string = "/api/sensAI-vault/summarize/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = JSON.parse(ko.toJSON({
      content: contentEditor.getData()
    }));

    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onGetSensaiVaultDataReturn;
    XHRHdl.execute();

  }

  protected onGetSensaiVaultDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {

        if (req.request.status === 200) {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.getTemplateViewModel().sensaiVaultGeneratedHtml(responseParsed.articleCardsHtml)
        }

      });
    }
  }

  public getArticleId() {

    return this.articlesEdit.getId();
  }

  protected getAIKeyPoints(editor) {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    if (editor.name == "article_content") {
      document
        .getElementById("cke_article_content")
        .children[1].classList.add("is-generating");
    } else if (editor.name == "article_sandbox") {
      document
        .getElementById("cke_article_sandbox")
        .children[1].classList.add("is-generating");
    } else if (editor.name == "article_republish") {
      document
        .getElementById("cke_article_republish")
        .children[1].classList.add("is-generating");
    }

    editor.setReadOnly(true);

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();

    let data = {
      idArticle: idArticle,
      content: editor.getData(),
      editor: editor.name,
    };

    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/key-points/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIKeyPointsReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected onGetAIKeyPointsReturn(req, obj) {
    return function () {
      contentEditor.setReadOnly(false);
      sandboxEditor.setReadOnly(false);
      republishEditor.setReadOnly(false);
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.keyPoints) {
          let tag =
            '<div class="emaki-custom key-points"><ul class="key-points-list">';

          let keyPoints = responseParsed.keyPoints;
          for (let i = 0; i < keyPoints.length; i++) {
            tag = tag + '<li class="key-points-item">' + keyPoints[i] + "</li>";
          }

          tag = tag + "</ul></div>";

          if (responseParsed.editor == "article_content") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              contentEditor.document
            );
            contentEditor.insertHtml("&nbsp;");
            contentEditor.insertElement(tagElement);
          } else if (responseParsed.editor == "article_sandbox") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              sandboxEditor.document
            );
            sandboxEditor.insertHtml("&nbsp;");
            sandboxEditor.insertElement(tagElement);
          } else if (responseParsed.editor == "article_republish") {
            let tagElement = CKEDITOR.dom.element.createFromHtml(
              tag,
              republishEditor.document
            );
            republishEditor.insertHtml("&nbsp;");
            republishEditor.insertElement(tagElement);
          }

          //obj.updateKeyPointsButton(responseParsed.generationAttempts);
        }
      });
      document
        .getElementById("cke_article_content")
        .children[1].classList.remove("is-generating");
      document
        .getElementById("cke_article_sandbox")
        .children[1].classList.remove("is-generating");
      document
        .getElementById("cke_article_republish")
        .children[1].classList.remove("is-generating");
    };
  }

  protected updateKeyPointsButton(generationAttempts) {
    let idArticle = this.articlesEdit.getId();
    let remainingAttempts = 3;
    if (generationAttempts) {
      this.keyPointsAttempts = generationAttempts;
      remainingAttempts = remainingAttempts - generationAttempts;
      if (remainingAttempts <= 0) {
        remainingAttempts = 0;
      }
    }
    let buttonElements = document.getElementsByClassName(
      "cke_button__keypointsbtn"
    );
    if (remainingAttempts == 0 || !idArticle) {
      // Disable the button
      if (buttonElements.length !== 0) {
        for (let element of buttonElements) {
          element.classList.add("is-disable");
          element.setAttribute(
            "title",
            "Key Takeaways ; " + remainingAttempts + " credits left"
          );
        }
      }
    } else {
      //enable the button
      if (buttonElements.length !== 0) {
        for (let element of buttonElements) {
          element.classList.remove("is-disable");
          element.setAttribute(
            "title",
            "Key Takeaways ; " + remainingAttempts + " credits left"
          );
        }
      }
    }
    let labelElements = document.getElementsByClassName(
      "cke_button__keypointsbtn_label"
    );
    if (labelElements.length !== 0) {
      for (let element of labelElements) {
        element.textContent = "" + remainingAttempts + "";
      }
    }
  }
  protected analyzeArticleTitle(type) {
    if (type == 'both') {
      this.requestStatus['optimize'] = false;
      this.requestStatus['ctr'] = false;
      this.analyzeArticleByType('ctr');

    }
    else {
      this.requestStatus[type] = false;
      this.analyzeArticleByType(type);
    }


  }

  protected progressivelyReveal(div: HTMLElement, htmlContent: string, obj, onRevealComplete?: () => void): void {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlContent}</div>`, 'text/html');
    const root = doc.body.firstChild as HTMLElement;

    const textNodes: HTMLElement[] = [];

    function wrapTextNodes(node: Node): void {
      [...node.childNodes].forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          const span = document.createElement('span');
          span.className = 'blurred-full';
          span.textContent = child.textContent;
          node.replaceChild(span, child);
          (node as HTMLElement).classList.add('blurred-full');
          textNodes.push(span);
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const el = child as HTMLElement;
          if (el.tagName === 'HR') {
            el.classList.add('blurred-full');
            textNodes.push(el);
          } else {
            wrapTextNodes(child);
          }
        }
      });
    }

    wrapTextNodes(root);
    div.innerHTML = '';
    div.appendChild(root);

    let nodeIndex = 0;
    let charIndex = 0;

    function revealNextChar(): void {

      if (nodeIndex >= textNodes.length) {
        obj.firstRevealComplete = true;
        obj.updateTitleAnalysisWindowPosition();
        if (onRevealComplete) {
          onRevealComplete();
        }
        return;
      };
      const node = textNodes[nodeIndex];

      const text = node.textContent || "";

      const jump = Math.ceil(text.length * (Math.random() * 0.01 + 0.01));

      if (charIndex >= text.length) {
        node.classList.remove('blurred-current', 'blurred-full');
        node.textContent = text;
        nodeIndex++;
        charIndex = 0;
        revealNextChar();
        return;
      }

      const parent = node.parentNode as HTMLElement;
      parent.classList.remove('blurred-current', 'blurred-full');

      const revealed = text.slice(0, charIndex + jump);
      const hidden = text.slice(charIndex + jump);
      node.innerHTML = `<span>${revealed}</span><span class="blurred-full">${hidden}</span>`;
      node.className = '';

      charIndex += jump;

      let delay = Math.max(8 - nodeIndex, 1);
      if (nodeIndex > textNodes.length * 0.8) delay = 1;

      setTimeout(revealNextChar, delay);
    }

    revealNextChar();
  }
  protected typeText(element, html, speed = 50) {
    element.innerHTML = "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    let i = 0;
    function typeChar() {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(typeChar, speed);
      }
    }

    typeChar();
  }

  /**
   * Detects if the current platform is Mac
   */
  private isMacPlatform(): boolean {
    return /Mac|iPhone|iPod|iPad/i.test(navigator.platform) ||
           /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
  }

  /**
   * Detects if the current platform is Windows
   */
  private isWindowsPlatform(): boolean {
    return /Win/i.test(navigator.platform) ||
           /Win/i.test(navigator.userAgent);
  }

  /**
   * Finds a link element on or next to the cursor position in the editor
   */
  private findLinkOnOrNextToCursor(editor: any): any {
    // First, try to get link if cursor is inside it
    let anchor = CKEDITOR.plugins.link.getSelectedLink(editor);

    if (anchor && anchor.getAttribute('href')) {
      return anchor;
    }

    // If no link found, check if cursor is next to a link
    let selection = editor.getSelection();
    if (!selection) {
      return null;
    }

    let ranges = selection.getRanges();
    if (!ranges || ranges.length === 0) {
      return null;
    }

    let range = ranges[0];
    let startElement = range.getStartElement();

    if (!startElement) {
      return null;
    }

    // Get the element path to check for links in parent hierarchy
    let elementPath = new CKEDITOR.dom.elementPath(startElement, editor.editable());
    let elements = elementPath.elements;

    // Check if any element in the path is a link
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].getName() === 'a' && elements[i].getAttribute('href')) {
        return elements[i];
      }
    }

    // Check parent element
    let parent = startElement.getParent();
    if (parent && parent.getName() === 'a' && parent.getAttribute('href')) {
      return parent;
    }

    // Check previous sibling
    let previousSibling = startElement.getPrevious();
    if (previousSibling && previousSibling.type === CKEDITOR.NODE_ELEMENT) {
      if (previousSibling.getName() === 'a' && previousSibling.getAttribute('href')) {
        return previousSibling;
      }
      // Check if previous sibling contains a link
      try {
        let linkInSibling = previousSibling.findOne('a');
        if (linkInSibling && linkInSibling.getAttribute('href')) {
          return linkInSibling;
        }
      } catch (e) {
        // findOne might not be available, continue
      }
    }

    // Check next sibling
    let nextSibling = startElement.getNext();
    if (nextSibling && nextSibling.type === CKEDITOR.NODE_ELEMENT) {
      if (nextSibling.getName() === 'a' && nextSibling.getAttribute('href')) {
        return nextSibling;
      }
      // Check if next sibling contains a link
      try {
        let linkInSibling = nextSibling.findOne('a');
        if (linkInSibling && linkInSibling.getAttribute('href')) {
          return linkInSibling;
        }
      } catch (e) {
        // findOne might not be available, continue
      }
    }

    // Check for link in the same container by looking at adjacent text nodes
    let container = range.startContainer;
    if (container && container.type === CKEDITOR.NODE_TEXT) {
      let textNode = container;
      let parentNode = textNode.getParent();

      // Check if parent is a link
      if (parentNode && parentNode.getName() === 'a' && parentNode.getAttribute('href')) {
        return parentNode;
      }

      // Check siblings of the text node's parent
      if (parentNode) {
        let prevSib = parentNode.getPrevious();
        if (prevSib && prevSib.getName() === 'a' && prevSib.getAttribute('href')) {
          return prevSib;
        }

        let nextSib = parentNode.getNext();
        if (nextSib && nextSib.getName() === 'a' && nextSib.getAttribute('href')) {
          return nextSib;
        }
      }
    }

    return null;
  }

  /**
   * Registers the open link shortcut (Alt+Enter / Option+Enter)
   */
  private registerOpenLinkShortcut(editor: any): void {
    editor.addCommand('openLinkShortcut', {
      exec: (editor: any) => {
        let anchor = this.findLinkOnOrNextToCursor(editor);

        if (anchor) {
          let href = anchor.getAttribute('href');
          if (href) {
            window.open(href, '_blank');
            return true;
          }
        }

        return false;
      }
    });

    // Register Alt+Enter (Windows) or Option+Enter (Mac)
    // Both map to CKEDITOR.ALT + 13 in JavaScript
    editor.setKeystroke(CKEDITOR.ALT + 13, 'openLinkShortcut');
  }

  /**
   * Registers the save shortcut (CMD+S on Mac, CTRL+S on Windows)
   */
  private registerSaveShortcut(editor: any, classInstance: any): void {
    editor.addCommand('saveStayShortcut', {
      exec: (editor: any) => {
        // Call save("stay") on the class instance
        if (classInstance && typeof classInstance.save === 'function') {
          classInstance.save("stay");
          return true;
        }
        return false;
      }
    });

    // Register CTRL+S (Windows) - key code 83 is 'S'
    // This will also work on Mac if the browser maps CMD to CTRL
    editor.setKeystroke(CKEDITOR.CTRL + 83, 'saveStayShortcut');
  }

  /**
   * Registers the strike shortcut (CMD+Shift+X on Mac, Alt+Shift+5 on Windows)
   */
  private registerStrikeShortcut(editor: any): void {
    const strikeCmd = editor.getCommand('strike');
    if (!strikeCmd) {
      console.warn('Strike command not found. Is the "basicstyles" plugin with strike enabled?');
      return;
    }

    const isMac = this.isMacPlatform();
    const isWindows = this.isWindowsPlatform();

    // Map CMD+Shift+X (Mac) to strike
    if (isMac) {
      editor.setKeystroke(
        CKEDITOR.CTRL + CKEDITOR.SHIFT + 88, // 88 = 'X'
        'strike'
      );
    }

    // Map Alt+Shift+X (Windows) to strike
    if (isWindows) {
      editor.setKeystroke(
        CKEDITOR.ALT + CKEDITOR.SHIFT + 88, // 88 = 'X'
        'strike'
      );
    }
  }

  /**
   * Registers the clear formatting shortcut (CMD+\ on Mac, CTRL+\ on Windows)
   */
  private registerClearFormattingShortcut(editor: any): void {
    const removeFormatCmd = editor.getCommand('removeFormat');
    if (!removeFormatCmd) {
      console.warn('RemoveFormat command not found.');
      return;
    }
    editor.setKeystroke(
      CKEDITOR.CTRL + 220, // 220 = '\'
      'removeFormat'
    );
  }

  private registerApplyNormalTextShortcut(editor: any): void {
    editor.setKeystroke(CKEDITOR.CTRL + CKEDITOR.ALT + 48, 'simulatePlainClick');
    editor.addCommand('simulatePlainClick', {
      exec: function() {
        const combo = editor.ui.get('Blocks');
        if (!combo) {
          console.error("RichCombo not found:", 'Blocks');
          return;
        }

        try {
          // This triggers the EXACT same code path as user selection
          combo.onClick('Plain');
        } catch (err) {
          console.error("Failed to simulate Plain click:", err);
        }
      }
    });

  }
  private registerApplyHeadingStyleShortcut(editor: any): void {
    const combo = editor.ui.get('Blocks');
    if (!combo) {
      return;
    }

    // Cmd + Option + 2 → Heading 2
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.ALT + 50, // 50 = key "2"
      'applyHeading2Shortcut'
    );

    // Cmd + Option + 3 → Heading 3
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.ALT + 51, // 51 = key "3"
      'applyHeading3Shortcut'
    );

    // Commands execute the same path as user clicking the dropdown
    editor.addCommand('applyHeading2Shortcut', {
      exec: () => combo.onClick('Heading 2')
    });

    editor.addCommand('applyHeading3Shortcut', {
      exec: () => combo.onClick('Heading 3')
    });
  }

  private registerApplyNumberedListShortcut(editor: any): void {
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.SHIFT + 55,
      'numberedlist'
    );
  }

  private registerApplyBulletedListShortcut(editor: any): void {
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.SHIFT + 56,
      'bulletedlist'
    );
  }

  private isInsideHeading(editor: any): boolean {
      let selection = editor.getSelection();
      let isInsideHeading = false;
      if (selection) {
          let startElement = selection.getStartElement();
          if (startElement) {
              isInsideHeading = !!(startElement.getAscendant('h2', true) || startElement.getAscendant('h3', true));
          }
      }
      return isInsideHeading;
  }

    private registerAlignLeftShortcut(editor: any): void {
        editor.addCommand('justifyleftHeadingOnly', {
            exec: (ed: any) => {
                if (this.isInsideHeading(ed)) {
                    ed.execCommand('justifyleft');
                }
            }
        });

        editor.setKeystroke(
            CKEDITOR.CTRL + CKEDITOR.SHIFT + 76, // 76 = 'L'
            'justifyleftHeadingOnly'
        );
    }

    private registerAlignCenterShortcut(editor: any): void {
        editor.addCommand('justifycenterHeadingOnly', {
            exec: (ed: any) => {
                if (this.isInsideHeading(ed)) {
                    ed.execCommand('justifycenter');
                }
            }
        });
        editor.setKeystroke(
            CKEDITOR.CTRL + CKEDITOR.SHIFT + 69, // 69 = 'E'
            'justifycenterHeadingOnly'
        );
    }

    private registerAlignRightShortcut(editor: any): void {
        editor.addCommand('justifyrightHeadingOnly', {
            exec: (ed: any) => {
                if (this.isInsideHeading(ed)) {
                    ed.execCommand('justifyright');
                }
            }
        });
        editor.setKeystroke(
            CKEDITOR.CTRL + CKEDITOR.SHIFT + 82, // 82 = 'R'
            'justifyrightHeadingOnly'
        );
    }

    private registerJustifyShortcut(editor: any): void {
        editor.addCommand('justifyblockHeadingOnly', {
            exec: (ed: any) => {
                if (this.isInsideHeading(ed)) {
                    ed.execCommand('justifyblock');
                }
            }
        });
        editor.setKeystroke(
            CKEDITOR.CTRL + CKEDITOR.SHIFT + 74, // 74 = 'J'
            'justifyblockHeadingOnly'
        );
    }

  private registerSuperscriptShortcut(editor: any): void {
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.SHIFT + 190, // 190 = '.'
      'superscript'
    );
  }

  private registerSubscriptShortcut(editor: any): void {
    editor.setKeystroke(
      CKEDITOR.CTRL + CKEDITOR.SHIFT + 188, // 188 = ','
      'subscript'
    );
  }

  private registerShortcutTooltips(editor: any): void {
    var isMac = this.isMacPlatform();

    // Map of button titles to their shortcut text
    // Using the actual button titles as they appear in the DOM
    var titleToShortcutMap: { [key: string]: string } = {
      'Strikethrough': isMac ? '⌘ + Shift + X' : 'Alt+Shift+5',
      'Numbered List': isMac ? '⌘ + Shift + 7' : 'Ctrl+Shift+7',
      'Bulleted List': isMac ? '⌘ + Shift + 8' : 'Ctrl+Shift+8',
      'Align Left': isMac ? '⌘ + Shift + L' : 'Ctrl+Shift+L',
      'Align Center': isMac ? '⌘ + Shift + E' : 'Ctrl+Shift+E',
      'Align Right': isMac ? '⌘ + Shift + R' : 'Ctrl+Shift+R',
      'Justify': isMac ? '⌘ + Shift + J' : 'Ctrl+Shift+J'
    };

    var blockStyleShortcut = isMac
      ? '⌘ + ⌥ + 0 / ⌘ + ⌥ + 2 / ⌘ + ⌥ + 3'
      : 'Ctrl+Alt+0 / Ctrl+Alt+2 / Ctrl+Alt+3';

    // Function to update tooltips by directly querying the DOM
    function updateAllTooltips() {
      if (!editor.container || !editor.container.$) {
        return;
      }

      var container = editor.container.$;

      // Find all toolbar buttons (anchor tags with title attributes)
      var buttons = container.querySelectorAll('a[title]');

      for (var i = 0; i < buttons.length; i++) {
        var button = buttons[i] as HTMLElement;
        var currentTitle = button.getAttribute('title');

        if (!currentTitle) continue;

        // Check if this button's title matches any in our map
        for (var titleKey in titleToShortcutMap) {
          if (!titleToShortcutMap.hasOwnProperty(titleKey)) continue;

          // Check if the current title matches (exact match or contains the key)
          if (currentTitle === titleKey || currentTitle.indexOf(titleKey) !== -1) {
            // Only update if it doesn't already have a shortcut
            if (currentTitle.indexOf('(') === -1) {
              var newTitle = currentTitle + ' (' + titleToShortcutMap[titleKey] + ')';
              button.setAttribute('title', newTitle);

              // Also update aria-label if it exists
              var ariaLabel = button.getAttribute('aria-label');
              if (ariaLabel && ariaLabel.indexOf('(') === -1) {
                button.setAttribute('aria-label', ariaLabel + ' (' + titleToShortcutMap[titleKey] + ')');
              }
            }
            break;
          }
        }
      }
    }

    // Update immediately
    updateAllTooltips();

    // Also try to update tooltips after delays to ensure UI is fully rendered
    setTimeout(updateAllTooltips, 100);
    setTimeout(updateAllTooltips, 300);
    setTimeout(updateAllTooltips, 500);
    setTimeout(updateAllTooltips, 1000);

    // Listen for UI ready event if available
    if (editor.on) {
      editor.on('uiReady', updateAllTooltips);
    }

    // Also listen for toolbar updates
    editor.on('toolbar', function() {
      setTimeout(updateAllTooltips, 50);
    });
  }


  protected initCkEditor(idElement) {
    let height, toolbarMA;
    let disallowedContent = "p";
    let skin = "emakiCustomComprehensive";
    //contextmenu,tabletools,tableselection
    let removePlugins = "elementspath,liststyle,image,forms";
    let _myThis = this;
    if (
      idElement == "article_directory_item_description" ||
      idElement == "sandbox_directory_item_description"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Source",
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "ImgBtn",
          "VideoBtn",
          "sensaiBtn",
          "Bold",
          "Italic",
          "Strike",
          "-",
          "LinkBtn",
          "Maximize",
        ],
      ];
      height = "500px";
    } else if (
      idElement == "image_description" ||
      idElement == "image_caption" ||
      idElement == "gallery_description" ||
      idElement == "gallery_credit_text"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "Bold",
          "Italic",
          "Strike",
        ],
      ];
      height = "125px";
    } else if (
      idElement == "bulk_image_description" ||
      idElement == "bulk_image_caption"
    ) {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "Bold",
          "Italic",
          "Strike",
        ],
      ];
      height = "75px";
    }
    else if (idElement == "additional_credit") {
      disallowedContent = "*"; // Disallow everything by default
      removePlugins += ",list,table,image,forms,video,blockquote";

      toolbarMA = [
        [
          "Bold",
          "Italic",
          "Link",
          "Unlink"
        ],
      ];

      height = "75px";

      // override extraAllowedContent to allow only those tags
    }
    else {
      height = "500px";
      skin = "emakiCustomComprehensive";
      //height = '1500px';
      toolbarMA = [
        [
            "Undo",
            "Redo",
            "EditMenu",
        ],
        [
            "Blocks",
            "Bold",
            "Italic",
            "Strike",
            "NumberedList",
            "BulletedList",
            "AlignDropdown",
            "FormatBtn",
            "ContentBtn",
            "-",
        ],
        [
            "Link",
            "ImgBtn",
            "VideoBtn",
            "TagBtn",
            "VignetteBtn",
            "ArticleBtn",
            "EmbedBtn",
            "Table",
            "TwoColumnsBtn",
            "LinkBtn",
            "sensaiBtn",
            "InsertDropdown",
        ],

        [
            "SelectionWrap",
            "TableOfContentsBtn",
            "UpdateBtn",
            "KeyPointsBtn",

        ],
        [
            "Source",
            "Maximize",
        ]
      ];
    }
    var extraAllowedContent = "";
    if (idElement == "additional_credit") {
      extraAllowedContent = "a[href];strong;em;b;i";
    } else {
      extraAllowedContent = "span(*)[!data-*,contenteditable]{background-image};img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];picture(*){*}[*];source(*){*}[*];style[*]{*};hr[*]{*}[*];sub;sup;table(*){*}[*]";
    }

    // Configure Code Snippet plugin (custom Highlight.js + languages)
    // The default highlight.js build doesn't have some programming languages
      this.initializeCodeSnippetConfig();

    // Set skin configuration before creating editor instance (important for Firefox)
    // Set both global config and ensure it's in the instance config
    CKEDITOR.config.skin = skin;

      CKEDITOR.replace(idElement, {
      height: height,
      toolbar: "MA",
      fillEmptyBlocks: false,
      extraAllowedContent: extraAllowedContent,
      disallowedContent: disallowedContent,
      removePlugins: removePlugins,
      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      },
      toolbar_MA: toolbarMA,
    });

    //CKEDITOR.config.toolbar_MA = toolbarMA;

    CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
    CKEDITOR.config.fillEmptyBlocks = false;
    CKEDITOR.config.contentsCss = [
      CKEDITOR.getUrl("contents.css"),
      "/css/cke_style.css?v=11.4",
    ];

    //CKEDITOR.config.disallowedContent = 'p';
    //CKEDITOR.config.skin ="kama";
    //CKEDITOR.config.skin ="moono";
    //CKEDITOR.config.skin ="moono-lisa";

    CKEDITOR.config.extraPlugins = "wordcount,notification,openlink,blocksCombo, selectionWrapCombo, colordialog, colorbutton, maTextHex, maBgHex, maPasteWithoutStyle,codesnippet,horizontalrule,editMenu,FormatBtn,InsertDropdown,justify,AlignDropdown,selectall";

    //CKEDITOR.config.extraPlugins ="colorbutton";

    CKEDITOR.config.forcePasteAsPlainText = false;
    contentEditor = CKEDITOR.instances.article_content;
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    republishEditor = CKEDITOR.instances.article_republish;

    CKEDITOR.config.wordcount = {
      // Whether or not you want to show the Paragraphs Count
      showParagraphs: false,

      // Whether or not you want to show the Word Count
      showWordCount: true,

      // Whether or not you want to show the Char Count
      showCharCount: true,
    };

    CKEDITOR.on("instanceReady", (event: any) => {
      let editor = event.editor;
      let dataProcessor = editor.dataProcessor;

      if (dataProcessor != null) {
        let htmlFilter = dataProcessor.htmlFilter;
        htmlFilter.addRules({
          elements: {
            p: function (element: any) {
              let parent = element.parent;
              if (parent && parent.name.toLowerCase() == "blockquote") {
                element.name = "";
              }
              return element;
            },
          },
        });
      }

      // Register keyboard shortcuts
      this.registerOpenLinkShortcut(editor);
      this.registerSaveShortcut(editor, _myThis);
      this.registerStrikeShortcut(editor);
      this.registerClearFormattingShortcut(editor);
      this.registerApplyNormalTextShortcut(editor);
      this.registerApplyHeadingStyleShortcut(editor);
      this.registerApplyNumberedListShortcut(editor);
      this.registerApplyBulletedListShortcut(editor);
      this.registerAlignLeftShortcut(editor);
      this.registerAlignCenterShortcut(editor);
      this.registerAlignRightShortcut(editor);
      this.registerJustifyShortcut(editor);
      this.registerSuperscriptShortcut(editor);
      this.registerSubscriptShortcut(editor);
      this.registerShortcutTooltips(editor);
    });
  }

    private initializeCodeSnippetConfig() {
        if (typeof CKEDITOR !== 'undefined') {
            CKEDITOR.config.codeSnippet_lib = "/js/ckeditor/plugins/codesnippet/lib/highlight.min.js";
            CKEDITOR.config.codeSnippet_languages = {
                bash: 'Bash',
                c: 'C',
                cpp: 'C++',
                csharp: 'C#',
                css: 'CSS',
                dockerfile: 'Dockerfile',
                go: 'Go',
                graphql: 'GraphQL',
                java: 'Java',
                javascript: 'JavaScript',
                json: 'JSON',
                kotlin: 'Kotlin',
                lua: 'Lua',
                // makefile: 'Makefile',
                markdown: 'Markdown',
                nginx: 'Nginx',
                objectivec: 'Objective-C',
                // perl: 'Perl',
                php: 'PHP',
                // 'php-template': 'PHP template',
                plaintext: 'Plain text',
                python: 'Python',
                // 'python-repl': 'Python REPL',
                r: 'R',
                ruby: 'Ruby',
                rust: 'Rust',
                scala: 'Scala',
                scss: 'SCSS',
                shell: 'Shell',
                sql: 'SQL',
                swift: 'Swift',
                typescript: 'TypeScript',
                vbnet: 'VB.NET',
                // wasm: 'WebAssembly',
                xml: 'XML / HTML',
                yaml: 'YAML'
            };
        }
    }

    protected initCkEditorDisabled(idElement, isDisabled = true, height = 200) {
    let toolbarMA;

    if (!isDisabled) {
      toolbarMA = [
        ["Bold", "Italic"]
      ];
    }

    CKEDITOR.replace(idElement, {
      height,
      toolbar: isDisabled ? [] : toolbarMA,
      readOnly: isDisabled,

      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      }
    });


    CKEDITOR.config.wordcount = {
      showParagraphs: false,
      showWordCount: true,
      showCharCount: true,
    };

    CKEDITOR.on("instanceReady", function (event: any) {
      let editor = event.editor;
      let dataProcessor = editor.dataProcessor;

      if (dataProcessor != null) {
        let htmlFilter = dataProcessor.htmlFilter;
        htmlFilter.addRules({
          elements: {
            p: function (element: any) {
              let parent = element.parent;
              if (parent && parent.name.toLowerCase() == "blockquote") {
                element.name = "";
              }
              return element;
            },
          },
        });
      }
    });
  }

  protected showEditorImagePicker(editor, keyword = null) {
    if (editor.name == "article_faq") {
      this.articlesEdit.showImagePicker("single-select", editor.name);
    } else {
      this.articlesEdit.showImagePicker("multi-select", editor.name, keyword);
    }
  }

  protected showVideoPicker(editor) {
    this.articlesEdit.showVideoPicker(editor.name);
  }

    protected showTagPicker(editor: any) {
        this.articlesEdit.tagPicker.resetPagination();
        this.getTagData();

        if (editor !== null && editor === "featuredTag") {
            this.articlesEdit.showTagPicker("in-content", editor);
        } else {
            let selectedText = null;
            if (editor && editor.getSelection && typeof editor.getSelection === "function") {
                const selection = editor.getSelection().getNative
                    ? editor.getSelection().getNative()
                    : null;

                if (selection && typeof selection.toString === "function") {
                    selectedText = selection.toString();
                }
            }

            const editorName = editor && editor.name ? editor.name : "";
            this.articlesEdit.showTagPicker("in-content", editorName, selectedText);
        }
    }
    protected showQuizPicker(editor: any) {
        if (editor !== null && editor === "featuredTag") {
            this.articlesEdit.showQuizPicker("in-content", editor);
        } else {
            let selectedText = null;
            if (editor && editor.getSelection && typeof editor.getSelection === "function") {
                const selection = editor.getSelection().getNative
                    ? editor.getSelection().getNative()
                    : null;

                if (selection && typeof selection.toString === "function") {
                    selectedText = selection.toString();
                }
            }

            const editorName = editor && editor.name ? editor.name : "";
            this.articlesEdit.showQuizPicker("in-content", editorName, selectedText);
        }

        this.articlesEdit.quizPicker.resetPagination();
        this.getQuizData();
    }
    protected showPollPicker(editor: any) {
        if (editor !== null && editor === "featuredTag") {
            this.articlesEdit.showPollPicker("in-content", editor);
        } else {
            let selectedText = null;
            if (editor && editor.getSelection && typeof editor.getSelection === "function") {
                const selection = editor.getSelection().getNative
                    ? editor.getSelection().getNative()
                    : null;

                if (selection && typeof selection.toString === "function") {
                    selectedText = selection.toString();
                }
            }

            const editorName = typeof editor === "string" ? editor : (editor && editor.name ? editor.name : "");
            this.articlesEdit.showPollPicker("in-content", editorName, selectedText);
        }

        this.articlesEdit.pollPicker.resetPagination();
        this.getPollData();
    }
  protected showLinkTool() {
    let url =
      "https://datastudio.google.com/u/0/reporting/1JtF204Vz8MIa9DhToLzu4Ou2bIqTSuVt/page/4uYeB";
    //launch the link tool in new tab
    var element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected showEmbedPopUp(editor) {
    this.articlesEdit.setActiveCkEditorInstance(editor);
    this.articlesEdit.toggleEmbedPopUp(true);
    this.articlesEdit.setEmbedSourceFocused(true);
  }

  protected addUpdateBlock(editor) {
    let d = new Date();
    let dformat =
      [
        d.getFullYear(),
        ("0" + (d.getMonth() + 1)).slice(-2),
        ("0" + d.getDate()).slice(-2),
      ].join("/") +
      " " +
      [("0" + d.getHours()).slice(-2), ("0" + d.getMinutes()).slice(-2)].join(
        ":"
      ) +
      " EST";
    let authorName =
      this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
    let tag =
      '<div class="emaki-custom update"><h3>UPDATE: ' +
      dformat +
      " BY " +
      authorName.toUpperCase() +
      "</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>";

    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected addTwoColumns(editor) {
    let tag = '<table border="1" cellpadding="1" cellspacing="1"><tbody><tr><td>&nbsp;</td><td>&nbsp;</td></tr></tbody></table>';

    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected addAIKeyPoints(editor) {
    this.getAIKeyPoints(editor);

    //lock button behind permissions
    //call api and return/replace
  }

  protected getAIScores() {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }
    this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let content = this.articlesEdit.getArticleContent();

    let data = { idArticle: idArticle, content: content };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-embeddings/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected getSingleAIScore(data, target = "ai-subject-coverage") {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showScoreLoading(target);
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let content = this.articlesEdit.getArticleContent();

    data = { idArticle: idArticle, content: content, idSuggestion: data.id };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-embeddings/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetSingleAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  protected getAIContent(
    isGeneratePressed = false,
    isRequestFromPrompt = false
  ) {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }

    if (isRequestFromPrompt) {
      this.articlesEdit.sensaiPromptTemplate.showLoading();
    } else {
      this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    }
    let idBrand = this.getVnAppZone().app.params.idBrand;

    let data = {
      articleData: ko.toJSON(this.getSavePostData()),
      isGeneratePressed: isGeneratePressed,
    };

    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/content-value-suggestions/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    if (isRequestFromPrompt) {
      this.keyPointsXHRHdl.onReadyStateFunction =
        this.onGetAIContentReturnForPrompt;
    } else {
      this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    }
    this.keyPointsXHRHdl.execute();
  }
  protected onGetSingleAIContentReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        obj.articlesEdit.articleReviewHistory.setSingleSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.hideScoreLoading();
    };
  }

  protected onGetAIContentReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        let sensaiCoverageScore = obj.calculateCoverageScore(coverageResults);
        obj.articlesEdit.setSensaiCoverageScore(sensaiCoverageScore);
        obj.articlesEdit.setTotalSensaiScore();
        // obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);

        // obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(sensaiCoverageScore);
        // obj.articlesEdit.sensaiProgressBar.setScore(obj.articlesEdit.articleReviewHistory.getTotalSensaiScore(), obj.articlesEdit.getSensaiRulePointThreshold());
        obj.articlesEdit.articleReviewHistory.setSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.hideSubjectCoverageLoading("ai-subject-coverage");
    };
  }

  protected onGetAIContentReturnForPrompt(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let coverageResults = responseParsed.coverageResults;
        let sensaiCoverageScore = obj.calculateCoverageScore(coverageResults);
        obj.articlesEdit.setSensaiCoverageScore(sensaiCoverageScore);
        obj.articlesEdit.setTotalSensaiScore();

        // obj.articlesEdit.articleReviewHistory.setSensaiCoverageScore(sensaiCoverageScore);
        // obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);
        // obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(sensaiCoverageScore);
        obj.articlesEdit.sensaiPromptTemplate.setSubjectCoverage(
          coverageResults
        );
      });

      obj.articlesEdit.sensaiPromptTemplate.removeLoading();
    };
  }

  public calculateCoverageScore(coverageResults) {
    //let currentScore = this.articlesEdit.getTotalSensaiScore();
    let totalScore = 0;
    let reliableScore = 0;

    if (coverageResults && Array.isArray(coverageResults)) {
      coverageResults.forEach((element) => {
        totalScore += element.sensaiCoverageScore;
        if (element.reliabilityFeedback == "Reliable") {
          reliableScore++;
        }
      });
    }

    if (reliableScore != 0) {
      totalScore = 20 * (totalScore / (reliableScore * 2) / 0.8);

      if (totalScore > 20) {
        totalScore = 20;
      }
    }

    return totalScore;
  }

  public saveFeedback() {
    if (this.keyPointsXHRHdl) {
      this.keyPointsXHRHdl.cancelAndReset();
    }
    this.articlesEdit.showSubjectCoverageLoading("ai-subject-coverage");
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();
    let suggestions = this.articlesEdit.getSubjectCoverage();
    let data = { idArticle: idArticle, suggestions: suggestions };

    let formReq_url: string =
      "/api/brand/" +
      idBrand +
      "/ai-tools/content-value-suggestions-feedback/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.keyPointsXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.keyPointsXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.keyPointsXHRHdl.onReadyStateFunction = this.onGetAIContentReturn;
    this.keyPointsXHRHdl.execute();
  }

  public getFaqAnswer() {
    return faqEditor.getData();
  }

  public setFaqAnswer(answer) {
    faqEditor.setData(answer, function () {
      this.resetUndo();
    });
  }

  public setDirectoryItemCkEditorData(data) {
    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "article") {
      articleDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox") {
      sandboxDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "republish") {
      republishDirectoryItemDescriptionEditor.setData(data, function () {
        this.resetUndo();
      });
    }
  }

  public getDirectoryItemCkEditorData() {
    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "article") {
      return articleDirectoryItemDescriptionEditor.getData();
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox") {
      return sandboxDirectoryItemDescriptionEditor.getData();
    }

    if (this.articlesEdit.getTemplateViewModel().selectedTab() == "republish") {
      return republishDirectoryItemDescriptionEditor.getData();
    }
  }

  // public setArticleDirectoryItemCkEditorData(data) {
  //
  //     articleDirectoryItemDescriptionEditor.setData(data, function () {
  //         this.resetUndo();
  //     });
  // }
  //
  // public getArticleDirectoryItemCkEditorData() {
  //
  //     return articleDirectoryItemDescriptionEditor.getData();
  // }
  //
  //
  // public setSandboxDirectoryItemCkEditorData(data) {
  //
  //     sandboxDirectoryItemDescriptionEditor.setData(data, function () {
  //         this.resetUndo();
  //     });
  // }
  //
  // public getSandboxDirectoryItemCkEditorData() {
  //
  //     return sandboxDirectoryItemDescriptionEditor.getData();
  // }

  public setImageDescription(description) {
    imageDescriptionEditor.setData(description, function () {
      this.resetUndo();
    });
  }

  public setImageCaption(caption) {
    imageCaptionEditor.setData(caption, function () {
      this.resetUndo();
    });
  }

  public setGalleryDescription(description) {
    galleryDescriptionEditor.setData(description, function () {
      this.resetUndo();
    });
  }

  public setGalleryCreditText(creditText) {
    galleryCreditTextEditor.setData(creditText, function () { })
  }

  public getGalleryCreditText() {
    return galleryCreditTextEditor.getData();
  }

  public getImageDescription(description) {
    return imageDescriptionEditor.getData();
  }

  public getGalleryDescription(description) {
    return galleryDescriptionEditor.getData();
  }

  public getImageCaption(description) {
    return imageCaptionEditor.getData();
  }

  public clearFaqAnswer() {
    faqEditor.setData(null);
  }

  public getBulkImageDescription() {
    return bulkImageDescriptionEditor.getData();
  }

  public getBulkImageCaption() {
    return bulkImageCaptionEditor.getData();
  }

  protected getArticleReferences() {
    // LOADING : starts
    this.loadingIn(this.articlesEdit.builtTemplate);
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/references";
    let usrReq_params: Array<Array<string>> = [];
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
    this.XHRHdl.execute();
  }

  protected getArticleAnalytics() {
    // LOADING : starts
    if (this.XHRHdls["getArticleAnalytics"]) {
      this.XHRHdls["getArticleAnalytics"].cancelAndReset();
    }
    if (
      this.articlesEdit.getTopKeyWordAnalytics() == null ||
      this.articlesEdit.getTopKeyWordAnalytics().length < 1
    ) {
      let analytics = document.getElementById("analytics-tab")
      if (analytics) {
        this.loadingIn(analytics);
      }

      let idBrand = this.getVnAppZone().getApp().params.idBrand;
      let idArticle = this.articlesEdit.getId();

      let usrReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/topKeywordAnalytics/get/" +
        idArticle;
      let usrReq_params: Array<Array<string>> = [];

      this.XHRHdls["getArticleAnalytics"] = new XMLHttpRequestHandler(
        usrReq_url,
        usrReq_params,
        this
      );
      this.XHRHdls["getArticleAnalytics"].onReadyStateFunction =
        this.onGetKeywordAnalyticsReturn;
      this.XHRHdls["getArticleAnalytics"].execute();
    }
  }

  protected onGetKeywordAnalyticsReturn(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.setTopKeyWordAnalytics(responseParsed);
      });
      let analytics = document.getElementById("analytics-tab")
      if (analytics) {
        obj.loadingOut(analytics);
      }
    };
  }

  protected getShortTermReport() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    chartDiv = document.getElementById("shortTermReportChart");
    if (chartDiv) {
      this.loadingIn(chartDiv);
    }

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let idArticle = this.articlesEdit.getId();

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/shortTermReport/get/" +
      idArticle;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push([
      "data",
      this.articlesEdit
        .getArticleAnalytics()
        .getTemplateViewModel()
        .shortTermReportRange(),
    ]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetShortTermReportReturn;
    this.XHRHdl.execute();
  }

  protected onGetShortTermReportReturn(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(
          req.request.response,
          function (key, value) {
            if (
              key == "date" ||
              key == "publishDate" ||
              key == "republishDate"
            ) {
              return new Date(value);
            } else {
              return value;
            }
          }
        );
        obj.articlesEdit.setShortTermReport(responseParsed);
      });
      if (obj.getChartDiv()) {
        obj.loadingOut(obj.getChartDiv());
      }
    };
  }

  protected onReferenceRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        obj.publishStatuses = responseParsed.publishStatuses;
        obj.articlesEdit.setPublishStatuses(responseParsed.publishStatuses);
        obj.articlesEdit.setArticleStatusOptions(responseParsed.statuses);
        obj.articlesEdit.setPermissions(responseParsed.permissions);
        obj.articlesEdit.setBrand(responseParsed.brand);
        obj.articlesEdit.setListOrder(responseParsed.defaultListOrder);
        obj.articlesEdit.setArticleTypesWithFAQ(responseParsed.articleTypesWithFAQ);
        obj.articlesEdit.setAudioReaderAllowedTemplateIds(responseParsed.audioReaderAllowedTemplateIds);
        let networkCategories = responseParsed.networkCategories;
        networkCategories.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setNetworkCategoryOptions(networkCategories);
        let paymentCategories = responseParsed.postPaymentCategory;
        obj.articlesEdit.setPaymentCategoryOptions(paymentCategories);
        let intents = responseParsed.intent;
        intents.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setIntentOptions(intents);
        let contentTypes = [...responseParsed.contentType];
        contentTypes.unshift({ id: null, name: "Select an Option" });
        obj.articlesEdit.setContentTypeOptions(contentTypes);

        let segments = responseParsed.segments;
        obj.articlesEdit.setSegmentOptions(segments);

        const classification = responseParsed.classification;
        obj.articlesEdit.setClassificationOptions(classification);
        obj.articlesEdit.setClassificationAllOptions(classification);

        obj.articlesEdit.setCategoryFilterItems(responseParsed.categories);
        obj.articlesEdit.setContentPresets(responseParsed.contentPresets);
        //let productTypes = responseParsed.tagTypes;
        //productTypesobj.articlesEdit.setProductTypeOptions(productTypes);//TODO: Remove this along with any unnecessary related code
        let tagAwards = responseParsed.tagAwards;
        obj.articlesEdit.setReviewItemTagOptions(tagAwards);

        obj.articlesEdit.setAffiliateLinksOptions(responseParsed.affiliates);

        obj.articlesEdit.setAmazonOnsite(responseParsed.amazonOnsite);
        obj.articlesEdit.setNewsletterServiceType(
          responseParsed.newsletterServiceType
        );

        obj.articlesEdit.tagPicker.setTagViewBadgeOptions(
          responseParsed.badges
        );
        obj.articlesEdit.setDefaultFeaturedTags(
          responseParsed.defaultFeaturedTags
        );
        obj.articlesEdit.setDefaultFeaturedImage(
          responseParsed.defaultFeaturedImage
        );

        let validAutoPricingPartnerNames = [];
        if (responseParsed.validAutoPricingPartnerNames) {
          validAutoPricingPartnerNames =
            responseParsed.validAutoPricingPartnerNames;
          obj.articlesEdit.setValidAutoPricingPartnerNames(
            validAutoPricingPartnerNames
          );
        }
        obj.articlesEdit.setNewsletterTemplates(
          responseParsed.newsletterTemplates
        );
        obj.articlesEdit.setNewsletterMailingLists(responseParsed.mailingLists);

        obj.articlesEdit.setArticlePageSettings(
          responseParsed.articlePagesSettings
        );
        //obj.articlesEdit.setAuthorPrompts(responseParsed.authorAgreements);
        obj.articlesEdit.setSegments(responseParsed.segments);

        obj.articlesEdit.articlePicker.setNetworkCategoryFilterItems(
          responseParsed.groupCategory
        );
        let articlePickerContentTypes = [...responseParsed.contentType];
        articlePickerContentTypes.sort((a, b) => a.index - b.index);
        obj.articlesEdit.articlePicker.setContentTypeFilterItems(
          articlePickerContentTypes
        );
        obj.articlesEdit.articlePicker.setCategoryFilterItems(
          responseParsed.categories
        );
        obj.articlesEdit.articlePicker.setClassificationFilterItems(
          responseParsed.classification
        );
        obj.articlesEdit.articlePicker.setIntentFilterItems(
          responseParsed.intents || []
        );

        let videoPickerContentTypes = articlePickerContentTypes;
        videoPickerContentTypes.unshift({ id: null, name: "Select an Option" });

        obj
          .getVideoPickerTemplate()
          .setCategoryFilter(responseParsed.categories);
        let contentTypeNames = [
          "Trailer",
          "Guide",
          "Feature",
          "News",
          "List",
          "Interview",
          "Podcast",
          "Review",
        ];
        //loop through contentTypes and if name matches any of the content type names create new array
        let filteredContentTypes = [];
        for (let i = 0; i < contentTypeNames.length; i++) {
          let contentType = contentTypeNames[i];
          let option = videoPickerContentTypes.find(
            (x) => x.name == contentType
          );
          if (option) {
            filteredContentTypes.push(option);
          }
        }
        obj
          .getVideoPickerTemplate()
          .setContentTypeFilter(videoPickerContentTypes);
        obj.getVideoPickerEditTemplate().setContentTypes(filteredContentTypes);
        obj
          .getVideoPickerEditTemplate()
          .setCategories(responseParsed.categories);

        let subtitlesLanguages = responseParsed.languages;
        //subtitlesLanguages.unshift({ id: null, name: "Select an Option" });
        obj
          .getVideoPickerEditTemplate()
          .setSubtitlesLanguages(subtitlesLanguages);

        obj.articlesEdit.setTemplateLayouts(responseParsed.templateLayouts);

        obj.editArticleData();
      });
    };
  }

  protected setPublishStatusOptions(article_data) {
    let permissions = this.articlesEdit.getPermissions();
    let publishStatus_options = this.publishStatuses;

    //1=unpublished,2=scheduled,3=published,4=republished
    let allowedStatusIds = [1, 2, 3];
    //completed
    if (article_data["status"]["id"] == 6) {
      //unpublished
      if (
        article_data["publishStatus"]["id"] == 1 &&
        !permissions["article_edit_publishingControl"].write
      ) {
        allowedStatusIds = [1];
      } else if (
        article_data["publishStatus"]["id"] != 1 &&
        article_data["publishStatus"]["id"] != 4
      ) {
        allowedStatusIds = [1, 2, 3];
      } else if (article_data["publishStatus"]["id"] == 4) {
        allowedStatusIds = [1, 2, 3, 4];
      }
    } else {
      allowedStatusIds = [1];
    }

    let status_options = publishStatus_options.filter(function (item) {
      return allowedStatusIds.indexOf(item.id) != -1;
    });

    this.articlesEdit.setPublishStatuses(status_options);
  }

  protected setArticleStatusOptions(article_data) {
    let permissions = this.articlesEdit.getPermissions();
    let articleStatus_options = this.articlesEdit.getArticleStatusOptions();
    let articleRepublishStatus_options = articleStatus_options;

    //1=draft,2=submittedforapproval,3=changesrequired,6=completed,7=trashed
    let allowedStatusIds = [1, 2, 3, 6, 7];

    //unpublished
    if (
      article_data["publishStatus"]["id"] == 1 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [1, 2, 3, 7];
    } else if (article_data["publishStatus"]["id"] != 1) {
      allowedStatusIds = [6, 7];
    }

    //if completed and user has publishing control, allow any status
    if (
      article_data["status"]["id"] == 6 &&
      permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [1, 2, 3, 6, 7];
    } else if (
      article_data["status"]["id"] == 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedStatusIds = [6];
    }

    let status_options = articleStatus_options.filter(function (item) {
      return allowedStatusIds.indexOf(item.id) != -1;
    });

    this.articlesEdit.setArticleStatusOptions(status_options);

    //repeat for trashed
    //1=draft,2=submittedforapproval,3=changesrequired,6=completed,7=trashed
    let allowedRepublishStatusIds = [1, 2, 3, 6];

    let idRepublishStatus = null;
    article_data["jsonSaves"].forEach((save) => {
      if (save.type === "republish") {
        let content = JSON.parse(save.content);
        idRepublishStatus = content.status.id;
      }
    });

    //unpublished
    if (
      idRepublishStatus != 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedRepublishStatusIds = [1, 2, 3];
    } else if (
      idRepublishStatus == 6 &&
      !permissions["article_edit_publishingControl"].write
    ) {
      allowedRepublishStatusIds = [6];
    }

    let republish_status_options = articleRepublishStatus_options.filter(
      function (item) {
        return allowedRepublishStatusIds.indexOf(item.id) != -1;
      }
    );

    this.articlesEdit.setArticleRepublishStatusOptions(
      republish_status_options
    );
  }

  public filterMultipleSelectorOnChange(idElement) {
    if (
      idElement == "categoryFilter" ||
      idElement == "categoryVideoFilter" ||
      idElement == "contentTypeVideoFilter"
    ) {
      this.articlesEdit.videoPickerHelper.resetPagination();
      this.getVideosData();
    } else if (idElement == "filterVideoCategoryEdit") {
      this.getVideoPickerEditTemplate().updateSelectedCategories();
    } else {
      this.articlesEdit.updateSelectedCategories();
    }
  }

  protected getPaymentCategories() {
    let usrReq_url: string;

    usrReq_url =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/transaction/rate-categories/get";

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push();
    this.paymentCategoryXHR = new XMLHttpRequestHandler(
      usrReq_url,
      usrReq_params,
      this
    );
    this.paymentCategoryXHR.onReadyStateFunction =
      this.onGetPaymentCategoriesRequestReturn;
    this.paymentCategoryXHR.execute();
  }

  protected onGetPaymentCategoriesRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updatePaymentCategoryList(responseParsed.data);
      });
    };
  }

  protected updatePaymentCategoryList(responseParsed: any) {
    let paymentCategories = [];
    paymentCategories.push({ id: null, name: "Select an Option" });
    for (let item of responseParsed.paymentCategories) {
      paymentCategories.push(item);
    }

    this.viewModel.edit_template_new.paymentCategoryFilter.setOptions(
      paymentCategories
    );
    this.viewModel.edit_template_new.scheduledRepublishPaymentCategoryFilter.setOptions(
      paymentCategories
    );
  }

  protected editArticleData(takeover = false) {
    // Clear autosave timers when loading a new article to prevent race conditions
    this.clearRecoverySave();
    this.cancelRecoveryRequest();
    this.clearRecoveryWarning();

    this.loadingIn(this.articlesEdit.builtTemplate);
    let id: number = this.getArticleIdFromUrl();

    if(!id){
      id = undefined;
    }

    if (id && !isNaN(id)) {
      const currentId = this.articlesEdit.getTemplateViewModel().id();
      if (currentId && currentId !== id) {
        console.warn('[editArticleData] ID mismatch detected! Current:', currentId, 'URL:', id, '- Using URL');
      }
      console.log('[editArticleData] Setting article ID:', id);
      console.log('[editArticleData] Current content before destroy:', contentEditor ? contentEditor.getData().substring(0, 50) : 'N/A');
      this.articlesEdit.getTemplateViewModel().id(id);
    }
    this.startArticleDataLoading();

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/getForEdit/" +
      id +
      "?takeover=" +
      takeover;
    let usrReq_params: Array<Array<string>> = [];

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
    this.XHRHdl.execute();
  }

  protected onFilterRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        let hydratedArticle = null;
        if (
          req.request.status == 423 &&
          obj.articlesEdit.getPermissions()["article_edit_takeover"] &&
          obj.articlesEdit.getPermissions()["article_edit_takeover"].read
        ) {
          let responseParsed = JSON.parse(req.request.response);

          obj.articlesEdit.setLockMessage(responseParsed.message);
          obj.articlesEdit.setIsLockMessageVisible(true);

          // only show this if not taking over
          //obj.articlesEdit.enableAutosaveBox();

          // Set autosave notice since it could not autosave after a lock
          //obj.articlesEdit.showAutoSaveMessage("Post has been taken over, save changes manually");
        } else {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);

            const {
              article,
              displayAuthors,
              userPreferences,
              directory,
              plagiarismResults,
              defaultThreadsImage,
              permalinkHistory,
              permalinkRedirects,
              articleRecommendations,
              emakiAssistantAgentId,
              emakiAssistantEngagementAgentId,
              isAutoLinkerEnabled,
            } = responseParsed.data;
            hydratedArticle = article;

            obj.articlesEdit.setPermalinkHistory(permalinkHistory);
            obj.articlesEdit.setPermalinkRedirect(permalinkRedirects);

            obj.setArticleStatusOptions(article);
            obj.updateChatHistoryOnArticleSave(article);
            obj.setArticleData(article);
            obj.setDisplayAuthors(displayAuthors);
            obj.articlesEdit.getTemplateViewModel().emakiAssistantAgentId(emakiAssistantAgentId !== undefined ? emakiAssistantAgentId : null);
            obj.articlesEdit.getTemplateViewModel().emakiAssistantEngagementAgentId(emakiAssistantEngagementAgentId !== undefined ? emakiAssistantEngagementAgentId : null);
            obj.setUserPreferences(userPreferences);
            //Overriding the current request stack with this if statement
            //Params are not detected until the next request

            if (window.location.pathname.includes('/add')) {
              let queryParams = new URLSearchParams(window.location.search);
              if (queryParams.has('videoId')) {
                //Hard coded 15 (video template) but this will be overrided by the autofill anyways
                obj.articlesEdit.setIdTemplate(15);
                let idBrand = obj.getVnAppZone().app.params.idBrand;

                // show the segment selection popup for SR only.
                if (idBrand == 6) {
                  obj.articlesEdit.setShowSegmentTab(true);
                }
              }
              if (queryParams.has('idThreadSuggestion')) {
                let idThreadSuggestion = queryParams.get('idThreadSuggestion');

                obj.articlesEdit.setIdTemplate(16);
              }
            }

            if (responseParsed.data.directory) {
              obj.articlesEdit.setDirectoryArticle(directory);
            }

            //obj.articlesEdit.enableAutosaveBox();
            obj.setPublishStatusOptions(article);
            obj.setPinnedTags(article);
            obj.setPlagiarismResults(plagiarismResults);
            obj.setDefaultThreadsImage(defaultThreadsImage);
            if (responseParsed.data.isAdmin) {
              obj.articlesEdit.setIsAdmin(responseParsed.data.isAdmin);
            }

            obj.setReviewTag(article);

            const articleEditVM = {
              ...obj.articlesEdit.getTemplateViewModel(),
            };
            obj.articlesEdit.imageWidgetForFeaturedImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.imageWidgetForThumbnailImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.imageWidgetForAlternateImage.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.articlePinnedTags.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.articlePinnedTags.filterTagType.setIsPublishingControl(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.filterCategory.setIsDisabled(
              articleEditVM.isPublishingControl()
            );
            obj.articlesEdit.articleRecommendations.setRecommendedArticles(articleRecommendations);
            obj.articlesEdit.setIsAutoLinkerEnabled(isAutoLinkerEnabled);
          });
        }
        if (obj.isArticleDataLoading) {
          obj.finishArticleDataLoading(hydratedArticle);
        }
        //obj.filterByUrl();
        obj.updateViewModelFromPath();
        obj.loadingOut(obj.articlesEdit.builtTemplate);

        obj.toggleAllCloseFilterUserButton(obj.articlesEdit);
        obj.getWidgetsArticleReferences();
      }
    };
  }
  protected filterByUrl() {
    this.updateViewModelFromPath();
  }
  private toggleAllCloseFilterUserButton(articlesEdit) {
    const {
      filterUser_author,
      filterUser_SrEditor,
      filterUser_JrEditor,
      filterUser_ideator,
      filterUser_republish_author,
      filterUser_republish_SrEditor,
      filterUser_republish_JrEditor,
      filterUser_scheduled_republish_author,
      filterUser_scheduled_republish_SrEditor,
      filterUser_scheduled_republish_JrEditor,
      filterUser_display_author,
    } = articlesEdit;

    filterUser_author.toggleCloseButton();
    filterUser_SrEditor.toggleCloseButton();
    filterUser_JrEditor.toggleCloseButton();
    filterUser_ideator.toggleCloseButton();
    filterUser_republish_author.toggleCloseButton();
    filterUser_republish_SrEditor.toggleCloseButton();
    filterUser_republish_JrEditor.toggleCloseButton();
    filterUser_scheduled_republish_author.toggleCloseButton();
    filterUser_scheduled_republish_SrEditor.toggleCloseButton();
    filterUser_scheduled_republish_JrEditor.toggleCloseButton();
    filterUser_display_author.toggleCloseButton();
  }

  public setPlagiarismResults(plagiarismResults) {
    this.articlesEdit.setPlagiarismResults(
      plagiarismResults ? plagiarismResults : []
    );
  }

  public setDefaultThreadsImage(defaultThreadsImage) {
    this.articlesEdit.setDefaultThreadsImage(defaultThreadsImage);
  }

  public setPinnedTags(article_data) {
    this.articlesEdit.articlePinnedTags.setTitle(article_data.pinnedTagsTitle);
    this.articlesEdit.articlePinnedTags.setPosition(
      article_data.pinnedTagsPosition
    );
    this.articlesEdit.articlePinnedTags.setSelectedStyle(
      article_data.pinnedTagsStyle
    );

    if (article_data.pinnedTagType) {
      article_data.pinnedTagType.name += ` ${article_data.pinnedTagType.formattedDataset}`;
      this.articlesEdit.articlePinnedTags.filterTagType.setOption(
        article_data.pinnedTagType
      );

      //set option for specs
      let filters = article_data.pinnedTagType.fields.filter(
        (v) => v.dataType != "tags"
      );
      let filterOptions = filters.map((v) => ({ name: v.label, id: v.id }));
      filterOptions.unshift({ name: "Select an option", id: null });
      this.articlesEdit.articlePinnedTags.setTagSpecs(filterOptions);
      this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedTagSpec(article_data.pinnedTagsSpecs[0]);

      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(true);
    }

    if (article_data.pinnedTags) {
      let tags = [];

      article_data.pinnedTags.forEach((tag) => {
        tag.tag.name += `  ${tag.tag.formattedTagTypeAndDataset}`;
        tags.push(tag.tag);
      });

      this.articlesEdit.articlePinnedTags.setTags(tags);

      const showPinnedTags = tags.length > 0;
      this.articlesEdit.setShowPinnedTags(showPinnedTags);
    }
  }

  public setReviewTag(article_data) {
    if (article_data.reviewTag) {
      this.articlesEdit.filterReviewTag.setOption(article_data.reviewTag);
      this.articlesEdit.getTemplateViewModel().tagReviewedByArticle(article_data.reviewTag);
    }
  }

  /**
   * Pillars on emaki_article are for the parent row; any republish history stores scores on republish rows
   * (article.republishes, newest first). Prefer the draft republish id when the republish UI is active.
   */
  protected applyRepublishEeatScoresToViewModelIfActive(article_data: any): void {
    const republishes = article_data["republishes"];
    if (!republishes || !republishes.length) {
      return;
    }
    const vm = this.articlesEdit.getTemplateViewModel();
    const republishUi = vm.isRepublishActive && vm.isRepublishActive();
    const rid =
      republishUi && vm.idRepublish ? vm.idRepublish() : null;
    let rep = republishes[0];
    if (rid != null && rid !== "") {
      const match = republishes.find((r: any) => String(r.id) === String(rid));
      if (match) {
        rep = match;
      }
    }
    this.articlesEdit.setEeatScoresFromArticleData(rep);
  }

  public setJsonSaves(article_data) {
    this.articlesEdit.getTemplateViewModel().idRepublish(null);
    this.articlesEdit.getTemplateViewModel().isRepublishActive(false);
    //Managing recovery & sandbox & revisions
    if (article_data["jsonSaves"] && article_data["jsonSaves"].length > 0) {
      let revisions = [];

      article_data["jsonSaves"].forEach((save) => {
        save.content = JSON.parse(save.content);
        save.content.reviewItems =
          typeof save.content.reviewItems === "string"
            ? JSON.parse(save.content.reviewItems)
            : save.content.reviewItems;
        save.content.directoryItems =
          typeof save.content.directoryItems === "string"
            ? JSON.parse(save.content.directoryItems)
            : save.content.directoryItems;

        if (save.type === "sandbox") {
          this.articlesEdit.getTemplateViewModel().isSandboxActive(true);
          this.setSandboxContent(save.content.content);
          this.setSandboxIntroText(save.content.introText);
          this.articlesEdit.setSandboxReviewItems(save.content.reviewItems);
          this.articlesEdit.sandboxDirectory.setSandboxDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "republish") {
          this.articlesEdit.getTemplateViewModel().isRepublishActive(true);
          this.setRepublishContent(save.content.content);
          this.setRepublishIntroText(save.content.introText);
          this.articlesEdit.productReviewRepublish.setReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.republishDirectory.setSandboxDirectoryItems(
            save.content.directoryItems
          );
          this.articlesEdit
            .getTemplateViewModel()
            .idRepublishStatus(save.content.status.id);

          let republishes = save.content.republishes;
          if (republishes && republishes.length > 0) {
            let republish = republishes[0];
            this.articlesEdit.republishDatePicker.setDate(
              republish.dateRepublished
            );
            if (republish.author) {
              this.articlesEdit.filterUser_republish_author
                .getTemplateViewModel()
                .user(republish.author.valnet_user.fullNameAndLogin);
              this.articlesEdit.filterUser_republish_author
                .getTemplateViewModel()
                .idUser(republish.author.id);
            }
            if (republish.editor) {
              this.articlesEdit.filterUser_republish_SrEditor
                .getTemplateViewModel()
                .user(republish.editor.valnet_user.fullNameAndLogin);
              this.articlesEdit.filterUser_republish_SrEditor
                .getTemplateViewModel()
                .idUser(republish.editor.id);
            }
            if (republish.juniorEditor) {
              this.articlesEdit.filterUser_republish_JrEditor
                .getTemplateViewModel()
                .user(
                  republish.juniorEditor
                    ? republish.juniorEditor.valnet_user.fullNameAndLogin
                    : ""
                );
              this.articlesEdit.filterUser_republish_JrEditor
                .getTemplateViewModel()
                .idUser(
                  republish.juniorEditor ? republish.juniorEditor.id : ""
                );
            }
            if (republish.postPaymentCategory) {
              this.articlesEdit.paymentCategoryFilter.setSelectedOption(
                republish.postPaymentCategory.id
              );
            }
            if (republish.percentageAuthor) {
              this.articlesEdit
                .getTemplateViewModel()
                .choosenPaymentTypeRepublish("Percentage");
              this.articlesEdit
                .getTemplateViewModel()
                .percentageAuthor(republish.percentageAuthor);
            }
            if (republish.amountAuthor) {
              this.articlesEdit
                .getTemplateViewModel()
                .choosenPaymentTypeRepublish("Amount");
              this.articlesEdit
                .getTemplateViewModel()
                .amountAuthor(republish.amountAuthor);
            }
            this.articlesEdit
              .getTemplateViewModel()
              .percentageEditor(republish.percentageEditor);

            this.articlesEdit.getTemplateViewModel().republishIsUnderEmbargo(!!republish.isUnderEmbargo);
            if (republish.id != null && republish.id !== "") {
              this.articlesEdit.getTemplateViewModel().idRepublish(republish.id);
            }
          }
        } else if (save.type === "recovery") {
          this.articlesEdit.setRecoveryContent(save.content.content);
          this.articlesEdit.setRecoveryIntroText(save.content.introText);
          this.articlesEdit.setRecoveryReviewItems(save.content.reviewItems);
          this.articlesEdit.setDateRecovery(save.dateUpdated);
          this.articlesEdit.setRecoveryUser(
            save.content.author.valnet_user.fullName
          );
          this.articlesEdit.setRecovery(save.content);
          this.articlesEdit.recoveryDirectory.setDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "sandboxRecovery") {
          this.articlesEdit.setSandboxRecoveryContent(save.content.content);
          this.articlesEdit.setSandboxRecoveryIntroText(save.content.introText);
          this.articlesEdit.setRecoverySandboxReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.setSandboxRecovery(save.content);
          this.articlesEdit.recoverySandboxDirectory.setDirectoryItems(
            save.content.directoryItems
          );
        } else if (save.type === "republishRecovery") {
          this.articlesEdit.setRepublishRecoveryContent(save.content.content);
          this.articlesEdit.setRepublishRecoveryIntroText(
            save.content.introText
          );
          this.articlesEdit.setRecoveryRepublishReviewItems(
            save.content.reviewItems
          );
          this.articlesEdit.recoveryRepublishDirectory.setDirectoryItems(
            save.content.directoryItems
          );
          this.articlesEdit.setRepublishRecovery(save.content);
          this.articlesEdit.setRecoveryRepublishData(
            save.content.republishes ? save.content.republishes[0] : []
          );
        } else if (save.type === "revision") {
          //revisions.push(save.content)
          revisions.push(save);
        }
      });

      this.articlesEdit.setRevisions(revisions);
      if (revisions.length > 0) {
        this.articlesEdit.setIdRevisionSelected(revisions[0].content.id);
        this.articlesEdit.setRevisionContent(revisions[0].content.content);
        this.articlesEdit.setRevisionIntroText(revisions[0].content.introText);
        this.articlesEdit.setRevisionReviewItems(
          revisions[0].content.reviewItems
        );
        this.articlesEdit.revisionDirectory.setDirectoryItems(
          revisions[0].content.directoryItems
        );
      }
    }
  }



  public setArticleData(article_data: Object, type = "set"): void {
    // @TODO: these constants should not be hard-coded!
    if (type == "set") {
      //init ck editors
      this.initializeCkEditors();
      this.initializePromptResponseCKEditor();
    }

    if (article_data["contentKeyPointsGenerationAttempts"]) {
      this.keyPointsAttempts =
        article_data["contentKeyPointsGenerationAttempts"];
    }

    const templates = {
      Regular: 2,
      List: 3,
      "Product Review": 5,
      "Buyer's Guide": 6,
      Directory: 7,
      "Buyer's Guide Light": 9,
      Deals: 10,
      Versus: 11,
      Collection: 12,
      Video: ID_TEMPLATE_VIDEO,
      Thread: ID_TEMPLATE_THREAD,
    };
    const defaultTemplate = "Regular";
    const defaultTemplateId = 2;

    let url = new URL(window.location.href);
    let title = article_data["title"] ? article_data["title"] : "";
    let template_id = article_data["template"]
      ? article_data["template"]["id"]
      : "";
    let template = article_data["template"]
      ? article_data["template"]["name"]
      : "";
    let permalink = article_data["permalink"];

    if (url.searchParams.has("title") && !article_data["title"]) {
      title = url.searchParams.get("title");
      // check if the value is URL encoded
      if (title !== decodeURIComponent(title)) {
        // decode the value if it's URL encoded
        title = decodeURIComponent(title);
      }
    }

    if (url.searchParams.has("template") && !article_data["template"]) {
      let template_param = url.searchParams.get("template");
      // check if the value is URL encoded
      if (template_param !== decodeURIComponent(template_param)) {
        // decode the value if it's URL encoded
        template_param = decodeURIComponent(template_param);
      }
      if (template_param in templates) {
        template_id = templates[template_param];
        template = template_param;
      } else {
        // default to regular template..
        template_id = defaultTemplateId;
        template = defaultTemplate;
      }
      //this.initializeCkEditors();
      this.articlesEdit.onClickTemplateTab(template_id, null);
    }

    if (url.searchParams.has("permalink") && !article_data["permalink"]) {
      permalink = url.searchParams.get("permalink");
      // check if the value is URL encoded
      if (permalink !== decodeURIComponent(permalink)) {
        // decode the value if it's URL encoded
        permalink = decodeURIComponent(permalink);
      }
      // MLT uses slashless canonical permalinks; other brands retain the legacy format.
      if (permalink !== "") {
        permalink = permalink.trim();
        const hasLeadingSlash = permalink.charAt(0) === "/";
        const isMltBrand = Number(this.getIdBrand()) === 50;
        permalink = (hasLeadingSlash ? "" : "/") + permalink;

        if (isMltBrand) {
          permalink = permalink.replace(/\/+$/, "");
        } else if (permalink.charAt(permalink.length - 1) !== "/") {
          permalink += "/";
        }
      }
    }

    this.articlesEdit.setId(article_data["id"]);
    this.articlesEdit.setIdTemplate(template_id);
    let idTemplateLayoutDefault = article_data["templateLayout"]
      ? article_data["templateLayout"]["id"]
      : null;
    this.articlesEdit.setTemplateLayoutsFiltered(
      template_id,
      idTemplateLayoutDefault
    );

    if (template_id == ID_TEMPLATE_VIDEO) {
      this.articlesEdit.setVideoTemplateDefaults();
    } else if (template_id == ID_TEMPLATE_THREAD) {
      this.articlesEdit.setThreadTemplateDefaults();
    }

    this.articlesEdit.setTitle(title);
    this.articlesEdit.setDateUpdated(
      article_data["dateUpdated"] ? article_data["dateUpdated"] : ""
    );
    this.articlesEdit.setDateCreated(
      article_data["dateCreated"] ? article_data["dateCreated"] : ""
    );
    this.articlesEdit.setExcerpt(article_data["excerpt"]);
    this.articlesEdit.setReference(article_data["reference"]);
    if (article_data["listOrder"]) {
        this.articlesEdit.setListOrder(article_data["listOrder"]);
    }
    this.articlesEdit.setSeoTitle(article_data["seoMetaTitle"]);
    this.articlesEdit.setSeoDescription(article_data["seoMetaDescription"]);
    this.articlesEdit.setSmoTitle(article_data["socialMediaTitle"]);
    this.articlesEdit.setSmoDescription(article_data["socialMediaExcerpt"]);
    this.articlesEdit.setSocialTagLine(article_data["socialTagLine"]);
    this.articlesEdit.setFileUrl(article_data["pdf"]);
    this.articlesEdit.setTableOfContents(article_data["tableOfContents"]);
    this.articlesEdit.setFaqs(article_data["faq"]);
    this.articlesEdit.setIsSponsored(article_data["isSponsored"]);
    this.articlesEdit.setIdIntent(
      article_data["intent"] ? article_data["intent"]["id"] : ""
    );
    this.articlesEdit.setIdNetworkCategory(
      article_data["networkCategory"]
        ? article_data["networkCategory"]["id"]
        : ""
    );
    this.articlesEdit.setIdContentType(
      article_data["contentType"] ? article_data["contentType"]["id"] : ""
    );
    this.articlesEdit.setIdSegment(
      article_data["segment"] ? article_data["segment"]["id"] : "",
      article_data["segment"] ? article_data["segment"] : null,
    );
    this.articlesEdit.setIdPaymentCategory(
      article_data["postPaymentCategory"]
        ? article_data["postPaymentCategory"]["id"]
        : ""
    );
    this.articlesEdit.setReviewCategory(
      article_data["reviewCategory"] ? article_data["reviewCategory"] : ""
    );
    this.articlesEdit.setIsAdHidden(article_data["isAdHidden"]);
    this.articlesEdit.setIsUnderEmbargo(article_data["isUnderEmbargo"]);
    this.articlesEdit.setIsAmpDisabled(
      article_data["isAmpEnabled"] ? false : true
    );
    this.articlesEdit.setInstareadOption(article_data["isInstareadEnabled"] || false);
    this.articlesEdit.setAudioReaderState({
      isAudioReaderEnabled: article_data["isAudioReaderEnabled"] || false,
      audioReaderFileUrl: article_data["audioReaderFileUrl"] || "",
      latest: null,
    });
    this.fetchArticleAudioReader();
    this.articlesEdit.setIsDevelopingStory(article_data["isDevelopingStory"]);

    // Set syndicated from isSyndicated field
    this.articlesEdit.setIsSyndicated(article_data["isSyndicated"] || false);
    this.articlesEdit.setNoAuthorship(article_data["noAuthorship"] || false);
    this.articlesEdit.setExternalAuthorName(article_data["external_author_name"]);
    this.articlesEdit.setIsLinkToOriginalArticle(article_data["isLinkToOriginalArticle"] || false);

    this.articlesEdit.setPinnedTag(article_data["pinnedTag"]);
    this.articlesEdit.setTemplate(template);
    this.articlesEdit.setIsFeaturedImageHidden(
      article_data["isFeaturedImageHidden"]
        ? article_data["isFeaturedImageHidden"]
        : false
    );
    this.articlesEdit.setIsCommentsDisabled(
      article_data["isCommentsDisabled"]
        ? article_data["isCommentsDisabled"]
        : false
    );
    this.articlesEdit.setIsCommentsPaused(
      article_data["isCommentsPaused"]
        ? article_data["isCommentsPaused"]
        : false
    );
    this.articlesEdit.setIsRatingEnabled(
      article_data["isRatingEnabled"] ? article_data["isRatingEnabled"] : false
    );
    this.articlesEdit.setIsReadNextDisabled(
      article_data["isReadNextDisabled"]
        ? article_data["isReadNextDisabled"]
        : false
    );
    this.articlesEdit.setIsDisplayCardQuickLinksShown(
      article_data["isDisplayCardQuickLinksShown"]
        ? article_data["isDisplayCardQuickLinksShown"]
        : false
    );
    this.articlesEdit.setIsDisplayCardQuickLinksMobileShown(
      article_data["isDisplayCardQuickLinksMobileShown"]
        ? article_data["isDisplayCardQuickLinksMobileShown"]
        : false
    );
    this.articlesEdit.setIsSidebarHidden(article_data["isSidebarHidden"]);
    this.articlesEdit.setIsExcerptHidden(article_data["isExcerptHidden"]);
    this.articlesEdit.setIsAffiliateLinkerEnabled(
      article_data["isAffiliateLinkerEnabled"]
    );
    this.articlesEdit.setFeaturedTags(article_data["featuredTagGroup"]);
    this.articlesEdit.setSensaiRulePointThreshold(
      article_data["contentType"] &&
        article_data["contentType"]["sensaiRulePointThreshold"]
        ? article_data["contentType"]["sensaiRulePointThreshold"]
        : 35
    );
    this.articlesEdit.setSensaiCoverageScore(
      article_data["sensaiCoverageScore"]
    );
    this.articlesEdit.setSensaiRuleScore(article_data["sensaiRuleScore"]);
    this.articlesEdit.setTotalSensaiScore();
    this.articlesEdit.setEeatScoresFromArticleData(article_data);
    if (
      article_data["featuredTagGroup"] !== null &&
      article_data["featuredTagGroup"]["tagObject"] !== null &&
      article_data["featuredTagGroup"]["tagObject"].length > 1
    ) {
      if (article_data["featuredTagGroup"].block.style == "versus") {
        this.articlesEdit.setIsVersusStyle(true);
      }
    } else {
      this.articlesEdit.setIsVersusStyle(false);
    }
    //this.updateKeyPointsButton(article_data['contentKeyPointsGenerationAttempts']);

    this.articlesEdit.setAutoCategorizationGenerationAttemptsRemaining(
      article_data["autoCategorizationGenerationAttempts"]
    );

    if (
      article_data["pinnedTag"] ||
      (article_data["featuredTagGroup"] &&
        article_data["featuredTagGroup"]["tagObject"])
    ) {
      this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedTagActive(
        true
      );
      this.articlesEdit.setIsFeaturedTagActive(true);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredTag");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredTag");
    }

    if (article_data["isHiddenFromAllSite"]) {
      this.articlesEdit.setDisplayConfiguration(3);
    } else if (
      article_data["isHiddenFromTrending"] &&
      article_data["isHiddenFromHomePage"]
    ) {
      this.articlesEdit.setDisplayConfiguration(24);
    } else if (article_data["isHiddenFromHomePage"]) {
      this.articlesEdit.setDisplayConfiguration(2);
    } else if (article_data["isHiddenFromTrending"]) {
      this.articlesEdit.setDisplayConfiguration(4);
    }

    this.articlesEdit.disableContributorFields();

    if (article_data["author"]) {
      this.articlesEdit.setAuthor(article_data["author"]);
    }

    if (article_data["editor"]) {
      this.articlesEdit.setEditor(article_data["editor"]);
    }

    if (article_data["juniorEditor"]) {
      this.articlesEdit.setJrEditor(article_data["juniorEditor"]);
    }

    if (article_data["ideator"]) {
      this.articlesEdit.setIdeator(article_data["ideator"]);
    }

    this.articlesEdit.getTemplateViewModel().articleAiAgents(article_data["aiAgents"] ? article_data["aiAgents"] : []);

    //featuredImage
    if (article_data["featuredImage"]) {
      let featuredImage = article_data["featuredImage"];
      featuredImage.isMobileOptimized = Boolean(
        article_data["isFeaturedImageOptimized"]
      );
      this.articlesEdit.setImage(featuredImage, "featured_image");
    }
    this.articlesEdit.getTemplateViewModel().featuredThumbnailImage(article_data['thumbnail']);
    //thumbnailImage
    if (article_data["alternateImage"]) {
      this.articlesEdit.setImage(
        article_data["alternateImage"],
        "alternate_image"
      );
    }

    //thumbnailImage
    if (article_data["thumbnail"]) {
      this.articlesEdit.setImage(article_data["thumbnail"], "thumbnail_image");
    }

    //Featured video
    if (article_data["featuredVideo"]) {
      this.articlesEdit.setFeaturedVideo(article_data["featuredVideo"]);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredVideo");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredVideo");
      this.articlesEdit.getTemplateViewModel().isFeaturedVideoActive(true);
      this.articlesEdit.getTemplateViewModel().isFeaturedImageActive(false);
      this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .isFeaturedVideoActive(true);

      this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoTitle(article_data["featuredVideo"]["title"]);
      this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoDescription(article_data["featuredVideo"]["description"]);
    }

    if (article_data["featuredEmbed"]) {
      this.articlesEdit.setFeaturedEmbed(
        article_data["featuredEmbed"]["embed"]
      );
      this.articlesEdit
        .getTemplateViewModel()
        .featuredSectionValue("featuredVideo");
      this.articlesEdit
        .getTemplateViewModel()
        .chosenFeaturedSectionValue("featuredVideo");
      this.articlesEdit.getTemplateViewModel().isFeaturedVideoActive(true);
      if (!article_data["featuredVideo"]) {
        this.articlesEdit.getTemplateViewModel().isFeaturedEmbedActive(true);
        this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(
          true
        );
        this.articlesEdit.getTemplateViewModel().isFeaturedImageActive(true);
      }
      if (article_data["featuredImage"]) {
        this.articlesEdit.setImage(
          article_data["featuredImage"],
          "featured_image_embed"
        );
      }
    }

    // Must run after every setImage call, since setting an image resets its crop position
    this.articlesEdit.setImageCropPositions(article_data["imageCropPositions"] || null);

    //pinned article
    if (article_data["pinnedArticle"]) {
      this.articlesEdit.setNextArticle(article_data["pinnedArticle"]);
    }

    //this.articlesEdit.setEditor(article_data['editor'] ? article_data['editor']['valnet_user']['fullName']: "");
    //this.articlesEdit.setJrEditor(article_data['juniorEditor'] ? article_data['juniorEditor']['valnet_user']['fullName']: "");

    this.articlesEdit.setDateLastPreview(article_data["dateLastPreview"]);
    this.articlesEdit.setDatePublished(article_data["dateOriginalPublish"]);
    this.articlesEdit.setDateLastPublishStatus(
      article_data["dateLastPublishStatus"]
    );
    this.articlesEdit.setDateMostRecentPublishStatus(
      article_data["dateMostRecentPublishedStatus"]
        ? article_data["dateMostRecentPublishedStatus"].date.substring(0, 19)
        : ""
    );
    this.articlesEdit.setDateLastStatus(article_data["dateLastStatus"]);
    this.articlesEdit.setDateLastSyncStatus(article_data["dateLastSyncStatus"]);
    this.articlesEdit.setTargetAudience(
      article_data["targetAudience"]
        ? article_data["targetAudience"]["name"]
        : ""
    );
    this.articlesEdit.setIntent(
      article_data["intent"] ? article_data["intent"]["name"] : ""
    );
    this.articlesEdit.setContentType(
      article_data["contentType"] ? article_data["contentType"]["name"] : ""
    );
    this.articlesEdit.setSegment(
      article_data["segment"] ? article_data["segment"]["name"] : ""
    );
    this.articlesEdit.setNetworkCategory(
      article_data["networkCategory"]
        ? article_data["networkCategory"]["name"]
        : ""
    );
    this.articlesEdit.setPostPaymentCategory(
      article_data["postPaymentCategory"]
        ? article_data["postPaymentCategory"]["name"]
        : ""
    );
    this.articlesEdit
      .getTemplateViewModel()
      .newRepublishDate(new Date().toISOString().slice(0, 10));
    //this.articlesEdit.setArticleRepublishData(article_data["republishes"]);
    this.articlesEdit.setPermalink(permalink);
    this.articlesEdit.setIdPublishStatus(
      article_data["publishStatus"] ? article_data["publishStatus"]["id"] : ""
    );
    this.articlesEdit.setArticleCurrentIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );
    this.articlesEdit.setSyncStatus(
      article_data["syncStatus"] ? article_data["syncStatus"]["name"] : ""
    );
    this.articlesEdit.setAmazonsiteArticleTitle(
      article_data["amazonsiteArticleTitle"]
    );
    this.articlesEdit.setNewsNowArticleTitle(article_data["newsNowTitle"]);
    this.articlesEdit.setIsNewsNowArticle(article_data["isNewsNowArticle"]);
    this.articlesEdit.setIsUpdateTime(false);
    this.articlesEdit.setContentKeyPoints(article_data["contentKeyPoints"]);
    this.articlesEdit.setIsSubContent(article_data["isSubContent"]);

    this.articlesEdit.setArticleHistoricalReviewComments(
      article_data["reviewComments"]
    );

    if (article_data["dateScheduled"]) {
      this.articlesEdit.setDateScheduled(article_data["dateScheduled"]);
    } else {
      this.articlesEdit.setEasternTimeOnScheduled();
    }

    if (article_data["dateDevelopingStoryCoverageStart"]) {
      this.articlesEdit.setDateDevelopingStoryCoverageStartAndEnd(article_data["dateDevelopingStoryCoverageStart"], article_data["dateDevelopingStoryCoverageEnd"]);
    }

    //directory
    if (article_data["template"] && article_data["template"]["id"] == 7) {
      this.articlesEdit.articleDirectory.setDirectoryItemsObservable(
        article_data["directoryItems"]
      );
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems([]);
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .isUndoAllChangesEnabled(false);
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .isUndoLastDeleteEnabled(false);
    }

    if (
      article_data["template"] &&
      article_data["template"]["id"] == ID_TEMPLATE_VIDEO
    ) {
      this.articlesEdit.setVideoTemplateDefaults();
    }

    if (
      (type == "set" || type == "refreshAfterKeyPointsAdded") &&
      article_data["content"]
    ) {
      let content = article_data["content"];
      contentEditor.setData(content, function () {
        this.resetUndo();
      });
    }

    if (type == "set" && article_data["introText"]) {
      let introText = article_data["introText"];
      introTextEditor.setData(introText, function () {
        this.resetUndo();
      });
    }

    this.articlesEdit.setIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );

    this.articlesEdit.setPreviousIdArticleStatus(
      article_data["status"] ? article_data["status"]["id"] : ""
    );

    //set amazon on site date
    if (article_data["amazonsitePublishDate"]) {
      this.articlesEdit.setAmazonOnSiteDate(
        article_data["amazonsitePublishDate"]
      );
    } else {
      this.articlesEdit.setAmazonOnSiteDate("Set when published");
    }

    this.articlesEdit.setReviewItems(article_data["reviewItems"]);

    if (article_data["categories"]) {
      this.articlesEdit.setSelectedCategories(article_data["categories"]);
      this.articlesEdit.setSelectedFilterCategories(article_data["categories"]);
    }

    if (article_data["tags"]) {
      this.articlesEdit.setSelectedTags(article_data["tags"]);
    }

    if (article_data["idPrimaryCategory"]) {
      this.articlesEdit.setIdPrimaryCategory(
        article_data["idPrimaryCategory"].toString()
      );
    }

    if (article_data["idPrimaryTag"]) {
      this.articlesEdit.setIdPrimaryTag(
        article_data["idPrimaryTag"].toString()
      );
    }

    //if clause inside
    this.setJsonSaves(article_data);
    this.applyRepublishEeatScoresToViewModelIfActive(article_data);

    this.articlesEdit.setArticleRepublishData(article_data["republishes"]);

    if (article_data["classification"]) {
      this.articlesEdit.setIdClassification(
        article_data["classification"]
          ? article_data["classification"]["id"]
          : ""
      );
      this.articlesEdit.setClassificationName(
        article_data["classification"]
          ? article_data["classification"]["name"]
          : ""
      );
    }

    /*if (article_data['revisions']) {
            this.articlesEdit.setIdRevisionSelected(article_data['revisions'][0]['id']);
            this.articlesEdit.setRevisionContent(article_data['revisions'][0]['content']);
            this.articlesEdit.setRevisionIntroText(article_data['revisions'][0]['introText']);
            this.articlesEdit.setRevisionReviewItems(article_data['revisions'][0]['reviewItems']);
            this.articlesEdit.setRevisions(article_data['revisions']);
        }*/

    this.articlesEdit.setPlagiarismStatus(article_data["plagiarismStatus"]);

    this.articlesEdit
      .getTemplateViewModel()
      .isPublishingControl(
        this.articlesEdit.getTemplateViewModel().idStatus() == 6 &&
        !this.articlesEdit.getTemplateViewModel().permissions()[
          "article_edit_publishingControl"
        ].write
      );

    if (this.articlesEdit.getTemplateViewModel().isPublishingControl()) {
      contentEditor.on("contentDom", function () {
        contentEditor.editable().attachListener(
          contentEditor.editable(),
          "click",
          function (evt) {
            evt.stop();
            evt.data.preventDefault();
          },
          null,
          null,
          0
        );
      });
    }

    this.articlesEdit.setPrompt(
      article_data["prompt"] ? article_data["prompt"] : ""
    );
    this.setRichTextForPromptResponseEditor(
      article_data["promptResponse"] ? article_data["promptResponse"] : ""
    );
    this.articlesEdit.setPromptResponse(
      article_data["promptResponse"] ? article_data["promptResponse"] : ""
    );
    if (article_data["promptAuthor"]) {
      this.articlesEdit.setPromptAuthor(article_data["promptAuthor"]);
    }
    this.articlesEdit.setPromptLink(
      article_data["promptLink"] ? article_data["promptLink"] : ""
    );

    if (article_data["channel"]) {
      this.articlesEdit.setChannel(article_data["channel"]);
      if (article_data["playlists"]) {
        this.articlesEdit.setPlaylists(article_data["playlists"]);
      }
    }

    if (article_data["republishesCount"]) {
      this.articlesEdit.setRepublishesCount(article_data["republishesCount"]);
    }

    if (additionalCreditEditor) {

      let additionalCredit = article_data["additionalCredit"];
      additionalCreditEditor.setData(additionalCredit);
    }
    const sourceTime = article_data["sourceTime"] ? article_data["sourceTime"] : null
    this.articlesEdit.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(sourceTime);

    this.articlesEdit.getTemplateViewModel().sourceUrl(article_data["sourceUrl"] ? article_data["sourceUrl"] : null);
    this.articlesEdit.getTemplateViewModel().isPortraitHeader(article_data["isPortraitHeader"] ? article_data["isPortraitHeader"] : false);
    this.fetchAndSetQuizData();
    this.fetchArticleAiSummaries();
    this.getArticleAiChatHistory();
    this.fetchArticleAiFaqs();
    this.fetchArticleAiThreadSummary();
    this.fetchNewsletterPromotion();
    // this.fetchDealsCategoryPromotion();
  }

  public fetchArticleAiThreadSummary(){
      const idBrand = this.getIdBrand();
        const idArticle = this.articlesEdit.getId();
        const vm = this.articlesEdit.getTemplateViewModel();
        const url = `/api/brand/${idBrand}/article/${idArticle}/threadSummary/get/`;
        //this.loadingIn(document.getElementById("ai-faqs-section"));

        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(payload)]);
        this.XHRHdl = new XMLHttpRequestHandler(url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onSaveThreadSummaryReturn;
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdl.execute();
    }
    public saveThreadSummary(regenerate = false) {

        this.loadingIn(document.getElementById("ai-thread-summary-section"));
        const idBrand = this.getIdBrand();
        const idArticle = this.articlesEdit.getId();
        const url = `/api/brand/${idBrand}/article/${idArticle}/threadSummary/save/`;
        this.performThreadSummaryOrStateSave(url, regenerate);
    }

    public saveThreadSummaryState() {
        const idBrand = this.getIdBrand();
        const idArticle = this.articlesEdit.getId();
        const url = `/api/brand/${idBrand}/article/${idArticle}/threadSummary/state/save/`;
        this.performThreadSummaryOrStateSave(url);
    }

    public performThreadSummaryOrStateSave(url, regenerate = false) {
        const vm = this.articlesEdit.getTemplateViewModel();
        //this.loadingIn(document.getElementById("ai-faqs-section"));
        this.loadingIn(document.getElementById("ai-thread-section"));
        const payload = {
            isAiThreadSummaryEnabled: vm.isAiThreadSummaryEnabled(),
            threadSummary: threadSummaryEditor.getData(),
            regenerate: regenerate
        };

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(payload)]);

        //usrReq_params.push(["data", ko.toJSON(payload)]);
        this.threadSummary = new XMLHttpRequestHandler(url, usrReq_params, this);
        this.threadSummary.onReadyStateFunction = this.onSaveThreadSummaryReturn;
        this.threadSummary.mode = XMLHttpRequestHandler_requestType.POST;
        this.threadSummary.execute();

    }

    protected onSaveThreadSummaryReturn(req, obj) {
        return function () {
          obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.setAiArticleThreadSummaryFeatureAvailable(responseParsed.featureAvailableForArticle);
                if(responseParsed.data){
                  // vm.factualSummary(res.data.factualSummary || '');
                  // factualSummaryEditor.setData(res.data.factualSummary  || '');
                  obj.articlesEdit.setisAiThreadSummaryEnabled(responseParsed.data.isAiThreadSummaryEnabled);
                  obj.setThreadSummaryData(responseParsed.data.threadSummary || '');
                  obj.articlesEdit.setAiArticleThreadSummary(responseParsed.data.threadSummary);
                  obj.articlesEdit.getTemplateViewModel().isThreadSummaryFetched = true;
                } else {
                  obj.articlesEdit.getTemplateViewModel().isThreadSummaryFetched = false;
                  const aiSettings = obj.articlesEdit.getTemplateViewModel().aiSettings() || {};
                  const onByDefault = aiSettings.isThreadOnByDefault !== false;
                  const isEligible = obj.articlesEdit.getTemplateViewModel().aiThreadSummaryFeatureAvailable && obj.articlesEdit.getTemplateViewModel().aiThreadSummaryFeatureAvailable();
                  obj.articlesEdit.setisAiThreadSummaryEnabled(isEligible && onByDefault);
                }
            });
            obj.loadingOut(document.getElementById("ai-thread-summary-section"));
            //obj.loadingOut(document.getElementById("ai-thread-section"));
        }
    }

    public setThreadSummaryData(threadSummary: string) {
        if (threadSummary) {
            let parsedSummary = this.parseAiThreadSummaryToHtml(threadSummary);
            threadSummaryEditor.setData(parsedSummary);
            this.articlesEdit.getTemplateViewModel().parsedAiThreadSummary(parsedSummary);
            this.articlesEdit.getTemplateViewModel().aiThreadSummary(threadSummary);
        }
    }

    public parseAiThreadSummaryToHtml(summary) {

        if (!summary) return "";

        try {
            let parsed = JSON.parse(summary);
            return `
            <p>
                <strong>User: ${parsed.comment_1_summary.username}</strong>
                <br/>
                <span>Summary: ${parsed.comment_1_summary.summary}</span>
            </p>
            <br/>
            <p>
                <strong>User: ${parsed.comment_2_summary.username}</strong>
                <br/>
                <span>Summary: ${parsed.comment_2_summary.summary}</span>
            </p>
            <br/>
            <p>
                <strong>Discussion Summary</strong>
                </br>
                <span>${parsed.discussion_summary}</span>
            </p>
            `;
        } catch(e) {
            console.error(e);
            return `Failed to parse summary.`;
        }
    }

  public fetchArticleAiFaqs() {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const vm = this.articlesEdit.getTemplateViewModel();
    const url = `/api/brand/${idBrand}/article/${idArticle}/faqs/get/`;
    //this.loadingIn(document.getElementById("ai-faqs-section"));

    let usrReq_params: Array<Array<string>> = [];
    //usrReq_params.push(["data", ko.toJSON(payload)]);
    this.XHRHdl = new XMLHttpRequestHandler(url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetArticleAiFaqsReturn;
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.XHRHdl.execute();
  }

  public saveArticleFaqs(regenerate = false) {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const vm = this.articlesEdit.getTemplateViewModel();
    const url = `/api/brand/${idBrand}/article/${idArticle}/faqs/save/`;
    this.loadingIn(document.getElementById("ai-faqs-section"));
    const payload = {
      isAiFaqEnabled: vm.isAiFaqEnabled(),
      regenerate: regenerate,
    };
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(payload)]);
    this.articleFAQS = new XMLHttpRequestHandler(url, usrReq_params, this);
    this.articleFAQS.onReadyStateFunction = this.onGetArticleAiFaqsReturn;
    this.articleFAQS.mode = XMLHttpRequestHandler_requestType.POST;
    this.articleFAQS.execute();
  }

  protected onGetArticleAiFaqsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed && responseParsed.data && "isAiFaqEnabled" in responseParsed.data) obj.articlesEdit.setisAiFaqEnabled(responseParsed.data.isAiFaqEnabled);
        if (responseParsed && responseParsed.data && "faq" in responseParsed.data) obj.articlesEdit.setAiArticleFaqs(responseParsed.data.faq);
        obj.loadingOut(document.getElementById("ai-faqs-section"));
      });
    };
  }

  public fetchArticleAudioReader(resolveCurrentInput = false) {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    if (!idArticle) {
      return;
    }
    const vm = this.articlesEdit.getTemplateViewModel();
    if (!resolveCurrentInput) {
      vm.isAudioReaderStateLoading(true);
    }
    vm.audioReaderErrorMessage("");

    const queryString = resolveCurrentInput ? "?resolveCurrentInput=1" : "";
    const url = `/api/brand/${idBrand}/article/${idArticle}/audioReader/get/${queryString}`;
    this.isAudioReaderResolvingCurrentInput = resolveCurrentInput;
    this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.XHRHdl.onReadyStateFunction = this.onGetArticleAudioReaderReturn;
    this.XHRHdl.execute();
  }

  protected onGetArticleAudioReaderReturn(req, obj) {
    return function () {
      if (req.request.readyState !== 4) {
        return;
      }

      const vm = obj.articlesEdit.getTemplateViewModel();
      const resolveCurrentInput = obj.isAudioReaderResolvingCurrentInput;
      vm.isAudioReaderStateLoading(false);
      if (req.request.status === 423) {
        obj.manageResponse(req, obj, function () {});
        return;
      }

      const responseParsed = obj.parseAudioReaderResponse(req);
      if (responseParsed && responseParsed.success && responseParsed.data) {
        obj.articlesEdit.setAudioReaderState(responseParsed.data);
        if (!resolveCurrentInput && !responseParsed.data.currentInputHash && responseParsed.data.audioReaderPublicInputHash) {
          obj.fetchArticleAudioReader(true);
        }
      } else if (responseParsed && responseParsed.message) {
        vm.audioReaderErrorMessage(responseParsed.message);
      } else if (req.request.status !== 200) {
        vm.audioReaderErrorMessage("Audio reader details could not be loaded. Please try again later.");
      }
    };
  }

  public generateArticleAudioReader() {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const vm = this.articlesEdit.getTemplateViewModel();
    this.clearAudioReaderFallbackTimeout();
    if (!idArticle) {
      this.showMessage("Save the article before generating audio.", 'alert');
      return;
    }
    if (!vm.isAudioReaderEnabled()) {
      this.showMessage("Enable Audio Reader to generate audio.", 'alert');
      return;
    }
    const url = `/api/brand/${idBrand}/article/${idArticle}/audioReader/generate/`;
    vm.audioReaderErrorMessage("");
    vm.audioReaderNoticeMessage("");
    vm.isAudioReaderBackgroundGenerationPending(false);
    vm.isGeneratingAudioReader(true);
    this.loadingIn(document.getElementById("audio-reader-section"));
    // The server may continue the same history row in the worker after the
    // browser stops waiting, so leave a persistent in-form notice.
    this.audioReaderFallbackTimeout = setTimeout(() => {
      if (vm.isGeneratingAudioReader()) {
        vm.isGeneratingAudioReader(false);
        vm.audioReaderNoticeMessage(AUDIO_READER_BACKGROUND_NOTICE);
        vm.isAudioReaderBackgroundGenerationPending(true);
        this.loadingOut(document.getElementById("audio-reader-section"));
      }
    }, AUDIO_READER_MANUAL_TIMEOUT_FALLBACK_MS);
    let formReqParams: Array<Array<string>> = [];
    formReqParams.push(["data", ko.toJSON({ isAudioReaderEnabled: vm.isAudioReaderEnabled() })]);
    this.XHRHdl = new XMLHttpRequestHandler(url, formReqParams, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onGenerateArticleAudioReaderReturn;
    this.XHRHdl.execute();
  }

  protected onGenerateArticleAudioReaderReturn(req, obj) {
    return function () {
      const vm = obj.articlesEdit.getTemplateViewModel();
      if (req.request.readyState !== 4) {
        return;
      }

      obj.clearAudioReaderFallbackTimeout();
      const audioReaderSection = document.getElementById("audio-reader-section");
      try {
        if (req.request.status === 423) {
          obj.manageResponse(req, obj, function () {});
          return;
        }

        if (req.request.status === 0) {
          // A dropped XHR often means the manual request outlived the browser
          // connection while the backend queued the same generation in the worker.
          vm.audioReaderNoticeMessage(AUDIO_READER_BACKGROUND_NOTICE);
          vm.audioReaderErrorMessage("");
          vm.isAudioReaderBackgroundGenerationPending(true);
          return;
        }

        // Audio Reader needs inline error text for editor-facing failures such
        // as size limits, so parse this response locally instead of relying only
        // on the shared handler/toaster flow.
        const responseParsed = obj.parseAudioReaderResponse(req);
        if (responseParsed && responseParsed.success && responseParsed.data) {
          obj.articlesEdit.setAudioReaderState(responseParsed.data, false);
          const latestAudioReader = responseParsed.data.history || responseParsed.data.latest || null;
          // Queued state for the current hash disables the button because another
          // attempt would only duplicate the same background request.
          const isBackgroundGeneration = responseParsed.asyncQueued
            || (latestAudioReader && latestAudioReader.isQueued && (latestAudioReader.status === "pending" || latestAudioReader.status === "generating"));
          if (isBackgroundGeneration) {
            vm.audioReaderNoticeMessage(AUDIO_READER_BACKGROUND_NOTICE);
            vm.isAudioReaderBackgroundGenerationPending(true);
          } else {
            vm.audioReaderNoticeMessage("");
            vm.isAudioReaderBackgroundGenerationPending(false);
            obj.showMessage("Audio generated successfully.", 'success');
          }
        } else if (responseParsed && responseParsed.message) {
          vm.audioReaderErrorMessage(responseParsed.message);
          vm.audioReaderNoticeMessage("");
          vm.isAudioReaderBackgroundGenerationPending(false);
          obj.showMessage(responseParsed.message, 'alert');
        } else {
          vm.audioReaderErrorMessage("Audio generation failed. Please try again later.");
          vm.audioReaderNoticeMessage("");
          vm.isAudioReaderBackgroundGenerationPending(false);
        }
      } finally {
        vm.isGeneratingAudioReader(false);
        obj.loadingOut(audioReaderSection);
      }
    };
  }

  protected clearAudioReaderFallbackTimeout(): void {
    if (this.audioReaderFallbackTimeout) {
      clearTimeout(this.audioReaderFallbackTimeout);
      this.audioReaderFallbackTimeout = null;
    }
  }

  protected parseAudioReaderResponse(req): any {
    if (!req.request.response) {
      return null;
    }
    try {
      return JSON.parse(req.request.response);
    } catch (e) {
      return null;
    }
  }

  public recalculateArticleEeatScore(): void {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const vm = this.articlesEdit.getTemplateViewModel();
    if (!idBrand || !idArticle) {
      const missing: string[] = [];
      if (!idBrand) {
        missing.push("brand");
      }
      if (!idArticle) {
        missing.push("article");
      }
      const detail =
        missing.length === 2
          ? "the brand and article identifiers are missing"
          : missing[0] === "brand"
            ? "the brand identifier is missing"
            : "the article identifier is missing";
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_WARNING,
        `Cannot generate E-E-A-T scores: ${detail}.`
      );
      this.getVnAppZone().showNotificationToModule();
      return;
    }
    if (vm.eeatRecalculateLoading && vm.eeatRecalculateLoading()) {
      return;
    }
    const idTpl = vm.idTemplate ? vm.idTemplate() : null;
    const templateIdNum =
      idTpl !== null && idTpl !== undefined && idTpl !== ""
        ? parseInt(String(idTpl), 10)
        : NaN;
    if (
      !isNaN(templateIdNum) &&
      (templateIdNum === ID_TEMPLATE_VIDEO || templateIdNum === ID_TEMPLATE_THREAD)
    ) {
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_WARNING,
        "This article is not currently eligible for this feature."
      );
      this.getVnAppZone().showNotificationToModule();
      return;
    }
    vm.eeatRecalculateLoading(true);
    const eeatSection = document.getElementById("eeatScore");
    if (eeatSection) {
      eeatSection.classList.add("loading");
    }
    const url = `/api/brand/${idBrand}/article/${idArticle}/eeat-score/recalculate/`;
    const idRepublishRaw = vm.idRepublish ? vm.idRepublish() : null;
    let idRepublishBody: number | undefined;
    if (idRepublishRaw != null && idRepublishRaw !== "") {
      const n = parseInt(String(idRepublishRaw), 10);
      if (n > 0) {
        idRepublishBody = n;
      }
    }
    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(idRepublishBody ? { idRepublish: idRepublishBody } : {}),
    })
      .then((res) =>
        res.text().then((text) => {
          let body: any = null;
          try {
            body = text ? JSON.parse(text) : null;
          } catch (e) {
            body = { success: false, message: "Invalid response from server (expected JSON)." };
          }
          return { ok: res.ok, status: res.status, body };
        })
      )
      .then(({ ok, body }) => {
        if (ok && body && body.success && body.data) {
          this.articlesEdit.setEeatScoresFromArticleData(body.data);
          this.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_SUCCESS,
            "E-E-A-T scores have been updated."
          );
        } else {
          const msg =
            (body && (body.message || body.error)) ||
            "Could not generate E-E-A-T scores.";
          this.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_ERROR,
            msg
          );
        }
        this.getVnAppZone().showNotificationToModule();
      })
      .catch(() => {
        this.getVnAppZone().notification = new vn_app_zone_notification(
          vn_app_zone_notification.TYPE_ERROR,
          "Could not generate E-E-A-T scores."
        );
        this.getVnAppZone().showNotificationToModule();
      })
      .then(() => {
        vm.eeatRecalculateLoading(false);
        const el = document.getElementById("eeatScore");
        if (el) {
          el.classList.remove("loading");
        }
      });
  }

    private quizGenerationPollingTimeout: ReturnType<typeof setTimeout> | null = null;
    private quizFetchAbortController: AbortController | null = null;
    private quizPollFailureCount: number = 0;
    private static readonly MAX_QUIZ_POLL_FAILURES = 5;

    private fetchAndSetQuizData(): void {
      const idBrand = this.getVnAppZone().app.params.idBrand;
      const idArticle = this.articlesEdit.getTemplateViewModel().id();
      if (!idBrand || !idArticle) return;

      this.quizFetchAbortController = new AbortController();
      const signal = this.quizFetchAbortController.signal;

      const quizUrl = `/api/brand/${idBrand}/article/${idArticle}/quiz/get/`;

      fetch(quizUrl, { signal })
        .then(res => {
          if (!res.ok) throw new Error(`Quiz fetch failed: HTTP ${res.status}`);
          return res.json();
        })
        .then(data => {
          this.quizPollFailureCount = 0;
          const vm = this.articlesEdit.getTemplateViewModel();
          if (data && data.quiz) {
            const mappedQuiz = data.quiz.map(q => {
                const question = ko.observable(q.question || "");
                const rationale = ko.observable(q.rationale || "");
                const options = ko.observableArray((q.options || []).map(opt => ({
                    text: ko.observable(opt.text || ""),
                    isCorrect: ko.observable(opt.isCorrect === true || opt.isCorrect === "on")
                })));
                return {
                    uniqueId: q.uniqueId || "quiz_" + (++quizUniqueIdCounter),
                    isValid: q.isValid || false,
                    question: question,
                    difficulty: ko.observable(q.difficulty || "easy"),
                    basis: ko.observable(q.basis || "article"),
                    rationale: rationale,
                    correctOptionIndex: ko.observable((() => {
                        const foundIndex = q.options ? q.options.findIndex(opt => opt.isCorrect === true || opt.isCorrect === "on") : -1;
                        return foundIndex !== -1 ? foundIndex : 0;
                    })()),
                    isCollapsed: ko.observable(false),
                    isFromAi: ko.observable(q.isFromAi === true),
                    toggleCollapsed: function() {
                        this.isCollapsed(!this.isCollapsed());
                    },
                    isQuestionValid: ko.pureComputed(() => {
                        const qVal = question() || "";
                        const rVal = rationale() || "";
                        const opts = options() || [];
                        if (qVal.trim() === "" || rVal.trim() === "" || opts.length === 0) {
                            return false;
                        }
                        return opts.every(option => option.text().trim() !== "");
                    }),
                    options: options
                };
            });
            this.articlesEdit.getTemplateViewModel().quizQuestions([]);
            this.articlesEdit.getTemplateViewModel().quizQuestions(mappedQuiz);

            if (data && "title" in data) {
              this.articlesEdit.getTemplateViewModel().quizTitle(data.title || "");
              // if we have a quiz element in the content, update the title on first load
              const editor = this.getEditor('article_content');
              const quizEl = editor && editor.editable() ? editor.editable().$.querySelector('[data-widget-injection="quiz"]') : null;
              const displayText = data.title
                ? `${data.title} (Click to Jump to Widgets Tab)`
                : "Quiz Generating (Click to Jump to Widgets Tab)";
              if (quizEl && quizEl.textContent !== displayText) {
                quizEl.innerHTML = displayText;
                editor.fire('saveSnapshot');
              }
            }
            this.articlesEdit.getTemplateViewModel().isQuizFetched = true;
          } else {
            this.articlesEdit.getTemplateViewModel().isQuizFetched = false;
          }
          // Dynamic placement is a per-instance content attribute (source of
          // truth). Mirror it onto the checkbox, falling back to the brand
          // default when no quiz placeholder exists in content yet.
          const contentDynamicPlacement = this.getQuizDynamicPlacementFromContent();
          this.articlesEdit.getTemplateViewModel().quizIsDynamicPlacement(
            contentDynamicPlacement !== null ? contentDynamicPlacement : this.getDynamicPlacementDefault('quiz')
          );
          const isPendingGeneration = !!data.isPendingGeneration;
          this.articlesEdit.getTemplateViewModel().quizIsGenerating(isPendingGeneration);

          if (isPendingGeneration) {
            this.startQuizGenerationPolling();
          } else {
            this.stopQuizGenerationPolling();
          }
        
        })
        .catch(err => {
          if (err.name === 'AbortError') return;
          console.error("Failed to load quiz:", err);
          // Keep the generation poll alive across transient failures so the
          // "generating" state isn't stuck until a page refresh. Cap retries to
          // avoid an endless loop on persistent errors.
          const vm = this.articlesEdit.getTemplateViewModel();
          this.quizPollFailureCount++;
          if (vm.quizIsGenerating() && this.quizPollFailureCount < articles_edit_new.MAX_QUIZ_POLL_FAILURES) {
            this.startQuizGenerationPolling();
          } else {
            this.stopQuizGenerationPolling();
          }
        });
    }

    private startQuizGenerationPolling(): void {
      if (this.quizGenerationPollingTimeout !== null) return;
      this.quizGenerationPollingTimeout = setTimeout(() => {
        this.quizGenerationPollingTimeout = null;
        this.fetchAndSetQuizData();
      }, 5000);
    }

    private stopQuizGenerationPolling(): void {
      if (this.quizFetchAbortController) {
        this.quizFetchAbortController.abort();
        this.quizFetchAbortController = null;
      }
      if (this.quizGenerationPollingTimeout !== null) {
        clearTimeout(this.quizGenerationPollingTimeout);
        this.quizGenerationPollingTimeout = null;
      }
    }

    public enqueueQuizGeneration(): void {
        const idBrand = this.getVnAppZone().app.params.idBrand;
        const idArticle = this.articlesEdit.getTemplateViewModel().id();
        if (!idBrand || !idArticle) return;

        fetch(`/api/brand/${idBrand}/article/${idArticle}/quiz/save/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ regenerate: true, isQuizEnabled: false, quiz: [] })
        }).catch(err => {
            console.error("Failed to start quiz generation:", err);
        });
    }

  public setDisplayAuthors(displayAuthors): void {
    this.articlesEdit.setDisplayAuthors(displayAuthors);
  }

  // public setAuthorPrompts(authorAgreements): void{

  //     this.articlesEdit.setAuthorPrompts(authorAgreements);
  // }

  protected cancelEditArticle() {
    // minimize CKEditors
    this.minimizeAllEditors();
    // disable buttons while loading next page
    // this.articlesEdit.disableSaveButtons();
    // clear recovery save
    this.clearRecoverySave();
    this.clearRecoveryWarning();
    this.stopQuizGenerationPolling();

    //release lock
    this.releaseLock();
    this.stopWatchScroll();
    this.getVnAppZone().app.removeWarningEventListeners();
    // redirect to articles list
    this.redirectToArticlesList();
  }

  protected onKickout() {
    this.clearRecoverySave();
    this.clearRecoveryWarning();

    this.articlesEdit.disableSaveButtons();
  }

  protected closeNotice() {
    this.articlesEdit.setIsNoticeVisible(false);
    let myThis = this;
    // delay to avoid ui wierdness due to fadeout
    //setTimeout(function () {
    //    myThis.articlesEdit.setNoticeMessage("");
    //}, 1000);
  }

  protected releaseLock() {
    // request a lock release
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/release/lock_edit/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", this.articlesEdit.getTemplateViewModel().id()]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.execute();
  }

  protected deleteRecovery() {
    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/recovery/delete/" +
      this.articlesEdit.getTemplateViewModel().id();

    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onDeleteRecoveryReturn;
    XHRHdl.execute();
  }

  protected onDeleteRecoveryReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        obj.redirectToArticlesList();
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public redirectToArticlesList(): void {
    this.stopQuizGenerationPolling();
    this.maximizeSideNav();

    let previousUrl = this.loadPreviousPage(window.location.href);
    if (previousUrl) {
      page.redirect(previousUrl);
    } else {
      page.redirect(
        "/brand/" + this.getVnAppZone().app.params.idBrand + "/articles/"
      );
    }
  }

  protected saveEditArticle(type) {
    this.save(type);
  }

  protected previewNoSaveArticle(type, previewMode = "desktop") {
    this.previewArticle(type);
    this.setPreviewMode(previewMode);
  }

  protected getUsersSuggestion(keyword, idElement) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel: any = {
      list: { keyword: keyword },
      idElement: idElement,
    };
    let usrReq_url: string = null;

    switch (idElement) {
      case "filterWebsiteUser_prompt_author":
        usrReq_url = "/api/search/website-users/";
        subViewModel.idBrand = this.getVnAppZone().app.params.idBrand;
        break;
      default:
        usrReq_url =
          "/api/brand/" +
          this.getVnAppZone().app.params.idBrand +
          "/search/user/";
        break;
    }

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
    this.XHRHdl.execute();
  }

  protected onGetUsersSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data.idElement == "filterUser_author") {
          obj.articlesEdit.setFilterUserAuthor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_SrEditor") {
          obj.articlesEdit.setFilterUserSrEditor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_JrEditor") {
          obj.articlesEdit.setFilterUserJrEditor(responseParsed.data.users);
        } else if (responseParsed.data.idElement == "filterUser_ideator") {
          obj.articlesEdit.setFilterUserIdeator(responseParsed.data.users);
        } else if (
          responseParsed.data.idElement == "filterUser_republish_author"
        ) {
          obj.articlesEdit.setFilterUserRepublishAuthor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_republish_SrEditor"
        ) {
          obj.articlesEdit.setFilterUserRepublishSrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_republish_JrEditor"
        ) {
          obj.articlesEdit.setFilterUserRepublishJrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_author"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishAuthor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_SrEditor"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishSrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement ==
          "filterUser_scheduled_republish_JrEditor"
        ) {
          obj.articlesEdit.setFilterUserScheduledRepublishJrEditor(
            responseParsed.data.users
          );
        } else if (
          responseParsed.data.idElement == "filterUser_display_author"
        ) {
          obj.articlesEdit.setFilterUserDisplayAuthor(
            responseParsed.data.users
          );
        } else if (responseParsed.data.idElement == "filterUser_producer") {
          obj
            .getVideoPickerEditTemplate()
            .setProducer(responseParsed.data.users);
        } else if (
          responseParsed.data.idElement == "filterWebsiteUser_prompt_author"
        ) {
          obj.articlesEdit.setFilterUserPromptAuthor(responseParsed.data.users);
        }
      });
    };
  }

  public getVideoPickerHelper() {
    return this.articlesEdit.videoPickerHelper;
  }

  public getVideoPickerEditTemplate() {
    return this.articlesEdit.videoPickerHelper.getVideoPickerEditTemplate();
  }

  public getVideoPickerTemplate() {
    return this.articlesEdit.videoPickerHelper.getVideoPickerTemplate();
  }

  public getImagePickerEditTemplate() {
    return this.articlesEdit.imagePicker.imageEdit;
  }

  public sendToArticleContent(content) {
    contentEditor.setData(content);
  }

  public sendToArticleIntroText(introText) {
    introTextEditor.setData(introText);
  }

  public revertSandboxRecovery(sandboxRecoveryContent) {
    sandboxEditor.setData(sandboxRecoveryContent);
  }

  public revertRepublishRecovery(sandboxRecoveryContent) {
    republishEditor.setData(sandboxRecoveryContent);
  }

  public revertSandboxIntroTextRecovery(sandboxIntroTextRecovery) {
    sandboxIntroTextEditor.setData(sandboxIntroTextRecovery);
  }

  public revertRepublishIntroTextRecovery(sandboxIntroTextRecovery) {
    republishIntroTextEditor.setData(sandboxIntroTextRecovery);
  }

  public filterDropdownOnChange(idElement) {
    switch (idElement) {
      case "videoRatioFilter":
      case "videoOrientationFilter":
        this.getVideosData();
        break;
      case "savedRulesHistory":
        let id = this.articlesEdit.getTemplateViewModel().id();
        let uuid = this.articlesEdit.getFeedbackHistoryOption();
        if (id && uuid != 0) {
          this.filterFeedBackHistory(id, uuid);
        } else {
          let idContentType = this.articlesEdit
            .getTemplateViewModel()
            .idContentType();
          this.getSensaiResults("article_content", idContentType);
        }
        break;
      default:
        this.getImageData();
        break;
    }
  }

  protected filterList() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }


  protected getSavePostData() {
    // Log data being gathered for debugging race conditions
    const articleId = this.articlesEdit.getTemplateViewModel().id();
    const contentPreview = contentEditor ? contentEditor.getData().substring(0, 100) : 'N/A';
    console.log('[getSavePostData] Gathering data for article ID:', articleId);
    console.log('[getSavePostData] Content preview:', contentPreview);

    let idAuthor =
      this.articlesEdit.getTemplateViewModel().filterUser_author.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_author.idUser()
        : null;
    let idSeniorEditor =
      this.articlesEdit.getTemplateViewModel().filterUser_SrEditor.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_SrEditor.idUser()
        : null;
    let idJuniorEditor =
      this.articlesEdit.getTemplateViewModel().filterUser_JrEditor.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_JrEditor.idUser()
        : null;
    let idIdeator =
      this.articlesEdit.getTemplateViewModel().filterUser_ideator.user() != ""
        ? this.articlesEdit.getTemplateViewModel().filterUser_ideator.idUser()
        : null;

    let articleRecommendations = this.articlesEdit.articleRecommendations.getSerializedData();

    const isReviewOrProductReviewContentType = this.articlesEdit.getTemplateViewModel().idContentType() == 5 ||
      this.articlesEdit.getTemplateViewModel().idContentType() == 24;
    let additionalCreditData = "";
    if (additionalCreditEditor) {
      additionalCreditData = additionalCreditEditor.getData();
    }
    let postData = {
      idArticle: this.articlesEdit.getTemplateViewModel().id(),
      isSubContent: this.articlesEdit.getTemplateViewModel().isSubContent(),
      idNextArticle: this.articlesEdit.getTemplateViewModel().filterArticle.idArticle,
      idPublishStatus: this.articlesEdit
        .getTemplateViewModel()
        .idPublishStatus(),
      idNetworkCategory: this.articlesEdit
        .getTemplateViewModel()
        .idNetworkCategory(),
      idContentType: this.articlesEdit.getTemplateViewModel().idContentType(),
      idSegment: this.articlesEdit.getTemplateViewModel().idSegment(),
      idIntent: this.articlesEdit.getTemplateViewModel().idIntent(),
      idPaymentCategory: this.articlesEdit
        .getTemplateViewModel()
        .idPaymentCategory(),
      permalink: this.articlesEdit.getTemplateViewModel().permalink(),
      amazonsiteArticleTitle: this.articlesEdit
        .getTemplateViewModel()
        .amazonsiteArticleTitle(),
      newsNowArticleTitle: this.articlesEdit
        .getTemplateViewModel()
        .newsNowArticleTitle(),
      amazonsitePublishDate: this.articlesEdit
        .getTemplateViewModel()
        .filterDate.singleDatePicker(),
      updateAmazonsitePublishDate: this.articlesEdit
        .getTemplateViewModel()
        .updateAmazonsitePublishDate(),
      idDisplayAuthor: this.articlesEdit
        .getTemplateViewModel()
        .filterUser_display_author.idUser(),
      idDisplayAuthors: this.articlesEdit
        .getTemplateViewModel()
        .display_authors.userIds(),
      dateScheduled: this.articlesEdit
        .getTemplateViewModel()
        .filterScheduleDate.singleDatePicker(),
      idDeleteRepublish: this.articlesEdit
        .getTemplateViewModel()
        .idDeleteRepublish(),
      createRepublish: this.articlesEdit
        .getTemplateViewModel()
        .showNewRepublish(),
      republishArticle: {
        idRepublish: this.articlesEdit.getTemplateViewModel().idRepublish(),
        republishDate: this.articlesEdit
          .getTemplateViewModel()
          .filterRepublishDate.singleDatePicker(),
        idRepublishStatus: this.articlesEdit
          .getTemplateViewModel()
          .idRepublishStatus(),
        idAuthor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_author.idUser(),
        idSeniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_SrEditor.idUser(),
        idJuniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_republish_JrEditor.idUser(),
        idPostPaymentCategory: this.articlesEdit
          .getTemplateViewModel()
          .paymentCategoryFilter.selectedOption(),
        amount: this.articlesEdit.getTemplateViewModel().amountAuthor(),
        percentage: this.articlesEdit.getTemplateViewModel().percentageAuthor(),
        percentageEditor: this.articlesEdit
          .getTemplateViewModel()
          .percentageEditor(),
        republishIsUnderEmbargo: this.articlesEdit
          .getTemplateViewModel()
          .republishIsUnderEmbargo(),
      },
      scheduledRepublish: this.articlesEdit
        .getTemplateViewModel()
        .showScheduledRepublish(),
      scheduledRepublishArticle: {
        idRepublish: this.articlesEdit.getTemplateViewModel().idRepublish(),
        republishDate: this.articlesEdit
          .getTemplateViewModel()
          .filterScheduledRepublishDate.singleDatePicker(),
        idAuthor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_author.idUser(),
        idSeniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_SrEditor.idUser(),
        idJuniorEditor: this.articlesEdit
          .getTemplateViewModel()
          .filterUser_scheduled_republish_JrEditor.idUser(),
        idPostPaymentCategory: this.articlesEdit
          .getTemplateViewModel()
          .scheduledRepublishPaymentCategoryFilter.selectedOption(),
        amount: this.articlesEdit
          .getTemplateViewModel()
          .scheduledAmountAuthor(),
        percentage: this.articlesEdit
          .getTemplateViewModel()
          .scheduledPercentageAuthor(),
        percentageEditor: this.articlesEdit
          .getTemplateViewModel()
          .scheduledPercentageEditor(),
      },
      title: this.articlesEdit.getTemplateViewModel().title(),
      excerpt: this.articlesEdit.getTemplateViewModel().excerpt(),
      idFeaturedImage: this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .imageId(),
      isFeaturedImageOptimized: this.articlesEdit.imageWidgetForFeaturedImage
        .getTemplateViewModel()
        .imageIsMobileOptimized(),
      idAlternateImage: this.articlesEdit.imageWidgetForAlternateImage
        .getTemplateViewModel()
        .imageId(),
      idThumbnailImage: this.articlesEdit.imageWidgetForThumbnailImage
        .getTemplateViewModel()
        .imageId(),
      imageCropPositions: this.articlesEdit.getImageCropPositions(),
      // idFeaturedVideoImage : this.articlesEdit.imageWidgetForFeaturedVideo.getTemplateViewModel().imageId(),
      idTemplate: this.articlesEdit.getTemplateViewModel().idTemplate(),
      idTemplateLayout: this.articlesEdit
        .getTemplateViewModel()
        .idTemplateLayout(),
      idClassification: this.articlesEdit
        .getTemplateViewModel()
        .idClassification(),
      idStatus: this.articlesEdit.getTemplateViewModel().idStatus(),
      idAuthor: idAuthor,
      idSeniorEditor: idSeniorEditor,
      idJuniorEditor: idJuniorEditor,
      idIdeator: idIdeator,
      aiAgents: this.articlesEdit.getTemplateViewModel().articleAiAgents(),
      content: contentEditor.getData(),
      additionalCredit: additionalCreditData,
      introText: introTextEditor.getData(),
      sandboxIntroText: sandboxIntroTextEditor.getData(),
      republishIntroText: republishIntroTextEditor.getData(),
      sandboxContent: sandboxEditor.getData(),
      republishContent: republishEditor.getData(),
      smoTitle: this.articlesEdit.getTemplateViewModel().smoTitle(),
      smoDescription: this.articlesEdit.getTemplateViewModel().smoDescription(),
      socialTagLine: this.articlesEdit.getTemplateViewModel().socialTagLine(),
      listOrder: this.articlesEdit.getTemplateViewModel().listOrder(),
      seoTitle: this.articlesEdit.getTemplateViewModel().seoTitle(),
      seoDescription: this.articlesEdit.getTemplateViewModel().seoDescription(),
      fileUrl: this.articlesEdit.getTemplateViewModel().fileUrl(),
      tableOfContents: this.articlesEdit
        .getTemplateViewModel()
        .tableOfContents(),
      isNewsNowArticle: this.articlesEdit
        .getTemplateViewModel()
        .isNewsNowArticle(),
      isSponsored: this.articlesEdit.getTemplateViewModel().isSponsored(),
      isUnderEmbargo: this.articlesEdit.getTemplateViewModel().isUnderEmbargo(),
      isSyndicated: this.articlesEdit.getTemplateViewModel().isSyndicated(),
      noAuthorship: this.articlesEdit.getTemplateViewModel().isSyndicated() && this.articlesEdit.getTemplateViewModel().noAuthorship(),
      externalAuthorName: this.articlesEdit.getTemplateViewModel().externalAuthorName(),
      isLinkToOriginalArticle: this.articlesEdit.getTemplateViewModel().isLinkToOriginalArticle(),
      displayConfiguration: this.articlesEdit
        .getTemplateViewModel()
        .displayConfiguration(),
      isAdHidden: this.articlesEdit.getTemplateViewModel().isAdHidden(),
      isAmpDisabled: this.articlesEdit.getTemplateViewModel().isAmpDisabled(),
      featuredTags: this.articlesEdit.getTemplateViewModel().featuredTags(),
      isVersusStyle: this.articlesEdit.getTemplateViewModel().isVersusStyle(),
      isAffiliateLinkerEnabled: this.articlesEdit
        .getTemplateViewModel()
        .isAffiliateLinkerEnabled(),
      isInstareadEnabled: this.articlesEdit.getTemplateViewModel().isInstareadEnabled(),
      isAudioReaderEnabled: this.articlesEdit.getTemplateViewModel().isAudioReaderEnabled(),
      isDevelopingStory: this.articlesEdit
        .getTemplateViewModel()
        .isDevelopingStory(),
      dateDevelopingStoryCoverageStart: this.articlesEdit
        .getTemplateViewModel()
        .filterDateDevelopingStoryCoverageStart.singleDatePicker(),
      dateDevelopingStoryCoverageEnd: this.articlesEdit
        .getTemplateViewModel()
        .filterDateDevelopingStoryCoverageEnd.singleDatePicker(),
      faqs: this.articlesEdit.getTemplateViewModel().faqs(),
      directoryItems: this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .directoryItems(),
      deletedDirectoryItems: this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      sandboxDirectoryItems: this.articlesEdit.sandboxDirectory
        .getTemplateViewModel()
        .directoryItems(),
      sandboxDeletedDirectoryItems: this.articlesEdit.sandboxDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      republishDirectoryItems: this.articlesEdit.republishDirectory
        .getTemplateViewModel()
        .directoryItems(),
      republishDeletedDirectoryItems: this.articlesEdit.republishDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems(),
      idPrimaryCategory: this.articlesEdit
        .getTemplateViewModel()
        .idPrimaryCategory(),
      idPrimaryTag: this.articlesEdit.getTemplateViewModel().idPrimaryTag(),
      selectedCategories: this.articlesEdit
        .getTemplateViewModel()
        .selectedCategories(),
      selectedTags: this.articlesEdit.getTemplateViewModel().selectedTags(),
      reviewItems: this.articlesEdit.getReviewItems(),
      sandboxReviewItems: this.articlesEdit.getSandboxReviewItems(),
      reviewItemsToDelete: this.articlesEdit.getReviewItemsToDelete(),
      sandboxReviewItemsToDelete:
        this.articlesEdit.getSandboxReviewItemsToDelete(),
      republishReviewItems: this.articlesEdit.getRepublishReviewItems(),
      republishReviewItemsToDelete:
        this.articlesEdit.getRepublishReviewItemsToDelete(),
      idDirectoryArticle:
        this.articlesEdit.getTemplateViewModel().filterArticleDirectory
          .idArticle,
      isFeaturedTagActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedTagActive(),
      pinnedTag: this.articlesEdit.getPinnedTag(),
      pinnedTags: {
        title: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .title(),
        position: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .position(),
        style: this.articlesEdit.articlePinnedTags
          .getTemplateViewModel()
          .selectedStyle(),
        tagTypeSpec:
          this.articlesEdit.articlePinnedTags.getTemplateViewModel()
            .selectedTagSpec,
        tags: this.articlesEdit.articlePinnedTags.getTemplateViewModel().tags(),
      },
      reviewTag: isReviewOrProductReviewContentType ? this.articlesEdit.filterReviewTag.getOptionObj() : null,
      updateLatestRepublishDateIsChecked: this.articlesEdit
        .getTemplateViewModel()
        .updateLatestRepublishDateIsChecked(),
      latestRepublishId: this.articlesEdit
        .getTemplateViewModel()
        .latestRepublishId(),
      template: this.articlesEdit.getTemplateViewModel().template(),
      isFeaturedImageHidden: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedImageHidden(),
      isCommentsDisabled: this.articlesEdit
        .getTemplateViewModel()
        .isCommentsDisabled(),
      isCommentsPaused: this.articlesEdit
        .getTemplateViewModel()
        .isCommentsPaused(),
      isRatingEnabled: this.articlesEdit
        .getTemplateViewModel()
        .isRatingEnabled(),
      isReadNextDisabled: this.articlesEdit
        .getTemplateViewModel()
        .isReadNextDisabled(),
      isDisplayCardQuickLinksShown: this.articlesEdit
        .getTemplateViewModel()
        .isDisplayCardQuickLinksShown(),

      isDisplayCardQuickLinksMobileShown: this.articlesEdit
        .getTemplateViewModel()
        .isDisplayCardQuickLinksMobileShown(),
      isSidebarHidden: this.articlesEdit
        .getTemplateViewModel()
        .isSidebarHidden(),
      isExcerptHidden: this.articlesEdit
        .getTemplateViewModel()
        .isExcerptHidden(),
      featuredVideo: this.articlesEdit.getTemplateViewModel().featuredVideo(),
      isFeaturedVideoActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedVideoActive(),
      featuredEmbed: this.articlesEdit.getTemplateViewModel().featuredEmbed(),
      isFeaturedEmbedActive: this.articlesEdit
        .getTemplateViewModel()
        .isFeaturedEmbedActive(),
      isUpdateTime: this.articlesEdit.getTemplateViewModel().isUpdateTime(),
      newsletterSendToSelf: this.articlesEdit
        .getTemplateViewModel()
        .newsletterSendToSelf(),
      newsletterSubject: this.articlesEdit
        .getTemplateViewModel()
        .newsletterSubject(),
      newsletterPreviewText: this.articlesEdit
        .getTemplateViewModel()
        .newsletterPreviewText(),
      newsletterRecipientsEmails: this.articlesEdit
        .getTemplateViewModel()
        .newsletterRecipientsEmails(),
      newsletterSelectedMailingLists: this.articlesEdit
        .getTemplateViewModel()
        .selectedMailingLists(),
      newsletterTemplate:
        this.articlesEdit.getTemplateViewModel().newsletterTemplateSelector
          .selectedOption,
      newsletterDateScheduled: this.articlesEdit
        .getTemplateViewModel()
        .newsletterDateScheduledSelector.singleDatePicker(),
      articleReviewComments: this.articlesEdit
        .getTemplateViewModel()
        .articleReviewComments(),
      featuredVideoTitle: this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoTitle(),
      featuredVideoDescription: this.articlesEdit
        .getTemplateViewModel()
        .featuredVideoDescription(),
      dateLastPreview: this.articlesEdit
        .getTemplateViewModel()
        .dateLastPreview(),
      prompt: this.articlesEdit.getTemplateViewModel().prompt(),
      promptResponse: this.getRichTextForPromptResponseEditor(),
      idPromptAuthor: this.articlesEdit
        .getTemplateViewModel()
        .filterWebsiteUser_prompt_author.idUser(),
      promptLink: this.articlesEdit.getTemplateViewModel().promptLink(),
      sensaiCoverageScore: this.articlesEdit.getSensaiCoverageScore(),
      contentGuidelineScore: this.articlesEdit.getContentGuidelineScore()
        ? this.articlesEdit.getContentGuidelineScore()
        : this.articlesEdit.sensaiPromptTemplate.getContentGuidelineScore(),
      sourceUrl: this.articlesEdit.getTemplateViewModel().sourceUrl(),
      sourceTime: this.articlesEdit.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(),
      isAiFaqEnabled: this.articlesEdit.getTemplateViewModel().isAiFaqEnabled(),
      isPortraitHeader : this.articlesEdit.getTemplateViewModel().isPortraitHeader(),
      articleRecommendations: articleRecommendations,
      isReviewTemplateLayout: (this.articlesEdit.getTemplateViewModel().isReviewLayout())
    };

    return postData;
  }

  public sendNewsletter() {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/newsletter/send/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = this.getSavePostData();
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSendNewsletterReturn;
    XHRHdl.execute();
  }

  public onSendNewsletterReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        obj.getVnAppZone().notification = new vn_app_zone_notification(
          vn_app_zone_notification.TYPE_SUCCESS,
          "Newsletter Delivery Scheduled !"
        );
        obj.getVnAppZone().showNotificationToModule();
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected save(type) {
    console.log('[SAVE] Article ID:', this.articlesEdit.getTemplateViewModel().id());
    console.log('[SAVE] Content preview:', contentEditor.getData().substring(0, 50));
    this.logArticleContext("[SAVE] Save requested");

    if (this.isSaveInProgress) {
      return;
    }

    if (this.isArticleDataLoading) {
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_WARNING,
        "Please wait for article data to finish loading before saving."
      );
      this.getVnAppZone().showNotificationToModule();
      return;
    }

    this.isSaveInProgress = true;
    this.articlesEdit.disableSaveButtons();

    // CRITICAL: Verify article ID matches URL params to prevent race condition
    // where content from Article A gets saved to Article B
    const currentArticleId = this.articlesEdit.getTemplateViewModel().id();
    const urlArticleId = this.getArticleIdFromUrl();

    if (currentArticleId && urlArticleId && currentArticleId != urlArticleId) {
      console.error(
        '[SAVE] RACE CONDITION DETECTED! Article ID mismatch - aborting save to prevent data corruption.',
        'Current ID:', currentArticleId,
        'URL ID:', urlArticleId
      );
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_ERROR,
        "Save aborted: Article context changed. Please refresh the page."
      );
      this.getVnAppZone().showNotificationToModule();
      this.finishSaveRequest();
      return;
    }

    this.loadingIn(this.articlesEdit.builtTemplate);

    let queryParams = new URLSearchParams(window.location.search);
    let formReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/article/save/`;
    let formReq_params: Array<Array<string>> = [];
    let subViewModel = this.getSavePostData();
    const templateViewModel = this.articlesEdit.getTemplateViewModel();
    const currentStatus = templateViewModel.idStatus();
    const currentPublishStatus = templateViewModel.idPublishStatus();

    if (
      subViewModel.idStatus !== currentStatus ||
      subViewModel.idPublishStatus !== currentPublishStatus
    ) {
      console.error(
        "[SAVE] CRITICAL: View model status changed during payload build",
        "Payload status:", subViewModel.idStatus,
        "Current status:", currentStatus,
        "Payload publish status:", subViewModel.idPublishStatus,
        "Current publish status:", currentPublishStatus
      );
      this.loadingOut(this.articlesEdit.builtTemplate);
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_ERROR,
        "Save aborted: Status changed during save. Please try again."
      );
      this.getVnAppZone().showNotificationToModule();
      this.finishSaveRequest();
      return;
    }
    if (this.loadedArticleId && Number(subViewModel.idArticle) !== this.loadedArticleId) {
      console.error(
        "[SAVE] CRITICAL: Loaded article context mismatch",
        "Loaded article:", this.loadedArticleId,
        "Payload article:", subViewModel.idArticle
      );
      this.loadingOut(this.articlesEdit.builtTemplate);
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_ERROR,
        "Save aborted: Article context changed during load. Please refresh."
      );
      this.getVnAppZone().showNotificationToModule();
      this.finishSaveRequest();
      return;
    }

    // Double-check that getSavePostData() returned the expected article ID
    if (subViewModel.idArticle != currentArticleId) {
      console.error(
        '[SAVE] CRITICAL: getSavePostData() returned mismatched ID!',
        'Expected:', currentArticleId,
        'Got:', subViewModel.idArticle,
        '- Aborting save'
      );
      this.loadingOut(this.articlesEdit.builtTemplate);
      this.getVnAppZone().notification = new vn_app_zone_notification(
        vn_app_zone_notification.TYPE_ERROR,
        "Save aborted: Data integrity check failed. Please refresh the page."
      );
      this.getVnAppZone().showNotificationToModule();
      this.finishSaveRequest();
      return;
    }

    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    if (queryParams.has("idThreadSuggestion")) {
      formReq_params.push(["idThreadSuggestion", queryParams.get("idThreadSuggestion")]);
    }

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    //XHRHdl.onReadyStateFunction = this.onSaveReturn;
    if (type == "stay") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onStayReturn;
    } else if (type == "save") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      // minimize editor on save
      this.minimizeAllEditors();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onSaveReturn;
    } else if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewReturn;
    } else if (type == "republish") {
      this.clearRecoverySave();
      this.clearRecoveryWarning();
      this.loadingIn(this.articlesEdit.builtTemplate);
      XHRHdl.onReadyStateFunction = this.onRepublishSaveReturn;
    } else {
      XHRHdl.onReadyStateFunction = this.onAMPPreviewReturn;
    }

    XHRHdl.execute();
    //These need to happen after the article is saved

  }

  protected previewArticle(type) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let formReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/article/previewNoSave/0";

    if (type == "preview-email") {
      formReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/article/previewEmail/0";
    }

    let formReq_params: Array<Array<string>> = [];
    let subViewModel = this.getSavePostData();

    //push article data and content type to pass to article and emakiArticle creators
    formReq_params.push(["data", ko.toJSON(subViewModel)]);
    formReq_params.push([
      "content",
      this.articlesEdit.getContentTypeToPreview(),
    ]);
    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    //using post to avoid data size limitation of GET
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewReturn;
    } else if (type == "preview") {
      XHRHdl.onReadyStateFunction = this.onPreviewEmailReturn;
    } else {
      XHRHdl.onReadyStateFunction = this.onAMPPreviewReturn;
    }

    XHRHdl.execute();
  }

  protected onSaveReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        // CRITICAL: Verify the XHR response is for the currently viewed article
        const savedArticleId = responseParsed.data.article.id;
        const currentArticleId = obj.articlesEdit.getId();

        if (savedArticleId && currentArticleId && savedArticleId != currentArticleId) {
          console.error(
            '[onSaveReturn] RACE CONDITION DETECTED! XHR response for article',
            savedArticleId,
            'arrived while viewing article',
            currentArticleId,
            '- Ignoring response to prevent corruption'
          );
          obj.loadingOut(obj.articlesEdit.builtTemplate);
          // Note: We still redirect to list since this is a regular save (not save & stay)
          obj.stopWatchScroll();
          obj.getVnAppZone().app.removeWarningEventListeners();
          obj.redirectToArticlesList();
          obj.finishSaveRequest();
          return;
        }

        obj.updateChatHistoryOnArticleSave(responseParsed.data.article);
        obj.articlesEdit.setArticleReviewComments("");
        obj.clearRecoverySave();
        //release lock
        obj.releaseLock();

        obj.stopWatchScroll();
        obj.getVnAppZone().app.removeWarningEventListeners();
        obj.redirectToArticlesList();
        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
        obj.saveArticleAiSummaries();
        obj.saveThreadSummaryState();
        obj.saveArticleFaqs();
        obj.saveArticleAiNewsletterPromotion();
        // obj.saveArticleAiDealsCategoryPromotion();
      });
      obj.finishSaveRequest();
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onRepublishSaveReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        // CRITICAL: Verify the XHR response is for the currently viewed article
        const savedArticleId = responseParsed.data.article.id;
        const currentArticleId = obj.articlesEdit.getId();

        if (savedArticleId && currentArticleId && savedArticleId != currentArticleId) {
          console.error(
            '[onRepublishSaveReturn] RACE CONDITION DETECTED! XHR response for article',
            savedArticleId,
            'arrived while viewing article',
            currentArticleId,
            '- Ignoring response to prevent corruption'
          );
          obj.loadingOut(obj.articlesEdit.builtTemplate);
          obj.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_WARNING,
            "Republish saved successfully, but context changed. Please refresh to see updates."
          );
          obj.getVnAppZone().showNotificationToModule();
          obj.finishSaveRequest();
          return;
        }

        obj.isSaveAndStay = true;
        obj.articlesEdit.setIsNoticeVisible(false);
        obj.articlesEdit.setArticleLockedStatus(false);
        obj.handleArticleEditionAfterSaveAndStay(responseParsed, "stay");
        obj.articlesEdit.updateArticleOnRepublish();
        obj.articlesEdit.clearRepublishSection();
        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
        obj.saveArticleAiSummaries();
        obj.saveThreadSummaryState();
        obj.saveArticleFaqs();
        obj.saveArticleAiNewsletterPromotion();
        // obj.saveArticleAiDealsCategoryPromotion();
      });
      obj.finishSaveRequest();
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected clearRecoverySave() {
    if (this.recoveryTimeout) {
      clearTimeout(this.recoveryTimeout);
      this.recoveryTimeout = null;
    }
    if (this.lastUpdatedTimer) {
      clearInterval(this.lastUpdatedTimer);
      this.lastUpdatedTimer = null;
    }
  }

  protected cancelRecoveryRequest() {
    if (this.recoveryXHRHdl) {
      this.recoveryXHRHdl.cancelAndReset();
      this.recoveryXHRHdl = null;
    }
  }

  protected clearRecoveryWarning() {
    if (this.recoveryWarning) {
      clearInterval(this.recoveryWarning);
      this.recoveryWarning = null;
    }
  }

  protected setContentFocusHandlers() {
    contentEditor = CKEDITOR.instances.article_content;
    introTextEditor = CKEDITOR.instances.productReview_intro_text;
    sandboxEditor = CKEDITOR.instances.article_sandbox;
    sandboxIntroTextEditor = CKEDITOR.instances.productReviewSandbox_intro_text;
    this.addFocusHandler([
      contentEditor,
      introTextEditor,
      sandboxIntroTextEditor,
      sandboxEditor,
    ]);
  }

  protected onStayReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        // CRITICAL: Verify the XHR response is for the currently viewed article
        // This prevents race condition where user clicks "Save & Stay" on Article A,
        // then immediately navigates to Article B, and the response from Article A
        // arrives while viewing Article B, corrupting Article B's state
        const savedArticleId = responseParsed.data.article.id;
        const currentArticleId = obj.articlesEdit.getId();

        if (savedArticleId && currentArticleId && savedArticleId != currentArticleId) {
          console.error(
            '[onStayReturn] RACE CONDITION DETECTED! XHR response for article',
            savedArticleId,
            'arrived while viewing article',
            currentArticleId,
            '- Ignoring response to prevent corruption'
          );
          obj.loadingOut(obj.articlesEdit.builtTemplate);
          obj.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_WARNING,
            "Article saved successfully, but context changed. Please refresh to see updates."
          );
          obj.getVnAppZone().showNotificationToModule();
          obj.finishSaveRequest();
          return;
        }

        obj.isSaveAndStay = true;
        obj.articlesEdit.setIsNoticeVisible(false);
        obj.articlesEdit.setArticleLockedStatus(false);
        obj.articlesEdit.setArticleReviewComments("");
        obj.handleArticleEditionAfterSaveAndStay(responseParsed, "stay");
        obj.articlesEdit.handleInDirectoryState();

        //PME-3186: reflect updated permalink and redirect history on save&stay action
        if (responseParsed.data.permalinkHistory) {
          obj.articlesEdit.setPermalinkHistory(
            responseParsed.data.permalinkHistory
          );
        }
        if (responseParsed.data.permalinkRedirects) {
          obj.articlesEdit.setPermalinkRedirect(
            responseParsed.data.permalinkRedirects
          );
        }

        if (
          responseParsed.data &&
          responseParsed.data.prependAIkeyPointsToContent
        ) {
          obj.showKeyTakeawayAddedNotification();
        }
        obj.saveArticleAiSummaries();
        obj.saveThreadSummaryState();
        obj.saveArticleFaqs();
        obj.saveArticleAiNewsletterPromotion();
        // obj.saveArticleAiDealsCategoryPromotion();
      });
      obj.finishSaveRequest();
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onPreviewReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.handleArticleEditionAfterSaveAndStay(responseParsed, "preview");
        });
      }
      /*
      obj.saveArticleAiSummaries();
      obj.saveThreadSummaryState();
      obj.saveArticleFaqs();
      obj.saveArticleAiNewsletterPromotion()
      */
      obj.finishSaveRequest();
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onPreviewEmailReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_SUCCESS,
            "Preview sent to your email."
          );
          obj.getVnAppZone().showNotificationToModule();
        });
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onAMPPreviewReturn(req, obj) {
    return function () {
      if (req.request.status == 423) {
        let responseParsed = JSON.parse(req.request.response);
        obj.handleArticleEditionWhenLocked(responseParsed);
      } else {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.handleArticleEditionAfterSaveAndStay(
            responseParsed,
            "preview-amp"
          );
        });
      }
      obj.finishSaveRequest();
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public handleArticleEditionWhenLocked(response): void {
    this.clearRecoverySave();

    this.articlesEdit.setKickoutkMessage(response.message);
    this.articlesEdit.setIsKickoutMessageVisible(true);
    this.articlesEdit.setArticleLockedStatus(true);
    this.articlesEdit.enableSaveButtons();
  }

  public clearRecoveryData() {
    this.articlesEdit.setRecoveryContent(null);
    this.articlesEdit.setRecoveryIntroText(null);
    this.articlesEdit.setRecoveryReviewItems([]);
    this.articlesEdit.setDateRecovery(null);
    this.articlesEdit.setRecoveryUser(null);
    this.articlesEdit.setRecovery(null);
    this.articlesEdit.setSandboxRecoveryContent(null);
    this.articlesEdit.setSandboxRecoveryIntroText(null);
    this.articlesEdit.setRecoverySandboxReviewItems([]);
  }

  private displayLastSavedTime() {
    let curDate = new Date(Date.now());
    this.articlesEdit
      .getTemplateViewModel()
      .lastSaveRecoveryAttempt(
        `${curDate.toDateString()} ${curDate.toLocaleTimeString()}`
      );
    if (this.hasLastSuccessfulAutosave) {
      let minutesAgo = Math.floor(
        (curDate.getTime() - this.lastSaved.getTime()) / 60000
      );
      if (minutesAgo < 1) {
        this.articlesEdit.setLastSaved("moments ago");
      } else if (minutesAgo === 1) {
        this.articlesEdit.setLastSaved("a minute ago");
      } else if (minutesAgo < 60) {
        this.articlesEdit.setLastSaved(minutesAgo + " minutes ago");
        if (minutesAgo > 6) {
          this.articlesEdit.setArticleAutoSaveError(true);
        }
      } else {
        this.articlesEdit.setLastSaved(
          Math.floor(minutesAgo / 60) + " hour(s) ago"
        );
        this.articlesEdit.setArticleAutoSaveError(true);
      }
    }
  }

  public handleArticleEditionAfterSaveAndStay(response, type): void {
    //If type is save and stay, then set article and sandbox data from passed, and go to /edit/ in case of first save.
    if (type == "stay") {
      this.clearRecoveryData();
      this.clearRecoverySave();
      this.lastSaved = new Date(Date.now());

      //this.articlesEdit.showAutoSaveMessage("Article saved manually - not autosaving until changes made.");
      this.articlesEdit.setArticleAutoSaveError(false);
      this.articlesEdit.disableAutosaveBox();

      // start autosave timer
      this.startAutosave("SaveAndStay");

      let value =
        response.data && response.data.prependAIkeyPointsToContent
          ? "refreshAfterKeyPointsAdded"
          : "refresh";
      this.updateChatHistoryOnArticleSave(response.data.article);
      this.setArticleData(response.data.article, value);
      this.setDisplayAuthors(response.data.displayAuthors);
      this.setPublishStatusOptions(response.data.article);
      if (this.articlesEdit.isArticleActiveTab("reviews")) {
        this.getSensaiArticleReferences(
          "article_content",
          response.data.article.id
        );
      }
      this.setContentFocusHandlers();
      window.history.pushState(
        "page2",
        "Emaki CMS",
        "/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/edit/" +
        response.data.article.id
      );
    }
    if (type == "preview") {
      if (response.data.dateLastPreview) {
        this.articlesEdit.setDateLastPreview(response.data.dateLastPreview);
      }
      if (this.getPreviewMode() == "desktop") {
        this.openArticlePreview(response.data);
      }
      if (this.getPreviewMode() == "mobile") {
        this.openArticlePreviewMobile(response.data);
      }
    }
    if (type == "preview-amp") {
      this.openArticlePreview(response.data, true);
    }
  }

  protected viewArticleOnSite(brand, permalink) {
    let origin = document.location.origin;
    let brandDomain = brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    let url = origin.replace("emakicms.com", brandDomain) + permalink;

    if (url.includes("mig1")) {
      url = url.replace("mig1", "qa2");
    }

    if (url.includes("mig2")) {
      url = url.replace("mig2", "qa8");
    }

    if (url.includes("mig3")) {
      url = url.replace("mig3", "qa7");
    }

    if (url.includes("mig4")) {
      url = url.replace("mig4", "qa1");
    }

    let element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected viewArticleOnSiteAMP(brand, permalink) {
    let origin = document.location.origin;
    let brandDomain = brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    let url = origin.replace("emakicms.com", brandDomain) + permalink + "amp";

    let element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected openArticlePreview(data, isAmp = false) {
    let origin = document.location.origin;
    let brandDomain = data.brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    //let url = '';
    //REMOVE THIS GOING LIVE
    // if(brandDomain.includes("topspeed.com") && !brandDomain.includes("ads.topspeed.com")){
    //     brandDomain = brandDomain.replace("topspeed.com","ads.topspeed.com");
    // }

    let url =
      origin.replace("emakicms.com", brandDomain) +
      "/preview/" +
      data.emakiPreview.id +
      "/";

    if (url.includes("mig1")) {
      const location = () => {
        switch (data.brand.shortName) {
          case "SR":
            return "qa2";
          case "HG":
            return "qa3";
          case "GR":
            return "qa2";
          case "SF":
            return "qa5";
          default:
            return "qa1";
        }
      };

      url = url.replace("mig1", location());
    } else if (url.includes("mig3")) {
      url = url.replace("mig3", "qa7");
    } else if (url.includes("mig2")) {
      url = url.replace("mig2", "qa8");
    } else if (url.includes("mig4")) {
      if (data.brand.id == 33) {
        url = url.replace("mig4", "qa2");
      } else if (data.brand.id == 34 || data.brand.id == 43) {
        url = url.replace("mig4", "qa3");
      } else {
        url = url.replace("mig4", "qa2");
      }
    }

    // For migration production preview url
    // if (url.includes("polygon.com")) {
    //   url = url.replace("www", "qa6");
    // }

    if (isAmp) {
      url = url + "amp/";
    }

    var f = document.createElement("form");
    f.action = url;
    f.method = "POST";
    f.target = "_blank";

    var i = document.createElement("input");
    i.type = "hidden";
    i.name = "token";
    i.value = "PWjvmuQqaq`;33}4";
    f.appendChild(i);

    var c = document.createElement("input");
    c.type = "hidden";
    c.name = "content";
    c.value = this.articlesEdit.getContentTypeToPreview();
    f.appendChild(c);

    //if an emakiPreview was created, then add it so the brand site can read it. Otherwise add nothing so the brand site can read from DB instead.
    if (data.emakiPreview) {
      var c = document.createElement("input");
      c.type = "hidden";
      c.name = "article";
      c.value = JSON.stringify(data.emakiPreview);
      f.appendChild(c);
    }

    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  }

  protected openArticlePreviewMobile(data, isAmp = false) {
    let origin = document.location.origin;
    let brandDomain = data.brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    //let url = '';
    //REMOVE THIS GOING LIVE
    // if(brandDomain.includes("topspeed.com") && !brandDomain.includes("ads.topspeed.com")){
    //     brandDomain = brandDomain.replace("topspeed.com","ads.topspeed.com");
    // }

    let url =
      origin.replace("emakicms.com", brandDomain) +
      "/preview/" +
      data.emakiPreview.id +
      "/";

    if (url.includes("mig1")) {
      const location = () => {
        switch (data.brand.shortName) {
          case "SR":
            return "qa2";
          case "HG":
            return "qa3";
          case "SF":
            return "qa5";
          default:
            return "qa1";
        }
      };

      url = url.replace("mig1", location());
    } else if (url.includes("mig3")) {
      url = url.replace("mig3", "qa7");
    } else if (url.includes("mig2")) {
      url = url.replace("mig2", "qa8");
    } else if (url.includes("mig4")) {
      if (data.brand.id == 33) {
        url = url.replace("mig4", "qa2");
      } else if (data.brand.id == 34) {
        url = url.replace("mig4", "qa3");
      } else {
        url = url.replace("mig4", "qa3");
      }
    }

    if (isAmp) {
      url = url + "amp/";
    }

    const popupName = "mobilePreview";
    const popup = window.open('about:blank', popupName, 'width=375,height=812,top=100,left=100,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,status=no');
    // Write something into the popup to keep it open and mark it as used (for Safari)
    const loadingDiv = popup.document.createElement("div");
    loadingDiv.innerHTML = "Loading Preview...";
    popup.document.body.appendChild(loadingDiv);

    var f = document.createElement("form");
    f.action = url;
    f.method = "POST";
    // f.target = "_blank";
    f.target = popupName;

    var i = document.createElement("input");
    i.type = "hidden";
    i.name = "token";
    i.value = "PWjvmuQqaq`;33}4";
    f.appendChild(i);

    var c = document.createElement("input");
    c.type = "hidden";
    c.name = "content";
    c.value = this.articlesEdit.getContentTypeToPreview();
    f.appendChild(c);

    //if an emakiPreview was created, then add it so the brand site can read it. Otherwise add nothing so the brand site can read from DB instead.
    if (data.emakiPreview) {
      var c = document.createElement("input");
      c.type = "hidden";
      c.name = "article";
      c.value = JSON.stringify(data.emakiPreview);
      f.appendChild(c);
    }

    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  }


  protected getAffiliatesSuggestion(keyword, limit) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { filter: { keyword: keyword, limit: limit } };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/affiliate/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
    this.XHRHdl.execute();
  }
  protected onGetAffiliatesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteAffiliate_template"
        ) {
          obj.articlesEdit.filterAffiliates
            .getTemplateViewModel()
            .suggestedObj(responseParsed.affiliates[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteAffiliate_template"
        ) {
          obj.articlesEdit.filterAffiliates.setOptions(
            responseParsed.affiliates
          );
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagViewAffiliate_template"
        ) {
          obj.articlesEdit.tagPicker.setTagViewAffiliateFilterOptions(
            responseParsed.affiliates
          );
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagEditAffiliate_template"
        ) {
          obj.articlesEdit.tagPicker.setTagEditAffiliateFilterOptions(
            responseParsed.affiliates
          );
        }
      });
    };
  }

  protected getAiAgentSuggestion(keyword, limit) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { filter: { keyword: keyword, limit: limit } };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/ai-agent/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetAiAgentSuggestionReturn;
    this.XHRHdl.execute();
  }

  protected onGetAiAgentSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteAiAgent_template"
        ) {
          obj.articlesEdit.filterAiAgent
            .getTemplateViewModel()
            .suggestedObj(responseParsed.aiAgents[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteAiAgent_template"
        ) {
          obj.articlesEdit.filterAiAgent.setOptions(responseParsed.aiAgents);
        }
      });
    };
  }

  public saveAiAgent(name: string) {
    let subViewModel = { name: name };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/ai-agent/save/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSaveAiAgentReturn;
    XHRHdl.execute();
  }

  protected onSaveAiAgentReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        const agent = responseParsed.aiAgent;
        if (!agent) { return; }

        const agents = obj.articlesEdit.getTemplateViewModel().articleAiAgents;
        const existing = agents().findIndex(a => a.name === agent.name && (a.id === null || a.id === agent.id));
        if (existing !== -1) {
          const updated = agents().slice();
          updated[existing] = { id: agent.id, name: agent.name };
          agents(updated);
        } else {
          const alreadyAdded = agents().some(a => a.id === agent.id);
          if (!alreadyAdded) {
            agents.push({ id: agent.id, name: agent.name });
          }
        }
      });
    };
  }

  public getLocaleSuggestion(keyword) {
    const locales = this.articlesEdit.tagPicker.getTagEditLocales();

    if (typeof locales != "undefined") {
      let matches = locales.filter((l) => (
        l.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        l.countryCode.toLowerCase() === keyword.toLowerCase()
      ));

      this.articlesEdit.tagPicker.setTagEditLocaleFilterOptions(matches);
      return matches;
    }

    return null;
  }

  protected getTagsTypeSuggestion(
    keyword,
    limit,
    restrictOwnedTagTypes = false
  ) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      filter: {
        keyword: keyword,
        limit: limit,
        restrictOwnedTagTypes: restrictOwnedTagTypes,
      },
    };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/tag/type/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
    this.XHRHdl.execute();
  }


  public getTagsSuggestion(keyword, idSourceElement) {
    this.getSuggestions(keyword, idSourceElement);
  }

  protected getTagsSuggestionOnInput(
    keyword,
    limit,
    tagType,
    getSelectable,
    getNonSelectable,
    imageAndSpecSelectable,
    specFields = false
  ) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      filter: {
        keyword: keyword,
        limit: limit,
        idTagType: tagType ? tagType.id : null,
        getSelectable: getSelectable,
        getNonSelectable: getNonSelectable,
        imageAndSpecSelectable: imageAndSpecSelectable,
        specFields: specFields,
      },
    };

    let usrReq_url: string =
      "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let tagTypes = responseParsed.data.tagTypes;

        if (Array.isArray(tagTypes) && tagTypes.length > 0) {
          tagTypes.forEach((tagType) => {
            if (tagType.dataset !== null) {
              tagType.name += `   ${tagType.formattedDataset}`;
            }
          });
        }

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteProductType_template"
        ) {
          obj.articlesEdit.filterProductTypes
            .getTemplateViewModel()
            .suggestedObj(tagTypes[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteProductType_template"
        ) {
          obj.articlesEdit.filterProductTypes.setOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterTagType") {
          obj.articlesEdit.tagPicker.setTagTypeOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterAddNewTagType") {
          //const idBrand = obj.getVnAppZone().app.params.idBrand;
          // filter out owned tag types that aren't owned by this brand.
          //tagTypes = tagTypes.filter((tagType: emaki_tag_type) => tagType.brandOwner? tagType.brandOwner.id == idBrand : true);

          obj.articlesEdit.tagPicker.setAddNewTagTypeOptions(tagTypes);
        } else if (obj.XHRHdlCaller == "getSuggestions_filterEditTagType") {
          obj.articlesEdit.tagPicker.setEditTagTypeOptions(tagTypes);
        } else if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteTagTypeArticlePinnedTags_template"
        ) {
          obj.articlesEdit.articlePinnedTags.filterTagType
            .getTemplateViewModel()
            .suggestedObj(tagTypes[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteTagTypeArticlePinnedTags_template"
        ) {
          obj.articlesEdit.articlePinnedTags.filterTagType.setOptions(tagTypes);
        } else if (
          obj.XHRHdlCaller == "getSuggestions_tagPickerSourceFilterTagType"
        ) {
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.tagPickerSourceFilterTagType.setOptions(
            tagTypes
          );
        }
      });
    };
  }

  protected onGetTagsSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed.data.tags) {
          if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompletePinnedTags_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name = tags[i].name + "   (" + tags[i].tagType + ")";
              }
            }
            obj.articlesEdit.filterPinnedTag.setOptions(tags);
          } else if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompleteTagArticlePinnedTags_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name =
                  tags[i].name + "  " + tags[i].formattedTagTypeAndDataset;
              }
            }
            obj.articlesEdit.articlePinnedTags.filterTags.setOptions(tags);
          } else if (
            obj.XHRHdlCaller ==
            "getSuggestions_filterAutocompleteReviewTag_template"
          ) {
            let tags = responseParsed.data.tags;
            for (let i = 0; i < tags.length; i++) {
              if (tags[i].tagType !== null) {
                tags[i].name =
                  tags[i].name + "  " + tags[i].formattedTagTypeAndDataset;
              }
            }
            obj.articlesEdit.filterReviewTag.setOptions(tags);
          } else if (obj.XHRHdlCaller == "getSuggestions_filterVideoTag") {
            obj
              .getVideoPickerTemplate()
              .tagFilter.getTemplateViewModel()
              .tags(responseParsed.data.tags);
          } else if (obj.XHRHdlCaller == "getSuggestions_filterVideoTagEdit") {
            obj
              .getVideoPickerEditTemplate()
              .setTagFilterAutocomplete(responseParsed.data.tags);
          } else if (
            obj.XHRHdlCaller == "getSuggestions_filterTagImagePickerEdit"
          ) {
            obj
              .getImagePickerEditTemplate()
              .filterTag.getTemplateViewModel()
              .tags(responseParsed.data.tags);
          } else {
            obj.articlesEdit.setTagFilterAutocomplete(responseParsed.data.tags);
          }
        }
      });
    };
  }

  public save_recovery(saveMode = "") {
    this.clearRecoverySave(); // clears existing timer

    console.log(
      "Autosaving (" +
      saveMode +
      ") : " +
      new Date(+Date.now()).toLocaleTimeString()
    );
    this.articlesEdit.setIsAutosaving(true);

    this.recoverySaveMode = saveMode;

    //if we are not in the edit page anymore, clear the recovery save
    let len = this.getVnAppZone().app.routeHistory.length;
    let lastRoute = this.getVnAppZone().app.routeHistory[len - 1];

    //clear the auto-save if we are no longer on the articles edit page
    if (
      !lastRoute.includes("/articles/edit") &&
      !lastRoute.includes("/articles/add")
    ) {
      this.clearRecoveryData();
      //this.clearRecoverySave();
    }

    // Capture the article ID at the start of save_recovery
    let idArticle = this.articlesEdit.getId();
    let content = contentEditor.getData();
    let sandboxContent = sandboxEditor.getData();
    let republishContent = republishEditor.getData();
    let articleIntroText = introTextEditor.getData();
    let sandboxIntroText = sandboxIntroTextEditor.getData();
    let republishIntroText = republishIntroTextEditor.getData();

    let isContentAvailable =
      (content != null && content != "") ||
      (sandboxContent != null && sandboxContent != "") ||
      (republishContent != null && republishContent != "") ||
      (articleIntroText != null && articleIntroText != "") ||
      (sandboxIntroText != null && sandboxIntroText != "") ||
      (republishIntroText != null && republishIntroText != "");
    let isReviewItemAvailable = this.articlesEdit.getReviewItems().length > 0;
    let isDirectoryItemAvailable =
      this.articlesEdit.articleDirectory.getDirectoryItems().length > 0;
    let isSandboxReviewItemAvailable =
      this.articlesEdit.getSandboxReviewItems().length > 0;
    let isRepublishReviewItemAvailable =
      this.articlesEdit.getRepublishReviewItems().length > 0;
    let isSandboxDirectoryItemAvailable =
      this.articlesEdit.sandboxDirectory.getDirectoryItems().length > 0;
    let isRepublishDirectoryItemAvailable =
      this.articlesEdit.republishDirectory.getDirectoryItems().length > 0;

    if (
      isContentAvailable ||
      isReviewItemAvailable ||
      isSandboxReviewItemAvailable ||
      isRepublishReviewItemAvailable ||
      isDirectoryItemAvailable ||
      isSandboxDirectoryItemAvailable ||
      isRepublishDirectoryItemAvailable
    ) {
      // Final verification: ensure article ID hasn't changed during data gathering
      const currentIdArticle = this.articlesEdit.getId();
      if (idArticle !== currentIdArticle) {
        console.log(
          "Article ID changed from " + idArticle + " to " + currentIdArticle +
          " during save_recovery execution, aborting save to prevent data corruption"
        );
        this.articlesEdit.setIsAutosaving(false);
        return;
      }

      this.articlesEdit.disableSaveButtons();
      let formReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/article/recovery/save/";
      let formReq_params: Array<Array<string>> = [];

      let subViewModel = this.getSavePostData();

      //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
      formReq_params.push(["data", ko.toJSON(subViewModel)]);

      let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
        formReq_url,
        formReq_params,
        this
      );
      (XHRHdl as any).__recoveryRequestContext = {
        articleId: idArticle !== undefined && idArticle !== null ? idArticle : null,
        pathname: window.location.pathname,
      };
      this.recoveryXHRHdl = XHRHdl;
      XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      XHRHdl.onReadyStateFunction = this.onSaveRecoveryReturn;
      XHRHdl.execute();
    }
  }

  protected onSaveRecoveryReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        if (obj.recoveryXHRHdl === req) {
          obj.recoveryXHRHdl = null;
        }

        const recoveryRequestContext = (req as any).__recoveryRequestContext || {};
        const requestedArticleId =
          recoveryRequestContext.articleId !== undefined &&
          recoveryRequestContext.articleId !== null
            ? recoveryRequestContext.articleId
            : null;
        const requestedPathname = recoveryRequestContext.pathname || "";
        const currentPathname = window.location.pathname;

        // whatever our save state, autosaving is no longer happening.
        obj.articlesEdit.setIsAutosaving(false);

        if (requestedPathname && requestedPathname !== currentPathname) {
          console.warn(
            "[onSaveRecoveryReturn] Ignoring stale autosave response after route change",
            "Requested path:",
            requestedPathname,
            "Current path:",
            currentPathname
          );
          return;
        }

        if (req.request.status == 401) {
          const lastSaveRecoveryAttempt = obj.articlesEdit
            .getTemplateViewModel()
            .lastSaveRecoveryAttempt();
          const message = `Your session expired. You will not be able to use save actions and any changes since ${lastSaveRecoveryAttempt} will be lost. Please backup any changes you may need.`;

          obj.lastSaved = "Not saved";
          obj.articlesEdit
            .getTemplateViewModel()
            .sessionExpiredOnSaveRecovery(true);
          obj.articlesEdit.showAutoSaveMessage(
            "Session expired. Autosave disable"
          );

          obj.articlesEdit.warningDialog_WhenLogOut.hideCancelBtn();
          obj.articlesEdit.warningDialog_WhenLogOut.setIsVisible(true);
          obj.articlesEdit.warningDialog_WhenLogOut.setTitle(
            "Session Expired!"
          );
          obj.articlesEdit.warningDialog_WhenLogOut.setMessage(message);

          obj.articlesEdit.setNoticeMessage(message);
          obj.articlesEdit.setIsNoticeVisible(true);
          obj.articlesEdit.setArticleLockedStatus(true);

          obj.articlesEdit.setLastSaved("Session Expired");
          obj.articlesEdit.setArticleAutoSaveError(true);

          obj.clearRecoverySave();
          obj.clearRecoveryWarning();
          obj.startAutosave(null);
        } else if (req.request.status == 423) {
          obj.manageResponse(req, obj, function () {
            let response = JSON.parse(req.request.response);
            const { message } = response;

            if (message) {
              obj.articlesEdit.showAutoSaveMessage(
                "Locked out of post. Could not autosave."
              );

              obj.clearRecoverySave();
              obj.articlesEdit.warningDialog_WhenArticleLock.hideCancelBtn();
              obj.articlesEdit.warningDialog_WhenArticleLock.setIsVisible(true);
              obj.articlesEdit.warningDialog_WhenArticleLock.setTitle(
                "Article Locked"
              );
              obj.articlesEdit.warningDialog_WhenArticleLock.setMessage(
                message
              );

              obj.articlesEdit.setNoticeMessage(message);
              obj.articlesEdit.setIsNoticeVisible(true);
              obj.articlesEdit.setArticleLockedStatus(true);

              obj.articlesEdit.setLastSaved("Article Locked");
              obj.articlesEdit.setArticleAutoSaveError(true);

              obj.clearRecoverySave();
              obj.clearRecoveryWarning();
              obj.startAutosave(null);
            }
          });
        } else if (req.request.status == 200) {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);

            if (responseParsed.data) {
              if (
                responseParsed.data.id &&
                obj.articlesEdit.getId() == null &&
                requestedArticleId == null &&
                currentPathname.includes("/articles/add")
              ) {

                obj.updateChatHistoryOnArticleSave(responseParsed.data);
                obj.articlesEdit.setId(responseParsed.data.id);
                window.history.pushState(
                  "page2",
                  "Emaki CMS",
                  "/brand/" +
                  obj.getVnAppZone().app.params.idBrand +
                  "/articles/edit/" +
                  responseParsed.data.id
                );
              }

              if (responseParsed.data.title) {
                obj.articlesEdit.setTitle(responseParsed.data.title);
              }
              obj.hasLastSuccessfulAutosave = true;
            }
          });
          //Enabling save buttons that were disabled in saveRecoveryReturn call
          obj.articlesEdit.enableSaveButtons();

          // track last saved here, upon successful return from api
          obj.lastSaved = new Date(Date.now());
          obj.displayLastSavedTime();
          obj.articlesEdit.showAutoSaveMessage("Saved");
          obj.articlesEdit.setArticleAutoSaveError(false);
          obj.articlesEdit.enableAutosaveBox();

          obj.articlesEdit.setIsNoticeVisible(false);
          obj.articlesEdit.setNoticeMessage("");

          // start new autosave process
          obj.startAutosave("onSaveRecoveryReturn");
        } else {
          // catch all other status codes

          obj.articlesEdit.showAutoSaveMessage("Not-Autosaved");
          obj.articlesEdit.setArticleAutoSaveError(true);
          obj.articlesEdit.enableAutosaveBox();

          // set new save attempt
          if (obj.recoverySaveMode != "manual") {
            obj.startAutosave("manualRecoveryAfterFail");
          }

          obj.articlesEdit.enableSaveButtons();
        }
      }
    };
  }

  //image picker functions
  protected getImageData(keyword = null) {
    if (this.imageXHRHdl) {
      this.imageXHRHdl.cancelAndReset();
    }

    this.articlesEdit.imagePicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/get/";
    let formReq_params: Array<Array<string>> = [];

    //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
    let viewModel = this.articlesEdit.imagePicker.getViewModelForRequest();
    /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
    formReq_params.push(["data", ko.toJSON(viewModel)]);

    this.imageXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
    this.imageXHRHdl.execute();
  }

  protected onGetImageDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        obj.articlesEdit.imagePicker.hideLoading();
        if (
          obj.articlesEdit.imagePicker.getSelectedTab() == "images" ||
          obj.isSaveImage
        ) {
          obj.isSaveImage = false;
        }
      });
    };
  }

  protected updateImagePickerForm(responseParsed) {
    let selectedImages = this.articlesEdit.imagePicker.getSelectedImages();

    if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
      for (let image of responseParsed.paginatedImages.data) {
        image.selected = false;
        let imageSelected = selectedImages.find((i) => i.id == image.id);
        if (imageSelected) {
          image.selected = true;
        }
        image.fileSize = this.bytesToSize(image.fileSize);
      }
      this.articlesEdit.imagePicker.setImagesPagination(
        responseParsed.paginatedImages
      );
      this.articlesEdit.imagePicker.setImageResults(
        responseParsed.paginatedImages.data
      );
    }

    if (responseParsed.imagesInContent) {
      for (let image of responseParsed.imagesInContent) {
        image.selected = false;
        let imageSelected = selectedImages.find((i) => i.id == image.id);
        if (imageSelected) {
          image.selected = true;
        }
        image.fileSize = this.bytesToSize(image.fileSize);
      }
      this.articlesEdit.imagePicker.setImagesInContent(
        responseParsed.imagesInContent
      );
    }

    let selectedGallery = this.articlesEdit.imagePicker.getSelectedGallery();

    if (
      responseParsed.paginatedGalleries &&
      responseParsed.paginatedGalleries.data
    ) {
      for (let gallery of responseParsed.paginatedGalleries.data) {
        gallery.selected = false;
        if (selectedGallery != null) {
          if (selectedGallery.id == gallery.id) {
            gallery.selected = true;
          }
        }
      }
      this.articlesEdit.imagePicker.setGalleryPagination(
        responseParsed.paginatedGalleries
      );
      this.articlesEdit.imagePicker.setGalleryResults(
        responseParsed.paginatedGalleries.data
      );
    }

    if (responseParsed.ratios) {
      this.articlesEdit.imagePicker.setRatios(responseParsed.ratios);
    }

    if (responseParsed.orientations) {
      this.articlesEdit.imagePicker.setOrientations(
        responseParsed.orientations
      );
    }

    if (responseParsed.uploadSources) {
      this.articlesEdit.imagePicker.setUploadSources(
        responseParsed.uploadSources,
        responseParsed.selectedUploadSource
      );
    }

    if (responseParsed.idBrand) {
      this.articlesEdit.imagePicker.setIdBrand(responseParsed.idBrand);
    }
  }

  protected bytesToSize(bytes) {
    var sizes = ["KB", "MB", "GB", "TB"];
    if (bytes == 0) return "n/a";
    var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
    if (i == 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  }

  protected saveImages(images, insert, param, insertType = "image") {
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/save/";
    let formReq_params: Array<Array<string>> = [];

    formReq_params.push(["data", ko.toJSON(images)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let response = JSON.parse(req.request.response);

          let target = obj.articlesEdit.getImagePickerTarget();

          if (target == "featured_image") {
            obj.articlesEdit.imageWidgetForFeaturedImage.setImage(
              response.images[0].image
            );
          }

          if (target == "alternate_image") {
            obj.articlesEdit.imageWidgetForAlternateImage.setImage(
              response.images[0].image
            );
          }

          if (target === "thumbnail_image") {
            obj.articlesEdit.imageWidgetForThumbnailImage.setImage(
              response.images[0].image
            );
          }

          // if(target === 'featured_video_image'){
          //     obj.articlesEdit.imageWidgetForFeaturedVideo.setImage(response.images[0].image)
          // }

          obj.articlesEdit.setImagePickerTarget(null);

          obj.articlesEdit.imagePicker.onImageSaveReturn(
            response.images,
            insert,
            param,
            insertType
          );

          obj.getImageData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected saveGallery(gallery, insert, param) {
    this.isSaveGallery = true;
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/galleries/save/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", ko.toJSON(gallery)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.imagePicker.onGallerySaveReturn(
            responseParsed.gallery,
            insert,
            param
          );
          obj.getGalleryData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected deleteImage(image) {
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/delete/" + image.id;
    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.articlesEdit.imagePicker.showLoading();
    XHRHdl.onReadyStateFunction = (req, obj) => () => {
      if (req.request.status == 400) {
        obj.articlesEdit.imagePicker.hideLoading();
        obj.articlesEdit.imagePicker.hide();
      }

      obj.manageResponse(req, obj, function () {
        // let responseParsed = JSON.parse(req.request.response);
        obj.getImageData();
      });
    };
    XHRHdl.execute();
  }

  protected handleFiles(files) {
    this.uploadImages(files);
  }

  protected initializeProgress(numFiles) {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
    this.uploadProgress = [];

    for (let i = numFiles; i > 0; i--) {
      this.uploadProgress.push(0);
    }
  }

  protected resetProgress() {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
  }

  protected updateProgress(fileNumber, percent): void {
    this.progressBar.value = percent;
  }

  protected uploadImages(files) {
    console.log("trial  - " + this.uploadStatus.currentTrial);

    let parent = this;
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/images/upload/";

    var formData = new FormData();

    this.initializeProgress(files.length);

    if (files.length > 1) {
      this.articlesEdit.imagePicker.showLoading();
    }

    this.articlesEdit.imagePicker.clearFilters();

    // upload status vars.
    this.uploadStatus.nextTrial();

    for (let i = 0; i < files.length; i++) {
      formData.append("file_" + i, files[i]);
    }
    formData.append("idBrand", idBrand);

    let request = [];
    var xhttp = new XMLHttpRequest();
    request["request"] = xhttp;

    // Set POST method and ajax file path
    xhttp.open("POST", formReq_url, true);

    let onReadyStateFunction = function (req, obj) {
      return function () {
        if (req.request.readyState == 4) {
          if (req.request.status == 200) {
            // reset the upload status when successful operation is complete.
            obj.uploadStatus.reset();
            let fileElement: any = document.getElementById("fileElem");
            fileElement.value = "";
            let response = JSON.parse(req.request.response);

            obj.updateProgress(response.images.length, 100); // <- Add this

            if (response.images.length == 1 && response.errors.length == 0) {
              obj.articlesEdit.imagePicker.editImage(response.images[0]);
              obj.articlesEdit.imagePicker.hideLoading();
            }

            if (
              (response.images.length == 1 && response.errors.length == 1) ||
              response.images.length > 1
            ) {
              obj.articlesEdit.imagePicker.hideImageAdd();
              obj.articlesEdit.imagePicker.handleBulkImages(response.images);
              obj.articlesEdit.imagePicker.hideLoading();

              if (response.errors.length == 1) {
                obj.articlesEdit.imagePicker.imagesBulkEdit.validationsList.setMessages(
                  response.errors
                );
              }
            }

            obj.resetProgress();
            obj.validationTemplate.clearMessages();
          } else if (req.request.status == 400) {
            let responseParsed = JSON.parse(req.request.response);
            obj.articlesEdit.imagePicker.imageAdd.validationsList.setMessages(
              responseParsed.validations
            );
            obj.articlesEdit.imagePicker.hideLoading();
            window.scrollTo(0, 0);
          } else {
            obj.uploadStatus.isInProgress = false;
            obj.articlesEdit.imagePicker.showUploadError();
          }
        }
      };
    };

    // call on request changes state
    xhttp.onreadystatechange = onReadyStateFunction(request, this);

    let firstTime = new Date().getTime();
    xhttp.upload.addEventListener("progress", function (e) {
      parent.uploadStatus.progress = e.loaded;
      let progressTime = new Date().getTime();
      let diff = progressTime - firstTime;
      firstTime = progressTime;
      console.log(
        "Upload Image progress: ",
        e.loaded,
        e.total,
        parent.uploadStatus.progress,
        diff
      );
    });

    xhttp.upload.addEventListener("loadend", (e) => {
      if (
        !parent.uploadStatus.isInProgress &&
        parent.uploadStatus.trialsReached()
      ) {
        xhttp.abort();
        parent.articlesEdit.imagePicker.showPickerUploadError();
        parent.articlesEdit.imagePicker.hideLoading();
      }
      console.log(
        "Upload Image Loadend: ",
        parent.uploadStatus.progress,
        e.loaded,
        e.total
      );
    });

    xhttp.upload.addEventListener("loadstart", (e) => {
      console.log("timeout started");
      setTimeout(() => {
        // check after one second if the progress is blocked then trigger another try.
        if (
          !parent.uploadStatus.isInProgress &&
          !parent.uploadStatus.trialsReached()
        ) {
          xhttp.abort();
          parent.uploadImages(files);
        }
      }, 1000);
    });

    // Send request with data
    xhttp.send(formData);
  }

  public reset() {
    this.uploadStatus.reset();
    this.articlesEdit.imagePicker.hidePickerUploadError();
  }

  protected getGalleryData() {
    if (this.galleryXHRHdl) {
      this.galleryXHRHdl.cancelAndReset();
    }
    this.articlesEdit.imagePicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/galleries/get/";
    let formReq_params: Array<Array<string>> = [];

    formReq_params.push([
      "data",
      ko.toJSON(this.articlesEdit.imagePicker.getViewModelForRequest()),
    ]);

    this.galleryXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.galleryXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;

    this.galleryXHRHdl.onReadyStateFunction = this.onGetGalleryDataReturn;
    this.galleryXHRHdl.execute();
  }

  protected onGetGalleryDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        if (
          obj.articlesEdit.imagePicker.getSelectedTab() == "galleries" ||
          obj.isSaveGallery
        ) {
          obj.articlesEdit.imagePicker.hideLoading();
          obj.isSaveGallery = false;
        }
      });
    };
  }

  public getImagesInContent(target) {
    if (this.ImagePickerXHRHdl) {
      this.ImagePickerXHRHdl.cancelAndReset();
    }

    this.articlesEdit.imagePicker.showInContentLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/images/get-in-content/";
    let formReq_params: Array<Array<string>> = [];

    let content;

    switch (target) {
      case "article_content":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    formReq_params.push(["content", content]);

    this.ImagePickerXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.ImagePickerXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    this.ImagePickerXHRHdl.onReadyStateFunction =
      this.onGetIncontentImageReturn;
    this.ImagePickerXHRHdl.execute();
  }

  public getEditorContent(target) {

    let content;

    switch (target) {
      case "article_content":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    return content;
  }


  public onGetIncontentImageReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        obj.articlesEdit.imagePicker.hideInContentLoading();
        //TODO after save
      });
    };
  }

  public getSensaiResults(target, idContentType) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }
    if (target == "sensai_prompt") {
      this.articlesEdit.sensaiPromptTemplate.showLoading();
    } else {
      this.articlesEdit.showFeedbackTabLoading();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/sensai/get-results/";
    let formReq_params: Array<Array<string>> = [];

    let content;

    switch (target) {
      case "article_content" || "sensai_prompt":
        content = contentEditor.getData();
        break;
      case "article_intro":
        content = introTextEditor.getData();
        break;
      case "article_sandbox":
        content = sandboxEditor.getData();
        break;
      case "article_faq":
        content = faqEditor.getData();
        break;
      case "article_republish":
        content = republishEditor.getData();
        break;
      default:
        content = contentEditor.getData();
    }

    let articleViewModel = this.getSavePostData();
    formReq_params.push(["article", ko.toJSON(articleViewModel)]);

    formReq_params.push(["content", content]);
    formReq_params.push(["idContentType", idContentType]);
    //formReq_params.push(["article", idContentType]);

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    if (target == "sensai_prompt") {
      this.SensaiXHRHdl.onReadyStateFunction =
        this.onGetSensaiResultsReturnPrompt;
    } else {
      this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiResultsReturn;
    }
    this.SensaiXHRHdl.execute();
    //return this.SensaiXHRHdl.onReadyStateFunction;
  }

  public onGetSensaiResultsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let guidelines = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.articleReviewHistory.setGuidelines(guidelines);
        obj.articlesEdit.setSensaiRuleScore(
          responseParsed.feedback.totalRuleScore
        );
        //obj.articlesEdit.articleReviewHistory.setTotalSensaiScore(responseParsed.feedback.totalRuleScore);
        //obj.articlesEdit.sensaiProgressBar.setScore(responseParsed.feedback.totalRuleScore, obj.articlesEdit.getSensaiRulePointThreshold());
        obj.getAIContent();
        obj.articlesEdit.hideFeedbackTabLoading();
      });

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  public organizeSensaiResults(responseParsed) {
    return Object.keys(responseParsed.feedback)
      .map(function (section) {
        if (section != "totalRuleScore") {
          return {
            sectionName: section,
            rules: Object.keys(responseParsed.feedback[section]).map(function (
              rule
            ) {
              return {
                ruleName: rule,
                ruleStatus:
                  responseParsed.feedback[section][rule]["ruleStatus"],
                isMandatory:
                  responseParsed.feedback[section][rule]["isMandatory"],
              };
            }),
          };
        }
      })
      .filter((item) => item !== undefined);
  }

  public onGetSensaiResultsReturnPrompt(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let content = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.sensaiPromptTemplate.setContent(content);
        obj.articlesEdit.sensaiPromptTemplate.setPromptType("sensaiPrompt");

        obj.articlesEdit.setSensaiRuleScore(
          responseParsed.feedback.totalRuleScore
        );
        //obj.articlesEdit.sensaiPromptTemplate.setSensaiCoverageScore(obj.articlesEdit.getTemplateViewModel().sensaiCoverageScore())
        obj.articlesEdit.setTotalSensaiScore();
        obj.articlesEdit.setSensaiPrompt(content);
      });

      obj.articlesEdit.sensaiPromptTemplate.removeLoading();
    };
  }

  protected getTagsByType(
    idType,
    keyword = null,
    limit = null,
    typeIsNotNull = false
  ) {
    // LOADING : starts

    let subViewModel = {
      filter: { keyword: keyword, limit: limit },
      typeIsNotNull: typeIsNotNull,
    };

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
    //this.loadingIn(this.articlesEdit.builtTemplate);

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/tags/get_by_type_for_review_item/" +
      idType;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagsRequestReturn;
    this.XHRHdl.execute();
  }

  protected getSuggestions(keyword, idSourceElement) {
    this.XHRHdlCaller = "getSuggestions_" + idSourceElement;
    if (idSourceElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

      if (!filterTypes.addNewSelected()) {
        this.getTagsByType(
          idType,
          this.articlesEdit.filterProducts.getTemplateViewModel().inputText(),
          5,
          true
        );
      } else {
        this.articlesEdit.filterProducts
          .getTemplateViewModel()
          .optionsLoading(false);
      }
    } else if (idSourceElement == "filterAutocompleteProductType_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      this.getTagsTypeSuggestion(filterTypes.inputText(), 5);
    } else if (idSourceElement == "filterAutocompleteAffiliate_template") {
      let filterAffiliates =
        this.articlesEdit.filterAffiliates.getTemplateViewModel();
      this.getAffiliatesSuggestion(filterAffiliates.inputText(), 5);
    } else if (idSourceElement == "filterAutocompleteAiAgent_template") {
      this.getAiAgentSuggestion(
        this.articlesEdit.filterAiAgent.getTemplateViewModel().inputText(),
        10
      );
    }
    //TODO here for  idSource Element use getTagSuggestions (already made)
    else if (idSourceElement == "filterAutocompletePinnedTags_template") {
      let pinnedTag = this.articlesEdit.filterPinnedTag.getTemplateViewModel();
      this.getTagsSuggestionOnInput(
        pinnedTag.inputText(),
        5,
        null,
        false,
        false,
        true
      );
    } else if (
      idSourceElement == "filterTagType" ||
      idSourceElement == "tagPickerSourceFilterTagType"
    ) {
      this.getTagsTypeSuggestion(keyword, 5);
    } else if (
      idSourceElement == "filterAddNewTagType" ||
      idSourceElement == "filterEditTagType"
    ) {
      this.getTagsTypeSuggestion(keyword, 5, true);
    } else if (
      idSourceElement == "filterAutocompleteTagViewAffiliate_template" ||
      idSourceElement == "filterAutocompleteTagEditAffiliate_template"
    ) {
      this.getAffiliatesSuggestion(keyword, 5);
    } else if (idSourceElement == "filterAutocompleteLocales_template") {
      this.getLocaleSuggestion(keyword);
    } else if (
      [
        "filterTag",
        "filterVideoTag",
        "filterVideoTagEdit",
        "filterTagImagePickerEdit",
        "filterAutocompleteReviewTag_template",
      ].indexOf(idSourceElement) >= 0
    ) {
      this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
    } else if (
      idSourceElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      let filterTypes =
        this.articlesEdit.articlePinnedTags.filterTagType.getTemplateViewModel();
      this.getTagsTypeSuggestion(filterTypes.inputText(), 5);
    } else if (
      idSourceElement == "filterDataset"
    ) {
      this.getDatasetSuggestion(keyword);
    } else if (
      idSourceElement == "filterAutocompleteTagArticlePinnedTags_template"
    ) {
      let filterTags =
        this.articlesEdit.articlePinnedTags.filterTags.getTemplateViewModel();
      let tagType =
        this.articlesEdit.articlePinnedTags.filterTagType.getOptionObj();

      this.getTagsSuggestionOnInput(
        filterTags.inputText(),
        5,
        tagType,
        true,
        true,
        false,
        true
      );
    } else if (idSourceElement == "tagSourcePickerTagFilter") {
      this.getTagPickerSpecificationTagSuggestions(keyword);
    } else if (idSourceElement == "vignetteFilter") {
      this.getVignettesSuggestion(keyword, this.onGetVignettesSuggestionReturn);
    } else if (idSourceElement == "defaultVignetteFilter") {
      this.getVignettesSuggestion(
        keyword,
        this.onGetDefaultVignettesSuggestionReturn
      );
    }
  }

  private getTagPickerSpecificationTagSuggestions(keyword) {
    let tagTypeFieldParams =
      this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.getViewModelForRequest();
    let typeRestrictions = tagTypeFieldParams.typeRestrictions;
    this.getTagsByTypes(keyword, typeRestrictions);
  }

  public getVignettesSuggestion(keyword, onReadyStateFunction: Function) {
    const idBrand = this.getVnAppZone().app.params.idBrand;

    this.XHRHdl.cancelAndReset();

    let subViewModel = {
      pagination: { itemPerPage: 25 },
      filter: { keyword: keyword },
    };
    let usrReq_url: string = `/api/brand/${idBrand}/search/tags/vignettes/`;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = onReadyStateFunction;
    this.XHRHdl.execute();
  }

  protected onGetVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          let vignettes = response.data;
          vignettes.forEach((vignette) => {
            vignette.name += ` (${vignette.id})`;
          });
          obj.articlesEdit.tagPicker.tagEdit.vignetteFilter.setOptions(
            vignettes
          );
        }
      });
    };
  }

  protected onGetDefaultVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          let vignettes = response.data;
          vignettes.forEach((vignette) => {
            vignette.name += ` (${vignette.id})`;
          });
          obj.articlesEdit.tagPicker.tagEdit.defaultVignetteFilter.setOptions(
            vignettes
          );
        }
      });
    };
  }

  protected getArticlesSuggestion(keyword, idElement) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { list: { keyword: keyword, sourceId: idElement } };

    let usrReq_url: string;

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);

    if (idElement == "filterArticleDirectory") {
      usrReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/directories/get/";
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.onReadyStateFunction =
        this.onGetDirectoryArticlesSuggestionsReturn;
    } else if (
      idElement == "pollPickerFilterArticle" ||
      idElement == "pollPickerDiscussionArticle"
    ) {
      usrReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/polls/article-suggestions/";
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
    } else {
      usrReq_url =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/articles/next/get/";
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
    }

    this.XHRHdl.execute();
  }

  protected onGetDirectoryArticlesSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data.articles) {
          obj.articlesEdit.setDirectoryArticlesFilter(
            responseParsed.data.articles
          );
        }
      });
    };
  }

  protected onGetArticlesSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let sourceId = JSON.parse(req._parameters[0][1])["list"]["sourceId"];

        if (responseParsed.data.articles) {
          if (
            sourceId == "article_directory" ||
            sourceId == "sandbox_directory" ||
            sourceId == "republish_directory"
          ) {
            obj.articlesEdit.setDirectoryItemFilter(
              responseParsed.data.articles,
              sourceId
            );
          } else if (sourceId == "quizPickerFilterArticle") {
            obj.articlesEdit.quizPicker.quizEdit.setArticlesFilter(
              responseParsed.data.articles
            );
          } else if (sourceId == "pollPickerFilterArticle") {
            obj.articlesEdit.pollPicker.pollEdit.setArticleOptions(
              responseParsed.data.articles
            );
          } else if (sourceId == "pollPickerDiscussionArticle") {
            obj.articlesEdit.pollPicker.pollEdit.setDiscussionArticleOptions(
              responseParsed.data.articles
            );
          } else {
            obj.articlesEdit.setArticlesFilter(responseParsed.data.articles);
          }
        }
      });
    };
  }

  protected insertImages(
    images,
    target,
    extra_option,
    isMobileOptimized = false
  ) {
    let imgGroupTag = this.buildImageGroupTag(images, extra_option);
    if (target == "article_content") {
      this.insertElement(imgGroupTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertElement(imgGroupTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertElement(imgGroupTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertElement(imgGroupTag, faqEditor);
    } else if (target == "productImages") {
      this.articlesEdit.setProductImages(images);
    } else if (target == "article_directory_item_description") {
      this.insertElement(imgGroupTag, articleDirectoryItemDescriptionEditor);
    } else if (target == "sandbox_directory_item_description") {
      this.insertElement(imgGroupTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertElement(imgGroupTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertElement(imgGroupTag, republishDirectoryItemDescriptionEditor);
    }

    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      let setArticleToEmbargo = false;
      for (let image of images) {
        if (image.isUnderEmbargo) {
          setArticleToEmbargo = true;
          break;
        }
      }
      if (setArticleToEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  protected insertImage(image, target, extra_option) {
    if (target.element) {
      let element = target.element;
      element.parentElement.removeChild(element);
      target = target.editor;
    }
    let isImageInsertionSectionOptimizable =
      this.articlesEdit.isImageInsertionSectionOptimizable(target);
    if (isImageInsertionSectionOptimizable == false) {
      image.isMobileOptimized = false;
    }

    let imgTag = this.buildImageTag(image, false, extra_option);
    if (target == "article_content") {
      this.insertTag(imgTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertTag(imgTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertTag(imgTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertTag(imgTag, faqEditor);
    } else if (target == "article_directory_item_description") {
      this.insertTag(imgTag, articleDirectoryItemDescriptionEditor);
    } else if (
      target == "articleImageOverride" ||
      target == "articleImageOverrideEdit"
    ) {
      this.articlesEdit.articlePicker.articlePickerView.setArticleImageOverride(
        image
      );
    } else if (target == "sandbox_directory_item_description") {
      this.insertTag(imgTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertTag(imgTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertTag(imgTag, republishDirectoryItemDescriptionEditor);
    } else if (target == "tagImage") {
      this.articlesEdit.setTagImage(image);
    } else if (target == "productImages") {
      this.articlesEdit.addProductImage(image);
    } else if (
      target == "tagImageOverride" ||
      target == "tagImageOverrideEdit"
    ) {
      this.articlesEdit.tagPicker.setTagImageOverride(image);
    } else if (target == "tagImageEdit") {
      this.articlesEdit.tagPicker.setTagImage(image);
    } else if (target == "tagIconImageEdit") {
      this.articlesEdit.tagPicker.setTagIconImage(image);
    } else if (target == "tagBannerImageEdit") {
      this.articlesEdit.tagPicker.setTagBannerImage(image);
    } else if (target == "tagIconOverride") {
      this.articlesEdit.tagPicker.setTagIconOverride(image);
    } else if (target == "tagImageBadge") {
      this.articlesEdit.tagPicker.setTagImageBadge(image);
    } else if (target == "video_thumbnail") {
      this.articlesEdit.videoPickerHelper.setThumbnailImage(image);
    } else {
      this.articlesEdit.setImage(image, target);
    }

    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      let setArticleToEmbargo = false;
      if (image.isUnderEmbargo) {
        setArticleToEmbargo = true;
      }
      if (setArticleToEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  public revertSandbox() {
    let sandboxData = sandboxEditor.getData();
    contentEditor.setData(sandboxData);
  }

  public revertSandboxIntroText() {
    let sandboxIntroData = sandboxIntroTextEditor.getData();
    introTextEditor.setData(sandboxIntroData);
  }

  public revertSandboxDirectory() {
    //to delete exiting ones
    let items = this.articlesEdit.articleDirectory.getDirectoryItems();
    items.forEach((item) =>
      this.articlesEdit.articleDirectory
        .getTemplateViewModel()
        .deletedDirectoryItems()
        .push(item)
    );
    this.articlesEdit.articleDirectory.setDirectoryItems([]);

    //set new ones
    let directoryItems = this.articlesEdit.sandboxDirectory.getDirectoryItems();
    directoryItems = ko.toJS(directoryItems); //convert observable array ot simple array
    this.articlesEdit.articleDirectory.setSandboxDirectoryItems(directoryItems);
  }

  public copyContent(tab) {
    let contentData = contentEditor.getData();

    if (tab == "sandbox") {
      sandboxEditor.setData(contentData);
    }

    if (tab == "republish") {
      let contentKeyPoints = this.articlesEdit
        .getTemplateViewModel()
        .contentKeyPoints();

      if (contentKeyPoints) {
        contentData = contentData.replaceAll("\t", ""); //to remove tab shift before elements
        contentKeyPoints = contentKeyPoints.split("\n");
        contentKeyPoints = contentKeyPoints.filter((item) => item);

        let html =
          '<div class="emaki-custom key-points">\n<ul class="key-points-list">\n';
        for (let i = 0; i < contentKeyPoints.length; i++) {
          let match = i + 1;
          let value = contentKeyPoints[i]
            .replace("" + match + ". ", "")
            .replace("" + match + ") ", "")
            .replace("" + match + " ", "")
            .replace("" + match + "/ ", "")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#39;");
          html = html + '<li class="key-points-item">' + value + "</li>\n";
        }
        html = html + "</ul>\n</div>";

        if (contentData.indexOf(html) > -1) {
          contentData = contentData.replace(html, "");
        }
      }

      republishEditor.setData(contentData);
    }
  }

  public copyIntroText(tab) {
    let introData = introTextEditor.getData();

    if (tab == "sandbox") {
      sandboxIntroTextEditor.setData(introData);
    }

    if (tab == "republish") {
      republishIntroTextEditor.setData(introData);
    }
  }

  protected insertGallery(gallery, target, extra_option) {
    let galleryTag = this.buildGalleryTag(gallery, extra_option);
    if (target == "article_content") {
      this.insertElement(galleryTag, contentEditor);
    } else if (target == "article_intro") {
      this.insertElement(galleryTag, introTextEditor);
    } else if (target == "article_sandbox") {
      this.insertElement(galleryTag, sandboxEditor);
    } else if (target == "article_faq") {
      this.insertElement(galleryTag, faqEditor);
    } else if (target == "article_directory_item_description") {
      this.insertElement(galleryTag, articleDirectoryItemDescriptionEditor);
    } else if (target == "sandbox_directory_item_description") {
      this.insertElement(galleryTag, sandboxDirectoryItemDescriptionEditor);
    } else if (target == "article_republish") {
      this.insertElement(galleryTag, republishEditor);
    } else if (target == "republish_directory_item_description") {
      this.insertElement(galleryTag, republishDirectoryItemDescriptionEditor);
    }
  }

  protected insertTag(tag, editor) {
    editor.insertHtml(tag);
  }

  protected insertElement(tag, editor) {
    var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
    editor.insertElement(tagElement);
  }

  protected onAutocompleteInputClear(idElement) {
    if (idElement == "filterAutocompleteProductType_template") {
      this.articlesEdit.filterProducts.setOptions([]);

      if (this.articlesEdit.filterProducts.getTemplateViewModel().optionObj()) {
        this.articlesEdit.filterProducts.clearInput();
      }

      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProduct_template") {
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "onAutocompleteOptionChange") {
      this.articlesEdit.filterPinnedTag.setOptions([]);
    } else if (idElement == "filterAutocompletePinnedTags_template") {
      this.articlesEdit.imageWidgetForFeaturedImage.clearImage();
    } else if (
      idElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(false);
      this.articlesEdit.articlePinnedTags.setTags([]);
    } else if (idElement == "vignetteFilter") {
      this.articlesEdit.tagPicker.tagEdit.setSelectedVignette(null);
    } else if (idElement == "defaultVignetteFilter") {
      this.articlesEdit.tagPicker.tagEdit.setSelectedDefaultVignette(null);
    }
    /*else if(idElement == 'filterEditTagType'){

            this.articlesEdit.tagPicker.onEditTagTypeFilter();
        }*/
  }

  protected onAutocompleteInputClick(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();

      if (filterTypes.addNewSelected()) {
        this.articlesEdit.filterProducts.setOptions([]);
      }
    }
    if (idElement == "filterAutocompleteProductType_template") {
      //this.articlesEdit.onChangeSelectTag(); //May be unnecessary
    }
  }

  protected onAutocompleteAddNewSelected(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      this.articlesEdit
        .getTemplateViewModel()
        .addedReviewItemTagSpecifications([]);
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProductType_template") {
      //Clearing product when a new type is selected
      this.articlesEdit
        .getTemplateViewModel()
        .addedReviewItemTagSpecifications([]);
      if (
        this.articlesEdit.filterProductTypes
          .getTemplateViewModel()
          .addNewSelected() &&
        !this.articlesEdit.filterProducts
          .getTemplateViewModel()
          .addNewSelected()
      ) {
        this.articlesEdit.filterProducts.clearEverything();
      }
      this.articlesEdit.onChangeSelectTag();
    }
  }

  protected onAutocompleteAddNewInputClick(idElement) {
    //TODO: May be useless

    if (idElement == "filterAutocompleteProduct_template") {
    } else if (idElement == "filterAutocompleteProductType_template") {
    }
  }

  protected onAutocompleteAcceptSuggestion(idElement) {
    if (idElement == "filterAutocompleteProduct_template") {
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      // let filterTypes = this.articlesEdit.filterProductTypes.getTemplateViewModel();

      if (filterProducts.optionObj().type) {
        this.articlesEdit.filterProductTypes
          .getTemplateViewModel()
          .addNewSelected(false);
        this.articlesEdit.filterProductTypes.setOption(
          filterProducts.optionObj().type
        );
      }
    } else if (idElement == "filterAutocompleteAiAgent_template") {
      this.articlesEdit.onClickAddAiAgent();
    }
  }


  protected onAutocompleteAddNewInputChange(idElement: string) {
    this.XHRHdlCaller = "onAutocompleteAddNewInputChange_" + idElement;

    if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      let idType;
      if (!filterTypes.addNewSelected()) {
        idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

        if (filterTypes.optionObj()) {
          idType = filterTypes.optionObj().id;
        } else {
          idType = 0;
        }
      } else {
        idType = 0;
      }
      this.getTagsByType(idType, filterProducts.newOptionName(), 1, true);
    } else if (idElement == "filterAutocompleteProductType_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      this.articlesEdit.filterProductTypes
        .getTemplateViewModel()
        .suggestedObj(""); //TODO: Investigate why this is needed
      this.getTagsTypeSuggestion(filterTypes.newOptionName(), 1);
    } else if (idElement == "filterAutocompleteAffiliate_template") {
      this.getAffiliatesSuggestion(
        this.articlesEdit.filterAffiliates
          .getTemplateViewModel()
          .newOptionName(),
        1
      );
    } else if (idElement == "filterAutocompleteAiAgent_template") {
      this.getAiAgentSuggestion(
        this.articlesEdit.filterAiAgent.getTemplateViewModel().newOptionName(),
        1
      );
    }
  }

  protected onPromptInputChangeClear(idElement) {
    this.clearValidationErrors();

    if (idElement === "filterAutocompleteTagEditAffiliate_template") {
      this.articlesEdit.tagPicker.clearTagEditAutomaticPricingOptions();
    } else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
      this.articlesEdit.tagPicker.clearTagViewAutomaticPricingOptions();
    }
  }

  protected onAutocompleteOptionChange(idElement) {
    this.clearValidationErrors();

    if (idElement === "filterAutocompleteTagEditAffiliate_template") {
      this.articlesEdit.tagPicker.updateTagEditAutomaticPricingOptions();
    } else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
      this.articlesEdit.tagPicker.updateTagViewAutomaticPricingOptions();
    } else if (idElement == "filterAutocompleteProductType_template") {
      this.articlesEdit.filterProducts.getTemplateViewModel().options([]);
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();
      let product = filterProducts.optionObj();

      if (product) {
        if (product.type) {
          this.articlesEdit.filterProducts.clearSelectedOption();
        }
      }

      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompleteProduct_template") {
      let filterTypes =
        this.articlesEdit.filterProductTypes.getTemplateViewModel();
      let filterProducts =
        this.articlesEdit.filterProducts.getTemplateViewModel();

      if (!filterTypes.addNewSelected()) {
        let tag = filterProducts.optionObj();
        if (filterTypes.optionObj() === null) {
          if (tag && tag.type) {
            filterTypes.optionObj(tag.type);
            filterTypes.inputText(tag.type.name);
          }
        } else if (tag.type.id === filterTypes.optionObj().id) {
          //Added after the anna struggle BEGIN

          if (tag.type.fields) {
            if (
              tag.type.fields.length > filterTypes.optionObj().fields.length
            ) {
              filterTypes.optionObj(tag.type);
            }
          }
        } //Added after the anna struggle END
      }
      this.articlesEdit.onChangeSelectTag();
    } else if (idElement == "filterAutocompletePinnedTags_template") {
      let featuredTag = this.articlesEdit.filterPinnedTag.getOptionObj();
      if (featuredTag) {
        this.articlesEdit.imageWidgetForFeaturedImage
          .getTemplateViewModel()
          .imageURL(featuredTag.imageUrl);
        this.articlesEdit.imageWidgetForFeaturedImage
          .getTemplateViewModel()
          .imageId(featuredTag.idImage);
      }
    } else if (idElement == "filterAutocompleteAffiliate_template") {
      if (
        this.articlesEdit.filterAffiliates.getTemplateViewModel().optionObj()
      ) {
        this.articlesEdit.filterAffiliates
          .getTemplateViewModel()
          .placeholder("Affiliate Partner");
      }
    } else if (idElement == "filterAutocompleteAiAgent_template") {
      this.articlesEdit.onClickAddAiAgent();
    } else if (idElement == "filterTagType") {
      this.articlesEdit.tagPicker.onAddTagTypeFilter();
    } else if (idElement == "filterEditTagType") {
      this.articlesEdit.tagPicker.onEditTagTypeFilter();
    } else if (
      idElement == "filterAutocompleteTagTypeArticlePinnedTags_template"
    ) {
      let tagType =
        this.articlesEdit.articlePinnedTags.filterTagType.getOptionObj();
      let filters = tagType.fields.filter((v) => v.dataType != "tags");
      let filterOptions = filters.map((v) => ({ name: v.label, id: v.id }));
      filterOptions.unshift({ name: "Select an option", id: null });
      this.articlesEdit.articlePinnedTags.setTagSpecs(filterOptions);
      this.articlesEdit.articlePinnedTags.setIsShownTagTypeSpec(true);
      this.articlesEdit.articlePinnedTags.setTags([]);
    } else if (idElement == "filterAutocompleteTagArticlePinnedTags_template") {
      let tag = this.articlesEdit.articlePinnedTags.filterTags.getOptionObj();
      let selectedSpecId = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedTagSpec();
      let allSpec = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .tagSpecs();
      let selectedSpec = allSpec.filter((v) => v.id == selectedSpecId);
      let style = this.articlesEdit.articlePinnedTags
        .getTemplateViewModel()
        .selectedStyle();
      let specFields = JSON.parse(tag.specificationFieldIds);

      if (
        style == "single-spec" &&
        selectedSpecId &&
        (!specFields || !specFields.includes(selectedSpecId))
      ) {
        this.articlesEdit.articlePinnedTags.missingSpecDialog.setIsVisible(
          true
        );
        let message =
          "<p>" +
          tag.name +
          " does not have a specification value for  " +
          selectedSpec[0].name +
          ".It can remain pinned but will not be displayed on the website until a specification value is added.</p>";
        this.articlesEdit.articlePinnedTags.missingSpecDialog.setMessage(
          message
        );
      } else {
        this.articlesEdit.articlePinnedTags.addTag();
      }
    } else if (idElement === "tagPickerSourceFilterTagType") {
      this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.addTagTypeRestriction();
    } else if (idElement == "vignetteFilter") {
      this.clearValidationErrors();
      this.articlesEdit.tagPicker.tagEdit.setSelectedVignette(
        this.articlesEdit.tagPicker.tagEdit.vignetteFilter.getOptionObj()
      );
    } else if (idElement == "defaultVignetteFilter") {
      this.clearValidationErrors();
      this.articlesEdit.tagPicker.tagEdit.setSelectedDefaultVignette(
        this.articlesEdit.tagPicker.tagEdit.defaultVignetteFilter.getOptionObj()
      );
    }
  }

    protected filterSimpleOnChange(idElement) {
        switch (idElement) {
            case "filterTag":
                this.articlesEdit.updateSelectedTags();
                break;
            case "filterArticle":
                break;
            case "quizPickerFilterArticle":
                this.articlesEdit.quizPicker.quizEdit.syncSelectedSourceArticle();
                break;
            case "pollPickerFilterArticle":
                this.articlesEdit.pollPicker.pollEdit.syncSelectedSourceArticle();
                break;
            case "pollPickerDiscussionArticle":
                break;
            case "filterDirectoryItem":
                this.clearValidationErrors();
                break;
            case "filterUser_display_author":
                this.articlesEdit.addDisplayAuthor();
                break;
            case "filterTagSearch":
                this.articlesEdit.tagPicker.resetPagination();
                this.getTagData();
                break;
            case "filterPollSearch":
                this.articlesEdit.pollPicker.resetPagination();
                this.getPollData();
                break;
            case "filterDataset":
                this.articlesEdit.tagPicker.resetPagination();
                this.getTagData();
                break;
            case "videoKeywordFilter":
                this.articlesEdit.videoPickerHelper.resetPagination();
                this.getVideosData();
                break;
            case "videoOrientationFilter":
                this.articlesEdit.videoPickerHelper.resetPagination();
                this.getVideosData();
                break;
            case "filterVideoTag":
                this.articlesEdit.videoPickerHelper.resetPagination();
                this.getVideosData();
                break;
            case "filterVideoTagEdit":
                this.getVideoPickerEditTemplate().updateSelectedTags();
                break;
            case "filterTagImagePickerEdit":
                this.getImagePickerEditTemplate().updateSelectedTags();
                break;
            case "tagSourcePickerTagFilter":
                this.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.addSelectedTag();
                break;
            case 'dealsCategoryPromotionListingPageFilter':
                this.articlesEdit.updateAiDealsCategoryPromotionListingPageId();
                break;
            case "filterUser_producer":
                break;
            case "filterUser_prompt_author":
                break;
            default:
                this.getImageData();
                this.getGalleryData();
                break;
        }
    }

  protected filterSimpleCancel() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  protected buildImageGroupTag(images, extra_option): string {
    let css = `emaki-imgGroup ${extra_option}`.trim();
    let imageGroupTag = `<div class="${css}">`;

    for (let image of images) {
      let imgTag = this.buildImageTag(image, false, "");
      imageGroupTag = imageGroupTag + imgTag;
    }

    imageGroupTag = imageGroupTag + "</div>";

    return imageGroupTag;
  }

  protected buildGalleryTag(gallery, extra_option): string {
    let css = `emaki-imgGroup emaki-group ${extra_option}`.trim();
    let galleryTag = `<div class="${css}" gallery-id="${gallery.id}">`;

    for (let image of gallery.images.slice(0, 5)) {
      let imgTag = this.buildImageTag(image, false, "");
      galleryTag = galleryTag + imgTag;
    }

    galleryTag = galleryTag + "</div>";

    return galleryTag;
  }

  protected buildImageTag(image, addCaption, extra_option): string {
    let imgTag = `<img `;

    imgTag += `data-image-id="${image.id}"`;

    imgTag += `src="${image.url}" `;
    if (image.altText != null) {
      let escapedAltText = image.altText.replace(/"/g, "&quot;");
      imgTag += `alt="${escapedAltText}" `;
    } else {
      imgTag += `alt="" `;
    }

    if (image.isMobileOptimized) {
      imgTag += ` data-mobile-optimized="true"`;
    }

    imgTag += ` width="${image.width}" height="${image.height}" />`;

    //add caption
    if (addCaption && image.caption != null && image.caption.trim() != "") {
      imgTag = `[caption]${imgTag} ${image.caption}[/caption]`;
    }

    if (extra_option) {
      imgTag = `<div class="emaki-imgGroup emaki-imgSingle grid_view">${imgTag}</div>`;
    }

    return imgTag;
  }

  protected cancelTakeOver() {
    this.clearRecoverySave();
    this.clearRecoveryWarning();

    this.maximizeSideNav();

    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_WARNING,
      "Article action canceled !"
    );

    let lastRoute = this.getVnAppZone().app.getLastRoute();

    page.redirect(lastRoute);
  }

  public setReviewText(text) {
    prodRevReviewText.setData(text, function () {
      this.resetUndo();
    });
  }

  protected onGetTagsRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let tags = responseParsed.data;

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteProduct_template"
        ) {
          if (tags) {
            obj.articlesEdit.filterProducts
              .getTemplateViewModel()
              .suggestedObj(tags[0]);
          }
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteProduct_template"
        ) {
          tags.forEach((tag) => {
            if (tag.type != null) {
              tag.displayNameComplement =
                tag.name + " ( " + tag.type.name + " ) ";
            } else {
              tag.displayNameComplement = tag.name + " ( * No type * )";
            }

            if (tag.details != null) {
              tag.isSelectable = tag.details.isSelectable;
            } else {
              tag.isSelectable = false;
            }
          });

          obj.articlesEdit.filterProducts.setOptions(tags);
          obj.articlesEdit.filterProducts.setIsLoading(false);
        }
      });
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected checkForReviewItemsUpdate(sourceOfReversal) {
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/reviewItem/checkForUpdate/";

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let saveData = {
      reviewItems: this.articlesEdit.getTemplateViewModel().backupReviewItems(),
      sourceOfReversal: sourceOfReversal,
    };

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    //Pass article status to know if an article is completed to choose proper validation of user
    usrReq_params.push([
      "idStatus",
      this.articlesEdit.getTemplateViewModel().idStatus(),
    ]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction =
      this.onCheckForReviewItemsUpdateRequestReturn;
    this.XHRHdl.execute();
  }

  protected onCheckForReviewItemsUpdateRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        if (req.request.status == 200) {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response); //TODO: Remove this

            obj.articlesEdit.revertReviewItems(
              responseParsed.reviewItems,
              responseParsed.fieldUpdates
            );
          });

          obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
      }
    };
  }

  protected validateArticleSaveFrontEnd() {
    let selectedStatus = this.articlesEdit.getTemplateViewModel().idStatus();
    let idContentType = this.articlesEdit
      .getTemplateViewModel()
      .idContentType();

    // before putting into the "Submit for approval" status, the content type must be set..
    if (
      (selectedStatus == 2 || selectedStatus == 3 || selectedStatus == 6) &&
      !idContentType
    ) {
      let message = {
        field: "Content Type",
        label: "Content Type",
        message: "Please select a Content Type.",
      };
      this.validationTemplate.setSingleMessage(message);
      return false;
    }

    return true;
  }

  protected validateReviewItem() {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let viewModel = this.articlesEdit.getTemplateViewModel();
    let productViewModel =
      this.articlesEdit.filterProducts.getTemplateViewModel();
    let productTypesViewModel =
      this.articlesEdit.filterProductTypes.getTemplateViewModel();
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/reviewItem/validate/";

    let tagTypeName, tagName, idTag, idTagType;

    if (productTypesViewModel.addNewSelected()) {
      idTagType = 0;
      tagTypeName = productTypesViewModel.newOptionName();
    } else {
      if (productTypesViewModel.optionObj()) {
        idTagType = productTypesViewModel.optionObj().id;
        tagTypeName = productTypesViewModel.optionObj().name;
      } else {
        idTagType = 0;
        tagTypeName = "";
      }
    }

    if (productViewModel.addNewSelected()) {
      idTag = 0;
      tagName = productViewModel.newOptionName();
    } else {
      if (productViewModel.optionObj()) {
        idTag = productViewModel.optionObj().id;
        tagName = productViewModel.optionObj().name;
      } else {
        idTag = 0;
        tagName = "";
      }
    }

    let saveData = {
      amazonSummary: viewModel.reviewItemAmazonSummary(),
      amazonHeadline: viewModel.reviewItemAmazonHeadline(),
      amazonAward: viewModel.reviewItemAmazonAward(),
      amazonRating: viewModel.reviewItemAmazonRating(),
      extraVideos: viewModel
        .reviewItemExtraVideos()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      extraImages: viewModel.reviewItemImages(),
      rating: viewModel.reviewItemRating(),
      idTagType: idTagType,
      tagTypeName: tagTypeName,
      tagName: tagName,
      idTag: idTag,
      tagSpecifications: viewModel
        .reviewItemTagSpecifications()
        .filter((e) => e.label.trim() || e.data.trim()),
      addedSpecifications: viewModel
        .addedReviewItemTagSpecifications()
        .filter((e) => e.label.trim() || e.data.trim()),
      pros: viewModel
        .reviewItemPros()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      cons: viewModel
        .reviewItemCons()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      keyFeatures: viewModel
        .reviewItemKeyFeatures()
        .map((obj) => {
          return obj.data;
        })
        .filter((e) => e.trim()),
      seoDescription: viewModel.reviewItemSeoDescription(),
      tagImage: viewModel.tagImage(),
      reviewText: prodRevReviewText.getData(),
      giveawayUrl: viewModel.reviewItemGiveawayUrl(),
      giveawayExpiryDate: viewModel.giveawayDatePicker.singleDatePicker(),
      idAwardType: viewModel.reviewItemIdAwardType(),
      affiliateLinks: viewModel
        .reviewItemAffiliateLinks()
        .filter((e) => e.value.trim()),
      id: viewModel.idReviewItem(),
      idArticle: this.articlesEdit.getId(),
      idTemplate: this.articlesEdit.getIdTemplate(),
    };

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onGetSaveReviewItemRequestReturn;
    this.XHRHdl.execute();
  }

  protected validateDirectoryItem(addNext, id) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    let saveData = {};
    if (id == "sandbox_directory") {
      saveData = {
        sectionTitle: this.articlesEdit.sandboxDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: sandboxDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.sandboxDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    } else if (id == "republish_directory") {
      saveData = {
        sectionTitle: this.articlesEdit.republishDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: republishDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.republishDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    } else {
      saveData = {
        sectionTitle: this.articlesEdit.articleDirectory
          .getTemplateViewModel()
          .sectionTitle(),
        description: articleDirectoryItemDescriptionEditor.getData(),
        idItem: this.articlesEdit.articleDirectory
          .getTemplateViewModel()
          .selectedDirectoryItemIdArticle(),
        idArticle: this.articlesEdit.getId(),
        addNext: addNext,
      };
    }

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/directoryItem/validate/";

    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(saveData)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction =
      this.onValidateDirectoryItemRequestReturn;
    this.XHRHdl.execute();
  }

  protected onValidateDirectoryItemRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed["valid"])
          if (
            obj.articlesEdit.getTemplateViewModel().selectedTab() == "sandbox"
          ) {
            obj.articlesEdit.sandboxDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          } else if (
            obj.articlesEdit.getTemplateViewModel().selectedTab() == "republish"
          ) {
            obj.articlesEdit.republishDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          } else {
            obj.articlesEdit.articleDirectory.addDirectoryItem(
              responseParsed["addNext"],
              obj.articlesEdit.getTemplateViewModel().selectedTab()
            );
          }
      });

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeValidationClass();
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected onGetSaveReviewItemRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.addReviewItem(responseParsed);
      });

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeValidationClass();
      }
      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected generateEmbed(source, embedContext = null) {
    this.loadingIn(this.articlesEdit.builtTemplate);

    this.embedHelper.generateEmbed(
      source,
      this.articlesEdit.getTemplateViewModel().embedType(),
      embedContext
    );
  }

  public onGenerateEmbedRequestReturn(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);

        if (req.request.status == 200) {
          obj.articlesEdit.setEmbedData(responseParsed.data);
        } else {
          obj.articlesEdit.setEmbedErrors(responseParsed);
        }
      }

      obj.loadingOut(obj.articlesEdit.builtTemplate);
    };
  }

  protected addEmbedCodeToCkEditor(value) {
    this.articlesEdit
      .getActiveCkEditorInstance()
      .insertHtml("<br />" + value + "<br /> &nbsp;");
    this.articlesEdit.toggleEmbedPopUp(false);
    this.articlesEdit.resetEmbedPopUp();
  }

  protected addEmbedCodeToFeaturedEmbed(value) {
    this.articlesEdit.setFeaturedEmbed(value);
    this.articlesEdit.getTemplateViewModel().isFeaturedEmbedActive(true);
    this.articlesEdit.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(
      true
    );
    this.articlesEdit.setFeaturedVideo(null);
    this.articlesEdit.setContentEmbedContext();
    this.articlesEdit.toggleEmbedPopUp(false);
    this.articlesEdit.resetEmbedPopUp();
  }

  public setSandboxIntroText(introText) {
    sandboxIntroTextEditor.setData(introText);
  }

  public setSandboxContent(introText) {
    sandboxEditor.setData(introText);
  }

  public setRepublishIntroText(introText) {
    republishIntroTextEditor.setData(introText);
  }

  public setRepublishContent(introText) {
    republishEditor.setData(introText);
  }

  public clearValidationErrors() {
    this.validationTemplate.clearMessages();
    this.articlesEdit.removeValidationClass();
  }

  public setContentEditorStatus(value) {
    if (CKEDITOR.instances.article_content) {
      CKEDITOR.instances["article_content"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_content"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);
        if (unescapeString.includes("<script")) {
          var openingRegex = new RegExp("<!--{cke_protected}", "g");
          unescapeString = unescapeString.replace(openingRegex, "");
          var openingRegex = new RegExp("<!--<script", "g");

          unescapeString = unescapeString.replace(openingRegex, "<script");
          var closingRegex = new RegExp("</script>-->", "g");
          unescapeString = unescapeString.replace(closingRegex, "</script>");

          evt.data.dataValue = unescapeString;
        }
      });
    }
  }

  public setSandboxEditorStatus(value) {
    if (CKEDITOR.instances.article_sandbox) {
      CKEDITOR.instances["article_sandbox"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_sandbox"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);

        if (unescapeString.includes("<script")) {
          unescapeString = unescapeString.replace("<!--{cke_protected}", "");
          unescapeString = unescapeString.replace("-->", "");

          evt.data.dataValue = unescapeString;
          console.log(unescapeString);
        }
      });
    }
  }

  public setRepublishEditorStatus(value) {
    if (CKEDITOR.instances.article_republish) {
      CKEDITOR.instances["article_republish"].on(
        "instanceReady",
        function (event) {
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );
      CKEDITOR.instances["article_republish"].on("paste", function (evt) {
        var unescapeString = unescape(evt.data.dataValue);

        if (unescapeString.includes("<script")) {
          unescapeString = unescapeString.replace("<!--{cke_protected}", "");
          unescapeString = unescapeString.replace("-->", "");

          evt.data.dataValue = unescapeString;
          console.log(unescapeString);
        }
      });
    }
  }

  public setIntroTextEditorStatus(value) {
    if (CKEDITOR.instances.productReview_intro_text) {
      CKEDITOR.instances["productReview_intro_text"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );

      CKEDITOR.instances["productReview_intro_text"].on(
        "paste",
        function (evt) {
          var unescapeString = unescape(evt.data.dataValue);

          if (unescapeString.includes("<script")) {
            unescapeString = unescapeString.replace("<!--{cke_protected}", "");
            unescapeString = unescapeString.replace("-->", "");

            evt.data.dataValue = unescapeString;
            console.log(unescapeString);
          }
        }
      );
    }
  }

  public setSandboxIntroTextEditorStatus(value) {
    if (CKEDITOR.instances.productReviewSandbox_intro_text) {
      CKEDITOR.instances["productReviewSandbox_intro_text"].on(
        "instanceReady",
        function (event) {
          this.setReadOnly(value);
          event.editor.dataProcessor.writer.setRules("div", {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false,
          });
        }
      );

      CKEDITOR.instances["productReviewSandbox_intro_text"].on(
        "paste",
        function (evt) {
          var unescapeString = unescape(evt.data.dataValue);

          if (unescapeString.includes("<script")) {
            unescapeString = unescapeString.replace("<!--{cke_protected}", "");
            unescapeString = unescapeString.replace("-->", "");

            evt.data.dataValue = unescapeString;
            console.log(unescapeString);
          }
        }
      );
    }
  }

  public setIsSandboxContentAvailable(data) {
    this.articlesEdit.setIsSandboxContent(data);
  }

  public getArticleContent() {
    return contentEditor.getData();
  }

  public getArticleIntroText() {
    return introTextEditor.getData();
  }

  public getSandboxInViewContent() {
    return sandboxEditor.getData();
  }

  public getSandboxIntroText() {
    return sandboxIntroTextEditor.getData();
  }

  public getRepublishInViewContent() {
    return republishEditor.getData();
  }

  public getRepublishIntroText() {
    return republishIntroTextEditor.getData();
  }

  public diffVersionText(oldText, newText) {
    // get the unified diff patch
    const oldHeader = "";
    const newHeader = "";
    const options = {
      context: "10000",
    };
    const result = diff.createPatch(
      "file",
      oldText,
      newText,
      oldHeader,
      newHeader,
      options
    );
    const html = Diff2Html.html(result, {
      drawFileList: false,
      matching: "words",
      outputFormat: "line-by-line",
    });

    this.articlesEdit.setVersionDiffResult(html);
  }

  public setUserPreferences(data) {
    //set the user preferences
    this.articlesEdit.setUserPreferences(data);
  }

    protected getQuizPickerReferences(): void {
        if (this.XHRHdls["getQuizPickerReferences"]) {
            this.XHRHdls["getQuizPickerReferences"].cancelAndReset();
        }

        const brandId = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = `/api/brand/${brandId}/quizzes/references/`;
        const usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["getQuizPickerReferences"] = new XMLHttpRequestHandler(
            usrReq_url,
            usrReq_params,
            this
        );
        this.XHRHdls["getQuizPickerReferences"].onReadyStateFunction =
            this.onQuizPickerReferencesRequestReturn;
        this.XHRHdls["getQuizPickerReferences"].execute();
    }

    protected onQuizPickerReferencesRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.quizPicker.quizView.setReferences(responseParsed);
                obj.articlesEdit.quizPicker.quizEdit.setReferences(responseParsed);
            });
        };
    }

    protected getPollPickerReferences(): void {
        if (this.XHRHdls["getPollPickerReferences"]) {
            this.XHRHdls["getPollPickerReferences"].cancelAndReset();
        }

        const usrReq_url: string = `/api/polls/references/`;
        const usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["getPollPickerReferences"] = new XMLHttpRequestHandler(
            usrReq_url,
            usrReq_params,
            this
        );
        this.XHRHdls["getPollPickerReferences"].onReadyStateFunction =
            this.onPollPickerReferencesRequestReturn;
        this.XHRHdls["getPollPickerReferences"].execute();
    }

    protected onPollPickerReferencesRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.pollPicker.pollView.setReferences(responseParsed);
                obj.articlesEdit.pollPicker.pollEdit.setReferences(responseParsed);
            });
        };
    }

  public getCurrentArticleForQuizPicker() {
      const idArticle = this.articlesEdit.getId();
      if (!idArticle) {
          return null;
      }

      const brand = this.articlesEdit.getTemplateViewModel().brand();
      const idBrand = brand && brand.id ? brand.id : this.getVnAppZone().app.params.idBrand;

      return {
          id: idArticle,
          title: this.articlesEdit.getTitle() || "",
          idBrand: idBrand,
          brandName: brand ? (brand.name || brand.shortName || "") : "",
          brandShortName: brand ? (brand.shortName || brand.name || "") : "",
      };
  }

  //tag picker functions
  protected getTagData() {
    if (this.tagSearchXHRHdl) {
      this.tagSearchXHRHdl.cancelAndReset();
    }

    this.articlesEdit.tagPicker.showLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = "/api/brand/" + idBrand + "/tags/get/";
    let formReq_params: Array<Array<string>> = [];

    //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
    let viewModel = this.articlesEdit.tagPicker.getViewModelForRequest();
    /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
    formReq_params.push(["data", ko.toJSON(viewModel)]);

    this.tagSearchXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
    this.tagSearchXHRHdl.execute();
  }

  protected onGetTagDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateTagPickerForm(responseParsed);
        obj.articlesEdit.tagPicker.hideLoading();
        /*if(obj.articlesEdit.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }*/
      });
    };
  }


    protected getQuizData() {
        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }

        this.articlesEdit.quizPicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/quizzes/get/";
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.articlesEdit.quizPicker.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.tagSearchXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetQuizDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    public getPollData() {
        if (this.pollPickerXHRHdl) {
            this.pollPickerXHRHdl.cancelAndReset();
        }

        this.articlesEdit.pollPicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/polls/get/";
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.articlesEdit.pollPicker.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.pollPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.pollPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.pollPickerXHRHdl.onReadyStateFunction = this.onGetPollDataReturn;
        this.pollPickerXHRHdl.execute();
    }

    public getQuizForPicker(idQuiz, openEdit = false) {
        if (this.quizPickerXHRHdl) {
            this.quizPickerXHRHdl.cancelAndReset();
        }

        this.quizPickerOpenEditOnLoad = openEdit;
        this.articlesEdit.quizPicker.quizView.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/quizzes/get/" + idQuiz + "/";
        let formReq_params: Array<Array<string>> = [];

        this.quizPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.quizPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.quizPickerXHRHdl.onReadyStateFunction = this.onGetQuizForPickerReturn;
        this.quizPickerXHRHdl.execute();
    }

    public getPollForPicker(idPoll, openEdit = false) {
        if (this.pollPickerXHRHdl) {
            this.pollPickerXHRHdl.cancelAndReset();
        }

        this.pollPickerOpenEditOnLoad = openEdit;
        this.articlesEdit.pollPicker.pollView.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/polls/get/" + idPoll + "/";
        let formReq_params: Array<Array<string>> = [];

        this.pollPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.pollPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.pollPickerXHRHdl.onReadyStateFunction = this.onGetPollForPickerReturn;
        this.pollPickerXHRHdl.execute();
    }

    protected onGetQuizForPickerReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.quizPicker.setQuiz(responseParsed.data);
                if (obj.quizPickerOpenEditOnLoad) {
                    obj.articlesEdit.quizPicker.editQuiz(responseParsed.data);
                }
                obj.quizPickerOpenEditOnLoad = false;
                obj.articlesEdit.quizPicker.quizView.hideLoading();
            });
        };
    }

    protected onGetPollForPickerReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.pollPicker.setPoll(responseParsed.data);
                if (obj.pollPickerOpenEditOnLoad) {
                    obj.articlesEdit.pollPicker.editPoll(responseParsed.data);
                }
                obj.pollPickerOpenEditOnLoad = false;
                obj.articlesEdit.pollPicker.pollView.hideLoading();
            });
        };
    }

    public saveQuizFromPicker(quiz, insertAfterSave = false, isQuizDynamicPlacement = null) {
        if (this.quizPickerXHRHdl) {
            this.quizPickerXHRHdl.cancelAndReset();
        }

        this.articlesEdit.quizPicker.quizEdit.clearValidationMessages();
        this.articlesEdit.quizPicker.quizEdit.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/quizzes/save/";
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(quiz)]);

        this.quizPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.quizPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.quizPickerXHRHdl["insertAfterSave"] = insertAfterSave;
        this.quizPickerXHRHdl["isQuizDynamicPlacement"] = isQuizDynamicPlacement;
        this.quizPickerXHRHdl.onReadyStateFunction = this.onSaveQuizFromPickerReturn;
        this.quizPickerXHRHdl.execute();
    }

    public savePollFromPicker(poll, insertAfterSave = false, isDynamicPlacement = null) {
        if (this.pollPickerXHRHdl) {
            this.pollPickerXHRHdl.cancelAndReset();
        }

        this.articlesEdit.pollPicker.pollEdit.clearValidationMessages();
        this.articlesEdit.pollPicker.pollEdit.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/polls/save/";
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(poll)]);

        this.pollPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.pollPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.pollPickerXHRHdl["insertAfterSave"] = insertAfterSave;
        this.pollPickerXHRHdl["isPollDynamicPlacement"] = isDynamicPlacement;
        this.pollPickerXHRHdl.onReadyStateFunction = this.onSavePollFromPickerReturn;
        this.pollPickerXHRHdl.execute();
    }

    /**
     * The quiz "Generate & Edit" picker button. Mirrors the poll flow: generation runs first and the
     * edit form is only opened once it succeeds. QuizController rejects a source article under its
     * minimum content length before any quiz is persisted, so a short article leaves the picker on
     * its list with the error popup shown instead of opening an empty edit form.
     *
     * @param draftQuiz Base fields for a fresh quiz to switch the edit form to on success. When
     * omitted the request regenerates from within the already open edit form.
     */
    public generateQuizFromArticleFromPicker(draftQuiz: any = null) {
        const quizPicker = this.articlesEdit.quizPicker;
        const quizEdit = quizPicker.quizEdit;
        const isFreshGeneration = !!draftQuiz;

        if (isFreshGeneration) {
            quizEdit.setQuiz(draftQuiz);
        }

        const idSourceArticle = quizEdit.getIdSourceArticle();
        if (!idSourceArticle) {
            return;
        }

        if (this.quizPickerXHRHdl) {
            this.quizPickerXHRHdl.cancelAndReset();
        }

        quizEdit.clearValidationMessages();
        if (isFreshGeneration) {
            quizPicker.showLoading();
        } else {
            quizEdit.showLoading();
        }

        const quiz = {
            ...quizEdit.getQuizForRequest(),
            regenerate: true,
        };

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = "/api/brand/" + idBrand + "/quizzes/save/";
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(quiz)]);

        this.quizPickerXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.quizPickerXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.quizPickerXHRHdl["isFreshGeneration"] = isFreshGeneration;
        this.quizPickerXHRHdl.onReadyStateFunction = this.onGenerateQuizFromArticleFromPickerReturn;
        this.quizPickerXHRHdl.execute();
    }

    protected onGenerateQuizFromArticleFromPickerReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }

            const quizPicker = obj.articlesEdit.quizPicker;
            const isFreshGeneration = req["isFreshGeneration"];
            const stopLoading = () => isFreshGeneration ? quizPicker.hideLoading() : quizPicker.quizEdit.hideLoading();

            if (req.request.status < 200 || req.request.status >= 300) {
                let message = "Quiz generation failed. Please try again.";
                try {
                    const responseParsed = JSON.parse(req.request.response || "{}");
                    message = obj.extractQuizGenerationErrorMessage(responseParsed) || message;
                } catch (e) {}
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, message);
                obj.getVnAppZone().showNotificationToModule();
                stopLoading();
                return;
            }

            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                quizPicker.quizEdit.clearValidationMessages();
                quizPicker.setQuizAfterSave(responseParsed.data);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Quiz generated from article."
                );
            });
            stopLoading();
        };
    }

    protected extractQuizGenerationErrorMessage(responseParsed): string {
        if (!responseParsed) {
            return "";
        }

        const validations = responseParsed.validations;
        if (Array.isArray(validations)) {
            for (const validation of validations) {
                if (validation && Array.isArray(validation.messages) && validation.messages.length > 0) {
                    return validation.messages[0];
                }
            }
        }

        return responseParsed.message || responseParsed.error || "";
    }

    protected onSaveQuizFromPickerReturn(req, obj) {
        return function () {
            if (req.request.readyState === 4 && req.request.status === 400) {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.quizPicker.quizEdit.setValidationMessages(responseParsed.validations || []);
            } else {
                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.articlesEdit.quizPicker.quizEdit.clearValidationMessages();
                    if (req["insertAfterSave"]) {
                        obj.articlesEdit.quizPicker.insertQuiz(responseParsed.data, req["isQuizDynamicPlacement"]);
                    } else {
                        obj.articlesEdit.quizPicker.setQuizAfterSave(responseParsed.data);
                    }
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        "Quiz saved successfully !"
                    );
                });
            }
            obj.articlesEdit.quizPicker.quizEdit.hideLoading();
        };
    }

    protected onSavePollFromPickerReturn(req, obj) {
        return function () {
            if (req.request.readyState === 4 && req.request.status === 400) {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.pollPicker.pollEdit.setValidationMessages(responseParsed.validations || []);
            } else {
                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    let poll = responseParsed.data || responseParsed;
                    obj.articlesEdit.pollPicker.pollEdit.clearValidationMessages();
                    obj.articlesEdit.pollPicker.setPollAfterSave(poll, req["insertAfterSave"], req["isPollDynamicPlacement"]);
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        "Poll saved successfully !"
                    );
                });
            }
            obj.articlesEdit.pollPicker.pollEdit.hideLoading();
        };
    }

    protected onGetQuizDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateQuizPickerForm(responseParsed);
                obj.articlesEdit.quizPicker.hideLoading();
            });
        };
    }

    protected onGetPollDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updatePollPickerForm(responseParsed);
                obj.articlesEdit.pollPicker.hideLoading();
            });
        };
    }



  public getTag(tag, select = false) {
    this.getTags([tag], select);
  }

  protected getTags(idTags, select = false) {
    if (this.tagXHRHdl) {
      this.tagXHRHdl.cancelAndReset();
    }

    if (idTags.length > 1) {
      this.XHRHdlCaller = "tag_picker_group";
      this.articlesEdit.tagPicker.showLoading();
    } else {
      if (select) {
        this.XHRHdlCaller = "tag_picker_select";
        this.articlesEdit.tagPicker.showLoading();
      } else {
        this.XHRHdlCaller = "tag_picker_view";
        this.articlesEdit.tagPicker.showViewLoading();
      }
    }

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/get/";

    let usrReq_params: Array<Array<string>> = [];

    //let vm:any = this.articlesEdit.getViewModelForRequest();
    //vm.lockItem = true;

    usrReq_params.push(["data", ko.toJSON({ idTags: idTags })]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
    this.tagXHRHdl.execute();
  }

  protected onGetTagRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.tags && responseParsed.tags.length > 0) {
          if (obj.XHRHdlCaller == "tag_picker_group") {
            let tagsResponse = responseParsed.tags;
            let tags = [];
            for (let response of tagsResponse) {
              let tag = response.tag;
              tag.specsValues = response.specsValues;
              tag.specDefaults = response.specDefaults;
              tag.communityRating = response.communityRating
                ? response.communityRating
                : { average: null, count: 0 };
              tag.includeCommunityRating = response.includeCommunityRating
                ? response.includeCommunityRating
                : false;
              tags.push(tag);
            }
            obj.articlesEdit.tagPicker.selectTags(tags);
          } else {
            let tag = responseParsed.tags[0].tag;
            tag.specsValues = responseParsed.tags[0].specsValues;
            tag.specDefaults = responseParsed.tags[0].specDefaults;
            tag.communityRating = responseParsed.tags[0].communityRating
              ? responseParsed.tags[0].communityRating
              : { average: null, count: 0 };
            tag.includeCommunityRating = responseParsed.tags[0]
              .includeCommunityRating
              ? responseParsed.tags[0].includeCommunityRating
              : false;
            if (obj.XHRHdlCaller == "tag_picker_select") {
              obj.articlesEdit.tagPicker.selectTag(
                { ...tag, pros: [], cons: [] },
                true
              );
              if (
                obj.articlesEdit.tagPicker.tagView
                  .getTemplateViewModel()
                  .isShown()
              ) {
                obj.articlesEdit.tagPicker.tagView.onClickSave();
              }
            } else if (obj.XHRHdlCaller == "tag_picker_view") {
              obj.articlesEdit.tagPicker.setTag({ ...tag, pros: [], cons: [] });
              obj.articlesEdit.tagPicker.setGroupings(
                responseParsed.tags[0].groupings
              );
            }
          }
        }
        //obj.editForm.setPermissions(responseParsed.permissions);
      });

      obj.articlesEdit.tagPicker.hideViewLoading();
      obj.articlesEdit.tagPicker.hideLoading();
      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addTagPickerValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeTagPickerValidationClass();
      }
    };
  }

  protected updateTagPickerForm(responseParsed) {
    let selectedTags = this.articlesEdit.tagPicker.getSelectedTags();

    if (responseParsed.data) {
      for (let tag of responseParsed.data) {
        tag.selected = false;
        let tagSelected = selectedTags.find((i) => i.id == tag.id);
        if (tagSelected) {
          tag.selected = true;
        }
      }
      this.articlesEdit.tagPicker.setTagsPagination(
        responseParsed.totalPage,
        responseParsed.currentPage
      );
      this.articlesEdit.tagPicker.setTagResults(responseParsed.data);
    }
  }

  protected updateQuizPickerForm(responseParsed) {
    if (responseParsed.data) {
      this.articlesEdit.quizPicker.setQuizzesPagination(
        responseParsed.totalPage,
        responseParsed.currentPage
      );
      this.articlesEdit.quizPicker.setQuizResults(responseParsed.data);
    }
  }

  protected updatePollPickerForm(responseParsed) {
    if (responseParsed.data) {
      this.articlesEdit.pollPicker.setPollsPagination(
        responseParsed.totalPage,
        responseParsed.currentPage
      );
      this.articlesEdit.pollPicker.setPollResults(responseParsed.data);
    }
  }

  /**
   * @param draftPoll Base fields for a fresh poll (from the picker's "Generate & Edit" button). When
   * provided, the edit form only opens once generation has succeeded, so a rejected draft (e.g. the
   * source article is under ArticlePollGenerationService's minimum content length) leaves the picker
   * on its list with the error popup instead of showing an empty edit form. Omitted when regenerating
   * from within an already open edit form (the "Generate based on article" button), which keeps
   * reading the reference article/brand directly off that form as before.
   */
  public generatePollFromArticleFromPicker(draftPoll: any = null) {
    const pollPicker = this.articlesEdit.pollPicker;
    const pollEdit = pollPicker.pollEdit;
    const isFreshGeneration = !!draftPoll;
    const articleId = isFreshGeneration ? draftPoll.idReferenceArticle : pollEdit.getReferenceArticleId();
    if (!articleId) return;

    if (isFreshGeneration) {
      pollPicker.showLoading();
    } else {
      pollEdit.showLoading();
    }

    const payload = {
      idPoll: isFreshGeneration ? draftPoll.id : pollEdit.getId(),
      idReferenceArticle: articleId,
      idReferenceBrand: isFreshGeneration ? draftPoll.idReferenceBrand : pollEdit.getReferenceBrandId(),
    };

    const request = new XMLHttpRequestHandler(
      `/api/brand/${this.getVnAppZone().app.params.idBrand}/polls/generate-from-article/`,
      [["data", ko.toJSON(payload)]],
      this
    );
    request.mode = XMLHttpRequestHandler_requestType.POST;
    request.onReadyStateFunction = (req: any, obj: any) => () => {
      if (req.request.readyState != 4) {
        return;
      }

      const stopLoading = () => isFreshGeneration ? pollPicker.hideLoading() : pollEdit.hideLoading();

      if (req.request.status < 200 || req.request.status >= 300) {
        let message = "Poll generation failed. Please try again.";
        try {
          const responseParsed = JSON.parse(req.request.response || "{}");
          message = responseParsed.message || responseParsed.error || message;
        } catch (e) {}
        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, message);
        obj.getVnAppZone().showNotificationToModule();
        stopLoading();
        return;
      }

      obj.manageResponse(req, obj, () => {
        const responseData = JSON.parse(req.request.response).data;
        if (isFreshGeneration) {
          pollPicker.editPoll(draftPoll);
        }
        pollEdit.setName(responseData.name);
        pollEdit.setGeneratedQuestions(responseData.questions);
        pollEdit.setReferenceBrandId(responseData.idReferenceBrand);
        pollEdit.setReferenceArticle(responseData.referenceArticle);
        pollEdit.lockReferenceArticle(responseData.dateGeneratedFromArticle);
        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Poll generated from article.");
      });
      stopLoading();
    };
    request.execute();
  }

  public generateCommercialSignalsFromPicker() {
    const pollEdit = this.articlesEdit.pollPicker.pollEdit;

    pollEdit.setIsGeneratingCommercialSignals(true);
    pollEdit.showLoading();

    const payload = { questions: JSON.parse(ko.toJSON(pollEdit.getQuestions())) };
    const request = new XMLHttpRequestHandler(
      `/api/brand/${this.getVnAppZone().app.params.idBrand}/polls/generate-commercial-signals/`,
      [["data", JSON.stringify(payload)]],
      this
    );
    request.mode = XMLHttpRequestHandler_requestType.POST;
    request.onReadyStateFunction = (req: any, obj: any) => () => {
      if (req.request.readyState != 4) {
        return;
      }

      let responseParsed: any = {};
      try {
        responseParsed = JSON.parse(req.request.response || "{}");
      } catch (e) {}

      if (req.request.status == 200) {
        const questions = responseParsed && responseParsed.data ? responseParsed.data.questions : null;
        if (questions) {
          obj.articlesEdit.pollPicker.pollEdit.setQuestions(questions);
        }
        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Commercial signals generated. Click Save to persist your changes.");
      } else {
        const message = responseParsed && responseParsed.message
          ? responseParsed.message
          : "Unable to generate commercial signals.";
        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, message);
      }

      obj.getVnAppZone().showNotificationToModule();
      obj.articlesEdit.pollPicker.pollEdit.setIsGeneratingCommercialSignals(false);
      obj.articlesEdit.pollPicker.pollEdit.hideLoading();
    };
    request.execute();
  }

  public exportPollFromPicker() {
    const pollView = this.articlesEdit.pollPicker.pollView;
    const idPoll = pollView.getId();
    if (!idPoll) {
      pollView.resetExportState();
      return;
    }

    const idBrand = this.getVnAppZone().app.params.idBrand;
    const filters = ko.toJS({ selectedBrandId: pollView.getSelectionBrandId() });
    const request = new XMLHttpRequestHandler(
      `/api/brand/${idBrand}/polls/export/${idPoll}/`,
      [["data", ko.toJSON(filters)]],
      this
    );
    request.mode = XMLHttpRequestHandler_requestType.POST;
    request.onReadyStateFunction = (req: any, obj: any) => () => {
      obj.manageResponse(req, obj, () => {
        const csvContent = req.request.response;
        if (csvContent) {
          obj.triggerPollCSVDownload(csvContent);
          obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "CSV export done successfully");
        } else {
          obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "No data to download");
        }
        obj.getVnAppZone().showNotificationToModule();
        obj.articlesEdit.pollPicker.pollView.resetExportState();
      });
    };
    request.execute();
  }

  private triggerPollCSVDownload(csvContent: string) {
    const pollView = this.articlesEdit.pollPicker.pollView;
    const today = new Date();
    const dateStr = [
      today.getFullYear(),
      ("0" + (today.getMonth() + 1)).slice(-2),
      ("0" + today.getDate()).slice(-2),
    ].join("-");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${pollView.getName()} (${pollView.getId()}) ${pollView.getCurrentBrandName()} Poll Data ${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  /**
   * The card is inserted before the AI has answered: the article's poll is reused when it already
   * has one, otherwise a placeholder poll is created server-side and its content is generated in
   * the background, the card being refreshed once the questions come back. The picker's loading
   * animation only spans this initial round trip (which also rejects a source article under
   * pollController::getOrCreateForArticle's minimum content length before anything is created or
   * inserted); the background generation is instead represented by the "Poll Generating..." card
   * already sitting in the content.
   *
   * @returns Whether something was inserted into the article, so the picker's "Generate & Insert"
   * button knows whether to close (success) or stay open with the error popup already shown.
   */
  public async insertGeneratedPollFromPicker(editorName: string | typeof CKEDITOR.editor, isDynamicPlacement: boolean): Promise<boolean> {
    const idBrand = Number(this.getVnAppZone().app.params.idBrand);
    const idArticle = Number(this.articlesEdit.getTemplateViewModel().id());
    if (!idBrand || !idArticle) {
      return false;
    }

    const editor = typeof editorName === "string" ? this.getEditor(editorName) : editorName;
    if (!editor) {
      return false;
    }

    const pollPicker = this.articlesEdit.pollPicker;
    this.saveSelection(editor);
    this.articlesEdit.getTemplateViewModel().onClickTab("article");
    await new Promise(resolve => setTimeout(resolve, 0));

    pollPicker.showLoading();
    try {
      const response = await this.getPollForInsertFlow(idBrand, idArticle);
      const poll = response && response.data ? response.data : null;
      if (!poll || !poll.id) {
        return false;
      }

      this.insertPollPlaceholder(editor, {
        idPoll: poll.id,
        pollName: poll.name || "Poll",
        isWithTitle: !!poll.isWithTitle,
        isDynamicPlacement: !!isDynamicPlacement,
      });

      if (response.isPlaceholderCreated) {
        // Not awaited: the placeholder card is already in the content, and the picker should close
        // on this success rather than wait for the AI response.
        this.generateInsertedPollInBackground(idBrand, idArticle, poll, editor);
      }

      return true;
    } catch (error) {
      console.error("Failed to insert poll:", error);
      this.notifyPollGenerationFailed(error && error.message);
      return false;
    } finally {
      pollPicker.hideLoading();
    }
  }

  private async getPollForInsertFlow(idBrand: number, idArticle: number): Promise<any> {
    const response = await fetch(`/api/brand/${idBrand}/article/${idArticle}/polls/insert/`);
    const responseParsed = await response.json().catch(() => null);
    if (!response.ok) {
      const message = responseParsed && (responseParsed.message || responseParsed.error);
      throw new Error(message || `Poll insert request failed: HTTP ${response.status}`);
    }

    return responseParsed;
  }

  /**
   * Insertion of the poll the assistant recommends. The suggestion only carries an id and a name, so
   * the poll is read back from the brand to card it with its stored flags and to catch a poll the
   * brand is no longer attached to; a recommendation without a poll generates one from the article.
   */
  public async insertSuggestedPoll(editorName: string | typeof CKEDITOR.editor, suggestedPoll: any): Promise<void> {
    const idPoll = suggestedPoll && suggestedPoll.id ? Number(suggestedPoll.id) : 0;
    if (!idPoll) {
      await this.insertGeneratedPollFromPicker(editorName, this.getDynamicPlacementDefault('poll'));
      return;
    }

    const idBrand = Number(this.getVnAppZone().app.params.idBrand);
    const editor = typeof editorName === "string" ? this.getEditor(editorName) : editorName;
    if (!idBrand || !editor) {
      return;
    }

    this.saveSelection(editor);
    await new Promise(resolve => setTimeout(resolve, 0));

    try {
      const poll = await this.getSuggestedPollForInsert(idBrand, idPoll);
      if (!poll || !poll.id) {
        this.notifySuggestedPollUnavailable();
        return;
      }

      this.insertPollPlaceholder(editor, {
        idPoll: poll.id,
        pollName: poll.name || "Poll",
        isWithTitle: !!poll.isWithTitle,
        isDynamicPlacement: this.getDynamicPlacementDefault('poll'),
      });
    } catch (error) {
      console.error("Failed to insert the suggested poll:", error);
      this.notifySuggestedPollUnavailable();
    }
  }

  private async getSuggestedPollForInsert(idBrand: number, idPoll: number): Promise<any> {
    const response = await fetch(`/api/brand/${idBrand}/polls/get/${idPoll}/`);
    if (!response.ok) {
      throw new Error(`Suggested poll request failed: HTTP ${response.status}`);
    }

    const responseParsed = await response.json();

    return responseParsed && responseParsed.data ? responseParsed.data : null;
  }

  private notifySuggestedPollUnavailable(): void {
    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_ERROR,
      "The suggested poll could not be inserted. Please insert one from the poll list."
    );
    this.getVnAppZone().showNotificationToModule();
  }

  /**
   * Fills the placeholder poll the endpoint just created. The generation itself is not tied to the
   * poll (a poll holding a reference article cannot be regenerated), so the draft is requested on
   * its own and then saved onto the placeholder id.
   */
  private async generateInsertedPollInBackground(idBrand: number, idArticle: number, poll: any, editor: typeof CKEDITOR.editor): Promise<void> {
    try {
      const generatedPoll = await this.generatePollDraftForCurrentArticle(idBrand, idArticle);
      if (!generatedPoll) {
        this.notifyPollGenerationFailed();
        return;
      }

      const savedPoll = await this.saveGeneratedPollForPicker(idBrand, idArticle, generatedPoll, poll.id);
      if (!savedPoll || !savedPoll.id) {
        this.notifyPollGenerationFailed();
        return;
      }

      this.replacePollPlaceholder(editor, savedPoll);
    } catch (error) {
      console.error("Failed to generate inserted poll:", error);
      this.notifyPollGenerationFailed();
    }
  }

  /**
   * Refreshes the card of an already inserted poll in place, so the name and flags the generation
   * produced replace the "Poll Generating..." placeholder without moving it.
   */
  private replacePollPlaceholder(editor: typeof CKEDITOR.editor, poll: any): void {
    if (!editor || !editor.editable || !poll || !poll.id) {
      return;
    }

    const existing = this.getWidgetsById(editor, 'poll', String(poll.id))[0];
    if (!existing) {
      return;
    }

    this.insertPollPlaceholder(editor, {
      idPoll: poll.id,
      pollName: poll.name || "Poll",
      isWithTitle: existing.getAttribute('data-poll-is-with-title') === '1',
      isDynamicPlacement: existing.getAttribute('data-dynamic-placement') === '1',
    }, existing);
    editor.fire('saveSnapshot');
  }

  private notifyPollGenerationFailed(message?: string): void {
    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_ERROR,
      message || "Poll generation failed. Please try again."
    );
    this.getVnAppZone().showNotificationToModule();
  }

  private async generatePollDraftForCurrentArticle(idBrand: number, idArticle: number): Promise<any> {
    const params = new URLSearchParams();
    params.append("data", JSON.stringify({
      idPoll: null,
      idReferenceArticle: idArticle,
      idReferenceBrand: idBrand,
    }));

    const response = await fetch(`/api/brand/${idBrand}/polls/generate-from-article/`, {
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"},
      body: params.toString(),
    });

    if (!response.ok) {
      throw new Error(`Poll generation request failed: HTTP ${response.status}`);
    }

    const responseParsed = await response.json();
    return responseParsed && responseParsed.data ? responseParsed.data : null;
  }

  private async saveGeneratedPollForPicker(idBrand: number, idArticle: number, generatedPoll: any, idPoll: number | null = null): Promise<any> {
    const params = new URLSearchParams();
    params.append("data", JSON.stringify({
      id: idPoll || null,
      name: generatedPoll.name || "Poll",
      questions: generatedPoll.questions || [],
      dateClosed: null,
      brands: [idBrand],
      idReferenceArticle: generatedPoll.idReferenceArticle || idArticle,
      idReferenceBrand: generatedPoll.idReferenceBrand || idBrand,
      dateGeneratedFromArticle: generatedPoll.dateGeneratedFromArticle || null,
    }));

    const response = await fetch(`/api/brand/${idBrand}/polls/save/`, {
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"},
      body: params.toString(),
    });

    if (!response.ok) {
      throw new Error(`Poll save request failed: HTTP ${response.status}`);
    }

    const responseParsed = await response.json();
    return responseParsed && responseParsed.data ? responseParsed.data : responseParsed;
  }

  protected saveTag(saveData) {
    this.articlesEdit.tagPicker.showEditLoading();

    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let formReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/save/";

    let formReq_params: Array<Array<string>> = [];

    formReq_params.push(["data", ko.toJSON(saveData)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = this.onSaveTagReturn;
    XHRHdl.execute();
  }

  protected onSaveTagReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let showPickerIfTagNew = false;
        if (responseParsed.tag) {
          obj.articlesEdit.tagPicker.hideEdit();

          const { tempTagItemPros, tempTagItemCons } =
            obj.articlesEdit.tagPicker.tagEdit.getTemplateViewModel();

          let tag = responseParsed.tag;

          tag.specsValues = responseParsed.specsValues;
          tag.specDefaults = responseParsed.specDefaults;
          tag.includeCommunityRating = responseParsed.includeCommunityRating;
          tag.communityRating = responseParsed.communityRating;
          tag.hasTagHubPage = responseParsed.hasTagHubPage;

          if (responseParsed.newTag) {
            showPickerIfTagNew = true;
            obj.articlesEdit.tagPicker.setTagAfterAddNew(tag);
          } else {
            obj.articlesEdit.tagPicker.setTagAfterSave({
              ...tag,
              pros: tempTagItemPros(),
              cons: tempTagItemCons(),
            });
          }

          obj.releaseBrandTagLock(tag.id);
          obj.articlesEdit.tagPicker.updateSelectedTagAfterSave(tag);

          if (showPickerIfTagNew) {
            obj.articlesEdit.tagPicker.setTagAfterSave({
              ...tag,
              pros: tempTagItemPros(),
              cons: tempTagItemCons(),
            });
          }
        }
      });

      obj.articlesEdit.tagPicker.hideEditLoading();

      if (obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
        obj.articlesEdit.addTagPickerValidationClass();
      } else if (
        obj.validationTemplate.getTemplateViewModel().isHidden() == 1
      ) {
        obj.articlesEdit.removeTagPickerValidationClass();
      }
    };
  }

  //TODO on error, close tag picker so user can see the error?
  public onClickHidePinnedTagsForm() {
    this.articlesEdit.onClickTogglePinnedTagsForm(false);
  }

  public onClickConfirmDialog(idElement) {
    if (idElement == "missingSpecDialog_template") {
      this.articlesEdit.articlePinnedTags.addTag();
    } else if (idElement == "dialogSandboxDelete") {
      this.articlesEdit.clearSandboxSection();
    } else if (idElement == "dialogRepublishDelete") {
      this.articlesEdit.clearRepublishSection();
    } else if (idElement == "dialogRepublishCreateAndUpdate") {
      this.articlesEdit.onClickCreateRepublishAndUpdateArticle();
    } else if (idElement == "warningDialog_newsletterSendingConfirmation") {
      this.sendNewsletter();
    } else if (idElement == "dialogWarningDialog_articleAiFaq") {
      this.saveArticleFaqs(true);
    }else if (idElement == "dialogWarningDialog_threadSummary") {
      this.saveThreadSummary(true);
    }else if (idElement == "dialogWarningDialog_audioReader") {
      this.generateArticleAudioReader();
    }
  }

  public onClickCancelDialog(idElement) {
    if (idElement == "missingSpecDialog_template") {
      this.articlesEdit.articlePinnedTags.filterTags.clearInput();
    }
  }

  private disableBrandSelectorButton() {
    if (
      document
        .getElementsByClassName("btn-sidebar")[0]
        .classList.contains("is-closed")
    ) {
      let brandSelector = document.getElementById("brandSelector");
      let brandSelectorBtnDropdown = brandSelector.querySelector("button");
      if (brandSelectorBtnDropdown) {
        brandSelectorBtnDropdown.classList.add("is-disable");
      }
    }
  }

  public setTagEditLock(tag) {
    this.articlesEdit.tagPicker.showViewLoading();
    this.XHRHdlCaller = "tag_picker_edit";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url = "/api/brand/" + idBrand + "/tag-picker/tags/get/";

    let usrReq_params: Array<Array<string>> = [];

    usrReq_params.push([
      "data",
      ko.toJSON({ idTags: [tag.id], lockItem: true }),
    ]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
    this.tagXHRHdl.execute();
  }

  private sendSimpleRequest(req, obj) {
    return () => {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);
        if (req.request.status == 200) {
          obj.articlesEdit.handleTagInArticle(obj.XHRHdlCaller);
        } else if (req.request.status == 423) {
          if (obj.XHRHdlCaller == "tag_picker_edit_cancel") {
            obj.articlesEdit.handleTagInArticle(obj.XHRHdlCaller);
          } else {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_WARNING,
              responseParsed.message
            );
            obj.getVnAppZone().showNotificationToModule();
          }
        }

        obj.articlesEdit.tagPicker.hideViewLoading();
      }
    };
  }

  public releaseBrandTagLock(idTag) {
    this.articlesEdit.tagPicker.showViewLoading();
    this.XHRHdlCaller = "tag_picker_edit_cancel";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let usrReq_url = `/api/brand/${idBrand}/tags/release/${idTag}`;

    let usrReq_params: Array<Array<string>> = [];

    usrReq_params.push(["data", ko.toJSON({ idTag })]);

    this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
    this.tagXHRHdl.execute();
  }

  public getTagToEdit() {
    return this.articlesEdit.tagPicker.tagView.getTag();
  }

  public getSandboxEditorContent() {
    return sandboxEditor.getData();
  }

  protected manageResponse(req, obj, successFct) {
    // This allows to intercept request on FE and do whatever you want
    // We will now lock the article edition when session is expired

    if (req.request.readyState == 4 && req.request.status == 423) {
      let response: any = {};
      try {
        response = JSON.parse(req.request.response);
      } catch (e) {
        response = {};
      }

      obj.articlesEdit.getTemplateViewModel().isGlobalLockEnabled(true);
      obj.articlesEdit.warningDialog_WhenLogOut.hideCancelBtn();
      obj.articlesEdit.warningDialog_WhenLogOut.setIsVisible(true);

      if (response.isTakenOver) {
        // Someone else with sufficient permissions took over the lock on this
        // article; this is not a session expiry, so it must not be reported as one.
        obj.articlesEdit.warningDialog_WhenLogOut.setTitle("Article Locked");
        obj.articlesEdit.warningDialog_WhenLogOut.setMessage(response.message);
      } else {
        let lastSaveRecoveryAttempt = obj.articlesEdit
          .getTemplateViewModel()
          .lastSaveRecoveryAttempt();
        if (lastSaveRecoveryAttempt == "") {
          const curDate = new Date();
          lastSaveRecoveryAttempt = `${curDate.toDateString()} ${curDate.toLocaleTimeString()}`;
        }
        const warningMessage = `Your session expired. You will not be able to use save actions and any changes since ${lastSaveRecoveryAttempt} will be lost. Please backup any changes you may need.`;

        obj.articlesEdit.warningDialog_WhenLogOut.setTitle("Session Expired");
        obj.articlesEdit.warningDialog_WhenLogOut.setMessage(warningMessage);
      }

      obj.articlesEdit.setArticleLockedStatus(true);
      obj.articlesEdit.setArticleAutoSaveError(true);

      obj.clearRecoverySave();
      obj.clearRecoveryWarning();
      obj.startAutosave(null);

      return; // No further action needed
    }

    super.manageResponse(req, obj, successFct);
  }

  public getChartDiv() {
    return chartDiv;
  }

  protected editWatchlist(isAddToWatchlist) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/articles/editWatchlist/" +
      this.articlesEdit.getId();
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", isAddToWatchlist]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetAddedToWatchlist;
    this.XHRHdl.execute();
  }

  protected onGetAddedToWatchlist(req, obj) {
    return () => {
      if (req.request.status == 200) {
        obj.manageResponse(req, obj, () => {
          let responseParsed = JSON.parse(req.request.response);
          obj.articlesEdit.setIsOnWatchlist(responseParsed);
          if (responseParsed) {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_SUCCESS,
              "Added to watchlist"
            );
          } else {
            obj.getVnAppZone().notification = new vn_app_zone_notification(
              vn_app_zone_notification.TYPE_SUCCESS,
              "Removed from watchlist"
            );
          }
          obj.getVnAppZone().showNotificationToModule();
        });
      } else {
        let responseParsed = JSON.parse(req.request.response);
        obj.getVnAppZone().notification = new vn_app_zone_notification(
          vn_app_zone_notification.TYPE_ERROR,
          responseParsed.message
        );
        obj.getVnAppZone().showNotificationToModule();
      }

      obj.articlesEdit.setWatchlistButtonEnabled(true);
    };
  }

  public clearbulkImageCaptionEditor() {
    bulkImageCaptionEditor.setData("");
  }

  public clearbulkImageDescriptionEditor() {
    bulkImageDescriptionEditor.setData("");
  }

  public insertVideo(param?, target?, data?) {
    if (target.element) {
      let element = target.element;
      element.parentElement.removeChild(element);
      target = target.editor;
    }

    let videoHTMLTag = this.buildVideoHTMLTag(data);

    if (target == "article_content") {
      this.insertTag(videoHTMLTag, contentEditor);
    }

    if (target == "article_sandbox") {
      this.insertTag(videoHTMLTag, sandboxEditor);
    }

    if (target == "article_republish") {
      this.insertTag(videoHTMLTag, republishEditor);
    }

    if (target == "featured_video") {
      this.articlesEdit.setFeaturedEmbed(null);
      this.articlesEdit.setFeaturedVideo(data);

      this.articlesEdit.setFeaturedVideoTitle(data.title);
      this.articlesEdit.setFeaturedVideoDescription(data.description);
      this.articlesEdit.setShowFeaturedVideoTitle(true);
      this.articlesEdit.setShowFeaturedVideoDescription(true);

      if (!this.articlesEdit.getTemplateViewModel().idContentType()) {
        let idContentType =
          data.details !== null && data.details.idContentType !== null
            ? data.details.idContentType
            : null;
        this.articlesEdit.setIdContentType(idContentType);
      }
      if (
        this.articlesEdit.getTemplateViewModel().selectedCategories().length ==
        0
      ) {
        let idPrimaryCategory =
          data.details !== null && data.details.idPrimaryCategory !== null
            ? data.details.idPrimaryCategory
            : null;
        if (idPrimaryCategory !== null) {
          this.articlesEdit.setIdPrimaryCategory(idPrimaryCategory.toString());
        }
        if (data && data.videoCategories && data.videoCategories.length > 0) {
          //this.articlesEdit.filterCategory.setSelectedItems(data.videoCategories);
          this.articlesEdit.setSelectedCategories(data.videoCategories);
        }
      }
      if (this.articlesEdit.getTemplateViewModel().selectedTags().length == 0) {
        let idPrimaryTag =
          data.details !== null && data.details.idPrimaryTag !== null
            ? data.details.idPrimaryTag
            : null;
        if (idPrimaryTag !== null) {
          this.articlesEdit.setIdPrimaryTag(idPrimaryTag.toString());
        }
        if (data && data.videoTags && data.videoTags.length > 0) {
          this.articlesEdit.setSelectedTags(data.videoTags);
        }
      }
      //Now selected through the article details modal
    }

    if (target == "tagPickerEdit_tagVideo") {
      this.articlesEdit.tagPicker.tagEdit.setTagVideo(data);
    }

    this.articlesEdit.videoPickerHelper.hideVideoPicker();
    if (this.articlesEdit.getTemplateViewModel().idPublishStatus() != 3) {
      const { isUnderEmbargo } = data;
      if (isUnderEmbargo) {
        this.articlesEdit.setIsUnderEmbargo(true);
      }
    }
  }

  public handleVideoUpload(files) {
    if (
      this.articlesEdit.videoPickerHelper.getVideoIsNotUploadable() &&
      this.articlesEdit.videoPickerHelper.getFileIsVideo()
    ) {
      //const messages =[{ field: "Video", label:"Size limit exceeded", messages: ["Video uploads cannot exceed 150MB per minute of video."] }]
      //this.articlesEdit.videoPicker.setValidationMessageOnAddVideo(messages)
      this.articlesEdit.videoPickerHelper.clearVideoFileInput();
      return;
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let url: string = `/api/brand/${idBrand}/videos/upload/`;

    const formData = new FormData();
    for (const file of files) {
      formData.append("videos[]", file);
    }

    const uploadPromise = new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.responseType = "json";

      xhr.open("POST", url);

      xhr.onload = () => {
        const response = xhr.response;
        if (xhr.readyState === 4 && xhr.status === 200) resolve(response);
        else reject(response);
      };

      xhr.upload.onprogress = (ev) => {
        console.log("Progress");
        const percentComplete = Math.round((ev.loaded / ev.total) * 100);
        this.articlesEdit.videoPickerHelper.setUploadValue(percentComplete);
      };

      xhr.upload.onloadstart = () => {
        console.log("Upload started");
        this.articlesEdit.videoPickerHelper.setUploadIsInProgress(true);
      };
      xhr.upload.onloadend = () => {
        console.log("Upload finished");
        this.articlesEdit.videoPickerHelper.setUploadIsInProgress(false);
      };

      xhr.send(formData);
    });

    uploadPromise
      //If success
      .then((response) => {
        //response['uploadVideos'][0]['details'] = null;
        //response['uploadVideos'][0]['id'] = 0;
        this.articlesEdit.videoPickerHelper.hideVideoPickerAdd();
        this.articlesEdit.videoPickerHelper.clearVideoFileInput();
        this.articlesEdit.videoPickerHelper.setVideoPickerEditData(
          response["uploadVideos"][0],
          "NEW_VIDEO_UPLOADED"
        );
        this.articlesEdit.videoPickerHelper.showVideoPickerEdit();
        this.articlesEdit.videoPickerHelper.setUploadValue(0);
      })
      .catch((errorResponse) => {
        if (errorResponse) {
          const { type, validations } = errorResponse;
          if (type == "validation") {
            this.articlesEdit.videoPickerHelper.setValidationMessageOnAddVideo(
              validations
            );
            this.articlesEdit.videoPickerHelper.clearVideoFileInput();
            this.articlesEdit.videoPickerHelper.setUploadValue(0);
          }
        } else {
          const messages = [
            {
              field: "Video",
              label: "Upload Error",
              messages: ["Video file cannot be uploaded!"],
            },
          ];
          this.articlesEdit.videoPickerHelper.setValidationMessageOnAddVideo(
            messages
          );
          this.articlesEdit.videoPickerHelper.clearVideoFileInput();
          this.articlesEdit.videoPickerHelper.setUploadValue(0);
        }
      });
  }

  protected buildVideoHTMLTag(video) {
    const { id, title, url, thumbnail } = video;
    let thumbnailUrl = thumbnail
      ? thumbnail.url
      : "/assets/images/replace-video.png";
    return `
            <div class="emaki-displayCard video" data-id="${id}">
                <div class="w-video-info">
                    <h3 class="video-title" data-field="title">${title || ""
      }</h3>
                    <div class="w-img" style="width: auto; height: auto">
                        <img data-field="video" src="${thumbnailUrl || ""
      }"  width="400" height="224" alt="" data-video-url="${url}" data-video-title="${title}">
                    </div>
                </div>
            </div>
        `;
  }

  protected getVideosData() {
    this.getVideoPickerHelper().getVideosData();
  }

  public saveVideo(videoData, param?) {
    this.articlesEdit.videoPickerHelper.showLoadingEditVideo();
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let url: string = "/api/brand/" + idBrand + "/videos/save/";
    let params: Array<Array<string>> = [];

    videoData["idProducer"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .filterUser_producer.idUser();
    videoData["videoTags"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .selectedTags();
    videoData["idPrimaryTag"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idPrimaryTag();
    videoData["videoCategories"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .selectedCategories();
    videoData["idPrimaryCategory"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idPrimaryCategory();
    videoData["idContentType"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .idContentType();
    videoData["videoSubtitles"] = this.getVideoPickerEditTemplate()
      .getTemplateViewModel()
      .subtitlesFiles();

    params.push(["data", ko.toJSON(videoData)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      url,
      params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        if (req.request.readyState == 4) {
          obj.articlesEdit.videoPickerHelper.hideLoadingEditVideo();
          if (req.request.status == 200) {
            obj.getVideoPickerEditTemplate().validations.clearMessages();
            obj.manageResponse(req, obj, function () {
              let responseParsed = JSON.parse(req.request.response);
              let video = responseParsed.video;
              obj.articlesEdit.videoPickerHelper.hideVideoPickerEdit();
              const target =
                obj.articlesEdit.videoPickerHelper.getVideoPickerTarget();
              if (param == "insert-save") {
                obj.insertVideo(param, target, video);
              }
              if (target == "featured_video" && param == "save") {
                obj.insertVideo(param, target, video);
                obj.articlesEdit.videoPickerHelper.hideVideoPickerEdit();
                obj.articlesEdit.setFeaturedVideo(video);
              }
              //refresh video view data
              obj.articlesEdit.videoPickerHelper.setViewVideoData(video);
              obj.getVideosData();
            });
          } else if (req.request.status == 400) {
            let errorResponse = JSON.parse(req.request.response);
            const { validations } = errorResponse;
            obj.getVideoPickerEditTemplate().setValidationMessage(validations);
          } else {
            const messages = [
              {
                field: "Video",
                label: "Video Save Error",
                messages: ["An error occurs"],
              },
            ];
            obj.getVideoPickerEditTemplate().setValidationMessage(messages);
          }
        }
      };
    };
    XHRHdl.execute();
  }

  getVideo(videoId) {
    if (this.contentVideoXHRHdl) {
      this.contentVideoXHRHdl.cancelAndReset();
    }

    let idBrand = this.getVnAppZone().app.params.idBrand;

    let url: string = "/api/brand/" + idBrand + "/videos/get-content-video/";
    let params: Array<Array<string>> = [];
    params.push(["videoId", videoId]);

    this.contentVideoXHRHdl = new XMLHttpRequestHandler(url, params, this);
    this.contentVideoXHRHdl.onReadyStateFunction = this.onVideoRequestReturn;
    this.contentVideoXHRHdl.execute();
  }

  protected onVideoRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        let video = responseParsed.video;

        obj.editVideo(video);
      });
    };
  }

  editVideo(video) {
    this.articlesEdit.videoPickerHelper.editVideo(video);
  }

  protected getUploadUrlSubtitles(): string {
    return (
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/videos/subtitles/upload"
    );
  }

  deleteVideo(video) {
    if (this.deleteVideoXHRHdl) {
      this.deleteVideoXHRHdl.cancelAndReset();
    }
    const { id } = video;
    let idBrand = this.getVnAppZone().app.params.idBrand;

    let url: string = "/api/brand/" + idBrand + "/videos/delete/";
    let params: Array<Array<string>> = [];
    params.push(["videoId", id]);

    this.articlesEdit.videoPickerHelper.showLoading();

    this.deleteVideoXHRHdl = new XMLHttpRequestHandler(url, params, this);
    this.deleteVideoXHRHdl.onReadyStateFunction =
      this.onVideoDeleteRequestReturn;
    this.deleteVideoXHRHdl.execute();
  }

  onVideoDeleteRequestReturn(req, obj) {
    return function () {
      if (req.request.status == 200) {
        obj.manageResponse(req, obj, function () {
          obj.articlesEdit.videoPickerHelper.hideVideoPickerView();
          obj.getVideosData();
        });
      } else if (req.request.status == 400) {
        if (req.request.response) {
          //To avoid syntax error
          let errorResponse = JSON.parse(req.request.response);
          const { validations } = errorResponse;
          obj.articlesEdit.videoPickerHelper.setValidationMessage(validations);
        }
      } else {
        //For all unexpected errors
        const messages = [
          {
            field: "Video",
            label: "Deletion Error",
            messages: ["An error occurs"],
          },
        ];
        obj.articlesEdit.videoPickerHelper.setValidationMessage(messages);
      }
      obj.articlesEdit.videoPickerHelper.hideLoading();
    };
  }

  replaceOrUpdateVideoCardElement(oldVideoElement, newVideoData, target) {
    let element = this.buildVideoHTMLTag(newVideoData);

    let editor = this.getEditor(target);
    const oldVideoElementId = oldVideoElement.dataset.id;

    const selector = `*[data-id="${oldVideoElementId}"]`;
    editor.editable().findOne(selector).remove();

    editor.insertHtml(element, "html", null);
  }

  public getIdBrand() {
    return Number(this.getVnAppZone().app.params.idBrand);
  }

  protected getArticleIdFromUrl(): number | null {
    const match = window.location.pathname.match(/\/articles\/edit\/(\d+)/);
    return match ? Number(match[1]) : null;
  }

  protected showKeyTakeawayAddedNotification() {
    this.getVnAppZone().notification = new vn_app_zone_notification(
      vn_app_zone_notification.TYPE_WARNING,
      'A "Key Takeaway" summary has been inserted into the top of the content. !'
    );
    this.getVnAppZone().showNotificationToModule();
  }

  protected setUpCkEditorTagsPickerEditTextArea() {
    classicEditor
      .create(document.querySelector("#tagPickerTagTypeFieldTextArea"), {
        toolbar: ["bold", "|", "italic", "link"],
        link: {
          addTargetToExternalLinks: true,
        },
      })
      .then((newEditor) => {
        tagPickerSpecAreaEditor = newEditor;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  private initializePromptResponseCKEditor() {
    const basicConfig = {
      toolbar: [
        {
          name: "basicstyles",
          items: ["Bold", "Italic", "Strike", "Link", "EmojiPanel"],
        },
      ],
      extraPlugins: "emoji",
      removeButtons: "",
    };
    CKEDITOR.replace("prompt_response", basicConfig);
    promptResponseEditor = CKEDITOR.instances.prompt_response;
  }

  public setRichTextTagSpecAreaEditor(value) {
    tagPickerSpecAreaEditor.setData(value);
  }

  public getRichTextTagSpecAreaEditor() {
    return tagPickerSpecAreaEditor.getData();
  }

  public setRichTextForPromptResponseEditor(text: string) {
    promptResponseEditor.setData(text);
  }

  public getRichTextForPromptResponseEditor() {
    return promptResponseEditor.getData();
  }

  public getBrandId() {
    return this.getVnAppZone().app.params.idBrand;
  }

  protected getTagTypes(listTagTypesId) {
    if (listTagTypesId && listTagTypesId.length > 0) {
      this.XHRHdl.cancelAndReset();

      let usrReq_url: string = "/api/tag/types/get/";
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push([
        "data",
        ko.toJSON({
          filters: {
            ids: listTagTypesId,
          },
        }),
      ]);
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

      this.XHRHdl.onReadyStateFunction = this.onGetTagTypesReturn;
      this.XHRHdl.execute();
    }
  }

  protected onGetTagTypesReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.setTagTypesRestriction(
            response.data
          );
        }
      });
    };
  }

  protected validateTagSpecFromSource(
    idField,
    idType,
    label,
    dataType,
    restrictionsArray,
    value = null,
    idBrand = null
  ) {
    let formReq_url: string = "/api/tags/field/validate/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = {
      idType: idType,
      label: label,
      idField: idField,
      dataType: dataType,
      typeRestrictions: restrictionsArray,
      value: value,
      idBrand: idBrand,
    };
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = this.onValidateSpecification;
    XHRHdl.execute();
  }

  public onValidateSpecification(req, obj) {
    return function () {
      if (req.request.readyState == 4) {
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed.data && responseParsed.data.valid) {
          obj.articlesEdit.tagPicker.tagEdit.appendSpecification();
        } else {
          let messages = responseParsed.validations.map((v) => {
            return { field: v.dataField, label: v.label, messages: v.messages };
          });
          obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.validationsList.setMessages(
            messages
          );
          window.scrollTo(0, 0);
        }
      }
    };
  }

  protected getTagsByTypes(keyword, typeRestrictions = []) {
    this.XHRHdl.cancelAndReset();

    let usrReq_url: string = "/api/tags/get_by_types/";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get_by_types/";
    }
    let subViewModel = {
      keyword: keyword,
      tagTypesIds: typeRestrictions,
    };
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagByTypesRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagByTypesRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        let tags = responseParsed.data;
        if (tags) {
          if (obj.XHRHdlCaller == "getSuggestions_tagSourcePickerTagFilter") {
            obj.articlesEdit.tagPicker.tagEdit.tagTypeFieldEdit.setTags(tags);
          }
        }
      });
    };
  }

  public resetEditedSpec() {
    this.articlesEdit.tagPicker.tagEdit.resetEditedSpec();
  }

  protected addArticlePickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showArticlePicker(editor);
          },
        };
      }

      editor.addCommand("articlePickerCommand", showMyDialog(this));

      editor.ui.addButton("ArticleBtn", {
        // add new button and bind our command
        label: "Insert Articles",
        command: "articlePickerCommand",
        toolbar: "insert",
        icon: "/assets/images/article.png",
      });
    });
  }

  protected showArticlePicker(editor) {
    const selectedText = editor.getSelection() && editor.getSelection().getNative() ? editor.getSelection().getNative().toString() : '';
    if (selectedText.length > 0) {
      this.articlesEdit.showArticlePicker(editor.name, selectedText);
    } else {
      this.articlesEdit.showArticlePicker(editor.name);
    }
  }

  /*protected insertArticleElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null && !this.isSensaiChat) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    if(this.isSensaiChat) {
      this.isSensaiChat = false;
    }
    let editor = this.getEditor(target);

    //set cursor position to end of current selection - to insert tag after elements
    if (editor != null) {
      let selectionElement = editor.getSelection().getStartElement();
      let range = null;

      if (
        selectionElement != null &&
        selectionElement.$ &&
        selectionElement.$.nodeName != "BODY" &&
        selectionElement.$.nodeName != "TD" &&
        selectionElement.getParent() != null
      ) {
        range = editor.createRange();
        range.setStartAt(selectionElement, CKEDITOR.POSITION_AFTER_END);
        range.collapse(true);
      } else if (selectionElement == null) {
        range = editor.createRange();
        range.moveToElementEditEnd(range.root);
      }
      editor.insertHtml(element, "html", range);
    }
  }*/
  protected insertArticleElement(elementToReplace, elementHtml, target) {
    const editor = this.getEditor(target);

    if (!editor) {
      console.warn("CKEditor instance not found.");
      return;
    }

    // Handle SensaiChat override
    if (this.isSensaiChat) {
      this.isSensaiChat = false;
    }

    const editorWindow = editor.document.$.defaultView || editor.document.$.parentWindow;
    const scrollTop = editorWindow ? editorWindow.scrollY || editorWindow.pageYOffset || 0 : 0;
    const scrollLeft = editorWindow ? editorWindow.scrollX || editorWindow.pageXOffset || 0 : 0;

    editor.focus();

    const fragment = CKEDITOR.htmlParser.fragment.fromHtml(elementHtml);
    const writer = new CKEDITOR.htmlParser.basicWriter();
    fragment.writeHtml(writer);
    const finalHtml = writer.getHtml();

    if (elementToReplace && elementToReplace.parentElement) {
      const editorDoc = editor.document.$;
      let ckElement = null;

      if (elementToReplace.id) {
        ckElement = editorDoc.getElementById(elementToReplace.id);
      }

      if (!ckElement) {
        const groups = editorDoc.querySelectorAll('.emaki-displayCard-group, .emaki-displayCard');
        for (let i = 0; i < groups.length; i++) {
          if (groups[i] === elementToReplace || groups[i].isEqualNode(elementToReplace)) {
            ckElement = groups[i];
            break;
          }
        }
      }

      if (ckElement) {
        ckElement.insertAdjacentHTML('afterend', finalHtml);
        ckElement.parentNode.removeChild(ckElement);
        editor.fire('saveSnapshot');
        if (editorWindow) {
          editorWindow.scrollTo(scrollLeft, scrollTop);
        }
        return;
      }
    }

    const selection = editor.getSelection();
    const ranges = selection ? selection.getRanges() : [];

    if (!ranges || ranges.length === 0) {
      console.warn("No selection range found.");
      return;
    }

    const range = ranges[0];
    range.deleteContents();
    editor.insertHtml(finalHtml);
    editor.fire('saveSnapshot');
    if (editorWindow) {
      editorWindow.scrollTo(scrollLeft, scrollTop);
    }
  }

  protected addVignettePickerCommand(editors) {
    let _myThis = this;

    editors.forEach(function (editor) {
      function showMyDialog(obj) {
        return {
          exec: function (editor) {
            _myThis.showVignettePicker(editor);
          },
        };
      }

      editor.addCommand("vignettePickerCommand", showMyDialog(this));

      editor.ui.addButton("VignetteBtn", {
        // add new button and bind our command
        label: "Insert Vignettes",
        command: "vignettePickerCommand",
        toolbar: "insert",
        icon: "/assets/images/vignette.png",
      });
    });
  }

  protected showVignettePicker(editor) {

    this.articlesEdit.showVignettePicker(editor.name);
  }

  protected insertVignetteElement(elementToReplace, element, target) {
    if (elementToReplace != null && elementToReplace.parentElement != null) {
      elementToReplace.parentElement.removeChild(elementToReplace);
    }
    let editor = this.getEditor(target);

    //set cursor position to end of current selection - to insert tag after elements
    if (editor != null) {
      let range = null;
      let selectionElement = editor.getSelection().getStartElement();

      if (
        selectionElement != null &&
        selectionElement.$ &&
        selectionElement.$.nodeName != "BODY" &&
        selectionElement.$.nodeName != "TD" &&
        selectionElement.getParent() != null
      ) {
        range = editor.createRange();
        range.setStartAt(selectionElement, CKEDITOR.POSITION_AFTER_END);
        range.collapse(true);
      } else if (selectionElement == null) {
        range = editor.createRange();
        range.moveToElementEditEnd(range.root);
      }
      editor.insertHtml(element, "html", range);
    }
  }

  public cancelFilter() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  public abortEmbedGeneration(): void {
    this.embedHelper.abortEmbedGeneration();
  }

  public setIsImageOptimized(val) {
    this.articlesEdit.setIsFeaturedImageMobileOptimized(val);
  }

  public getSensaiArticleReferences(target, idArticle) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showFeedbackTabLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/sensai/references/" + idArticle + "/";
    let formReq_params: Array<Array<string>> = [];

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiArticleReferences;
    this.SensaiXHRHdl.execute();
  }

  public onGetSensaiArticleReferences(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.setSavedFeedbacksHistoryOptions(responseParsed);
      });
    };
  }

  public filterFeedBackHistory(idArticle, uuid) {
    if (this.SensaiXHRHdl) {
      this.SensaiXHRHdl.cancelAndReset();
    }

    this.articlesEdit.showFeedbackTabLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/sensai/feedback/" + idArticle + "/";
    let formReq_params: Array<Array<string>> = [];
    let subViewModel = { uuid: uuid };
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    this.SensaiXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.SensaiXHRHdl.onReadyStateFunction =
      this.onGetSensaiArticleFeedbackHistory;
    this.SensaiXHRHdl.execute();
  }

  public onGetSensaiArticleFeedbackHistory(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);

        let guidelines = obj.organizeSensaiResults(responseParsed);
        obj.articlesEdit.articleReviewHistory.setGuidelines(guidelines);

        obj.articlesEdit.hideFeedbackTabLoading();
      });
    };
  }
  public setDataFromBackend(urlParams) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
    this.cancelRecoveryRequest();

    let takeover = false;

    let id: number = this.getArticleIdFromUrl();

    if(!id){
      id = undefined;
    }

    if (id && !isNaN(id)) {
      this.articlesEdit.getTemplateViewModel().id(id);
    }
    this.startArticleDataLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let searchParams = new URLSearchParams();

    if (urlParams["videoId"])
      searchParams.append("videoId", urlParams["videoId"]);

    if (urlParams["idThreadSuggestion"])
      searchParams.append("idThreadSuggestion", urlParams["idThreadSuggestion"]);

    let searchParamsString = searchParams.toString();

    if (searchParamsString)
      searchParamsString = `?${searchParamsString}`;

    let usrReq_url: string = `/api/brand/${idBrand}/articles/getForEdit/${id}${searchParamsString}`;
    let usrReq_params: Array<Array<string>> = [];
    //usrReq_params.push(['data', ko.toJSON(urlParams)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetDataFromBackend;
    this.XHRHdl.execute();
  }

  public onGetDataFromBackend(req, obj) {
    return function () {
      let hydratedArticle = null;
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        const { article } = response.data;
        hydratedArticle = article;
        obj.updateChatHistoryOnArticleSave(article);
        obj.setArticleData(article);
      });
      if (obj.isArticleDataLoading) {
        obj.finishArticleDataLoading(hydratedArticle);
      }
    };
  }



  protected getDatasetSuggestion(keyword, limit = null, restrictOwnedTagTypes = false) {

    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = {
      keyword: keyword,
      limit: limit,
      restrictOwnedTagTypes: restrictOwnedTagTypes,
    };
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url: string = '';
    if (idBrand) {
      usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/dataset/";
    } else {
      usrReq_url = "/api/search/tag/dataset/";
    }
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetDatasetSuggestionReturn;
    this.XHRHdl.execute();

  }

  protected onGetDatasetSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let datasets = responseParsed.data.templateTypes;

        obj.articlesEdit.setDatasetFilter(datasets);

      });
    }
  }

  protected getTagTypeByDatasetId(idDataset) {
    //if (this.XHRHdl) {
    //    this.XHRHdl.cancelAndReset();
    //}

    let subViewModel = {
      idDataset: idDataset
    };

    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    let usrReq_url: string = '';
    if (idBrand) {
      usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/types/get_by_dataset_id/" + idDataset + "/";
    } else {
      usrReq_url = "/api/search/tag/types/get_by_dataset_id/" + idDataset + "/";
    }
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypeByDatasetIdReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypeByDatasetIdReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        let tagTypes = responseParsed.data;

        obj.articlesEdit.setTagTypeDropdown(tagTypes);

      });
    };
  }

  public deleteAllSelectedTagType() {
    this.articlesEdit.deleteAllSelectedTagType();
  }

  public initiateSensaiChat(userQuery, isQuickPrompt = false) {

    this.loadingIn(document.getElementById("user-query-container"));
    let articleText = contentEditor.getData();
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    let sessionId = this.articlesEdit.getTemplateViewModel().sessionId();
    // Close any existing EventSource connection
    if (this.eventSource) {
      this.eventSource.close();
    }

    this.articlesEdit.getTemplateViewModel().isChatDisabled(true);

    fetch('/api/sensAI-vault/save-chat-session/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ articleText: articleText, sessionId: sessionId, chatHistory: this.articlesEdit.getTemplateViewModel().chatHistory() })
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then(data => {
      let sessionId = data.sessionId;
      this.articlesEdit.getTemplateViewModel().sessionId(sessionId);
      userQuery = encodeURIComponent(userQuery);
      let formReq_url = `/api/sensAI-vault/sensai-vault-chat/?userQuery=${userQuery}&isQuickPrompt=${isQuickPrompt}&idBrand=${idBrand}&idArticle=${this.articlesEdit.getTemplateViewModel().id()}`;
      this.eventSource = new EventSource(formReq_url);
      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          //console.log("Streaming response:", data);

          if (data.response) {
            this.articlesEdit.addToChatHistory(data.response, "system");
          }

          if (data === "[DONE]") {
            console.log("Streaming finished.");
            this.eventSource.close();
            this.loadingOut(document.getElementById("user-query-container"));
          }
        } catch (e) {
          console.error("Error parsing SSE stream:", e);
        }
      };

      this.eventSource.addEventListener('close', (event) => {
        console.log("Streaming finished gracefully via custom close event.");
        this.eventSource.close();
        this.loadingOut(document.getElementById("user-query-container"));
        this.articlesEdit.getTemplateViewModel().isChatDisabled(false);
      });


      this.eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
        this.eventSource.close();
        this.loadingOut(document.getElementById("user-query-container"));
        this.articlesEdit.getTemplateViewModel().isChatDisabled(false);
      };
    })
  }

  public async scrappingExternalSourceNewsUrl({ sourceUrl, isLoadingSrcTimeBtn }) {
    const endpoint = '/api/extract/date-published/';
    isLoadingSrcTimeBtn(true);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sourceUrl: sourceUrl() }),
      });

      if (!response.ok) {
        console.error('Request failed:', response.status);
        this.showMessage('An error occurred. Please try again later.', 'error');
      } else {
        const data = await response.json();
        const datePublished = data.publicationTime || null;

        this.articlesEdit.sourceNewsDatePicker
          .getTemplateViewModel()
          .singleDatePicker(datePublished);

        const message = datePublished
          ? 'Completed! Found source publication time.'
          : 'Cannot get the date published from the source.';
        const messageType = datePublished ? 'success' : 'alert';

        this.showMessage(message, messageType);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      this.showMessage('An error occurred. Please try again later.', 'error');
    } finally {
      isLoadingSrcTimeBtn(false);
    }
  }


  private showMessage(message: string, type: 'success' | 'alert' | 'error' = 'success') {
    this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
    this.getVnAppZone().showNotificationToModule();
  }


  public fetchArticleAiSummaries() {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const url = `/api/brand/${idBrand}/article/${idArticle}/summary/get/`;
    return fetch(url)
      .then(res => res.json())
      .then(res => {
        const vm = this.articlesEdit.getTemplateViewModel();
        if (res.data) {
          vm.factualSummary(res.data.factualSummary || '');
          factualSummaryEditor.setData(res.data.factualSummary || '');
          vm.simpleSummary(res.data.simpleSummary || '');
          simpleSummaryEditor.setData(res.data.simpleSummary || '');
          vm.satiricalCommentary(res.data.satiricalCommentary || '');
          satiricalCommentaryEditor.setData(res.data.satiricalCommentary || '');
          vm.reactionPost(res.data.reactionPost || '');
          vm.isFactualSummaryEnabled(res.data.isFactualSummaryEnabled !== false);
          vm.isSimpleSummaryEnabled(res.data.isSimpleSummaryEnabled !== false);
          vm.isSatiricalCommentaryEnabled(res.data.isSatiricalCommentaryEnabled !== false);
          vm.isSummaryFetched = true;
        } else {
          vm.isSummaryFetched = false;
          const aiSettings = vm.aiSettings() || {};
          const onByDefault = aiSettings.isSummaryOnByDefault !== false;
          const isEligible = vm.showSummary && vm.showSummary();
          vm.isFactualSummaryEnabled(onByDefault && isEligible);
          vm.isSimpleSummaryEnabled(onByDefault && isEligible);
          vm.isSatiricalCommentaryEnabled(onByDefault && isEligible);
        }
      });
  }

  public fetchNewsletterPromotion() {

    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const url = `/api/brand/${idBrand}/article/${idArticle}/newsletterPromotion/get/`;
    return fetch(url)
      .then(res => res.json())
      .then(res => {
        const vm = this.articlesEdit.getTemplateViewModel();
        if (res.data) {
          const data = res.data || {};
          vm.isAiNewsletterPromotionEnabled(data.isEnabled || false);
          vm.aiNewsletterPromotionTitle(data.title || '');
          vm.aiNewsletterPromotionExcerpt(data.excerpt || '');
          vm.isNewsletterPromotionFetched = true;
        } else {
          vm.isNewsletterPromotionFetched = false;
          const aiSettings = vm.aiSettings() || {};
          const onByDefault = aiSettings.isNewsletterPromotionOnByDefault !== false;
          const isEligible = vm.showNewsletterPromotion && vm.showNewsletterPromotion();
          vm.isAiNewsletterPromotionEnabled(onByDefault && isEligible);
        }
      });
  }

  public fetchDealsCategoryPromotion() {

    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const url = `/api/brand/${idBrand}/article/${idArticle}/dealsCategoryPromotion/get/`;
    return fetch(url)
        .then(res => res.json())
        .then(res => {
            const vm = this.articlesEdit.getTemplateViewModel();
            if (res.data) {
                const data = res.data || {};
                vm.isAiDealsCategoryPromotionEnabled(data.isEnabled || false);
                vm.aiDealsCategoryPromotionTitle(data.title || '');
                vm.aiDealsCategoryPromotionExcerpt(data.excerpt || '');
                vm.aiDealsCategoryPromotionListingPageId(data.idListingPage || null);
                vm.isDealsCategoryPromotionFetched = true;
            } else {
                vm.isDealsCategoryPromotionFetched = false;
                const aiSettings = vm.aiSettings() || {};
                const onByDefault = aiSettings.isDealsCategoryPromotionOnByDefault !== false;
                const isEligible = vm.showDealsCategoryPromotion && vm.showDealsCategoryPromotion();
                vm.isAiDealsCategoryPromotionEnabled(onByDefault && isEligible);
            }
        });
  }

  public saveArticleAiSummaries(regenerate = false) {
    const idBrand = this.getIdBrand();
    const idArticle = this.articlesEdit.getId();
    const vm = this.articlesEdit.getTemplateViewModel();
    const url = `/api/brand/${idBrand}/article/${idArticle}/summary/save/`;
    this.loadingIn(document.getElementById("widgets-section-summary"));

    const factualSummary = factualSummaryEditor.getData();
    const simpleSummary = simpleSummaryEditor.getData();
    const satiricalCommentary = satiricalCommentaryEditor.getData();

    const payload = {
      factualSummary: (factualSummary && factualSummary.trim() !== "") ? factualSummary : null,
      simpleSummary: (simpleSummary && simpleSummary.trim() !== "") ? simpleSummary : null,
      satiricalCommentary: (satiricalCommentary && satiricalCommentary.trim() !== "") ? satiricalCommentary : null,

      reactionPost: vm.reactionPost(),
      isFactualSummaryEnabled: vm.isFactualSummaryEnabled(),
      isSimpleSummaryEnabled: vm.isSimpleSummaryEnabled(),
      isSatiricalCommentaryEnabled: vm.isSatiricalCommentaryEnabled(),
      updateSummariesWithContent: vm.updateSummariesWithContent(),
      regenerate: regenerate
    };
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(res => res.json()).then(res => {
      if (res.data) {
        const vm = this.articlesEdit.getTemplateViewModel();
        vm.factualSummary(res.data.factualSummary || '');
        factualSummaryEditor.setData(res.data.factualSummary || '');
        vm.simpleSummary(res.data.simpleSummary || '');
        simpleSummaryEditor.setData(res.data.simpleSummary || '');
        vm.satiricalCommentary(res.data.satiricalCommentary || '');
        satiricalCommentaryEditor.setData(res.data.satiricalCommentary || '');
        vm.reactionPost(res.data.reactionPost || '');
        vm.isFactualSummaryEnabled(res.data.isFactualSummaryEnabled !== false);
        vm.isSimpleSummaryEnabled(res.data.isSimpleSummaryEnabled !== false);
        vm.isSatiricalCommentaryEnabled(res.data.isSatiricalCommentaryEnabled !== false);
        vm.updateSummariesWithContent(res.data.updateSummariesWithContent !== false);
        this.loadingOut(document.getElementById("widgets-section-summary"));

      }
    });
  }

  public saveArticleAiNewsletterPromotion(regenerate = false) {

      this.loadingIn(document.getElementById("ai-newsletter-promotion-section"));
      const idBrand = this.getIdBrand();
      const idArticle = this.articlesEdit.getId();
      const vm = this.articlesEdit.getTemplateViewModel();

      const title = vm.aiNewsletterPromotionTitle();
      const excerpt = vm.aiNewsletterPromotionExcerpt();


      let viewModel = {
          title: title,
          excerpt: excerpt,
          isEnabled: vm.isAiNewsletterPromotionEnabled(),
          regenerate: regenerate
      };

      // build the right url for the API call
      const url = `/api/brand/${idBrand}/article/${idArticle}/newsletterPromotion/save/`;
      let formReq_params: Array<Array<string>> = [];
      formReq_params.push(["data", ko.toJSON(viewModel)] );

      this.XHRHdl = new XMLHttpRequestHandler(url,formReq_params, this);
      this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      this.XHRHdl.onReadyStateFunction = this.onSaveArticleAiNewsletterPromotion;
      this.XHRHdl.execute();
  }

  public onSaveArticleAiNewsletterPromotion(req, obj) {
     return function () {
          obj.manageResponse(req, obj, function () {
            let response = JSON.parse(req.request.response);
            const data = response.data || {};
            const vm = obj.articlesEdit.getTemplateViewModel();
            vm.aiNewsletterPromotionTitle(data.title || '');
            vm.aiNewsletterPromotionExcerpt(data.excerpt || ''); vm.isAiNewsletterPromotionEnabled(data.isEnabled || false);
        });
        obj.loadingOut(document.getElementById("ai-newsletter-promotion-section"));
    }
  }
// ai-deals-category-promotion-section

    public saveArticleAiDealsCategoryPromotion(regenerate = false) {

        this.loadingIn(document.getElementById("ai-deals-category-promotion-section"));
        const idBrand = this.getIdBrand();
        const idArticle = this.articlesEdit.getId();
        const vm = this.articlesEdit.getTemplateViewModel();

        const title = vm.aiDealsCategoryPromotionTitle();
        const excerpt = vm.aiDealsCategoryPromotionExcerpt();
        const idListingPage = vm.aiDealsCategoryPromotionListingPageId();


        let viewModel = {
            title: title,
            excerpt: excerpt,
            idListingPage: idListingPage,
            isEnabled: vm.isAiDealsCategoryPromotionEnabled(),
            regenerate: regenerate
        };

        // build the right url for the API call
        const url = `/api/brand/${idBrand}/article/${idArticle}/dealsCategoryPromotion/save/`;
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(viewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(url,formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveArticleAiDealsCategoryPromotion;
        this.XHRHdl.execute();
    }

    public onSaveArticleAiDealsCategoryPromotion(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                const data = response.data || {};
                const vm = obj.articlesEdit.getTemplateViewModel();
                vm.aiDealsCategoryPromotionTitle(data.title || '');
                vm.aiDealsCategoryPromotionExcerpt(data.excerpt || '');
                vm.aiDealsCategoryPromotionListingPageId(data.idListingPage || '');
                vm.isAiDealsCategoryPromotionEnabled(data.isEnabled || false);
            });
            obj.loadingOut(document.getElementById("ai-deals-category-promotion-section"));
        }
    }

  public getWidgetsArticleReferences() {
    if (this.widgetXHRHdl) {
      this.widgetXHRHdl.cancelAndReset();
    }
    const idArticle = this.articlesEdit.getId();

    this.articlesEdit.showFeedbackTabLoading();

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string =
      "/api/brand/" + idBrand + "/widgets/references/";
    let formReq_params: Array<Array<string>> = [];

    this.widgetXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.widgetXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.widgetXHRHdl.onReadyStateFunction = this.onGetWidgetsArticleReferences;
    this.widgetXHRHdl.execute();
  }

  public onGetWidgetsArticleReferences(req, obj) {
    return () => {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);
        obj.articlesEdit.getTemplateViewModel().showQuiz(obj.articlesEdit.isQuizAllowed(responseParsed));
        obj.articlesEdit.getTemplateViewModel().showAiFaq(false);//obj.articlesEdit.isAiFaqAllowed(responseParsed));
        if (!obj.articlesEdit.getTemplateViewModel().titleDiscoverandOptimizePrompt() || obj.articlesEdit.getTemplateViewModel().titleDiscoverandOptimizePrompt() === '') {
          obj.articlesEdit.getTemplateViewModel().titleDiscoverandOptimizePrompt(responseParsed.titleDiscoverandOptimizePrompt);
        }

        if (responseParsed.emakiBrandContext !== '') {
          obj.articlesEdit.getTemplateViewModel().aiPromptBrandContextIncludedEnabled(true);
        }

        if (responseParsed.authorTone !== null && responseParsed.authorTone !== '') {
          obj.articlesEdit.getTemplateViewModel().aiPromptAuthorToneIncludedEnabled(true);
        }

        obj.articlesEdit.getTemplateViewModel().aiSettings(responseParsed);

      });
    };
  }




  protected getArticleAiChatHistory() {

    let idBrand = this.getVnAppZone().app.params.idBrand;
    let idArticle = this.articlesEdit.getId();

    let data = {
      idArticle: idArticle,
    };

    let formReq_url: string =
      "/api/brand/" + idBrand + "/ai-tools/chat-history/get/";
    let formReq_params: Array<Array<string>> = [];
    formReq_params.push(["data", JSON.stringify(data)]);

    this.autoCategorizeXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.autoCategorizeXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.autoCategorizeXHRHdl.onReadyStateFunction =
      this.onArticleChatHistoryReturn;
    this.autoCategorizeXHRHdl.execute();
  }


  protected onArticleChatHistoryReturn(req, obj) {

    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        if (responseParsed.data) {

          obj.articlesEdit.getTemplateViewModel().haveAiChatHistory(responseParsed.data.chatHistory ? true : false);

          const imageAnalysisEl = document.getElementById("title-analysis-content");
          imageAnalysisEl.innerHTML = responseParsed.data.chatHistory || '';
          const customChatHistoryEl = document.getElementById("custom-prompts-content");
          customChatHistoryEl.innerHTML = responseParsed.data.customChatHistory || '';

          obj.articlesEdit.scrollChatToBottom(true);
          obj.articlesEdit.scrollChatToBottom(true, 'customprompt');

          obj.updateTitleAnalysisWindowPosition();
          obj.initializeReadMoreBehavior(imageAnalysisEl);
          obj.initializeReadMoreBehavior(customChatHistoryEl);

          obj.attachChatEventListeners(imageAnalysisEl);
          obj.updateChatButtons(contentEditor);
        }
      });
    };

  }

  protected attachChatEventListeners(chatHistoryEl) {

    let _myThis = this;

    let autoLinkingButtons = this.getAllAutoLinkingButtons(chatHistoryEl);

    autoLinkingButtons.forEach((btn: HTMLButtonElement) => {
      // Remove existing event listeners by cloning the element
      const newBtn = btn.cloneNode(true) as HTMLButtonElement;
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const dataValue = newBtn.getAttribute('data-value');
        if (dataValue) {
          try {
            // decode JSON, handle HTML-encoded quotes if necessary
            let decodedValue = dataValue;
            // If the value is HTML-encoded, decode it
            if (decodedValue.indexOf('&quot;') !== -1) {
              decodedValue = decodedValue.replace(/&quot;/g, '"');
            }
            const dataObj = JSON.parse(decodedValue);
            if (dataObj && dataObj.permalink) {
              const target = dataObj.target ? dataObj.target : '_self';
              _myThis.insertHyperlink(contentEditor, dataObj.permalink, target);
            }
          } catch (e) {
            console.error('Failed to parse data-value JSON or insert hyperlink:', e);
          }
        }
      });
    });

    let findNextButtons = this.getAllFindNextButtons(chatHistoryEl);

    findNextButtons.forEach((btn: HTMLButtonElement) => {
      // Remove existing event listeners by cloning the element
      const newBtn = btn.cloneNode(true) as HTMLButtonElement;
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const dataText = newBtn.getAttribute('data-text');
        if (dataText) {
          _myThis.CKE4Finder.findNext(contentEditor, dataText);
        }
      });
    });

    let findPrevButtons = this.getAllFindPrevButtons(chatHistoryEl);

    findPrevButtons.forEach((btn: HTMLButtonElement) => {
      // Remove existing event listeners by cloning the element
      const newBtn = btn.cloneNode(true) as HTMLButtonElement;
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const dataText = newBtn.getAttribute('data-text');
        if (dataText) {
          _myThis.CKE4Finder.findPrevious(contentEditor, dataText);
        }
      });
    });

    let findButtons = this.getAllFindButtons(chatHistoryEl);

    findButtons.forEach((btn: HTMLButtonElement) => {
      // Remove existing event listeners by cloning the element
      const newBtn = btn.cloneNode(true) as HTMLButtonElement;
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const dataText = newBtn.getAttribute('data-text');
        if (dataText) {
          _myThis.CKE4Finder.findNext(contentEditor, dataText);
        }
      });
    });

    this.getAllAiWidgetsButtons(chatHistoryEl).forEach((btn: HTMLButtonElement) => {
      // Remove existing event listeners by cloning the element
      const newBtn = btn.cloneNode(true) as HTMLButtonElement;
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (ev: MouseEvent) => {
        ev.preventDefault();
        _myThis.onAiWidgetsButtonClick(newBtn);
      });
    });

    //this.updateInsertButtonState(contentEditor);

  }

  protected onAiWidgetsButtonClick(btn: HTMLButtonElement) {
    const data = btn.getAttribute('data-value');
    try {
      const dataObj = JSON.parse(data);
      switch(dataObj.type) {
        case "quiz":
          this.articlesEdit.getTemplateViewModel().onClickTab("article");
          this.showQuizInsertFlow('article_content');
          break;
        case "poll":
          this.articlesEdit.getTemplateViewModel().onClickTab("article");
          this.insertGeneratedPollFromPicker(
            "article_content",
            this.getDynamicPlacementDefault('poll')
          );
          break;
        default:
          break;
      }
    } catch (e) {
      console.error('Failed to parse data-value JSON or insert ai widgets:', e);
    }
  }

  protected getAllAiWidgetsButtons(chatHistoryEl) {
    return chatHistoryEl.querySelectorAll('li.has-insert button[data-field="aiWidgets"]');
  }

  protected getAllAutoLinkingButtons(chatHistoryEl) {
    if (!chatHistoryEl) return [];

    const listItemsWithHasInsert = chatHistoryEl.querySelectorAll('li.has-insert');

    // Loop through list items and get all child buttons with data-field="article_autoLinking"
    const autoLinkingButtons: HTMLButtonElement[] = [];
    listItemsWithHasInsert.forEach((li: HTMLElement) => {
      const buttons = li.querySelectorAll('button[data-field="article_autoLinking"]');
      buttons.forEach((btn: Element) => {
        if (btn instanceof HTMLButtonElement) {
          autoLinkingButtons.push(btn);
        }
      });
    });

    return autoLinkingButtons;
  }

  protected getAllFindNextButtons(chatHistoryEl) {

    const listItemsWithHasInsert = chatHistoryEl.querySelectorAll('li.has-insert');

    const findNextButtons: HTMLButtonElement[] = [];
    listItemsWithHasInsert.forEach((li: HTMLElement) => {
      const buttons = li.querySelectorAll('.btn-next');
      buttons.forEach((btn: Element) => {
        if (btn instanceof HTMLButtonElement) {
          findNextButtons.push(btn);
        }
      });
    });

    return findNextButtons;
  }

  protected getAllFindPrevButtons(chatHistoryEl) {
    const listItemsWithHasInsert = chatHistoryEl.querySelectorAll('li.has-insert');

    const findPrevButtons: HTMLButtonElement[] = [];
    listItemsWithHasInsert.forEach((li: HTMLElement) => {
      const buttons = li.querySelectorAll('.btn-prev');
      buttons.forEach((btn: Element) => {
        if (btn instanceof HTMLButtonElement) {
          findPrevButtons.push(btn);
        }
      });
    });
    return findPrevButtons;
  }

  protected getAllFindButtons(chatHistoryEl) {
    const listItemsWithHasInsert = chatHistoryEl.querySelectorAll('li.has-insert');

    const findButtons: HTMLButtonElement[] = [];
    listItemsWithHasInsert.forEach((li: HTMLElement) => {
      const buttons = li.querySelectorAll('.btn-find');
      buttons.forEach((btn: Element) => {
        if (btn instanceof HTMLButtonElement) {
          findButtons.push(btn);
        }
      });
    });
    return findButtons;
  }

  protected analyzeArticleByType(type: string) {

    this.articlesEdit.getTemplateViewModel().haveAiChatHistory(true);

    const usesEngagementAssistant = type === 'thread' || type === 'widgets';
    const emakiAssistantName = usesEngagementAssistant
      ? "Emaki Assistant (Engagement)"
      : "Emaki Assistant";
    const currentAgents = this.articlesEdit.getTemplateViewModel().articleAiAgents();
    const alreadyAdded = currentAgents.some(a => a.name === emakiAssistantName);
    if (!alreadyAdded) {
      const emakiAssistantId = usesEngagementAssistant
        ? this.articlesEdit.getTemplateViewModel().emakiAssistantEngagementAgentId()
        : this.articlesEdit.getTemplateViewModel().emakiAssistantAgentId();
      this.articlesEdit.getTemplateViewModel().articleAiAgents.push({ id: emakiAssistantId, name: emakiAssistantName });
    }

    var buttonId = '';
    if (type != 'both' && type != 'optimize' && type != 'ctr') {
      buttonId = type + "-analysis-button";
    } else {
      buttonId = "title-analysis-button";
    }
    var endpoint = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/ai-tools/discover-optimize-title/get/";


    var button = document.getElementById(buttonId);
    if (button) {
      button.classList.add("is-generated");
    }

    var idBrand = this.getVnAppZone().app.params.idBrand;
    var idArticle = this.articlesEdit.getId();
    var idContentType = this.articlesEdit.getIdContentType();
    var title = this.articlesEdit.getTitle();

    var userMessage = "";
    if (type === 'customprompt') {
      var userMessages = document.querySelectorAll("#custom-prompts-content-userMessage");
      if (userMessages.length > 0) {
        userMessage = userMessages[userMessages.length - 1].outerHTML;
      }
    }
    else if (type !== 'optimize') {
      var userMessages = document.querySelectorAll("#title-analysis-content-userMessage");
      if (userMessages.length > 0) {
        userMessage = userMessages[userMessages.length - 1].outerHTML;
      }
      this.articlesEdit.getTemplateViewModel().activeChatTab('preset')
    }

    let cnc = this.getAiContentAndContext('');

    let selectedText = '';

    //for article/tag interlinking we separate the content and the selected text
    if(type == 'internalLinkingArticlesRelatedBrands' || type == 'internalLinkingArticlesBrand' || type == 'internalLinkingArticlesRelatedBrandsNewModel' || type == 'internalLinkingArticlesBrandNewModel' || type == 'internalLinkingTags'){

      if(cnc.context.indexOf('selectedText') !== -1){
        selectedText = contentEditor.getSelection() ? contentEditor.getSelection().getSelectedText() : '';
      }

      cnc.content = contentEditor.getData();

    }

    aiEventArray.push({ 'type': type, 'usedContext': cnc.context });


    var data: any = {
      idArticle: idArticle,
      title: title,
      content: cnc.content,
      idContentType: idContentType,
      prompt: this.articlesEdit.getTemplateViewModel().customPrompt(),
      userMessage: userMessage,
      type: type,
      selectedText,
      context: cnc.context //context
    };

    if (type === 'customprompt') {
      data.previousResponseId = this.articlesEdit.getTemplateViewModel().customPromptPreviousResponseId();
    }

    if (this.requestStatus[type] !== undefined) {
      this.requestStatus[type] = false;
    }

    var formReq_params: Array<Array<string>> = [["data", JSON.stringify(data)]];

    this.autoCategorizeXHRHdl = new XMLHttpRequestHandler(endpoint, formReq_params, this);
    this.autoCategorizeXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.autoCategorizeXHRHdl.onReadyStateFunction = this.onAnalyzeArticleReturn;
    this.autoCategorizeXHRHdl.execute();
  }

  protected getAiContext(content) {
    return (this.getAiContentAndContext(content)).context;
  }

  protected getAiContentAndContext(content): { content: string, context: Array<string> } {
    let context = [];
    if (this.articlesEdit.getTemplateViewModel().aiPromptSelectedTextIncluded() && contentEditor.getSelection().getSelectedText() != '') {
      content += "Base your answer on the selected text :  " + contentEditor.getSelection().getSelectedText();
      context.push('selectedText');
    }
    if (this.articlesEdit.getTemplateViewModel().aiPromptArticleIncluded() && contentEditor.getData() != '') {
      content += "\n use the following article as context : " + contentEditor.getData();
      context.push('article');
    }

    if (this.articlesEdit.getTemplateViewModel().aiPromptBrandContextIncluded() && this.articlesEdit.getTemplateViewModel().aiSettings().emakiBrandContext != '') {
      content += " \n Adapt the response to this publication's brand context: " + this.articlesEdit.getTemplateViewModel().aiSettings().emakiBrandContext;
      context.push('emakiBrandContext');
    }

    if (this.articlesEdit.getTemplateViewModel().aiPromptAuthorToneIncluded() && this.articlesEdit.getTemplateViewModel().aiSettings().authorTone != null && this.articlesEdit.getTemplateViewModel().aiSettings().authorTone != '') {
      content += " \n Adapt the response to this author's personal tone:: " + this.articlesEdit.getTemplateViewModel().aiSettings().authorTone;
      context.push('authorTone');
    }

    return {
      context: context,
      content: content
    };
  }

  protected onGetInterlinkingArticlesReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, () => {
        let responseParsed = JSON.parse(req.request.response);

        let contentEl = document.getElementById("title-analysis-content");
        let parentContainer = document.getElementById("title-analysis-container");

        if (contentEl && responseParsed.data) {
          contentEl.insertAdjacentHTML('beforeend', responseParsed.data);
          obj.updateChatButtons(contentEditor);
        }
      });
    };
  }

  protected onAnalyzeArticleReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        var responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data) {
          var type = responseParsed.type
          if (type === 'customprompt' && typeof responseParsed.responseId === "string" && responseParsed.responseId !== "") {
            obj.articlesEdit.getTemplateViewModel().customPromptPreviousResponseId(responseParsed.responseId);
          }
          var containerId = "title-analysis-content-" + type;
          var parentContainer = document.getElementById("title-analysis-content");

          if (type === 'customprompt') {
            parentContainer = document.getElementById("custom-prompts-content");
          }

          var contentEl = document.createElement("div");
          contentEl.id = containerId;

          if (parentContainer) {
            parentContainer.appendChild(contentEl);
          }

          document.querySelectorAll('.ai-scroll-spacer').forEach(function (spacer) {
            if (spacer && spacer.parentNode) {
              spacer.parentNode.removeChild(spacer);
            }
          });

          var aiThinking = document.querySelector('.ai-thinking');
          if (aiThinking && aiThinking.parentNode) {
            aiThinking.parentNode.removeChild(aiThinking);
          }

          if (type == 'internalLinkingTags' || type == 'internalLinkingArticlesBrand' || type == 'internalLinkingArticlesRelatedBrands' || type == 'internalLinkingArticlesBrandNewModel' || type == 'internalLinkingArticlesRelatedBrandsNewModel') {

            contentEl.insertAdjacentHTML('beforeend', responseParsed.data);
            obj.updateChatButtons(contentEditor);

          }else{
            obj.progressivelyReveal(contentEl, responseParsed.data, obj, () => {
              obj.updateChatButtons(contentEditor);
              if (type === 'widgets') {
                obj.articlesEdit.onWidgetsAiResponseRendered();
              }
            });

            setTimeout(function () {
              if (parentContainer) {
                var containerHeight = parentContainer.clientHeight;
                var contentHeight = contentEl.scrollHeight;


                if (contentHeight < containerHeight) {
                  var spacer = document.createElement("div");
                  spacer.className = "ai-scroll-spacer";
                  spacer.style.height = (containerHeight - contentHeight) + "px";
                  spacer.style.opacity = "0";
                  spacer.setAttribute("aria-hidden", "true");
                  parentContainer.appendChild(spacer);
                }
              }
            }, 0);
          }



          if (type === 'ctr') {
            obj.requestStatus[type] = true;
            obj.articlesEdit.addAiBotThinking();
            obj.analyzeArticleByType('optimize');
          }
          else if (type === 'internalLinkingTags' ) {
            //obj.requestStatus[type] = true;
            //obj.articlesEdit.addAiBotThinking();
            //obj.analyzeArticleByType('internalLinkingArticlesBrand');
            let  buttonId = "interlinking-analysis-button";
            var button = document.getElementById(buttonId);
            if (button) {
              button.classList.remove("is-generated");
            }
            obj.articlesEdit.getTemplateViewModel().isAiAnalyzing(false);
          } else if (type === 'internalLinkingArticlesBrand' ) {
            obj.requestStatus[type] = true;
            obj.articlesEdit.addAiBotThinking();
            obj.analyzeArticleByType('internalLinkingArticlesRelatedBrands');
          } else if (type === 'internalLinkingArticlesBrandNewModel' ) {
            obj.requestStatus[type] = true;
            obj.articlesEdit.addAiBotThinking();
            obj.analyzeArticleByType('internalLinkingArticlesRelatedBrandsNewModel');
          }else if (type === 'internalLinkingArticlesRelatedBrands' ) {
            obj.requestStatus[type] = true;
            obj.articlesEdit.addAiBotThinking();
            obj.analyzeArticleByType('internalLinkingTags');
          }else if (type === 'internalLinkingArticlesRelatedBrandsNewModel' ) {
            obj.requestStatus[type] = true;
            obj.articlesEdit.addAiBotThinking();
            obj.analyzeArticleByType('internalLinkingTags');
          } else if (type === 'optimize') {
              var titleBtn = document.getElementById("title-analysis-button");
              if (titleBtn) {
                titleBtn.classList.remove("is-generated");
              }
              obj.articlesEdit.getTemplateViewModel().isAiAnalyzing(false);
          }else if (type === 'image') {
            var imageBtn = document.getElementById("image-analysis-button");
            if (imageBtn) {
              imageBtn.classList.remove("is-generated");
            }
            obj.articlesEdit.getTemplateViewModel().isAiAnalyzing(false);

          } else {
            let buttonId = type + "-analysis-button";
            var button = document.getElementById(buttonId);
            if (button) {
              button.classList.remove("is-generated");
            }
            obj.articlesEdit.getTemplateViewModel().isAiAnalyzing(false);
          }
          obj.articlesEdit.getTemplateViewModel().customPrompt("");

        }else{
          var titleBtn = document.getElementById("title-analysis-button");
          if (titleBtn) {
            titleBtn.classList.remove("is-generated");
          }
          obj.articlesEdit.getTemplateViewModel().isAiAnalyzing(false);
          // If a widgets popup was open in the deferred-save flow, resolve it gracefully
          obj.articlesEdit.onWidgetsAiResponseRendered();
        }

      });
    };
  }

  public initializeReadMoreBehavior(container) {
    const messageBlocks = container.querySelectorAll('.ai-userMessage');

    messageBlocks.forEach((block) => {
      const messageBody = block.querySelector('.message-body');
      const toggleBtn = block.querySelector('.read-more-btn');

      if (!messageBody || !toggleBtn) return;

      // Reset to collapsed state if needed
      messageBody.classList.add("truncated");
      toggleBtn.textContent = "Read More";

      toggleBtn.addEventListener("click", () => {
        const isExpanded = !messageBody.classList.contains("truncated");

        if (isExpanded) {
          messageBody.classList.add("truncated");
          toggleBtn.textContent = "Read More";
        } else {
          messageBody.classList.remove("truncated");
          toggleBtn.textContent = "Hide";
        }
      });
    });
  }

  protected insertHyperlink(editor, url, target = '_blank') {
    const selection = editor.getSelection();
    if (!selection) return false;

    const ranges = selection.getRanges();
    if (ranges.length === 0 || ranges[0].collapsed) {
      // No text is selected.
      return false;
    }
    const range = ranges[0];

    if (this.isInsideHyperlink(range)) {
      // The selection is already part of a link.
      return false;
    }

    // --- NEW, MORE ROBUST LOGIC ---
    try {
        // 1. Create the new <a> element that will wrap the selection.
        const linkElement = editor.document.createElement('a');
        linkElement.setAttributes({
            'href': url,
            'target': target,
            'class': 'is-inserting'
        });

        // 2. "Cut" the selected content from the document and move it inside the new <a> element.
        // This preserves all original HTML formatting.
        linkElement.append(range.extractContents());

        // 3. Insert the new, complete <a> element back into the editor.
        editor.insertElement(linkElement);

    } catch (e) {
      console.error('Error creating hyperlink:', e);
      return false;
    }

    // Refresh matches since DOM structure has changed
    if (this.CKE4Finder.searchText) {
        this.CKE4Finder.findAllMatches(editor, this.CKE4Finder.searchText);
    } else {
        this.CKE4Finder.allMatches = [];
        this.CKE4Finder.currentMatchIndex = -1;
    }

    this.updateChatButtons(editor);

    return true;
  }

  protected isInsideHyperlink(range) {
    // Check if the range is inside an anchor tag
    const startElement = range.getStartElement ? range.getStartElement() : range.startContainer;
    let element = startElement;

    while (element) {
      if (element.getName && element.getName() === 'a') {
        return true;
      }
      if (element.tagName && element.tagName.toLowerCase() === 'a') {
        return true;
      }
      element = element.getParent ? element.getParent() : element.parentNode;
    }

    return false;
  }

  public updateChatHistoryOnArticleSave(article_data: Object): void {

    let idArticle = this.articlesEdit.getId();
    if (idArticle == null || idArticle == undefined) {
      idArticle = article_data["id"];
      const chatHistory = document.getElementById("title-analysis-content").innerHTML;
      const customChatHistory = document.getElementById("custom-prompts-content").innerHTML;


      var endpoint = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/ai-tools/chat-history/post/";

      var data: any = {
        idArticle: idArticle,
        chatHistory: chatHistory,
        customChatHistory: customChatHistory,
        eventArray: aiEventArray
      };
      var formReq_params: Array<Array<string>> = [["data", JSON.stringify(data)]];

      this.autoCategorizeXHRHdl = new XMLHttpRequestHandler(endpoint, formReq_params, this);
      this.autoCategorizeXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      this.autoCategorizeXHRHdl.onReadyStateFunction = this.onArticleChatHistoryReturn;
      this.autoCategorizeXHRHdl.execute();
    }

  }

  private isExcludedForIndicator(editor: any, element: HTMLElement): boolean {

    if (element.nodeName === "IMG") return true;

    // Check if element has excluded classes
    const excludedClasses = ['emaki-displayCard'];
    let currentElement: HTMLElement | null = element;

    while (currentElement) {
      const hasExcludedClass = excludedClasses.some(cls =>
        currentElement.classList.contains(cls));

      if (hasExcludedClass) return true;

      // Stop at editor container
      if (currentElement.classList.contains('cke_editable')) {
        break;
      }

      currentElement = currentElement.parentElement;
    }

    return false;
  }

  private getHighestEligibleAncestor(editor: any, element: HTMLElement): HTMLElement | null {
    if (!element) return null;

    const allowedTags = new Set(['SPAN', 'BLOCKQUOTE', 'DIV', 'H2', 'H3']);
    const editableRoot: HTMLElement | null = editor.editable() && editor.editable().$;
    if (!editableRoot) return null;

    let node: HTMLElement | null = (element.nodeType === 1 ? element : element.parentElement);
    let topmost: HTMLElement | null = null;

    while (node && node !== editableRoot) {
      if (allowedTags.has(node.nodeName) && !this.isExcludedForIndicator(editor, node)) {
        topmost = node;
      }
      node = node.parentElement;
    }

    return topmost;
  }

  protected clearIndicatorMarkers(editor: any = null) {
    if (editor) {
      try {
        const indicatorMarkers = editor.editable().find('[data-cke-ma-indicator]');
        for (let i = 0; i < indicatorMarkers.count(); i++) {
          const marker = indicatorMarkers.getItem(i);
          marker.removeAttribute('data-cke-ma-indicator');
          marker.removeAttribute('data-tag');
        }
      } catch (_) {
      }
      return;
    }
  }

  public resolveStyleName(el: HTMLElement | null): { name: string, type: 'block' | 'inline' | 'none' } {
    if (!el) return { name: '', type: 'none' };

    const tag = el.tagName.toLowerCase();
    const cls = (el.getAttribute('class') || '').split(/\s+/);
    const has = (c: string) => cls.indexOf(c) !== -1;

    // Block styles
    if (tag === 'h2') return { name: 'Heading 2', type: 'block' };
    if (tag === 'h3') return { name: 'Heading 3', type: 'block' };
    if (has('paragraph-dropcap')) return { name: 'Drop Cap', type: 'block' };
    if (tag === 'blockquote') return { name: 'Blockquote', type: 'block' };
    if (has('pullquote')) return { name: 'Pullquote', type: 'block' };
    if (has('tip'))        return { name: 'Tip - Box', type: 'block' };
    if (has('warning'))    return { name: 'Warning - Box', type: 'block' };
    if (has('note'))       return { name: 'Note - Box', type: 'block' };
    if (has('promoted'))   return { name: 'Promoted - Box', type: 'block' };
    if (has('expandable')) return { name: 'Expandable - See More', type: 'block' };
    if (has('wrap-image')) return { name: 'Float Image Left', type: 'block' };
    if (has('wrap-image-right')) return { name: 'Float Image Right', type: 'block' };
    if (has('wrap-badge-left')) return { name: 'Float Badge Left', type: 'block' };
    if (has('wrap-widget-right')) return { name: 'Float Widget Right', type: 'block' };

    // Fallbacks
    if (tag === 'div') return { name: '', type: 'block' };
    if (tag === 'pre') return { name: '', type: 'block' };

    return { name: '', type: 'none' };
  }

  protected updateVisualIndicator(editor: any) {
    try {
      const indicatorTarget = editor.editable().findOne('[data-cke-ma-indicator]');
      if (indicatorTarget) {
        const styleInfo = this.resolveStyleName(indicatorTarget.$);
        indicatorTarget.setAttribute('data-tag', styleInfo.name || indicatorTarget.$.tagName.toLowerCase());

        // Update dropdowns
        const block = styleInfo.type === 'block' ? (styleInfo.name || '') : '';

        this.updateDropdownSelection(editor, 'Blocks', block);
      }
    } catch (_) {
    }
  }

  protected updateDropdownSelection(editor: any, dropdownName: string, value: string) {
    setTimeout(() => {
      try {
        const dropdown = editor.ui.get(dropdownName);
        if (dropdown) {
          dropdown.setValue(value, value);

          if (value && !dropdown.getValue()) {
            dropdown.setValue('', '');
          }
        }
      } catch (_) {
      }
    }, 50);
  }

  protected scrubIfHeadingOrBQ(editor) {
    try {
      var sel = editor.getSelection && editor.getSelection();
      var start = sel && sel.getStartElement && sel.getStartElement();
      if (!start) return;

      var path = editor.elementPath(start);
      var block = path && path.block;
      if (!block || !block.getName) return;

      var name = block.getName();
      if (name === 'h1' || name === 'h2' || name === 'h3' || name === 'blockquote') {
        block.removeAttribute('class');
        block.removeAttribute('id');
        block.removeAttribute('style');
      }
    } catch (_e) { console.log(_e); }
  }

  public sendSensaiFeatureFeedback(feedbackData: Object = {}): boolean {
    let requiredKeys = ['category', 'message'];
    let meetsRequired = true;
    for (let k of requiredKeys) {
      if (!feedbackData[k]) {
        meetsRequired = false;
        break;
      }
    }
    let idArticle = this.articlesEdit.getId();

    if (idArticle == null || idArticle == undefined || !meetsRequired) {
      return false;
    }

    let endpoint = `/api/brand/${this.getVnAppZone().app.params.idBrand}/ai-tools/give-feedback/${idArticle}`;
    let formData = new FormData();
    for (let k in feedbackData) {
      formData.append(k, feedbackData[k]);
    }

    const chatHistory = document.getElementById("title-analysis-content");
    const customChatHistory = document.getElementById("custom-prompts-content");

    fetch(endpoint, {
      method: 'POST',
      body: formData
    }).then(() => {
      this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Feedback sent!");
      this.getVnAppZone().showNotificationToModule();
    }).catch(() => {
      this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "Something went wrong while sending feedback!");
      this.getVnAppZone().showNotificationToModule();
    });

    return true;
  }

  public updateArticleRecommendationAtIndex(index, article) {
      this.articlesEdit.updateArticleRecommendationAtIndex(index, article);
  }

    public getListingPagesSuggestion(keyword, idElement): void {

        if( "getListingPagesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getListingPagesSuggestion"].cancelAndReset();
        }


        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword, config: 'deals'}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/search/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getListingPagesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getListingPagesSuggestion"].onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdls["getListingPagesSuggestion"].execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {


        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    console.log(response);
                    obj.articlesEdit.setFilterListingPagesAutoComplete(response.data.listingPages, response.data.idElement);
                }

            });
        }
    }

    public getListingPageById(idListingPage, idElement): void {
        if (idElement !== "dealsCategoryPromotionListingPageFilter") {
            return;
        }

        const idBrand = this.getIdBrand();
        const url = `/api/brand/${idBrand}/config/listing-pages/get/${idListingPage}`;

        fetch(url)
            .then(res => res.json())
            .then(response => {
                const listingPage = response.listingPage || (response.data && response.data.listingPage) || response.data;
                this.articlesEdit.setDealsCategoryListingPage(listingPage);
            });
    }
}



// WEBPACK FOOTER //
// ./js/modules/articles_edit_new.ts